!function ()
{
    var e = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : {};

    function t(e)
    {
        return e && e.__esModule ? e.default : e
    }

    function n(e)
    {
        Object.defineProperty(e, "__esModule", {value: !0})
    }

    function r(e, t, n)
    {
        Object.defineProperty(e, t, {get: n, enumerable: !0})
    }

    var i, o, a, s, l, c, u, d, p, f = {}, h = {}, m = !1;

    function v(e, t)
    {
        for (var n in t) e[n] = t[n];
        return e
    }

    function g(e)
    {
        var t = e.parentNode;
        t && t.removeChild(e)
    }

    function y(e, t, n)
    {
        var r, i, o, a = arguments, s = {};
        for (o in t) "key" == o ? r = t[o] : "ref" == o ? i = t[o] : s[o] = t[o];
        if (arguments.length > 3) for (n = [n], o = 3; o < arguments.length; o++) n.push(a[o]);
        if (null != n && (s.children = n), "function" == typeof e && null != e.defaultProps) for (o in e.defaultProps) void 0 === s[o] && (s[o] = e.defaultProps[o]);
        return b(e, s, r, i, null)
    }

    function b(e, t, n, r, i)
    {
        var a = {
            type: e,
            props: t,
            key: n,
            ref: r,
            __k: null,
            __: null,
            __b: 0,
            __e: null,
            __d: void 0,
            __c: null,
            __h: null,
            constructor: void 0,
            __v: null == i ? ++o.__v : i
        };
        return null != o.vnode && o.vnode(a), a
    }

    function w()
    {
        return {current: null}
    }

    function x(e)
    {
        return e.children
    }

    function _(e, t)
    {
        this.props = e, this.context = t
    }

    function C(e, t)
    {
        if (null == t) return e.__ ? C(e.__, e.__.__k.indexOf(e) + 1) : null;
        for (var n; t < e.__k.length; t++) if (null != (n = e.__k[t]) && null != n.__e) return n.__e;
        return "function" == typeof e.type ? C(e) : null
    }

    function E(e)
    {
        var t, n;
        if (null != (e = e.__) && null != e.__c)
        {
            for (e.__e = e.__c.base = null, t = 0; t < e.__k.length; t++) if (null != (n = e.__k[t]) && null != n.__e)
            {
                e.__e = e.__c.base = n.__e;
                break
            }
            return E(e)
        }
    }

    function S(e)
    {
        (!e.__d && (e.__d = !0) && a.push(e) && !k.__r++ || l !== o.debounceRendering) && ((l = o.debounceRendering) || s)(k)
    }

    function k()
    {
        for (var e; k.__r = a.length;) e = a.sort((function (e, t)
        {
            return e.__v.__b - t.__v.__b
        })), a = [], e.some((function (e)
        {
            var t, n, r, i, o, a;
            e.__d && (o = (i = (t = e).__v).__e, (a = t.__P) && (n = [], (r = v({}, i)).__v = i.__v + 1, L(a, i, r, t.__n, void 0 !== a.ownerSVGElement, null != i.__h ? [o] : null, n, null == o ? C(i) : o, i.__h), D(n, i), i.__e != o && E(i)))
        }))
    }

    function T(e, t, n, r, i, o, a, s, l, c)
    {
        var p, f, h, m, v, g, y, w = r && r.__k || d, _ = w.length;
        for (n.__k = [], p = 0; p < t.length; p++) if (null != (m = n.__k[p] = null == (m = t[p]) || "boolean" == typeof m ? null : "string" == typeof m || "number" == typeof m ? b(null, m, null, null, m) : Array.isArray(m) ? b(x, {children: m}, null, null, null) : m.__b > 0 ? b(m.type, m.props, m.key, null, m.__v) : m))
        {
            if (m.__ = n, m.__b = n.__b + 1, null === (h = w[p]) || h && m.key == h.key && m.type === h.type) w[p] = void 0; else for (f = 0; f < _; f++)
            {
                if ((h = w[f]) && m.key == h.key && m.type === h.type)
                {
                    w[f] = void 0;
                    break
                }
                h = null
            }
            L(e, m, h = h || u, i, o, a, s, l, c), v = m.__e, (f = m.ref) && h.ref != f && (y || (y = []), h.ref && y.push(h.ref, null, m), y.push(f, m.__c || v, m)), null != v ? (null == g && (g = v), "function" == typeof m.type && null != m.__k && m.__k === h.__k ? m.__d = l = O(m, l, e) : l = R(e, m, h, w, v, l), c || "option" !== n.type ? "function" == typeof n.type && (n.__d = l) : e.value = "") : l && h.__e == l && l.parentNode != e && (l = C(h))
        }
        for (n.__e = g, p = _; p--;) null != w[p] && ("function" == typeof n.type && null != w[p].__e && w[p].__e == n.__d && (n.__d = C(r, p + 1)), F(w[p], w[p]));
        if (y) for (p = 0; p < y.length; p++) N(y[p], y[++p], y[++p])
    }

    function O(e, t, n)
    {
        var r, i;
        for (r = 0; r < e.__k.length; r++) (i = e.__k[r]) && (i.__ = e, t = "function" == typeof i.type ? O(i, t, n) : R(n, i, i, e.__k, i.__e, t));
        return t
    }

    function M(e, t)
    {
        return t = t || [], null == e || "boolean" == typeof e || (Array.isArray(e) ? e.some((function (e)
        {
            M(e, t)
        })) : t.push(e)), t
    }

    function R(e, t, n, r, i, o)
    {
        var a, s, l;
        if (void 0 !== t.__d) a = t.__d, t.__d = void 0; else if (null == n || i != o || null == i.parentNode) e:if (null == o || o.parentNode !== e) e.appendChild(i), a = null; else
        {
            for (s = o, l = 0; (s = s.nextSibling) && l < r.length; l += 2) if (s == i) break e;
            e.insertBefore(i, o), a = o
        }
        return void 0 !== a ? a : i.nextSibling
    }

    function P(e, t, n)
    {
        "-" === t[0] ? e.setProperty(t, n) : e[t] = null == n ? "" : "number" != typeof n || p.test(t) ? n : n + "px"
    }

    function z(e, t, n, r, i)
    {
        var o;
        e:if ("style" === t) if ("string" == typeof n) e.style.cssText = n; else
        {
            if ("string" == typeof r && (e.style.cssText = r = ""), r) for (t in r) n && t in n || P(e.style, t, "");
            if (n) for (t in n) r && n[t] === r[t] || P(e.style, t, n[t])
        } else if ("o" === t[0] && "n" === t[1]) o = t !== (t = t.replace(/Capture$/, "")), t = t.toLowerCase() in e ? t.toLowerCase().slice(2) : t.slice(2), e.l || (e.l = {}), e.l[t + o] = n, n ? r || e.addEventListener(t, o ? A : I, o) : e.removeEventListener(t, o ? A : I, o); else if ("dangerouslySetInnerHTML" !== t)
        {
            if (i) t = t.replace(/xlink[H:h]/, "h").replace(/sName$/, "s"); else if ("href" !== t && "list" !== t && "form" !== t && "download" !== t && t in e) try
            {
                e[t] = null == n ? "" : n;
                break e
            } catch (e)
            {
            }
            "function" == typeof n || (null != n && (!1 !== n || "a" === t[0] && "r" === t[1]) ? e.setAttribute(t, n) : e.removeAttribute(t))
        }
    }

    function I(e)
    {
        this.l[e.type + !1](o.event ? o.event(e) : e)
    }

    function A(e)
    {
        this.l[e.type + !0](o.event ? o.event(e) : e)
    }

    function L(e, t, n, r, i, a, s, l, c)
    {
        var p, f, h, m, y, b, w, C, E, S, k, O = t.type;
        if (void 0 !== t.constructor) return null;
        null != n.__h && (c = n.__h, l = t.__e = n.__e, t.__h = null, a = [l]), (p = o.__b) && p(t);
        try
        {
            e:if ("function" == typeof O)
            {
                if (C = t.props, E = (p = O.contextType) && r[p.__c], S = p ? E ? E.props.value : p.__ : r, n.__c ? w = (f = t.__c = n.__c).__ = f.__E : ("prototype" in O && O.prototype.render ? t.__c = f = new O(C, S) : (t.__c = f = new _(C, S), f.constructor = O, f.render = B), E && E.sub(f), f.props = C, f.state || (f.state = {}), f.context = S, f.__n = r, h = f.__d = !0, f.__h = []), null == f.__s && (f.__s = f.state), null != O.getDerivedStateFromProps && (f.__s == f.state && (f.__s = v({}, f.__s)), v(f.__s, O.getDerivedStateFromProps(C, f.__s))), m = f.props, y = f.state, h) null == O.getDerivedStateFromProps && null != f.componentWillMount && f.componentWillMount(), null != f.componentDidMount && f.__h.push(f.componentDidMount); else
                {
                    if (null == O.getDerivedStateFromProps && C !== m && null != f.componentWillReceiveProps && f.componentWillReceiveProps(C, S), !f.__e && null != f.shouldComponentUpdate && !1 === f.shouldComponentUpdate(C, f.__s, S) || t.__v === n.__v)
                    {
                        f.props = C, f.state = f.__s, t.__v !== n.__v && (f.__d = !1), f.__v = t, t.__e = n.__e, t.__k = n.__k, f.__h.length && s.push(f);
                        break e
                    }
                    null != f.componentWillUpdate && f.componentWillUpdate(C, f.__s, S), null != f.componentDidUpdate && f.__h.push((function ()
                    {
                        f.componentDidUpdate(m, y, b)
                    }))
                }
                f.context = S, f.props = C, f.state = f.__s, (p = o.__r) && p(t), f.__d = !1, f.__v = t, f.__P = e, p = f.render(f.props, f.state, f.context), f.state = f.__s, null != f.getChildContext && (r = v(v({}, r), f.getChildContext())), h || null == f.getSnapshotBeforeUpdate || (b = f.getSnapshotBeforeUpdate(m, y)), k = null != p && p.type === x && null == p.key ? p.props.children : p, T(e, Array.isArray(k) ? k : [k], t, n, r, i, a, s, l, c), f.base = t.__e, t.__h = null, f.__h.length && s.push(f), w && (f.__E = f.__ = null), f.__e = !1
            } else null == a && t.__v === n.__v ? (t.__k = n.__k, t.__e = n.__e) : t.__e = function (e, t, n, r, i, o, a, s)
                {
                    var l, c, p, f, h = n.props, m = t.props, v = t.type, y = 0;
                    if ("svg" === v && (i = !0), null != o) for (; y < o.length; y++) if ((l = o[y]) && (l === e || (v ? l.localName == v : 3 == l.nodeType)))
                    {
                        e = l, o[y] = null;
                        break
                    }
                    if (null == e)
                    {
                        if (null === v) return document.createTextNode(m);
                        e = i ? document.createElementNS("http://www.w3.org/2000/svg", v) : document.createElement(v, m.is && m), o = null, s = !1
                    }
                    if (null === v) h === m || s && e.data === m || (e.data = m); else
                    {
                        if (o = o && d.slice.call(e.childNodes), c = (h = n.props || u).dangerouslySetInnerHTML, p = m.dangerouslySetInnerHTML, !s)
                        {
                            if (null != o) for (h = {}, f = 0; f < e.attributes.length; f++) h[e.attributes[f].name] = e.attributes[f].value;
                            (p || c) && (p && (c && p.__html == c.__html || p.__html === e.innerHTML) || (e.innerHTML = p && p.__html || ""))
                        }
                        if (function (e, t, n, r, i)
                        {
                            var o;
                            for (o in n) "children" === o || "key" === o || o in t || z(e, o, null, n[o], r);
                            for (o in t) i && "function" != typeof t[o] || "children" === o || "key" === o || "value" === o || "checked" === o || n[o] === t[o] || z(e, o, t[o], n[o], r)
                        }(e, m, h, i, s), p) t.__k = []; else if (y = t.props.children, T(e, Array.isArray(y) ? y : [y], t, n, r, i && "foreignObject" !== v, o, a, e.firstChild, s), null != o) for (y = o.length; y--;) null != o[y] && g(o[y]);
                        s || ("value" in m && void 0 !== (y = m.value) && (y !== e.value || "progress" === v && !y) && z(e, "value", y, h.value, !1), "checked" in m && void 0 !== (y = m.checked) && y !== e.checked && z(e, "checked", y, h.checked, !1))
                    }
                    return e
                }(n.__e, t, n, r, i, a, s, c);
            (p = o.diffed) && p(t)
        } catch (e)
        {
            t.__v = null, (c || null != a) && (t.__e = l, t.__h = !!c, a[a.indexOf(l)] = null), o.__e(e, t, n)
        }
    }

    function D(e, t)
    {
        o.__c && o.__c(t, e), e.some((function (t)
        {
            try
            {
                e = t.__h, t.__h = [], e.some((function (e)
                {
                    e.call(t)
                }))
            } catch (e)
            {
                o.__e(e, t.__v)
            }
        }))
    }

    function N(e, t, n)
    {
        try
        {
            "function" == typeof e ? e(t) : e.current = t
        } catch (e)
        {
            o.__e(e, n)
        }
    }

    function F(e, t, n)
    {
        var r, i, a;
        if (o.unmount && o.unmount(e), (r = e.ref) && (r.current && r.current !== e.__e || N(r, null, t)), n || "function" == typeof e.type || (n = null != (i = e.__e)), e.__e = e.__d = void 0, null != (r = e.__c))
        {
            if (r.componentWillUnmount) try
            {
                r.componentWillUnmount()
            } catch (e)
            {
                o.__e(e, t)
            }
            r.base = r.__P = null
        }
        if (r = e.__k) for (a = 0; a < r.length; a++) r[a] && F(r[a], t, n);
        null != i && g(i)
    }

    function B(e, t, n)
    {
        return this.constructor(e, n)
    }

    function W(e, t, n)
    {
        var r, i, a;
        o.__ && o.__(e, t), i = (r = "function" == typeof n) ? null : n && n.__k || t.__k, a = [], L(t, e = (!r && n || t).__k = y(x, null, [e]), i || u, u, void 0 !== t.ownerSVGElement, !r && n ? [n] : i ? null : t.firstChild ? d.slice.call(t.childNodes) : null, a, !r && n ? n : i ? i.__e : t.firstChild, r), D(a, e)
    }

    function $(e, t)
    {
        W(e, t, $)
    }

    function H(e, t, n)
    {
        var r, i, o, a = arguments, s = v({}, e.props);
        for (o in t) "key" == o ? r = t[o] : "ref" == o ? i = t[o] : s[o] = t[o];
        if (arguments.length > 3) for (n = [n], o = 3; o < arguments.length; o++) n.push(a[o]);
        return null != n && (s.children = n), b(e.type, s, r || e.key, i || e.ref, null)
    }

    function j(e, t)
    {
        var n = {
            __c: t = "__cC" + c++, __: e, Consumer: function (e, t)
            {
                return e.children(t)
            }, Provider: function (e)
            {
                var n, r;
                return this.getChildContext || (n = [], (r = {})[t] = this, this.getChildContext = function ()
                {
                    return r
                }, this.shouldComponentUpdate = function (e)
                {
                    this.props.value !== e.value && n.some(S)
                }, this.sub = function (e)
                {
                    n.push(e);
                    var t = e.componentWillUnmount;
                    e.componentWillUnmount = function ()
                    {
                        n.splice(n.indexOf(e), 1), t && t.call(e)
                    }
                }), e.children
            }
        };
        return n.Provider.__ = n.Consumer.contextType = n
    }

    function V()
    {
        return m || (m = !0, i = {}, u = {}, d = [], p = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, o = {
            __e: function (e, t)
            {
                for (var n, r, i; t = t.__;) if ((n = t.__c) && !n.__) try
                {
                    if ((r = n.constructor) && null != r.getDerivedStateFromError && (n.setState(r.getDerivedStateFromError(e)), i = n.__d), null != n.componentDidCatch && (n.componentDidCatch(e), i = n.__d), i) return n.__E = n
                } catch (t)
                {
                    e = t
                }
                throw e
            }, __v: 0
        }, function (e)
        {
            return null != e && void 0 === e.constructor
        }, _.prototype.setState = function (e, t)
        {
            var n;
            n = null != this.__s && this.__s !== this.state ? this.__s : this.__s = v({}, this.state), "function" == typeof e && (e = e(v({}, n), this.props)), e && v(n, e), null != e && this.__v && (t && this.__h.push(t), S(this))
        }, _.prototype.forceUpdate = function (e)
        {
            this.__v && (this.__e = !0, e && this.__h.push(e), S(this))
        }, _.prototype.render = x, a = [], s = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, k.__r = 0, c = 0, r(i, "options", (function ()
        {
            return o
        })), r(i, "toChildArray", (function ()
        {
            return M
        })), r(i, "createContext", (function ()
        {
            return j
        })), r(i, "cloneElement", (function ()
        {
            return H
        })), r(i, "Component", (function ()
        {
            return _
        })), r(i, "createRef", (function ()
        {
            return w
        })), r(i, "Fragment", (function ()
        {
            return x
        })), r(i, "createElement", (function ()
        {
            return y
        })), r(i, "hydrate", (function ()
        {
            return $
        })), r(i, "render", (function ()
        {
            return W
        }))), i
    }

    V();
    var q, U, G, Z = 0, K = [], Y = V().options.__b, X = V().options.__r, J = V().options.diffed, Q = V().options.__c,
        ee = V().options.unmount;

    function te(e, t)
    {
        V().options.__h && V().options.__h(U, e, Z || t), Z = 0;
        var n = U.__H || (U.__H = {__: [], __h: []});
        return e >= n.__.length && n.__.push({}), n.__[e]
    }

    function ne(e)
    {
        return Z = 1, re(we, e)
    }

    function re(e, t, n)
    {
        var r = te(q++, 2);
        return r.t = e, r.__c || (r.__ = [n ? n(t) : we(void 0, t), function (e)
        {
            var t = r.t(r.__[0], e);
            r.__[0] !== t && (r.__ = [t, r.__[1]], r.__c.setState({}))
        }], r.__c = U), r.__
    }

    function ie(e, t)
    {
        var n = te(q++, 3);
        !V().options.__s && be(n.__H, t) && (n.__ = e, n.__H = t, U.__H.__h.push(n))
    }

    function oe(e, t)
    {
        var n = te(q++, 4);
        !V().options.__s && be(n.__H, t) && (n.__ = e, n.__H = t, U.__h.push(n))
    }

    function ae(e)
    {
        return Z = 5, le((function ()
        {
            return {current: e}
        }), [])
    }

    function se(e, t, n)
    {
        Z = 6, oe((function ()
        {
            "function" == typeof e ? e(t()) : e && (e.current = t())
        }), null == n ? n : n.concat(e))
    }

    function le(e, t)
    {
        var n = te(q++, 7);
        return be(n.__H, t) && (n.__ = e(), n.__H = t, n.__h = e), n.__
    }

    function ce(e, t)
    {
        return Z = 8, le((function ()
        {
            return e
        }), t)
    }

    function ue(e)
    {
        var t = U.context[e.__c], n = te(q++, 9);
        return n.__c = e, t ? (null == n.__ && (n.__ = !0, t.sub(U)), t.props.value) : e.__
    }

    function de(e, t)
    {
        V().options.useDebugValue && V().options.useDebugValue(t ? t(e) : e)
    }

    function pe(e)
    {
        var t = te(q++, 10), n = ne();
        return t.__ = e, U.componentDidCatch || (U.componentDidCatch = function (e)
        {
            t.__ && t.__(e), n[1](e)
        }), [n[0], function ()
        {
            n[1](void 0)
        }]
    }

    function fe()
    {
        K.forEach((function (e)
        {
            if (e.__P) try
            {
                e.__H.__h.forEach(ge), e.__H.__h.forEach(ye), e.__H.__h = []
            } catch (t)
            {
                e.__H.__h = [], V().options.__e(t, e.__v)
            }
        })), K = []
    }

    V().options.__b = function (e)
    {
        U = null, Y && Y(e)
    }, V().options.__r = function (e)
    {
        X && X(e), q = 0;
        var t = (U = e.__c).__H;
        t && (t.__h.forEach(ge), t.__h.forEach(ye), t.__h = [])
    }, V().options.diffed = function (e)
    {
        J && J(e);
        var t = e.__c;
        t && t.__H && t.__H.__h.length && (1 !== K.push(t) && G === V().options.requestAnimationFrame || ((G = V().options.requestAnimationFrame) || function (e)
        {
            var t, n = function ()
            {
                clearTimeout(r), ve && cancelAnimationFrame(t), setTimeout(e)
            }, r = setTimeout(n, 100);
            ve && (t = requestAnimationFrame(n))
        })(fe)), U = void 0
    }, V().options.__c = function (e, t)
    {
        t.some((function (e)
        {
            try
            {
                e.__h.forEach(ge), e.__h = e.__h.filter((function (e)
                {
                    return !e.__ || ye(e)
                }))
            } catch (n)
            {
                t.some((function (e)
                {
                    e.__h && (e.__h = [])
                })), t = [], V().options.__e(n, e.__v)
            }
        })), Q && Q(e, t)
    }, V().options.unmount = function (e)
    {
        ee && ee(e);
        var t = e.__c;
        if (t && t.__H) try
        {
            t.__H.__.forEach(ge)
        } catch (e)
        {
            V().options.__e(e, t.__v)
        }
    };
    var he, me, ve = "function" == typeof requestAnimationFrame;

    function ge(e)
    {
        var t = U;
        "function" == typeof e.__c && e.__c(), U = t
    }

    function ye(e)
    {
        var t = U;
        e.__c = e.__(), U = t
    }

    function be(e, t)
    {
        return !e || e.length !== t.length || t.some((function (t, n)
        {
            return t !== e[n]
        }))
    }

    function we(e, t)
    {
        return "function" == typeof t ? t(e) : t
    }

    function xe(e, t)
    {
        for (var n in t) e[n] = t[n];
        return e
    }

    function _e(e, t)
    {
        for (var n in e) if ("__source" !== n && !(n in t)) return !0;
        for (var r in t) if ("__source" !== r && e[r] !== t[r]) return !0;
        return !1
    }

    function Ce(e)
    {
        this.props = e
    }

    function Ee(e, t)
    {
        function n(e)
        {
            var n = this.props.ref, r = n == e.ref;
            return !r && n && (n.call ? n(null) : n.current = null), t ? !t(this.props, e) || !r : _e(this.props, e)
        }

        function r(t)
        {
            return this.shouldComponentUpdate = n, V().createElement(e, t)
        }

        return r.displayName = "Memo(" + (e.displayName || e.name) + ")", r.prototype.isReactComponent = !0, r.__f = !0, r
    }

    r(h, "useErrorBoundary", (function ()
    {
        return pe
    })), r(h, "useDebugValue", (function ()
    {
        return de
    })), r(h, "useContext", (function ()
    {
        return ue
    })), r(h, "useCallback", (function ()
    {
        return ce
    })), r(h, "useMemo", (function ()
    {
        return le
    })), r(h, "useImperativeHandle", (function ()
    {
        return se
    })), r(h, "useRef", (function ()
    {
        return ae
    })), r(h, "useLayoutEffect", (function ()
    {
        return oe
    })), r(h, "useEffect", (function ()
    {
        return ie
    })), r(h, "useReducer", (function ()
    {
        return re
    })), r(h, "useState", (function ()
    {
        return ne
    })), he = f, me = h, Object.keys(me).forEach((function (e)
    {
        "default" !== e && "__esModule" !== e && Object.defineProperty(he, e, {
            enumerable: !0, get: function ()
            {
                return me[e]
            }
        })
    })), V(), V(), r(f, "Component", (function ()
    {
        return V().Component
    })), r(f, "Fragment", (function ()
    {
        return V().Fragment
    })), r(f, "createRef", (function ()
    {
        return V().createRef
    })), r(f, "createContext", (function ()
    {
        return V().createContext
    })), r(f, "createElement", (function ()
    {
        return V().createElement
    })), (Ce.prototype = new (V().Component)).isPureReactComponent = !0, Ce.prototype.shouldComponentUpdate = function (e, t)
    {
        return _e(this.props, e) || _e(this.state, t)
    };
    var Se = V().options.__b;
    V().options.__b = function (e)
    {
        e.type && e.type.__f && e.ref && (e.props.ref = e.ref, e.ref = null), Se && Se(e)
    };
    var ke = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;

    function Te(e)
    {
        function t(t, n)
        {
            var r = xe({}, t);
            return delete r.ref, e(r, (n = t.ref || n) && ("object" != typeof n || "current" in n) ? n : null)
        }

        return t.$$typeof = ke, t.render = t, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (e.displayName || e.name) + ")", t
    }

    var Oe = function (e, t)
    {
        return null == e ? null : V().toChildArray(V().toChildArray(e).map(t))
    }, Me = {
        map: Oe, forEach: Oe, count: function (e)
        {
            return e ? V().toChildArray(e).length : 0
        }, only: function (e)
        {
            var t = V().toChildArray(e);
            if (1 !== t.length) throw"Children.only";
            return t[0]
        }, toArray: V().toChildArray
    }, Re = V().options.__e;

    function Pe()
    {
        this.__u = 0, this.t = null, this.__b = null
    }

    function ze(e)
    {
        var t = e.__.__c;
        return t && t.__e && t.__e(e)
    }

    function Ie(e)
    {
        var t, n, r;

        function i(i)
        {
            if (t || (t = e()).then((function (e)
            {
                n = e.default || e
            }), (function (e)
            {
                r = e
            })), r) throw r;
            if (!n) throw t;
            return V().createElement(n, i)
        }

        return i.displayName = "Lazy", i.__f = !0, i
    }

    function Ae()
    {
        this.u = null, this.o = null
    }

    V().options.__e = function (e, t, n)
    {
        if (e.then) for (var r, i = t; i = i.__;) if ((r = i.__c) && r.__c) return null == t.__e && (t.__e = n.__e, t.__k = n.__k), r.__c(e, t);
        Re(e, t, n)
    }, (Pe.prototype = new (V().Component)).__c = function (e, t)
    {
        var n = t.__c, r = this;
        null == r.t && (r.t = []), r.t.push(n);
        var i = ze(r.__v), o = !1, a = function ()
        {
            o || (o = !0, n.componentWillUnmount = n.__c, i ? i(s) : s())
        };
        n.__c = n.componentWillUnmount, n.componentWillUnmount = function ()
        {
            a(), n.__c && n.__c()
        };
        var s = function ()
        {
            if (!--r.__u)
            {
                if (r.state.__e)
                {
                    var e = r.state.__e;
                    r.__v.__k[0] = function e(t, n, r)
                    {
                        return t && (t.__v = null, t.__k = t.__k && t.__k.map((function (t)
                        {
                            return e(t, n, r)
                        })), t.__c && t.__c.__P === n && (t.__e && r.insertBefore(t.__e, t.__d), t.__c.__e = !0, t.__c.__P = r)), t
                    }(e, e.__c.__P, e.__c.__O)
                }
                var t;
                for (r.setState({__e: r.__b = null}); t = r.t.pop();) t.forceUpdate()
            }
        }, l = !0 === t.__h;
        r.__u++ || l || r.setState({__e: r.__b = r.__v.__k[0]}), e.then(a, a)
    }, Pe.prototype.componentWillUnmount = function ()
    {
        this.t = []
    }, Pe.prototype.render = function (e, t)
    {
        if (this.__b)
        {
            if (this.__v.__k)
            {
                var n = document.createElement("div"), r = this.__v.__k[0].__c;
                this.__v.__k[0] = function e(t, n, r)
                {
                    return t && (t.__c && t.__c.__H && (t.__c.__H.__.forEach((function (e)
                    {
                        "function" == typeof e.__c && e.__c()
                    })), t.__c.__H = null), null != (t = xe({}, t)).__c && (t.__c.__P === r && (t.__c.__P = n), t.__c = null), t.__k = t.__k && t.__k.map((function (t)
                    {
                        return e(t, n, r)
                    }))), t
                }(this.__b, n, r.__O = r.__P)
            }
            this.__b = null
        }
        var i = t.__e && V().createElement(V().Fragment, null, e.fallback);
        return i && (i.__h = null), [V().createElement(V().Fragment, null, t.__e ? null : e.children), i]
    };
    var Le = function (e, t, n)
    {
        if (++n[1] === n[0] && e.o.delete(t), e.props.revealOrder && ("t" !== e.props.revealOrder[0] || !e.o.size)) for (n = e.u; n;)
        {
            for (; n.length > 3;) n.pop()();
            if (n[1] < n[0]) break;
            e.u = n = n[2]
        }
    };

    function De(e)
    {
        return this.getChildContext = function ()
        {
            return e.context
        }, e.children
    }

    function Ne(e)
    {
        var t = this, n = e.i;
        t.componentWillUnmount = function ()
        {
            V().render(null, t.l), t.l = null, t.i = null
        }, t.i && t.i !== n && t.componentWillUnmount(), e.__v ? (t.l || (t.i = n, t.l = {
            nodeType: 1,
            parentNode: n,
            childNodes: [],
            appendChild: function (e)
            {
                this.childNodes.push(e), t.i.appendChild(e)
            },
            insertBefore: function (e, n)
            {
                this.childNodes.push(e), t.i.appendChild(e)
            },
            removeChild: function (e)
            {
                this.childNodes.splice(this.childNodes.indexOf(e) >>> 1, 1), t.i.removeChild(e)
            }
        }), V().render(V().createElement(De, {context: t.context}, e.__v), t.l)) : t.l && t.componentWillUnmount()
    }

    function Fe(e, t)
    {
        return V().createElement(Ne, {__v: e, i: t})
    }

    (Ae.prototype = new (V().Component)).__e = function (e)
    {
        var t = this, n = ze(t.__v), r = t.o.get(e);
        return r[0]++, function (i)
        {
            var o = function ()
            {
                t.props.revealOrder ? (r.push(i), Le(t, e, r)) : i()
            };
            n ? n(o) : o()
        }
    }, Ae.prototype.render = function (e)
    {
        this.u = null, this.o = new Map;
        var t = V().toChildArray(e.children);
        e.revealOrder && "b" === e.revealOrder[0] && t.reverse();
        for (var n = t.length; n--;) this.o.set(t[n], this.u = [1, 0, this.u]);
        return e.children
    }, Ae.prototype.componentDidUpdate = Ae.prototype.componentDidMount = function ()
    {
        var e = this;
        this.o.forEach((function (t, n)
        {
            Le(e, n, t)
        }))
    };
    var Be = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103,
        We = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|fill|flood|font|glyph(?!R)|horiz|marker(?!H|W|U)|overline|paint|stop|strikethrough|stroke|text(?!L)|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/,
        $e = function (e)
        {
            return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/i : /fil|che|ra/i).test(e)
        };

    function He(e, t, n)
    {
        return null == t.__k && (t.textContent = ""), V().render(e, t), "function" == typeof n && n(), e ? e.__c : null
    }

    function je(e, t, n)
    {
        return V().hydrate(e, t), "function" == typeof n && n(), e ? e.__c : null
    }

    V().Component.prototype.isReactComponent = {}, ["componentWillMount", "componentWillReceiveProps", "componentWillUpdate"].forEach((function (e)
    {
        Object.defineProperty(V().Component.prototype, e, {
            configurable: !0, get: function ()
            {
                return this["UNSAFE_" + e]
            }, set: function (t)
            {
                Object.defineProperty(this, e, {configurable: !0, writable: !0, value: t})
            }
        })
    }));
    var Ve = V().options.event;

    function qe()
    {
    }

    function Ue()
    {
        return this.cancelBubble
    }

    function Ge()
    {
        return this.defaultPrevented
    }

    V().options.event = function (e)
    {
        return Ve && (e = Ve(e)), e.persist = qe, e.isPropagationStopped = Ue, e.isDefaultPrevented = Ge, e.nativeEvent = e
    };
    var Ze, Ke = {
        configurable: !0, get: function ()
        {
            return this.class
        }
    }, Ye = V().options.vnode;
    V().options.vnode = function (e)
    {
        var t = e.type, n = e.props, r = n;
        if ("string" == typeof t)
        {
            for (var i in r = {}, n)
            {
                var o = n[i];
                "value" === i && "defaultValue" in n && null == o || ("defaultValue" === i && "value" in n && null == n.value ? i = "value" : "download" === i && !0 === o ? o = "" : /ondoubleclick/i.test(i) ? i = "ondblclick" : /^onchange(textarea|input)/i.test(i + t) && !$e(n.type) ? i = "oninput" : /^on(Ani|Tra|Tou|BeforeInp)/.test(i) ? i = i.toLowerCase() : We.test(i) ? i = i.replace(/[A-Z0-9]/, "-$&").toLowerCase() : null === o && (o = void 0), r[i] = o)
            }
            "select" == t && r.multiple && Array.isArray(r.value) && (r.value = V().toChildArray(n.children).forEach((function (e)
            {
                e.props.selected = -1 != r.value.indexOf(e.props.value)
            }))), "select" == t && null != r.defaultValue && (r.value = V().toChildArray(n.children).forEach((function (e)
            {
                e.props.selected = r.multiple ? -1 != r.defaultValue.indexOf(e.props.value) : r.defaultValue == e.props.value
            }))), e.props = r
        }
        t && n.class != n.className && (Ke.enumerable = "className" in n, null != n.className && (r.class = n.className), Object.defineProperty(r, "className", Ke)), e.$$typeof = Be, Ye && Ye(e)
    };
    var Xe = V().options.__r;
    V().options.__r = function (e)
    {
        Xe && Xe(e), Ze = e.__c
    };
    var Je = {
        ReactCurrentDispatcher: {
            current: {
                readContext: function (e)
                {
                    return Ze.__n[e.__c].props.value
                }
            }
        }
    };

    function Qe(e, t)
    {
        return t()
    }

    var et = "object" == typeof performance && "function" == typeof performance.now ? performance.now.bind(performance) : function ()
    {
        return Date.now()
    };

    function tt(e)
    {
        return V().createElement.bind(null, e)
    }

    function nt(e)
    {
        return !!e && e.$$typeof === Be
    }

    function rt(e)
    {
        return nt(e) ? V().cloneElement.apply(null, arguments) : e
    }

    function it(e)
    {
        return !!e.__k && (V().render(null, e), !0)
    }

    function ot(e)
    {
        return e && (e.base || 1 === e.nodeType && e) || null
    }

    var at = function (e, t)
    {
        return e(t)
    }, st = V().Fragment, lt = {
        useState: ne,
        useReducer: re,
        useEffect: ie,
        useLayoutEffect: oe,
        useRef: ae,
        useImperativeHandle: se,
        useMemo: le,
        useCallback: ce,
        useContext: ue,
        useDebugValue: de,
        version: "16.8.0",
        Children: Me,
        render: He,
        hydrate: je,
        unmountComponentAtNode: it,
        createPortal: Fe,
        createElement: V().createElement,
        createContext: V().createContext,
        createFactory: tt,
        cloneElement: rt,
        createRef: V().createRef,
        Fragment: V().Fragment,
        isValidElement: nt,
        findDOMNode: ot,
        Component: V().Component,
        PureComponent: Ce,
        memo: Ee,
        forwardRef: Te,
        unstable_batchedUpdates: at,
        StrictMode: V().Fragment,
        Suspense: Pe,
        SuspenseList: Ae,
        lazy: Ie,
        __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: Je
    };
    r(f, "default", (function ()
    {
        return lt
    })), r(f, "unstable_now", (function ()
    {
        return et
    })), r(f, "unstable_runWithPriority", (function ()
    {
        return Qe
    })), r(f, "unstable_IdlePriority", (function ()
    {
        return 5
    })), r(f, "unstable_LowPriority", (function ()
    {
        return 4
    })), r(f, "unstable_NormalPriority", (function ()
    {
        return 3
    })), r(f, "unstable_UserBlockingPriority", (function ()
    {
        return 2
    })), r(f, "unstable_ImmediatePriority", (function ()
    {
        return 1
    })), r(f, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", (function ()
    {
        return Je
    })), r(f, "lazy", (function ()
    {
        return Ie
    })), r(f, "SuspenseList", (function ()
    {
        return Ae
    })), r(f, "Suspense", (function ()
    {
        return Pe
    })), r(f, "StrictMode", (function ()
    {
        return st
    })), r(f, "unstable_batchedUpdates", (function ()
    {
        return at
    })), r(f, "forwardRef", (function ()
    {
        return Te
    })), r(f, "memo", (function ()
    {
        return Ee
    })), r(f, "PureComponent", (function ()
    {
        return Ce
    })), r(f, "findDOMNode", (function ()
    {
        return ot
    })), r(f, "isValidElement", (function ()
    {
        return nt
    })), r(f, "cloneElement", (function ()
    {
        return rt
    })), r(f, "createFactory", (function ()
    {
        return tt
    })), r(f, "createPortal", (function ()
    {
        return Fe
    })), r(f, "unmountComponentAtNode", (function ()
    {
        return it
    })), r(f, "hydrate", (function ()
    {
        return je
    })), r(f, "render", (function ()
    {
        return He
    })), r(f, "Children", (function ()
    {
        return Me
    })), r(f, "version", (function ()
    {
        return "16.8.0"
    })), n(f);
    var ct = {}, ut = {black: "#000", white: "#fff"}, dt = {
        50: "#ffebee",
        100: "#ffcdd2",
        200: "#ef9a9a",
        300: "#e57373",
        400: "#ef5350",
        500: "#f44336",
        600: "#e53935",
        700: "#d32f2f",
        800: "#c62828",
        900: "#b71c1c",
        A100: "#ff8a80",
        A200: "#ff5252",
        A400: "#ff1744",
        A700: "#d50000"
    }, pt = {
        50: "#fce4ec",
        100: "#f8bbd0",
        200: "#f48fb1",
        300: "#f06292",
        400: "#ec407a",
        500: "#e91e63",
        600: "#d81b60",
        700: "#c2185b",
        800: "#ad1457",
        900: "#880e4f",
        A100: "#ff80ab",
        A200: "#ff4081",
        A400: "#f50057",
        A700: "#c51162"
    }, ft = {
        50: "#f3e5f5",
        100: "#e1bee7",
        200: "#ce93d8",
        300: "#ba68c8",
        400: "#ab47bc",
        500: "#9c27b0",
        600: "#8e24aa",
        700: "#7b1fa2",
        800: "#6a1b9a",
        900: "#4a148c",
        A100: "#ea80fc",
        A200: "#e040fb",
        A400: "#d500f9",
        A700: "#aa00ff"
    }, ht = {
        50: "#ede7f6",
        100: "#d1c4e9",
        200: "#b39ddb",
        300: "#9575cd",
        400: "#7e57c2",
        500: "#673ab7",
        600: "#5e35b1",
        700: "#512da8",
        800: "#4527a0",
        900: "#311b92",
        A100: "#b388ff",
        A200: "#7c4dff",
        A400: "#651fff",
        A700: "#6200ea"
    }, mt = {
        50: "#e8eaf6",
        100: "#c5cae9",
        200: "#9fa8da",
        300: "#7986cb",
        400: "#5c6bc0",
        500: "#3f51b5",
        600: "#3949ab",
        700: "#303f9f",
        800: "#283593",
        900: "#1a237e",
        A100: "#8c9eff",
        A200: "#536dfe",
        A400: "#3d5afe",
        A700: "#304ffe"
    }, vt = {
        50: "#e3f2fd",
        100: "#bbdefb",
        200: "#90caf9",
        300: "#64b5f6",
        400: "#42a5f5",
        500: "#2196f3",
        600: "#1e88e5",
        700: "#1976d2",
        800: "#1565c0",
        900: "#0d47a1",
        A100: "#82b1ff",
        A200: "#448aff",
        A400: "#2979ff",
        A700: "#2962ff"
    }, gt = {
        50: "#e1f5fe",
        100: "#b3e5fc",
        200: "#81d4fa",
        300: "#4fc3f7",
        400: "#29b6f6",
        500: "#03a9f4",
        600: "#039be5",
        700: "#0288d1",
        800: "#0277bd",
        900: "#01579b",
        A100: "#80d8ff",
        A200: "#40c4ff",
        A400: "#00b0ff",
        A700: "#0091ea"
    }, yt = {
        50: "#e0f7fa",
        100: "#b2ebf2",
        200: "#80deea",
        300: "#4dd0e1",
        400: "#26c6da",
        500: "#00bcd4",
        600: "#00acc1",
        700: "#0097a7",
        800: "#00838f",
        900: "#006064",
        A100: "#84ffff",
        A200: "#18ffff",
        A400: "#00e5ff",
        A700: "#00b8d4"
    }, bt = {
        50: "#e0f2f1",
        100: "#b2dfdb",
        200: "#80cbc4",
        300: "#4db6ac",
        400: "#26a69a",
        500: "#009688",
        600: "#00897b",
        700: "#00796b",
        800: "#00695c",
        900: "#004d40",
        A100: "#a7ffeb",
        A200: "#64ffda",
        A400: "#1de9b6",
        A700: "#00bfa5"
    }, wt = {
        50: "#e8f5e9",
        100: "#c8e6c9",
        200: "#a5d6a7",
        300: "#81c784",
        400: "#66bb6a",
        500: "#4caf50",
        600: "#43a047",
        700: "#388e3c",
        800: "#2e7d32",
        900: "#1b5e20",
        A100: "#b9f6ca",
        A200: "#69f0ae",
        A400: "#00e676",
        A700: "#00c853"
    }, xt = {
        50: "#f1f8e9",
        100: "#dcedc8",
        200: "#c5e1a5",
        300: "#aed581",
        400: "#9ccc65",
        500: "#8bc34a",
        600: "#7cb342",
        700: "#689f38",
        800: "#558b2f",
        900: "#33691e",
        A100: "#ccff90",
        A200: "#b2ff59",
        A400: "#76ff03",
        A700: "#64dd17"
    }, _t = {
        50: "#f9fbe7",
        100: "#f0f4c3",
        200: "#e6ee9c",
        300: "#dce775",
        400: "#d4e157",
        500: "#cddc39",
        600: "#c0ca33",
        700: "#afb42b",
        800: "#9e9d24",
        900: "#827717",
        A100: "#f4ff81",
        A200: "#eeff41",
        A400: "#c6ff00",
        A700: "#aeea00"
    }, Ct = {
        50: "#fffde7",
        100: "#fff9c4",
        200: "#fff59d",
        300: "#fff176",
        400: "#ffee58",
        500: "#ffeb3b",
        600: "#fdd835",
        700: "#fbc02d",
        800: "#f9a825",
        900: "#f57f17",
        A100: "#ffff8d",
        A200: "#ffff00",
        A400: "#ffea00",
        A700: "#ffd600"
    }, Et = {
        50: "#fff8e1",
        100: "#ffecb3",
        200: "#ffe082",
        300: "#ffd54f",
        400: "#ffca28",
        500: "#ffc107",
        600: "#ffb300",
        700: "#ffa000",
        800: "#ff8f00",
        900: "#ff6f00",
        A100: "#ffe57f",
        A200: "#ffd740",
        A400: "#ffc400",
        A700: "#ffab00"
    }, St = {
        50: "#fff3e0",
        100: "#ffe0b2",
        200: "#ffcc80",
        300: "#ffb74d",
        400: "#ffa726",
        500: "#ff9800",
        600: "#fb8c00",
        700: "#f57c00",
        800: "#ef6c00",
        900: "#e65100",
        A100: "#ffd180",
        A200: "#ffab40",
        A400: "#ff9100",
        A700: "#ff6d00"
    }, kt = {
        50: "#fbe9e7",
        100: "#ffccbc",
        200: "#ffab91",
        300: "#ff8a65",
        400: "#ff7043",
        500: "#ff5722",
        600: "#f4511e",
        700: "#e64a19",
        800: "#d84315",
        900: "#bf360c",
        A100: "#ff9e80",
        A200: "#ff6e40",
        A400: "#ff3d00",
        A700: "#dd2c00"
    }, Tt = {
        50: "#efebe9",
        100: "#d7ccc8",
        200: "#bcaaa4",
        300: "#a1887f",
        400: "#8d6e63",
        500: "#795548",
        600: "#6d4c41",
        700: "#5d4037",
        800: "#4e342e",
        900: "#3e2723",
        A100: "#d7ccc8",
        A200: "#bcaaa4",
        A400: "#8d6e63",
        A700: "#5d4037"
    }, Ot = {
        50: "#fafafa",
        100: "#f5f5f5",
        200: "#eeeeee",
        300: "#e0e0e0",
        400: "#bdbdbd",
        500: "#9e9e9e",
        600: "#757575",
        700: "#616161",
        800: "#424242",
        900: "#212121",
        A100: "#d5d5d5",
        A200: "#aaaaaa",
        A400: "#303030",
        A700: "#616161"
    }, Mt = {
        50: "#eceff1",
        100: "#cfd8dc",
        200: "#b0bec5",
        300: "#90a4ae",
        400: "#78909c",
        500: "#607d8b",
        600: "#546e7a",
        700: "#455a64",
        800: "#37474f",
        900: "#263238",
        A100: "#cfd8dc",
        A200: "#b0bec5",
        A400: "#78909c",
        A700: "#455a64"
    };

    function Rt(e, t, n)
    {
        return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n, e
    }

    function Pt(e, t)
    {
        if (null == e) return {};
        var n, r, i = {}, o = Object.keys(e);
        for (r = 0; r < o.length; r++) n = o[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
        return i
    }

    function zt(e, t)
    {
        if (null == e) return {};
        var n, r, i = Pt(e, t);
        if (Object.getOwnPropertySymbols)
        {
            var o = Object.getOwnPropertySymbols(e);
            for (r = 0; r < o.length; r++) n = o[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n])
        }
        return i
    }

    function It()
    {
        return (It = Object.assign || function (e)
        {
            for (var t = 1; t < arguments.length; t++)
            {
                var n = arguments[t];
                for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r])
            }
            return e
        }).apply(this, arguments)
    }

    r(ct, "common", (function ()
    {
        return ut
    })), r(ct, "red", (function ()
    {
        return dt
    })), r(ct, "pink", (function ()
    {
        return pt
    })), r(ct, "purple", (function ()
    {
        return ft
    })), r(ct, "deepPurple", (function ()
    {
        return ht
    })), r(ct, "indigo", (function ()
    {
        return mt
    })), r(ct, "blue", (function ()
    {
        return vt
    })), r(ct, "lightBlue", (function ()
    {
        return gt
    })), r(ct, "cyan", (function ()
    {
        return yt
    })), r(ct, "teal", (function ()
    {
        return bt
    })), r(ct, "green", (function ()
    {
        return wt
    })), r(ct, "lightGreen", (function ()
    {
        return xt
    })), r(ct, "lime", (function ()
    {
        return _t
    })), r(ct, "yellow", (function ()
    {
        return Ct
    })), r(ct, "amber", (function ()
    {
        return Et
    })), r(ct, "orange", (function ()
    {
        return St
    })), r(ct, "deepOrange", (function ()
    {
        return kt
    })), r(ct, "brown", (function ()
    {
        return Tt
    })), r(ct, "grey", (function ()
    {
        return Ot
    })), r(ct, "blueGrey", (function ()
    {
        return Mt
    }));
    var At = It;

    function Lt(e)
    {
        return (Lt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e)
        {
            return typeof e
        } : function (e)
        {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    var Dt = Lt;

    function Nt(e)
    {
        return e && "object" === Dt(e) && !Array.isArray(e)
    }

    function Ft(e, t)
    {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {clone: !0},
            r = n.clone ? At({}, e) : e;
        return Nt(e) && Nt(t) && Object.keys(t).forEach((function (i)
        {
            "__proto__" !== i && (Nt(t[i]) && i in e ? r[i] = Ft(e[i], t[i], n) : r[i] = t[i])
        })), r
    }

    var Bt, Wt = !1;

    function $t()
    {
        return Wt || (Wt = !0, Bt = {}, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED", Bt = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"), Bt
    }

    var Ht, jt, Vt = !1;

    function qt()
    {
    }

    function Ut()
    {
    }

    var Gt = {}, Zt = t(Gt = (Vt || (Vt = !0, Ht = {}, jt = $t(), Ut.resetWarningCache = qt, Ht = function ()
    {
        function e(e, t, n, r, i, o)
        {
            if (o !== jt)
            {
                var a = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                throw a.name = "Invariant Violation", a
            }
        }

        function t()
        {
            return e
        }

        e.isRequired = e;
        var n = {
            array: e,
            bool: e,
            func: e,
            number: e,
            object: e,
            string: e,
            symbol: e,
            any: e,
            arrayOf: t,
            element: e,
            elementType: e,
            instanceOf: t,
            node: e,
            objectOf: t,
            oneOf: t,
            oneOfType: t,
            shape: t,
            exact: t,
            checkPropTypes: Ut,
            resetWarningCache: qt
        };
        return n.PropTypes = n, n
    }), Ht)());
    var Kt = (Zt.element, function ()
    {
        return null
    });
    Kt.isRequired = (Zt.element.isRequired, function ()
    {
        return null
    });
    Gt.elementType;
    var Yt, Xt, Jt, Qt, en, tn, nn, rn, on, an, sn, ln, cn, un, dn, pn, fn, hn, mn, vn, gn, yn, bn, wn, xn, _n, Cn, En,
        Sn, kn, Tn, On, Mn, Rn, Pn, zn, In, An, Ln, Dn, Nn, Fn, Bn, Wn, $n, Hn, jn, Vn = !1;

    function qn(e)
    {
        if ("object" == typeof e && null !== e)
        {
            var t = e.$$typeof;
            switch (t)
            {
                case Jt:
                    switch (e = e.type)
                    {
                        case an:
                        case sn:
                        case en:
                        case nn:
                        case tn:
                        case cn:
                            return e;
                        default:
                            switch (e = e && e.$$typeof)
                            {
                                case on:
                                case ln:
                                case pn:
                                case dn:
                                case rn:
                                    return e;
                                default:
                                    return t
                            }
                    }
                case Qt:
                    return t
            }
        }
    }

    function Un(e)
    {
        return qn(e) === sn
    }

    var Gn = {};
    Vn || (Vn = !0, Yt = {}, Object.defineProperty(Yt, "__esModule", {value: !0}), Xt = "function" == typeof Symbol && Symbol.for, Jt = Xt ? Symbol.for("react.element") : 60103, Qt = Xt ? Symbol.for("react.portal") : 60106, en = Xt ? Symbol.for("react.fragment") : 60107, tn = Xt ? Symbol.for("react.strict_mode") : 60108, nn = Xt ? Symbol.for("react.profiler") : 60114, rn = Xt ? Symbol.for("react.provider") : 60109, on = Xt ? Symbol.for("react.context") : 60110, an = Xt ? Symbol.for("react.async_mode") : 60111, sn = Xt ? Symbol.for("react.concurrent_mode") : 60111, ln = Xt ? Symbol.for("react.forward_ref") : 60112, cn = Xt ? Symbol.for("react.suspense") : 60113, un = Xt ? Symbol.for("react.suspense_list") : 60120, dn = Xt ? Symbol.for("react.memo") : 60115, pn = Xt ? Symbol.for("react.lazy") : 60116, fn = Xt ? Symbol.for("react.fundamental") : 60117, hn = Xt ? Symbol.for("react.responder") : 60118, mn = Xt ? Symbol.for("react.scope") : 60119, vn = qn, Yt.typeOf = vn, gn = an, Yt.AsyncMode = gn, yn = sn, Yt.ConcurrentMode = yn, bn = on, Yt.ContextConsumer = bn, wn = rn, Yt.ContextProvider = wn, xn = Jt, Yt.Element = xn, _n = ln, Yt.ForwardRef = _n, Cn = en, Yt.Fragment = Cn, En = pn, Yt.Lazy = En, Sn = dn, Yt.Memo = Sn, kn = Qt, Yt.Portal = kn, Tn = nn, Yt.Profiler = Tn, On = tn, Yt.StrictMode = On, Mn = cn, Yt.Suspense = Mn, Rn = function (e)
    {
        return "string" == typeof e || "function" == typeof e || e === en || e === sn || e === nn || e === tn || e === cn || e === un || "object" == typeof e && null !== e && (e.$$typeof === pn || e.$$typeof === dn || e.$$typeof === rn || e.$$typeof === on || e.$$typeof === ln || e.$$typeof === fn || e.$$typeof === hn || e.$$typeof === mn)
    }, Yt.isValidElementType = Rn, Pn = function (e)
    {
        return Un(e) || qn(e) === an
    }, Yt.isAsyncMode = Pn, zn = Un, Yt.isConcurrentMode = zn, In = function (e)
    {
        return qn(e) === on
    }, Yt.isContextConsumer = In, An = function (e)
    {
        return qn(e) === rn
    }, Yt.isContextProvider = An, Ln = function (e)
    {
        return "object" == typeof e && null !== e && e.$$typeof === Jt
    }, Yt.isElement = Ln, Dn = function (e)
    {
        return qn(e) === ln
    }, Yt.isForwardRef = Dn, Nn = function (e)
    {
        return qn(e) === en
    }, Yt.isFragment = Nn, Fn = function (e)
    {
        return qn(e) === pn
    }, Yt.isLazy = Fn, Bn = function (e)
    {
        return qn(e) === dn
    }, Yt.isMemo = Bn, Wn = function (e)
    {
        return qn(e) === Qt
    }, Yt.isPortal = Wn, $n = function (e)
    {
        return qn(e) === nn
    }, Yt.isProfiler = $n, Hn = function (e)
    {
        return qn(e) === tn
    }, Yt.isStrictMode = Hn, jn = function (e)
    {
        return qn(e) === cn
    }, Yt.isSuspense = jn), Gn = Yt;
    "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")(), Zt.oneOfType([Zt.func, Zt.object]);
    var Zn = ["xs", "sm", "md", "lg", "xl"];

    function Kn(e)
    {
        var t = e.values, n = void 0 === t ? {xs: 0, sm: 600, md: 960, lg: 1280, xl: 1920} : t, r = e.unit,
            i = void 0 === r ? "px" : r, o = e.step, a = void 0 === o ? 5 : o, s = zt(e, ["values", "unit", "step"]);

        function l(e)
        {
            var t = "number" == typeof n[e] ? n[e] : e;
            return "@media (min-width:".concat(t).concat(i, ")")
        }

        function c(e, t)
        {
            var r = Zn.indexOf(t);
            return r === Zn.length - 1 ? l(e) : "@media (min-width:".concat("number" == typeof n[e] ? n[e] : e).concat(i, ") and ") + "(max-width:".concat((-1 !== r && "number" == typeof n[Zn[r + 1]] ? n[Zn[r + 1]] : t) - a / 100).concat(i, ")")
        }

        return At({
            keys: Zn, values: n, up: l, down: function (e)
            {
                var t = Zn.indexOf(e) + 1, r = n[Zn[t]];
                return t === Zn.length ? l("xs") : "@media (max-width:".concat(("number" == typeof r && t > 0 ? r : e) - a / 100).concat(i, ")")
            }, between: c, only: function (e)
            {
                return c(e, e)
            }, width: function (e)
            {
                return n[e]
            }
        }, s)
    }

    function Yn(e, t, n)
    {
        var r;
        return At({
            gutters: function ()
            {
                var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                return At({paddingLeft: t(2), paddingRight: t(2)}, n, Rt({}, e.up("sm"), At({
                    paddingLeft: t(3),
                    paddingRight: t(3)
                }, n[e.up("sm")])))
            },
            toolbar: (r = {minHeight: 56}, Rt(r, "".concat(e.up("xs"), " and (orientation: landscape)"), {minHeight: 48}), Rt(r, e.up("sm"), {minHeight: 64}), r)
        }, n)
    }

    function Xn(e)
    {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
        return Math.min(Math.max(t, e), n)
    }

    function Jn(e)
    {
        if (e.type) return e;
        if ("#" === e.charAt(0)) return Jn(function (e)
        {
            e = e.substr(1);
            var t = new RegExp(".{1,".concat(e.length / 3, "}"), "g"), n = e.match(t);
            return n && 1 === n[0].length && (n = n.map((function (e)
            {
                return e + e
            }))), n ? "rgb(".concat(n.map((function (e)
            {
                return parseInt(e, 16)
            })).join(", "), ")") : ""
        }(e));
        var t = e.indexOf("("), n = e.substring(0, t);
        if (-1 === ["rgb", "rgba", "hsl", "hsla"].indexOf(n)) throw new Error(["Material-UI: unsupported `".concat(e, "` color."), "We support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()."].join("\n"));
        var r = e.substring(t + 1, e.length - 1).split(",");
        return {
            type: n, values: r = r.map((function (e)
            {
                return parseFloat(e)
            }))
        }
    }

    function Qn(e)
    {
        var t = e.type, n = e.values;
        return -1 !== t.indexOf("rgb") ? n = n.map((function (e, t)
        {
            return t < 3 ? parseInt(e, 10) : e
        })) : -1 !== t.indexOf("hsl") && (n[1] = "".concat(n[1], "%"), n[2] = "".concat(n[2], "%")), "".concat(t, "(").concat(n.join(", "), ")")
    }

    function er(e, t)
    {
        var n = tr(e), r = tr(t);
        return (Math.max(n, r) + .05) / (Math.min(n, r) + .05)
    }

    function tr(e)
    {
        var t = "hsl" === (e = Jn(e)).type ? Jn(function (e)
        {
            var t = (e = Jn(e)).values, n = t[0], r = t[1] / 100, i = t[2] / 100, o = r * Math.min(i, 1 - i),
                a = function (e)
                {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : (e + n / 30) % 12;
                    return i - o * Math.max(Math.min(t - 3, 9 - t, 1), -1)
                }, s = "rgb", l = [Math.round(255 * a(0)), Math.round(255 * a(8)), Math.round(255 * a(4))];
            return "hsla" === e.type && (s += "a", l.push(t[3])), Qn({type: s, values: l})
        }(e)).values : e.values;
        return t = t.map((function (e)
        {
            return (e /= 255) <= .03928 ? e / 12.92 : Math.pow((e + .055) / 1.055, 2.4)
        })), Number((.2126 * t[0] + .7152 * t[1] + .0722 * t[2]).toFixed(3))
    }

    function nr(e, t)
    {
        return e = Jn(e), t = Xn(t), "rgb" !== e.type && "hsl" !== e.type || (e.type += "a"), e.values[3] = t, Qn(e)
    }

    var rr = {
        text: {
            primary: "rgba(0, 0, 0, 0.87)",
            secondary: "rgba(0, 0, 0, 0.54)",
            disabled: "rgba(0, 0, 0, 0.38)",
            hint: "rgba(0, 0, 0, 0.38)"
        },
        divider: "rgba(0, 0, 0, 0.12)",
        background: {paper: ut.white, default: Ot[50]},
        action: {
            active: "rgba(0, 0, 0, 0.54)",
            hover: "rgba(0, 0, 0, 0.04)",
            hoverOpacity: .04,
            selected: "rgba(0, 0, 0, 0.08)",
            selectedOpacity: .08,
            disabled: "rgba(0, 0, 0, 0.26)",
            disabledBackground: "rgba(0, 0, 0, 0.12)",
            disabledOpacity: .38,
            focus: "rgba(0, 0, 0, 0.12)",
            focusOpacity: .12,
            activatedOpaciy: .12
        }
    }, ir = {
        text: {
            primary: ut.white,
            secondary: "rgba(255, 255, 255, 0.7)",
            disabled: "rgba(255, 255, 255, 0.5)",
            hint: "rgba(255, 255, 255, 0.5)",
            icon: "rgba(255, 255, 255, 0.5)"
        },
        divider: "rgba(255, 255, 255, 0.12)",
        background: {paper: Ot[800], default: "#303030"},
        action: {
            active: ut.white,
            hover: "rgba(255, 255, 255, 0.08)",
            hoverOpacity: .08,
            selected: "rgba(255, 255, 255, 0.16)",
            selectedOpacity: .16,
            disabled: "rgba(255, 255, 255, 0.3)",
            disabledBackground: "rgba(255, 255, 255, 0.12)",
            disabledOpacity: .38,
            focus: "rgba(255, 255, 255, 0.12)",
            focusOpacity: .12,
            activatedOpaciy: .24
        }
    };

    function or(e, t, n, r)
    {
        e[t] || (e.hasOwnProperty(n) ? e[t] = e[n] : "light" === t ? e.light = function (e, t)
        {
            if (e = Jn(e), t = Xn(t), -1 !== e.type.indexOf("hsl")) e.values[2] += (100 - e.values[2]) * t; else if (-1 !== e.type.indexOf("rgb")) for (var n = 0; n < 3; n += 1) e.values[n] += (255 - e.values[n]) * t;
            return Qn(e)
        }(e.main, r) : "dark" === t && (e.dark = function (e, t)
        {
            if (e = Jn(e), t = Xn(t), -1 !== e.type.indexOf("hsl")) e.values[2] *= 1 - t; else if (-1 !== e.type.indexOf("rgb")) for (var n = 0; n < 3; n += 1) e.values[n] *= 1 - t;
            return Qn(e)
        }(e.main, 1.5 * r)))
    }

    function ar(e)
    {
        var t = e.primary, n = void 0 === t ? {light: mt[300], main: mt[500], dark: mt[700]} : t, r = e.secondary,
            i = void 0 === r ? {light: pt.A200, main: pt.A400, dark: pt.A700} : r, o = e.error,
            a = void 0 === o ? {light: dt[300], main: dt[500], dark: dt[700]} : o, s = e.warning,
            l = void 0 === s ? {light: St[300], main: St[500], dark: St[700]} : s, c = e.info,
            u = void 0 === c ? {light: vt[300], main: vt[500], dark: vt[700]} : c, d = e.success,
            p = void 0 === d ? {light: wt[300], main: wt[500], dark: wt[700]} : d, f = e.type,
            h = void 0 === f ? "light" : f, m = e.contrastThreshold, v = void 0 === m ? 3 : m, g = e.tonalOffset,
            y = void 0 === g ? .2 : g,
            b = zt(e, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]);

        function w(e)
        {
            if (!e) throw new TypeError("Material-UI: missing background argument in getContrastText(".concat(e, ")."));
            var t = er(e, ir.text.primary) >= v ? ir.text.primary : rr.text.primary;
            return t
        }

        function x(e)
        {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 500,
                n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 300,
                r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 700;
            return !(e = At({}, e)).main && e[t] && (e.main = e[t]), or(e, "light", n, y), or(e, "dark", r, y), e.contrastText || (e.contrastText = w(e.main)), e
        }

        var _ = {dark: ir, light: rr};
        return Ft(At({
            common: ut,
            type: h,
            primary: x(n),
            secondary: x(i, "A400", "A200", "A700"),
            error: x(a),
            warning: x(l),
            info: x(u),
            success: x(p),
            grey: Ot,
            contrastThreshold: v,
            getContrastText: w,
            augmentColor: x,
            tonalOffset: y
        }, _[h]), b)
    }

    function sr(e)
    {
        return Math.round(1e5 * e) / 1e5
    }

    var lr = {textTransform: "uppercase"}, cr = '"Poppins", "Helvetica", "Arial", sans-serif';

    function ur(e, t)
    {
        var n = "function" == typeof t ? t(e) : t, r = n.fontFamily, i = void 0 === r ? cr : r, o = n.fontSize,
            a = void 0 === o ? 14 : o, s = n.fontWeightLight, l = void 0 === s ? 300 : s, c = n.fontWeightRegular,
            u = void 0 === c ? 400 : c, d = n.fontWeightMedium, p = void 0 === d ? 500 : d, f = n.fontWeightBold,
            h = void 0 === f ? 700 : f, m = n.htmlFontSize, v = void 0 === m ? 16 : m, g = n.allVariants, y = n.pxToRem,
            b = zt(n, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);
        var w = a / 14, x = y || function (e)
        {
            return "".concat(e / v * w, "rem")
        }, _ = function (e, t, n, r, o)
        {
            return At({
                fontFamily: i,
                fontWeight: e,
                fontSize: x(t),
                lineHeight: n
            }, i === cr ? {letterSpacing: "".concat(sr(r / t), "em")} : {}, {}, o, {}, g)
        }, C = {
            h1: _(l, 96, 1.167, -1.5),
            h2: _(l, 60, 1.2, -.5),
            h3: _(u, 48, 1.167, 0),
            h4: _(u, 34, 1.235, .25),
            h5: _(u, 24, 1.334, 0),
            h6: _(p, 20, 1.6, .15),
            subtitle1: _(u, 16, 1.75, .15),
            subtitle2: _(p, 14, 1.57, .1),
            body1: _(u, 16, 1.5, .15),
            body2: _(u, 14, 1.43, .15),
            button: _(p, 14, 1.75, .4, lr),
            caption: _(u, 12, 1.66, .4),
            overline: _(u, 12, 2.66, 1, lr)
        };
        return Ft(At({
            htmlFontSize: v,
            pxToRem: x,
            round: sr,
            fontFamily: i,
            fontSize: a,
            fontWeightLight: l,
            fontWeightRegular: u,
            fontWeightMedium: p,
            fontWeightBold: h
        }, C), b, {clone: !1})
    }

    function dr()
    {
        return ["".concat(arguments.length <= 0 ? void 0 : arguments[0], "px ").concat(arguments.length <= 1 ? void 0 : arguments[1], "px ").concat(arguments.length <= 2 ? void 0 : arguments[2], "px ").concat(arguments.length <= 3 ? void 0 : arguments[3], "px rgba(0,0,0,").concat(.2, ")"), "".concat(arguments.length <= 4 ? void 0 : arguments[4], "px ").concat(arguments.length <= 5 ? void 0 : arguments[5], "px ").concat(arguments.length <= 6 ? void 0 : arguments[6], "px ").concat(arguments.length <= 7 ? void 0 : arguments[7], "px rgba(0,0,0,").concat(.14, ")"), "".concat(arguments.length <= 8 ? void 0 : arguments[8], "px ").concat(arguments.length <= 9 ? void 0 : arguments[9], "px ").concat(arguments.length <= 10 ? void 0 : arguments[10], "px ").concat(arguments.length <= 11 ? void 0 : arguments[11], "px rgba(0,0,0,").concat(.12, ")")].join(",")
    }

    var pr = ["none", dr(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), dr(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), dr(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), dr(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), dr(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), dr(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), dr(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), dr(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), dr(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), dr(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), dr(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), dr(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), dr(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), dr(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), dr(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), dr(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), dr(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), dr(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), dr(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), dr(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), dr(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), dr(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), dr(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), dr(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)],
        fr = {borderRadius: 4};

    function hr()
    {
        var e, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 8;
        if (t.mui) return t;
        e = "function" == typeof t ? t : function (e)
        {
            return t * e
        };
        var n = function ()
        {
            for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
            return 0 === n.length ? e(1) : 1 === n.length ? e(n[0]) : n.map((function (t)
            {
                var n = e(t);
                return "number" == typeof n ? "".concat(n, "px") : n
            })).join(" ")
        };
        return Object.defineProperty(n, "unit", {
            get: function ()
            {
                return t
            }
        }), n.mui = !0, n
    }

    var mr = {
        easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
        easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
        easeIn: "cubic-bezier(0.4, 0, 1, 1)",
        sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
    }, vr = {
        shortest: 150,
        shorter: 200,
        short: 250,
        standard: 300,
        complex: 375,
        enteringScreen: 225,
        leavingScreen: 195
    };

    function gr(e)
    {
        return "".concat(Math.round(e), "ms")
    }

    var yr = {
        easing: mr, duration: vr, create: function ()
        {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ["all"],
                t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = t.duration,
                r = void 0 === n ? vr.standard : n, i = t.easing, o = void 0 === i ? mr.easeInOut : i, a = t.delay,
                s = void 0 === a ? 0 : a;
            zt(t, ["duration", "easing", "delay"]);
            return (Array.isArray(e) ? e : [e]).map((function (e)
            {
                return "".concat(e, " ").concat("string" == typeof r ? r : gr(r), " ").concat(o, " ").concat("string" == typeof s ? s : gr(s))
            })).join(",")
        }, getAutoHeightDuration: function (e)
        {
            if (!e) return 0;
            var t = e / 36;
            return Math.round(10 * (4 + 15 * Math.pow(t, .25) + t / 5))
        }
    }, br = {
        mobileStepper: 1e3,
        speedDial: 1050,
        appBar: 1100,
        drawer: 1200,
        modal: 1300,
        snackbar: 1400,
        tooltip: 1500
    };

    function wr()
    {
        for (var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e.breakpoints, n = void 0 === t ? {} : t, r = e.mixins, i = void 0 === r ? {} : r, o = e.palette, a = void 0 === o ? {} : o, s = e.spacing, l = e.typography, c = void 0 === l ? {} : l, u = zt(e, ["breakpoints", "mixins", "palette", "spacing", "typography"]), d = ar(a), p = Kn(n), f = hr(s), h = Ft({
            breakpoints: p,
            direction: "ltr",
            mixins: Yn(p, f, i),
            overrides: {},
            palette: d,
            props: {},
            shadows: pr,
            typography: ur(d, c),
            spacing: f,
            shape: fr,
            transitions: yr,
            zIndex: br
        }, u), m = arguments.length, v = new Array(m > 1 ? m - 1 : 0), g = 1; g < m; g++) v[g - 1] = arguments[g];
        return h = v.reduce((function (e, t)
        {
            return Ft(e, t)
        }), h)
    }

    function xr(e)
    {
        var t = e.theme, n = e.name, r = e.props;
        if (!t || !t.props || !t.props[n]) return r;
        var i, o = t.props[n];
        for (i in o) void 0 === r[i] && (r[i] = o[i]);
        return r
    }

    var _r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e)
        {
            return typeof e
        } : function (e)
        {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        },
        Cr = "object" === ("undefined" == typeof window ? "undefined" : _r(window)) && "object" === ("undefined" == typeof document ? "undefined" : _r(document)) && 9 === document.nodeType;

    function Er(e, t)
    {
        for (var n = 0; n < t.length; n++)
        {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r)
        }
    }

    function Sr(e, t, n)
    {
        return t && Er(e.prototype, t), n && Er(e, n), e
    }

    function kr(e, t)
    {
        e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t
    }

    function Tr(e)
    {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e
    }

    var Or = {}.constructor;

    function Mr(e)
    {
        if (null == e || "object" != typeof e) return e;
        if (Array.isArray(e)) return e.map(Mr);
        if (e.constructor !== Or) return e;
        var t = {};
        for (var n in e) t[n] = Mr(e[n]);
        return t
    }

    function Rr(e, t, n)
    {
        void 0 === e && (e = "unnamed");
        var r = n.jss, i = Mr(t), o = r.plugins.onCreateRule(e, i, n);
        return o || (e[0], null)
    }

    var Pr = function (e, t)
    {
        for (var n = "", r = 0; r < e.length && "!important" !== e[r]; r++) n && (n += t), n += e[r];
        return n
    };

    function zr(e, t)
    {
        if (void 0 === t && (t = !1), !Array.isArray(e)) return e;
        var n = "";
        if (Array.isArray(e[0])) for (var r = 0; r < e.length && "!important" !== e[r]; r++) n && (n += ", "), n += Pr(e[r], " "); else n = Pr(e, ", ");
        return t || "!important" !== e[e.length - 1] || (n += " !important"), n
    }

    function Ir(e, t)
    {
        for (var n = "", r = 0; r < t; r++) n += "  ";
        return n + e
    }

    function Ar(e, t, n)
    {
        void 0 === n && (n = {});
        var r = "";
        if (!t) return r;
        var i = n.indent, o = void 0 === i ? 0 : i, a = t.fallbacks;
        if (e && o++, a) if (Array.isArray(a)) for (var s = 0; s < a.length; s++)
        {
            var l = a[s];
            for (var c in l)
            {
                var u = l[c];
                null != u && (r && (r += "\n"), r += "" + Ir(c + ": " + zr(u) + ";", o))
            }
        } else for (var d in a)
        {
            var p = a[d];
            null != p && (r && (r += "\n"), r += "" + Ir(d + ": " + zr(p) + ";", o))
        }
        for (var f in t)
        {
            var h = t[f];
            null != h && "fallbacks" !== f && (r && (r += "\n"), r += "" + Ir(f + ": " + zr(h) + ";", o))
        }
        return (r || n.allowEmpty) && e ? (r && (r = "\n" + r + "\n"), Ir(e + " {" + r, --o) + Ir("}", o)) : r
    }

    var Lr = /([[\].#*$><+~=|^:(),"'`\s])/g, Dr = "undefined" != typeof CSS && CSS.escape, Nr = function (e)
        {
            return Dr ? Dr(e) : e.replace(Lr, "\\$1")
        }, Fr = function ()
        {
            function e(e, t, n)
            {
                this.type = "style", this.key = void 0, this.isProcessed = !1, this.style = void 0, this.renderer = void 0, this.renderable = void 0, this.options = void 0;
                var r = n.sheet, i = n.Renderer;
                this.key = e, this.options = n, this.style = t, r ? this.renderer = r.renderer : i && (this.renderer = new i)
            }

            return e.prototype.prop = function (e, t, n)
            {
                if (void 0 === t) return this.style[e];
                var r = !!n && n.force;
                if (!r && this.style[e] === t) return this;
                var i = t;
                n && !1 === n.process || (i = this.options.jss.plugins.onChangeValue(t, e, this));
                var o = null == i || !1 === i, a = e in this.style;
                if (o && !a && !r) return this;
                var s = o && a;
                if (s ? delete this.style[e] : this.style[e] = i, this.renderable && this.renderer) return s ? this.renderer.removeProperty(this.renderable, e) : this.renderer.setProperty(this.renderable, e, i), this;
                var l = this.options.sheet;
                return l && l.attached, this
            }, e
        }(), Br = function (e)
        {
            function t(t, n, r)
            {
                var i;
                (i = e.call(this, t, n, r) || this).selectorText = void 0, i.id = void 0, i.renderable = void 0;
                var o = r.selector, a = r.scoped, s = r.sheet, l = r.generateId;
                return o ? i.selectorText = o : !1 !== a && (i.id = l(Tr(Tr(i)), s), i.selectorText = "." + Nr(i.id)), i
            }

            kr(t, e);
            var n = t.prototype;
            return n.applyTo = function (e)
            {
                var t = this.renderer;
                if (t)
                {
                    var n = this.toJSON();
                    for (var r in n) t.setProperty(e, r, n[r])
                }
                return this
            }, n.toJSON = function ()
            {
                var e = {};
                for (var t in this.style)
                {
                    var n = this.style[t];
                    "object" != typeof n ? e[t] = n : Array.isArray(n) && (e[t] = zr(n))
                }
                return e
            }, n.toString = function (e)
            {
                var t = this.options.sheet, n = !!t && t.options.link ? At({}, e, {allowEmpty: !0}) : e;
                return Ar(this.selectorText, this.style, n)
            }, Sr(t, [{
                key: "selector", set: function (e)
                {
                    if (e !== this.selectorText)
                    {
                        this.selectorText = e;
                        var t = this.renderer, n = this.renderable;
                        if (n && t) t.setSelector(n, e) || t.replaceRule(n, this)
                    }
                }, get: function ()
                {
                    return this.selectorText
                }
            }]), t
        }(Fr), Wr = {
            onCreateRule: function (e, t, n)
            {
                return "@" === e[0] || n.parent && "keyframes" === n.parent.type ? null : new Br(e, t, n)
            }
        }, $r = {indent: 1, children: !0}, Hr = /@([\w-]+)/, jr = function ()
        {
            function e(e, t, n)
            {
                this.type = "conditional", this.at = void 0, this.key = void 0, this.query = void 0, this.rules = void 0, this.options = void 0, this.isProcessed = !1, this.renderable = void 0, this.key = e, this.query = n.name;
                var r = e.match(Hr);
                for (var i in this.at = r ? r[1] : "unknown", this.options = n, this.rules = new di(At({}, n, {parent: this})), t) this.rules.add(i, t[i]);
                this.rules.process()
            }

            var t = e.prototype;
            return t.getRule = function (e)
            {
                return this.rules.get(e)
            }, t.indexOf = function (e)
            {
                return this.rules.indexOf(e)
            }, t.addRule = function (e, t, n)
            {
                var r = this.rules.add(e, t, n);
                return r ? (this.options.jss.plugins.onProcessRule(r), r) : null
            }, t.toString = function (e)
            {
                if (void 0 === e && (e = $r), null == e.indent && (e.indent = $r.indent), null == e.children && (e.children = $r.children), !1 === e.children) return this.query + " {}";
                var t = this.rules.toString(e);
                return t ? this.query + " {\n" + t + "\n}" : ""
            }, e
        }(), Vr = /@media|@supports\s+/, qr = {
            onCreateRule: function (e, t, n)
            {
                return Vr.test(e) ? new jr(e, t, n) : null
            }
        }, Ur = {indent: 1, children: !0}, Gr = /@keyframes\s+([\w-]+)/, Zr = function ()
        {
            function e(e, t, n)
            {
                this.type = "keyframes", this.at = "@keyframes", this.key = void 0, this.name = void 0, this.id = void 0, this.rules = void 0, this.options = void 0, this.isProcessed = !1, this.renderable = void 0;
                var r = e.match(Gr);
                r && r[1] ? this.name = r[1] : this.name = "noname", this.key = this.type + "-" + this.name, this.options = n;
                var i = n.scoped, o = n.sheet, a = n.generateId;
                for (var s in this.id = !1 === i ? this.name : Nr(a(this, o)), this.rules = new di(At({}, n, {parent: this})), t) this.rules.add(s, t[s], At({}, n, {parent: this}));
                this.rules.process()
            }

            return e.prototype.toString = function (e)
            {
                if (void 0 === e && (e = Ur), null == e.indent && (e.indent = Ur.indent), null == e.children && (e.children = Ur.children), !1 === e.children) return this.at + " " + this.id + " {}";
                var t = this.rules.toString(e);
                return t && (t = "\n" + t + "\n"), this.at + " " + this.id + " {" + t + "}"
            }, e
        }(), Kr = /@keyframes\s+/, Yr = /\$([\w-]+)/g, Xr = function (e, t)
        {
            return "string" == typeof e ? e.replace(Yr, (function (e, n)
            {
                return n in t ? t[n] : e
            })) : e
        }, Jr = function (e, t, n)
        {
            var r = e[t], i = Xr(r, n);
            i !== r && (e[t] = i)
        }, Qr = {
            onCreateRule: function (e, t, n)
            {
                return "string" == typeof e && Kr.test(e) ? new Zr(e, t, n) : null
            }, onProcessStyle: function (e, t, n)
            {
                return "style" === t.type && n ? ("animation-name" in e && Jr(e, "animation-name", n.keyframes), "animation" in e && Jr(e, "animation", n.keyframes), e) : e
            }, onChangeValue: function (e, t, n)
            {
                var r = n.options.sheet;
                if (!r) return e;
                switch (t)
                {
                    case"animation":
                    case"animation-name":
                        return Xr(e, r.keyframes);
                    default:
                        return e
                }
            }
        }, ei = function (e)
        {
            function t()
            {
                for (var t, n = arguments.length, r = new Array(n), i = 0; i < n; i++) r[i] = arguments[i];
                return (t = e.call.apply(e, [this].concat(r)) || this).renderable = void 0, t
            }

            return kr(t, e), t.prototype.toString = function (e)
            {
                var t = this.options.sheet, n = !!t && t.options.link ? At({}, e, {allowEmpty: !0}) : e;
                return Ar(this.key, this.style, n)
            }, t
        }(Fr), ti = {
            onCreateRule: function (e, t, n)
            {
                return n.parent && "keyframes" === n.parent.type ? new ei(e, t, n) : null
            }
        }, ni = function ()
        {
            function e(e, t, n)
            {
                this.type = "font-face", this.at = "@font-face", this.key = void 0, this.style = void 0, this.options = void 0, this.isProcessed = !1, this.renderable = void 0, this.key = e, this.style = t, this.options = n
            }

            return e.prototype.toString = function (e)
            {
                if (Array.isArray(this.style))
                {
                    for (var t = "", n = 0; n < this.style.length; n++) t += Ar(this.key, this.style[n]), this.style[n + 1] && (t += "\n");
                    return t
                }
                return Ar(this.key, this.style, e)
            }, e
        }(), ri = {
            onCreateRule: function (e, t, n)
            {
                return "@font-face" === e ? new ni(e, t, n) : null
            }
        }, ii = function ()
        {
            function e(e, t, n)
            {
                this.type = "viewport", this.at = "@viewport", this.key = void 0, this.style = void 0, this.options = void 0, this.isProcessed = !1, this.renderable = void 0, this.key = e, this.style = t, this.options = n
            }

            return e.prototype.toString = function (e)
            {
                return Ar(this.key, this.style, e)
            }, e
        }(), oi = {
            onCreateRule: function (e, t, n)
            {
                return "@viewport" === e || "@-ms-viewport" === e ? new ii(e, t, n) : null
            }
        }, ai = function ()
        {
            function e(e, t, n)
            {
                this.type = "simple", this.key = void 0, this.value = void 0, this.options = void 0, this.isProcessed = !1, this.renderable = void 0, this.key = e, this.value = t, this.options = n
            }

            return e.prototype.toString = function (e)
            {
                if (Array.isArray(this.value))
                {
                    for (var t = "", n = 0; n < this.value.length; n++) t += this.key + " " + this.value[n] + ";", this.value[n + 1] && (t += "\n");
                    return t
                }
                return this.key + " " + this.value + ";"
            }, e
        }(), si = {"@charset": !0, "@import": !0, "@namespace": !0}, li = [Wr, qr, Qr, ti, ri, oi, {
            onCreateRule: function (e, t, n)
            {
                return e in si ? new ai(e, t, n) : null
            }
        }], ci = {process: !0}, ui = {force: !0, process: !0}, di = function ()
        {
            function e(e)
            {
                this.map = {}, this.raw = {}, this.index = [], this.counter = 0, this.options = void 0, this.classes = void 0, this.keyframes = void 0, this.options = e, this.classes = e.classes, this.keyframes = e.keyframes
            }

            var t = e.prototype;
            return t.add = function (e, t, n)
            {
                var r = this.options, i = r.parent, o = r.sheet, a = r.jss, s = r.Renderer, l = r.generateId, c = r.scoped,
                    u = At({
                        classes: this.classes,
                        parent: i,
                        sheet: o,
                        jss: a,
                        Renderer: s,
                        generateId: l,
                        scoped: c,
                        name: e
                    }, n), d = e;
                e in this.raw && (d = e + "-d" + this.counter++), this.raw[d] = t, d in this.classes && (u.selector = "." + Nr(this.classes[d]));
                var p = Rr(d, t, u);
                if (!p) return null;
                this.register(p);
                var f = void 0 === u.index ? this.index.length : u.index;
                return this.index.splice(f, 0, p), p
            }, t.get = function (e)
            {
                return this.map[e]
            }, t.remove = function (e)
            {
                this.unregister(e), delete this.raw[e.key], this.index.splice(this.index.indexOf(e), 1)
            }, t.indexOf = function (e)
            {
                return this.index.indexOf(e)
            }, t.process = function ()
            {
                var e = this.options.jss.plugins;
                this.index.slice(0).forEach(e.onProcessRule, e)
            }, t.register = function (e)
            {
                this.map[e.key] = e, e instanceof Br ? (this.map[e.selector] = e, e.id && (this.classes[e.key] = e.id)) : e instanceof Zr && this.keyframes && (this.keyframes[e.name] = e.id)
            }, t.unregister = function (e)
            {
                delete this.map[e.key], e instanceof Br ? (delete this.map[e.selector], delete this.classes[e.key]) : e instanceof Zr && delete this.keyframes[e.name]
            }, t.update = function ()
            {
                var e, t, n;
                if ("string" == typeof (arguments.length <= 0 ? void 0 : arguments[0]) ? (e = arguments.length <= 0 ? void 0 : arguments[0], t = arguments.length <= 1 ? void 0 : arguments[1], n = arguments.length <= 2 ? void 0 : arguments[2]) : (t = arguments.length <= 0 ? void 0 : arguments[0], n = arguments.length <= 1 ? void 0 : arguments[1], e = null), e) this.updateOne(this.map[e], t, n); else for (var r = 0; r < this.index.length; r++) this.updateOne(this.index[r], t, n)
            }, t.updateOne = function (t, n, r)
            {
                void 0 === r && (r = ci);
                var i = this.options, o = i.jss.plugins, a = i.sheet;
                if (t.rules instanceof e) t.rules.update(n, r); else
                {
                    var s = t, l = s.style;
                    if (o.onUpdate(n, t, a, r), r.process && l && l !== s.style)
                    {
                        for (var c in o.onProcessStyle(s.style, s, a), s.style)
                        {
                            var u = s.style[c];
                            u !== l[c] && s.prop(c, u, ui)
                        }
                        for (var d in l)
                        {
                            var p = s.style[d], f = l[d];
                            null == p && p !== f && s.prop(d, null, ui)
                        }
                    }
                }
            }, t.toString = function (e)
            {
                for (var t = "", n = this.options.sheet, r = !!n && n.options.link, i = 0; i < this.index.length; i++)
                {
                    var o = this.index[i].toString(e);
                    (o || r) && (t && (t += "\n"), t += o)
                }
                return t
            }, e
        }(), pi = function ()
        {
            function e(e, t)
            {
                for (var n in this.options = void 0, this.deployed = void 0, this.attached = void 0, this.rules = void 0, this.renderer = void 0, this.classes = void 0, this.keyframes = void 0, this.queue = void 0, this.attached = !1, this.deployed = !1, this.classes = {}, this.keyframes = {}, this.options = At({}, t, {
                    sheet: this,
                    parent: this,
                    classes: this.classes,
                    keyframes: this.keyframes
                }), t.Renderer && (this.renderer = new t.Renderer(this)), this.rules = new di(this.options), e) this.rules.add(n, e[n]);
                this.rules.process()
            }

            var t = e.prototype;
            return t.attach = function ()
            {
                return this.attached || (this.renderer && this.renderer.attach(), this.attached = !0, this.deployed || this.deploy()), this
            }, t.detach = function ()
            {
                return this.attached ? (this.renderer && this.renderer.detach(), this.attached = !1, this) : this
            }, t.addRule = function (e, t, n)
            {
                var r = this.queue;
                this.attached && !r && (this.queue = []);
                var i = this.rules.add(e, t, n);
                return i ? (this.options.jss.plugins.onProcessRule(i), this.attached ? this.deployed ? (r ? r.push(i) : (this.insertRule(i), this.queue && (this.queue.forEach(this.insertRule, this), this.queue = void 0)), i) : i : (this.deployed = !1, i)) : null
            }, t.insertRule = function (e)
            {
                this.renderer && this.renderer.insertRule(e)
            }, t.addRules = function (e, t)
            {
                var n = [];
                for (var r in e)
                {
                    var i = this.addRule(r, e[r], t);
                    i && n.push(i)
                }
                return n
            }, t.getRule = function (e)
            {
                return this.rules.get(e)
            }, t.deleteRule = function (e)
            {
                var t = "object" == typeof e ? e : this.rules.get(e);
                return !!t && (this.rules.remove(t), !(this.attached && t.renderable && this.renderer) || this.renderer.deleteRule(t.renderable))
            }, t.indexOf = function (e)
            {
                return this.rules.indexOf(e)
            }, t.deploy = function ()
            {
                return this.renderer && this.renderer.deploy(), this.deployed = !0, this
            }, t.update = function ()
            {
                var e;
                return (e = this.rules).update.apply(e, arguments), this
            }, t.updateOne = function (e, t, n)
            {
                return this.rules.updateOne(e, t, n), this
            }, t.toString = function (e)
            {
                return this.rules.toString(e)
            }, e
        }(), fi = function ()
        {
            function e()
            {
                this.plugins = {internal: [], external: []}, this.registry = void 0
            }

            var t = e.prototype;
            return t.onCreateRule = function (e, t, n)
            {
                for (var r = 0; r < this.registry.onCreateRule.length; r++)
                {
                    var i = this.registry.onCreateRule[r](e, t, n);
                    if (i) return i
                }
                return null
            }, t.onProcessRule = function (e)
            {
                if (!e.isProcessed)
                {
                    for (var t = e.options.sheet, n = 0; n < this.registry.onProcessRule.length; n++) this.registry.onProcessRule[n](e, t);
                    e.style && this.onProcessStyle(e.style, e, t), e.isProcessed = !0
                }
            }, t.onProcessStyle = function (e, t, n)
            {
                for (var r = 0; r < this.registry.onProcessStyle.length; r++) t.style = this.registry.onProcessStyle[r](t.style, t, n)
            }, t.onProcessSheet = function (e)
            {
                for (var t = 0; t < this.registry.onProcessSheet.length; t++) this.registry.onProcessSheet[t](e)
            }, t.onUpdate = function (e, t, n, r)
            {
                for (var i = 0; i < this.registry.onUpdate.length; i++) this.registry.onUpdate[i](e, t, n, r)
            }, t.onChangeValue = function (e, t, n)
            {
                for (var r = e, i = 0; i < this.registry.onChangeValue.length; i++) r = this.registry.onChangeValue[i](r, t, n);
                return r
            }, t.use = function (e, t)
            {
                void 0 === t && (t = {queue: "external"});
                var n = this.plugins[t.queue];
                -1 === n.indexOf(e) && (n.push(e), this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce((function (e, t)
                {
                    for (var n in t) n in e && e[n].push(t[n]);
                    return e
                }), {
                    onCreateRule: [],
                    onProcessRule: [],
                    onProcessStyle: [],
                    onProcessSheet: [],
                    onChangeValue: [],
                    onUpdate: []
                }))
            }, e
        }(), hi = new (function ()
        {
            function e()
            {
                this.registry = []
            }

            var t = e.prototype;
            return t.add = function (e)
            {
                var t = this.registry, n = e.options.index;
                if (-1 === t.indexOf(e)) if (0 === t.length || n >= this.index) t.push(e); else for (var r = 0; r < t.length; r++) if (t[r].options.index > n) return void t.splice(r, 0, e)
            }, t.reset = function ()
            {
                this.registry = []
            }, t.remove = function (e)
            {
                var t = this.registry.indexOf(e);
                this.registry.splice(t, 1)
            }, t.toString = function (e)
            {
                for (var t = void 0 === e ? {} : e, n = t.attached, r = Pt(t, ["attached"]), i = "", o = 0; o < this.registry.length; o++)
                {
                    var a = this.registry[o];
                    null != n && a.attached !== n || (i && (i += "\n"), i += a.toString(r))
                }
                return i
            }, Sr(e, [{
                key: "index", get: function ()
                {
                    return 0 === this.registry.length ? 0 : this.registry[this.registry.length - 1].options.index
                }
            }]), e
        }()),
        mi = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
    null == mi["2f1acc6c3a606b082e5eef5e54414ffb"] && (mi["2f1acc6c3a606b082e5eef5e54414ffb"] = 0);
    var vi = mi["2f1acc6c3a606b082e5eef5e54414ffb"]++, gi = function (e)
    {
        void 0 === e && (e = {});
        var t = 0;
        return function (n, r)
        {
            t += 1;
            var i = "", o = "";
            return r && (r.options.classNamePrefix && (o = r.options.classNamePrefix), null != r.options.jss.id && (i = String(r.options.jss.id))), e.minify ? "" + (o || "c") + vi + i + t : o + n.key + "-" + vi + (i ? "-" + i : "") + "-" + t
        }
    }, yi = function (e)
    {
        var t;
        return function ()
        {
            return t || (t = e()), t
        }
    };

    function bi(e, t)
    {
        try
        {
            return e.attributeStyleMap ? e.attributeStyleMap.get(t) : e.style.getPropertyValue(t)
        } catch (e)
        {
            return ""
        }
    }

    function wi(e, t, n)
    {
        try
        {
            var r = n;
            if (Array.isArray(n) && (r = zr(n, !0), "!important" === n[n.length - 1])) return e.style.setProperty(t, r, "important"), !0;
            e.attributeStyleMap ? e.attributeStyleMap.set(t, r) : e.style.setProperty(t, r)
        } catch (e)
        {
            return !1
        }
        return !0
    }

    function xi(e, t)
    {
        try
        {
            e.attributeStyleMap ? e.attributeStyleMap.delete(t) : e.style.removeProperty(t)
        } catch (e)
        {
        }
    }

    function _i(e, t)
    {
        return e.selectorText = t, e.selectorText === t
    }

    var Ci = yi((function ()
    {
        return document.querySelector("head")
    }));

    function Ei(e)
    {
        var t = hi.registry;
        if (t.length > 0)
        {
            var n = function (e, t)
            {
                for (var n = 0; n < e.length; n++)
                {
                    var r = e[n];
                    if (r.attached && r.options.index > t.index && r.options.insertionPoint === t.insertionPoint) return r
                }
                return null
            }(t, e);
            if (n && n.renderer) return {parent: n.renderer.element.parentNode, node: n.renderer.element};
            if ((n = function (e, t)
            {
                for (var n = e.length - 1; n >= 0; n--)
                {
                    var r = e[n];
                    if (r.attached && r.options.insertionPoint === t.insertionPoint) return r
                }
                return null
            }(t, e)) && n.renderer) return {parent: n.renderer.element.parentNode, node: n.renderer.element.nextSibling}
        }
        var r = e.insertionPoint;
        if (r && "string" == typeof r)
        {
            var i = function (e)
            {
                for (var t = Ci(), n = 0; n < t.childNodes.length; n++)
                {
                    var r = t.childNodes[n];
                    if (8 === r.nodeType && r.nodeValue.trim() === e) return r
                }
                return null
            }(r);
            if (i) return {parent: i.parentNode, node: i.nextSibling}
        }
        return !1
    }

    var Si = yi((function ()
    {
        var e = document.querySelector('meta[property="csp-nonce"]');
        return e ? e.getAttribute("content") : null
    })), ki = function (e, t, n)
    {
        var r = e.cssRules.length;
        (void 0 === n || n > r) && (n = r);
        try
        {
            if ("insertRule" in e) e.insertRule(t, n); else if ("appendRule" in e)
            {
                e.appendRule(t)
            }
        } catch (e)
        {
            return !1
        }
        return e.cssRules[n]
    }, Ti = function ()
    {
        function e(e)
        {
            this.getPropertyValue = bi, this.setProperty = wi, this.removeProperty = xi, this.setSelector = _i, this.element = void 0, this.sheet = void 0, this.hasInsertedRules = !1, e && hi.add(e), this.sheet = e;
            var t, n = this.sheet ? this.sheet.options : {}, r = n.media, i = n.meta, o = n.element;
            this.element = o || ((t = document.createElement("style")).textContent = "\n", t), this.element.setAttribute("data-jss", ""), r && this.element.setAttribute("media", r), i && this.element.setAttribute("data-meta", i);
            var a = Si();
            a && this.element.setAttribute("nonce", a)
        }

        var t = e.prototype;
        return t.attach = function ()
        {
            if (!this.element.parentNode && this.sheet)
            {
                !function (e, t)
                {
                    var n = t.insertionPoint, r = Ei(t);
                    if (!1 !== r && r.parent) r.parent.insertBefore(e, r.node); else if (n && "number" == typeof n.nodeType)
                    {
                        var i = n, o = i.parentNode;
                        o && o.insertBefore(e, i.nextSibling)
                    } else Ci().appendChild(e)
                }(this.element, this.sheet.options);
                var e = Boolean(this.sheet && this.sheet.deployed);
                this.hasInsertedRules && e && (this.hasInsertedRules = !1, this.deploy())
            }
        }, t.detach = function ()
        {
            var e = this.element.parentNode;
            e && e.removeChild(this.element)
        }, t.deploy = function ()
        {
            var e = this.sheet;
            e && (e.options.link ? this.insertRules(e.rules) : this.element.textContent = "\n" + e.toString() + "\n")
        }, t.insertRules = function (e, t)
        {
            for (var n = 0; n < e.index.length; n++) this.insertRule(e.index[n], n, t)
        }, t.insertRule = function (e, t, n)
        {
            if (void 0 === n && (n = this.element.sheet), e.rules)
            {
                var r = e, i = n;
                return ("conditional" !== e.type && "keyframes" !== e.type || !1 !== (i = ki(n, r.toString({children: !1}), t))) && (this.insertRules(r.rules, i), i)
            }
            if (e.renderable && e.renderable.parentStyleSheet === this.element.sheet) return e.renderable;
            var o = e.toString();
            if (!o) return !1;
            var a = ki(n, o, t);
            return !1 !== a && (this.hasInsertedRules = !0, e.renderable = a, a)
        }, t.deleteRule = function (e)
        {
            var t = this.element.sheet, n = this.indexOf(e);
            return -1 !== n && (t.deleteRule(n), !0)
        }, t.indexOf = function (e)
        {
            for (var t = this.element.sheet.cssRules, n = 0; n < t.length; n++) if (e === t[n]) return n;
            return -1
        }, t.replaceRule = function (e, t)
        {
            var n = this.indexOf(e);
            return -1 !== n && (this.element.sheet.deleteRule(n), this.insertRule(t, n))
        }, t.getRules = function ()
        {
            return this.element.sheet.cssRules
        }, e
    }(), Oi = 0, Mi = function ()
    {
        function e(e)
        {
            this.id = Oi++, this.version = "10.0.4", this.plugins = new fi, this.options = {
                id: {minify: !1},
                createGenerateId: gi,
                Renderer: Cr ? Ti : null,
                plugins: []
            }, this.generateId = gi({minify: !1});
            for (var t = 0; t < li.length; t++) this.plugins.use(li[t], {queue: "internal"});
            this.setup(e)
        }

        var t = e.prototype;
        return t.setup = function (e)
        {
            return void 0 === e && (e = {}), e.createGenerateId && (this.options.createGenerateId = e.createGenerateId), e.id && (this.options.id = At({}, this.options.id, e.id)), (e.createGenerateId || e.id) && (this.generateId = this.options.createGenerateId(this.options.id)), null != e.insertionPoint && (this.options.insertionPoint = e.insertionPoint), "Renderer" in e && (this.options.Renderer = e.Renderer), e.plugins && this.use.apply(this, e.plugins), this
        }, t.createStyleSheet = function (e, t)
        {
            void 0 === t && (t = {});
            var n = t.index;
            "number" != typeof n && (n = 0 === hi.index ? 0 : hi.index + 1);
            var r = new pi(e, At({}, t, {
                jss: this,
                generateId: t.generateId || this.generateId,
                insertionPoint: this.options.insertionPoint,
                Renderer: this.options.Renderer,
                index: n
            }));
            return this.plugins.onProcessSheet(r), r
        }, t.removeStyleSheet = function (e)
        {
            return e.detach(), hi.remove(e), this
        }, t.createRule = function (e, t, n)
        {
            if (void 0 === t && (t = {}), void 0 === n && (n = {}), "object" == typeof e) return this.createRule(void 0, e, t);
            var r = At({}, n, {name: e, jss: this, Renderer: this.options.Renderer});
            r.generateId || (r.generateId = this.generateId), r.classes || (r.classes = {}), r.keyframes || (r.keyframes = {});
            var i = Rr(e, t, r);
            return i && this.plugins.onProcessRule(i), i
        }, t.use = function ()
        {
            for (var e = this, t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
            return n.forEach((function (t)
            {
                e.plugins.use(t)
            })), this
        }, e
    }();

    function Ri(e)
    {
        var t = null;
        for (var n in e)
        {
            var r = e[n], i = typeof r;
            if ("function" === i) t || (t = {}), t[n] = r; else if ("object" === i && null !== r && !Array.isArray(r))
            {
                var o = Ri(r);
                o && (t || (t = {}), t[n] = o)
            }
        }
        return t
    }

    var Pi = "undefined" != typeof CSS && CSS && "number" in CSS, zi = function (e)
    {
        return new Mi(e)
    };
    /**
     * A better abstraction over CSS.
     *
     * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
     * @website https://github.com/cssinjs/jss
     * @license MIT
     */zi();

    function Ii()
    {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e.baseClasses,
            n = e.newClasses;
        e.Component;
        if (!n) return t;
        var r = At({}, t);
        return Object.keys(n).forEach((function (e)
        {
            n[e] && (r[e] = "".concat(t[e], " ").concat(n[e]))
        })), r
    }

    var Ai = function (e, t, n, r)
    {
        var i = e.get(t);
        i || (i = new Map, e.set(t, i)), i.set(n, r)
    }, Li = function (e, t, n)
    {
        var r = e.get(t);
        return r ? r.get(n) : void 0
    }, Di = function (e, t, n)
    {
        e.get(t).delete(n)
    }, Ni = lt.createContext(null);

    function Fi()
    {
        return lt.useContext(Ni)
    }

    var Bi = "function" == typeof Symbol && Symbol.for ? Symbol.for("mui.nested") : "__THEME_NESTED__",
        Wi = ["checked", "disabled", "error", "focused", "focusVisible", "required", "expanded", "selected"];
    var $i = Date.now(), Hi = "fnValues" + $i, ji = "fnStyle" + ++$i;
    var Vi = "@global", qi = "@global ", Ui = function ()
    {
        function e(e, t, n)
        {
            for (var r in this.type = "global", this.at = Vi, this.rules = void 0, this.options = void 0, this.key = void 0, this.isProcessed = !1, this.key = e, this.options = n, this.rules = new di(At({}, n, {parent: this})), t) this.rules.add(r, t[r]);
            this.rules.process()
        }

        var t = e.prototype;
        return t.getRule = function (e)
        {
            return this.rules.get(e)
        }, t.addRule = function (e, t, n)
        {
            var r = this.rules.add(e, t, n);
            return this.options.jss.plugins.onProcessRule(r), r
        }, t.indexOf = function (e)
        {
            return this.rules.indexOf(e)
        }, t.toString = function ()
        {
            return this.rules.toString()
        }, e
    }(), Gi = function ()
    {
        function e(e, t, n)
        {
            this.type = "global", this.at = Vi, this.options = void 0, this.rule = void 0, this.isProcessed = !1, this.key = void 0, this.key = e, this.options = n;
            var r = e.substr(qi.length);
            this.rule = n.jss.createRule(r, t, At({}, n, {parent: this}))
        }

        return e.prototype.toString = function (e)
        {
            return this.rule ? this.rule.toString(e) : ""
        }, e
    }(), Zi = /\s*,\s*/g;

    function Ki(e, t)
    {
        for (var n = e.split(Zi), r = "", i = 0; i < n.length; i++) r += t + " " + n[i].trim(), n[i + 1] && (r += ", ");
        return r
    }

    function Yi()
    {
        return {
            onCreateRule: function (e, t, n)
            {
                if (!e) return null;
                if (e === Vi) return new Ui(e, t, n);
                if ("@" === e[0] && e.substr(0, qi.length) === qi) return new Gi(e, t, n);
                var r = n.parent;
                return r && ("global" === r.type || r.options.parent && "global" === r.options.parent.type) && (n.scoped = !1), !1 === n.scoped && (n.selector = e), null
            }, onProcessRule: function (e)
            {
                "style" === e.type && (function (e)
                {
                    var t = e.options, n = e.style, r = n ? n["@global"] : null;
                    if (r)
                    {
                        for (var i in r) t.sheet.addRule(i, r[i], At({}, t, {selector: Ki(i, e.selector)}));
                        delete n["@global"]
                    }
                }(e), function (e)
                {
                    var t = e.options, n = e.style;
                    for (var r in n) if ("@" === r[0] && r.substr(0, Vi.length) === Vi)
                    {
                        var i = Ki(r.substr(Vi.length), e.selector);
                        t.sheet.addRule(i, n[r], At({}, t, {selector: i})), delete n[r]
                    }
                }(e))
            }
        }
    }

    var Xi = /\s*,\s*/g, Ji = /&/g, Qi = /\$([\w-]+)/g;

    function eo()
    {
        function e(e, t)
        {
            return function (n, r)
            {
                var i = e.getRule(r) || t && t.getRule(r);
                return i ? (i = i).selector : r
            }
        }

        function t(e, t)
        {
            for (var n = t.split(Xi), r = e.split(Xi), i = "", o = 0; o < n.length; o++) for (var a = n[o], s = 0; s < r.length; s++)
            {
                var l = r[s];
                i && (i += ", "), i += -1 !== l.indexOf("&") ? l.replace(Ji, a) : a + " " + l
            }
            return i
        }

        function n(e, t, n)
        {
            if (n) return At({}, n, {index: n.index + 1});
            var r = e.options.nestingLevel;
            r = void 0 === r ? 1 : r + 1;
            var i = At({}, e.options, {nestingLevel: r, index: t.indexOf(e) + 1});
            return delete i.name, i
        }

        return {
            onProcessStyle: function (r, i, o)
            {
                if ("style" !== i.type) return r;
                var a, s, l = i, c = l.options.parent;
                for (var u in r)
                {
                    var d = -1 !== u.indexOf("&"), p = "@" === u[0];
                    if (d || p)
                    {
                        if (a = n(l, c, a), d)
                        {
                            var f = t(u, l.selector);
                            s || (s = e(c, o)), f = f.replace(Qi, s), c.addRule(f, r[u], At({}, a, {selector: f}))
                        } else p && c.addRule(u, {}, a).addRule(l.key, r[u], {selector: l.selector});
                        delete r[u]
                    }
                }
                return r
            }
        }
    }

    var to = /[A-Z]/g, no = /^ms-/, ro = {};

    function io(e)
    {
        return "-" + e.toLowerCase()
    }

    function oo(e)
    {
        if (ro.hasOwnProperty(e)) return ro[e];
        var t = e.replace(to, io);
        return ro[e] = no.test(t) ? "-" + t : t
    }

    function ao(e)
    {
        var t = {};
        for (var n in e)
        {
            t[0 === n.indexOf("--") ? n : oo(n)] = e[n]
        }
        return e.fallbacks && (Array.isArray(e.fallbacks) ? t.fallbacks = e.fallbacks.map(ao) : t.fallbacks = ao(e.fallbacks)), t
    }

    var so = Pi && CSS ? CSS.px : "px", lo = Pi && CSS ? CSS.ms : "ms", co = Pi && CSS ? CSS.percent : "%";

    function uo(e)
    {
        var t = /(-[a-z])/g, n = function (e)
        {
            return e[1].toUpperCase()
        }, r = {};
        for (var i in e) r[i] = e[i], r[i.replace(t, n)] = e[i];
        return r
    }

    var po = uo({
        "animation-delay": lo,
        "animation-duration": lo,
        "background-position": so,
        "background-position-x": so,
        "background-position-y": so,
        "background-size": so,
        border: so,
        "border-bottom": so,
        "border-bottom-left-radius": so,
        "border-bottom-right-radius": so,
        "border-bottom-width": so,
        "border-left": so,
        "border-left-width": so,
        "border-radius": so,
        "border-right": so,
        "border-right-width": so,
        "border-top": so,
        "border-top-left-radius": so,
        "border-top-right-radius": so,
        "border-top-width": so,
        "border-width": so,
        margin: so,
        "margin-bottom": so,
        "margin-left": so,
        "margin-right": so,
        "margin-top": so,
        padding: so,
        "padding-bottom": so,
        "padding-left": so,
        "padding-right": so,
        "padding-top": so,
        "mask-position-x": so,
        "mask-position-y": so,
        "mask-size": so,
        height: so,
        width: so,
        "min-height": so,
        "max-height": so,
        "min-width": so,
        "max-width": so,
        bottom: so,
        left: so,
        top: so,
        right: so,
        "box-shadow": so,
        "text-shadow": so,
        "column-gap": so,
        "column-rule": so,
        "column-rule-width": so,
        "column-width": so,
        "font-size": so,
        "font-size-delta": so,
        "letter-spacing": so,
        "text-indent": so,
        "text-stroke": so,
        "text-stroke-width": so,
        "word-spacing": so,
        motion: so,
        "motion-offset": so,
        outline: so,
        "outline-offset": so,
        "outline-width": so,
        perspective: so,
        "perspective-origin-x": co,
        "perspective-origin-y": co,
        "transform-origin": co,
        "transform-origin-x": co,
        "transform-origin-y": co,
        "transform-origin-z": co,
        "transition-delay": lo,
        "transition-duration": lo,
        "vertical-align": so,
        "flex-basis": so,
        "shape-margin": so,
        size: so,
        grid: so,
        "grid-gap": so,
        "grid-row-gap": so,
        "grid-column-gap": so,
        "grid-template-rows": so,
        "grid-template-columns": so,
        "grid-auto-rows": so,
        "grid-auto-columns": so,
        "box-shadow-x": so,
        "box-shadow-y": so,
        "box-shadow-blur": so,
        "box-shadow-spread": so,
        "font-line-height": so,
        "text-shadow-x": so,
        "text-shadow-y": so,
        "text-shadow-blur": so
    });

    function fo(e, t, n)
    {
        if (!t) return t;
        if (Array.isArray(t)) for (var r = 0; r < t.length; r++) t[r] = fo(e, t[r], n); else if ("object" == typeof t) if ("fallbacks" === e) for (var i in t) t[i] = fo(i, t[i], n); else for (var o in t) t[o] = fo(e + "-" + o, t[o], n); else if ("number" == typeof t) return n[e] ? "" + t + n[e] : po[e] ? "function" == typeof po[e] ? po[e](t).toString() : "" + t + po[e] : t.toString();
        return t
    }

    function ho(e)
    {
        void 0 === e && (e = {});
        var t = uo(e);
        return {
            onProcessStyle: function (e, n)
            {
                if ("style" !== n.type) return e;
                for (var r in e) e[r] = fo(r, e[r], t);
                return e
            }, onChangeValue: function (e, n)
            {
                return fo(n, e, t)
            }
        }
    }

    function mo(e)
    {
        return function (e)
        {
            if (Array.isArray(e))
            {
                for (var t = 0, n = new Array(e.length); t < e.length; t++) n[t] = e[t];
                return n
            }
        }(e) || function (e)
        {
            if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e)
        }(e) || function ()
        {
            throw new TypeError("Invalid attempt to spread non-iterable instance")
        }()
    }

    var vo = "", go = "", yo = "", bo = Cr && "ontouchstart" in document.documentElement;
    if (Cr)
    {
        var wo = {Moz: "-moz-", ms: "-ms-", O: "-o-", Webkit: "-webkit-"}, xo = document.createElement("p").style;
        for (var _o in wo) if (_o + "Transform" in xo)
        {
            vo = _o, go = wo[_o];
            break
        }
        "Webkit" === vo && "msHyphens" in xo && (vo = "ms", go = wo.ms, "edge"), "Webkit" === vo && "-apple-trailing-word" in xo && (yo = "apple")
    }
    var Co = vo, Eo = go, So = yo, ko = bo;
    var To = {
        noPrefill: ["appearance"], supportedProperty: function (e)
        {
            return "appearance" === e && ("ms" === Co ? "-webkit-" + e : Eo + e)
        }
    }, Oo = {
        noPrefill: ["color-adjust"], supportedProperty: function (e)
        {
            return "color-adjust" === e && ("Webkit" === Co ? Eo + "print-" + e : e)
        }
    }, Mo = /[-\s]+(.)?/g;

    function Ro(e, t)
    {
        return t ? t.toUpperCase() : ""
    }

    function Po(e)
    {
        return e.replace(Mo, Ro)
    }

    function zo(e)
    {
        return Po("-" + e)
    }

    var Io, Ao = {
        noPrefill: ["mask"], supportedProperty: function (e, t)
        {
            if (!/^mask/.test(e)) return !1;
            if ("Webkit" === Co)
            {
                var n = "mask-image";
                if (Po(n) in t) return e;
                if (Co + zo(n) in t) return Eo + e
            }
            return e
        }
    }, Lo = {
        noPrefill: ["text-orientation"], supportedProperty: function (e)
        {
            return "text-orientation" === e && ("apple" !== So || ko ? e : Eo + e)
        }
    }, Do = {
        noPrefill: ["transform"], supportedProperty: function (e, t, n)
        {
            return "transform" === e && (n.transform ? e : Eo + e)
        }
    }, No = {
        noPrefill: ["transition"], supportedProperty: function (e, t, n)
        {
            return "transition" === e && (n.transition ? e : Eo + e)
        }
    }, Fo = {
        noPrefill: ["writing-mode"], supportedProperty: function (e)
        {
            return "writing-mode" === e && ("Webkit" === Co || "ms" === Co ? Eo + e : e)
        }
    }, Bo = {
        noPrefill: ["user-select"], supportedProperty: function (e)
        {
            return "user-select" === e && ("Moz" === Co || "ms" === Co || "apple" === So ? Eo + e : e)
        }
    }, Wo = {
        supportedProperty: function (e, t)
        {
            return !!/^break-/.test(e) && ("Webkit" === Co ? "WebkitColumn" + zo(e) in t && Eo + "column-" + e : "Moz" === Co && ("page" + zo(e) in t && "page-" + e))
        }
    }, $o = {
        supportedProperty: function (e, t)
        {
            if (!/^(border|margin|padding)-inline/.test(e)) return !1;
            if ("Moz" === Co) return e;
            var n = e.replace("-inline", "");
            return Co + zo(n) in t && Eo + n
        }
    }, Ho = {
        supportedProperty: function (e, t)
        {
            return Po(e) in t && e
        }
    }, jo = {
        supportedProperty: function (e, t)
        {
            var n = zo(e);
            return "-" === e[0] || "-" === e[0] && "-" === e[1] ? e : Co + n in t ? Eo + e : "Webkit" !== Co && "Webkit" + n in t && "-webkit-" + e
        }
    }, Vo = {
        supportedProperty: function (e)
        {
            return "scroll-snap" === e.substring(0, 11) && ("ms" === Co ? "" + Eo + e : e)
        }
    }, qo = {
        supportedProperty: function (e)
        {
            return "overscroll-behavior" === e && ("ms" === Co ? Eo + "scroll-chaining" : e)
        }
    }, Uo = {
        "flex-grow": "flex-positive",
        "flex-shrink": "flex-negative",
        "flex-basis": "flex-preferred-size",
        "justify-content": "flex-pack",
        order: "flex-order",
        "align-items": "flex-align",
        "align-content": "flex-line-pack"
    }, Go = {
        supportedProperty: function (e, t)
        {
            var n = Uo[e];
            return !!n && (Co + zo(n) in t && Eo + n)
        }
    }, Zo = {
        flex: "box-flex",
        "flex-grow": "box-flex",
        "flex-direction": ["box-orient", "box-direction"],
        order: "box-ordinal-group",
        "align-items": "box-align",
        "flex-flow": ["box-orient", "box-direction"],
        "justify-content": "box-pack"
    }, Ko = Object.keys(Zo), Yo = function (e)
    {
        return Eo + e
    }, Xo = [To, Oo, Ao, Lo, Do, No, Fo, Bo, Wo, $o, Ho, jo, Vo, qo, Go, {
        supportedProperty: function (e, t, n)
        {
            var r = n.multiple;
            if (Ko.indexOf(e) > -1)
            {
                var i = Zo[e];
                if (!Array.isArray(i)) return Co + zo(i) in t && Eo + i;
                if (!r) return !1;
                for (var o = 0; o < i.length; o++) if (!(Co + zo(i[0]) in t)) return !1;
                return i.map(Yo)
            }
            return !1
        }
    }], Jo = Xo.filter((function (e)
    {
        return e.supportedProperty
    })).map((function (e)
    {
        return e.supportedProperty
    })), Qo = Xo.filter((function (e)
    {
        return e.noPrefill
    })).reduce((function (e, t)
    {
        return e.push.apply(e, mo(t.noPrefill)), e
    }), []), ea = {};
    if (Cr)
    {
        Io = document.createElement("p");
        var ta = window.getComputedStyle(document.documentElement, "");
        for (var na in ta) isNaN(na) || (ea[ta[na]] = ta[na]);
        Qo.forEach((function (e)
        {
            return delete ea[e]
        }))
    }

    function ra(e, t)
    {
        if (void 0 === t && (t = {}), !Io) return e;
        if (null != ea[e]) return ea[e];
        "transition" !== e && "transform" !== e || (t[e] = e in Io.style);
        for (var n = 0; n < Jo.length && (ea[e] = Jo[n](e, Io.style, t), !ea[e]); n++) ;
        try
        {
            Io.style[e] = ""
        } catch (e)
        {
            return !1
        }
        return ea[e]
    }

    var ia, oa = {},
        aa = {transition: 1, "transition-property": 1, "-webkit-transition": 1, "-webkit-transition-property": 1},
        sa = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;

    function la(e, t, n)
    {
        if ("var" === t) return "var";
        if ("all" === t) return "all";
        if ("all" === n) return ", all";
        var r = t ? ra(t) : ", " + ra(n);
        return r || (t || n)
    }

    function ca(e, t)
    {
        var n = t;
        if (!ia || "content" === e) return t;
        if ("string" != typeof n || !isNaN(parseInt(n, 10))) return n;
        var r = e + n;
        if (null != oa[r]) return oa[r];
        try
        {
            ia.style[e] = n
        } catch (e)
        {
            return oa[r] = !1, !1
        }
        if (aa[e]) n = n.replace(sa, la); else if ("" === ia.style[e] && ("-ms-flex" === (n = Eo + n) && (ia.style[e] = "-ms-flexbox"), ia.style[e] = n, "" === ia.style[e])) return oa[r] = !1, !1;
        return ia.style[e] = "", oa[r] = n, oa[r]
    }

    function ua()
    {
        function e(t)
        {
            for (var n in t)
            {
                var r = t[n];
                if ("fallbacks" === n && Array.isArray(r)) t[n] = r.map(e); else
                {
                    var i = !1, o = ra(n);
                    o && o !== n && (i = !0);
                    var a = !1, s = ca(o, zr(r));
                    s && s !== r && (a = !0), (i || a) && (i && delete t[n], t[o || n] = s || r)
                }
            }
            return t
        }

        return {
            onProcessRule: function (e)
            {
                if ("keyframes" === e.type)
                {
                    var t = e;
                    t.at = "-" === (n = t.at)[1] || "ms" === Co ? n : "@" + Eo + "keyframes" + n.substr(10)
                }
                var n
            }, onProcessStyle: function (t, n)
            {
                return "style" !== n.type ? t : e(t)
            }, onChangeValue: function (e, t)
            {
                return ca(t, zr(e)) || e
            }
        }
    }

    function da()
    {
        return {
            plugins: [{
                onCreateRule: function (e, t, n)
                {
                    if ("function" != typeof t) return null;
                    var r = Rr(e, {}, n);
                    return r[ji] = t, r
                }, onProcessStyle: function (e, t)
                {
                    if (Hi in t || ji in t) return e;
                    var n = {};
                    for (var r in e)
                    {
                        var i = e[r];
                        "function" == typeof i && (delete e[r], n[r] = i)
                    }
                    return t[Hi] = n, e
                }, onUpdate: function (e, t, n, r)
                {
                    var i = t, o = i[ji];
                    o && (i.style = o(e) || {});
                    var a = i[Hi];
                    if (a) for (var s in a) i.prop(s, a[s](e), r)
                }
            }, Yi(), eo(), {
                onProcessStyle: function (e)
                {
                    if (Array.isArray(e))
                    {
                        for (var t = 0; t < e.length; t++) e[t] = ao(e[t]);
                        return e
                    }
                    return ao(e)
                }, onChangeValue: function (e, t, n)
                {
                    if (0 === t.indexOf("--")) return e;
                    var r = oo(t);
                    return t === r ? e : (n.prop(r, e), null)
                }
            }, ho(), "undefined" == typeof window ? null : ua(), (e = function (e, t)
            {
                return e.length === t.length ? e > t ? 1 : -1 : e.length - t.length
            }, {
                onProcessStyle: function (t, n)
                {
                    if ("style" !== n.type) return t;
                    for (var r = {}, i = Object.keys(t).sort(e), o = 0; o < i.length; o++) r[i[o]] = t[i[o]];
                    return r
                }
            })]
        };
        var e
    }

    Cr && (ia = document.createElement("p"));
    var pa = zi(da()), fa = {
        disableGeneration: !1, generateClassName: function ()
        {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e.disableGlobal,
                n = void 0 !== t && t, r = e.productionPrefix, i = void 0 === r ? "pwzrjss" : r, o = e.seed,
                a = void 0 === o ? "" : o, s = "" === a ? "" : "".concat(a, "-"), l = 0;
            return function (e, t)
            {
                l += 1;
                var r = t.options.name;
                if (r && 0 === r.indexOf("Pwzr") && !t.options.link && !n)
                {
                    if (-1 !== Wi.indexOf(e.key)) return "Pwzr-".concat(e.key);
                    var o = "".concat(s).concat(r, "-").concat(e.key);
                    return t.options.theme[Bi] && "" === a ? "".concat(o, "-").concat(l) : o
                }
                return "".concat(s).concat(i).concat(l)
            }
        }(), jss: pa, sheetsCache: null, sheetsManager: new Map, sheetsRegistry: null
    }, ha = lt.createContext(fa);
    r({}, "StylesContext", (function ()
    {
        return ha
    }));
    var ma = -1e9;

    function va()
    {
        return ma += 1
    }

    var ga = {};

    function ya(e)
    {
        var t = "function" == typeof e;
        return {
            create: function (n, r)
            {
                var i;
                try
                {
                    i = t ? e(n) : e
                } catch (e)
                {
                    throw e
                }
                if (!r || !n.overrides || !n.overrides[r]) return i;
                var o = n.overrides[r], a = At({}, i);
                return Object.keys(o).forEach((function (e)
                {
                    a[e] = Ft(a[e], o[e])
                })), a
            }, options: {}
        }
    }

    function ba(e, t, n)
    {
        var r = e.state;
        if (e.stylesOptions.disableGeneration) return t || {};
        r.cacheClasses || (r.cacheClasses = {value: null, lastProp: null, lastJSS: {}});
        var i = !1;
        return r.classes !== r.cacheClasses.lastJSS && (r.cacheClasses.lastJSS = r.classes, i = !0), t !== r.cacheClasses.lastProp && (r.cacheClasses.lastProp = t, i = !0), i && (r.cacheClasses.value = Ii({
            baseClasses: r.cacheClasses.lastJSS,
            newClasses: t,
            Component: n
        })), r.cacheClasses.value
    }

    function wa(e, t)
    {
        var n = e.state, r = e.theme, i = e.stylesOptions, o = e.stylesCreator, a = e.name;
        if (!i.disableGeneration)
        {
            var s = Li(i.sheetsManager, o, r);
            s || (s = {refs: 0, staticSheet: null, dynamicStyles: null}, Ai(i.sheetsManager, o, r, s));
            var l = At({}, o.options, {}, i, {
                theme: r,
                flip: "boolean" == typeof i.flip ? i.flip : "rtl" === r.direction
            });
            l.generateId = l.serverGenerateClassName || l.generateClassName;
            var c = i.sheetsRegistry;
            if (0 === s.refs)
            {
                var u;
                i.sheetsCache && (u = Li(i.sheetsCache, o, r));
                var d = o.create(r, a);
                u || ((u = i.jss.createStyleSheet(d, At({link: !1}, l))).attach(), i.sheetsCache && Ai(i.sheetsCache, o, r, u)), c && c.add(u), s.staticSheet = u, s.dynamicStyles = Ri(d)
            }
            if (s.dynamicStyles)
            {
                var p = i.jss.createStyleSheet(s.dynamicStyles, At({link: !0}, l));
                p.update(t), p.attach(), n.dynamicSheet = p, n.classes = Ii({
                    baseClasses: s.staticSheet.classes,
                    newClasses: p.classes
                }), c && c.add(p)
            } else n.classes = s.staticSheet.classes;
            s.refs += 1
        }
    }

    function xa(e, t)
    {
        var n = e.state;
        n.dynamicSheet && n.dynamicSheet.update(t)
    }

    function _a(e)
    {
        var t = e.state, n = e.theme, r = e.stylesOptions, i = e.stylesCreator;
        if (!r.disableGeneration)
        {
            var o = Li(r.sheetsManager, i, n);
            o.refs -= 1;
            var a = r.sheetsRegistry;
            0 === o.refs && (Di(r.sheetsManager, i, n), r.jss.removeStyleSheet(o.staticSheet), a && a.remove(o.staticSheet)), t.dynamicSheet && (r.jss.removeStyleSheet(t.dynamicSheet), a && a.remove(t.dynamicSheet))
        }
    }

    function Ca(e, t)
    {
        var n, r = lt.useRef([]), i = lt.useMemo((function ()
        {
            return {}
        }), t);
        r.current !== i && (r.current = i, n = e()), lt.useEffect((function ()
        {
            return function ()
            {
                n && n()
            }
        }), [i])
    }

    function Ea(e)
    {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = t.name, r = t.classNamePrefix,
            i = t.Component, o = t.defaultTheme, a = void 0 === o ? ga : o,
            s = zt(t, ["name", "classNamePrefix", "Component", "defaultTheme"]), l = ya(e), c = n || r || "makeStyles";
        return l.options = {index: va(), name: n, meta: c, classNamePrefix: c}, function ()
        {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = Fi() || a,
                r = At({}, lt.useContext(ha), {}, s), o = lt.useRef(), c = lt.useRef();
            return Ca((function ()
            {
                var i = {name: n, state: {}, stylesCreator: l, stylesOptions: r, theme: t};
                return wa(i, e), c.current = !1, o.current = i, function ()
                {
                    _a(i)
                }
            }), [t, l]), lt.useEffect((function ()
            {
                c.current && xa(o.current, e), c.current = !0
            })), ba(o.current, e.classes, i)
        }
    }

    function Sa(e)
    {
        var t, n, r = "";
        if (e) if ("object" == typeof e) if (e.push) for (t = 0; t < e.length; t++) e[t] && (n = Sa(e[t])) && (r && (r += " "), r += n); else for (t in e) e[t] && (n = Sa(t)) && (r && (r += " "), r += n); else "boolean" == typeof e || e.call || (r && (r += " "), r += e);
        return r
    }

    var ka = function ()
        {
            for (var e, t = 0, n = ""; t < arguments.length;) (e = Sa(arguments[t++])) && (n && (n += " "), n += e);
            return n
        }, Ta = {
            childContextTypes: !0,
            contextType: !0,
            contextTypes: !0,
            defaultProps: !0,
            displayName: !0,
            getDefaultProps: !0,
            getDerivedStateFromError: !0,
            getDerivedStateFromProps: !0,
            mixins: !0,
            propTypes: !0,
            type: !0
        }, Oa = {name: !0, length: !0, prototype: !0, caller: !0, callee: !0, arguments: !0, arity: !0},
        Ma = {$$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0}, Ra = {};

    function Pa(e)
    {
        return Gn.isMemo(e) ? Ma : Ra[e.$$typeof] || Ta
    }

    Ra[Gn.ForwardRef] = {$$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0}, Ra[Gn.Memo] = Ma;
    var za = Object.defineProperty, Ia = Object.getOwnPropertyNames, Aa = Object.getOwnPropertySymbols,
        La = Object.getOwnPropertyDescriptor, Da = Object.getPrototypeOf, Na = Object.prototype;
    var Fa = t((function e(t, n, r)
    {
        if ("string" != typeof n)
        {
            if (Na)
            {
                var i = Da(n);
                i && i !== Na && e(t, i, r)
            }
            var o = Ia(n);
            Aa && (o = o.concat(Aa(n)));
            for (var a = Pa(t), s = Pa(n), l = 0; l < o.length; ++l)
            {
                var c = o[l];
                if (!(Oa[c] || r && r[c] || s && s[c] || a && a[c]))
                {
                    var u = La(n, c);
                    try
                    {
                        za(t, c, u)
                    } catch (e)
                    {
                    }
                }
            }
        }
        return t
    }));

    function Ba(e, t)
    {
        var n = {};
        return Object.keys(e).forEach((function (r)
        {
            -1 === t.indexOf(r) && (n[r] = e[r])
        })), n
    }

    function Wa(e)
    {
        var t = e.children, n = e.theme, r = Fi();
        var i = lt.useMemo((function ()
        {
            var e = null === r ? n : function (e, t)
            {
                if ("function" == typeof t)
                {
                    return t(e)
                }
                return At({}, e, {}, t)
            }(r, n);
            return null != e && (e[Bi] = null !== r), e
        }), [n, r]);
        return lt.createElement(Ni.Provider, {value: i}, t)
    }

    var $a = function (e)
    {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return function (n)
        {
            var r = t.defaultTheme, i = t.withTheme, o = void 0 !== i && i, a = t.name,
                s = zt(t, ["defaultTheme", "withTheme", "name"]);
            var l = a, c = Ea(e, At({defaultTheme: r, Component: n, name: a || n.displayName, classNamePrefix: l}, s)),
                u = lt.forwardRef((function (e, t)
                {
                    e.classes;
                    var i, s = e.innerRef, l = zt(e, ["classes", "innerRef"]), u = c(e), d = l;
                    return ("string" == typeof a || o) && (i = Fi() || r, a && (d = xr({
                        theme: i,
                        name: a,
                        props: l
                    })), o && !d.theme && (d.theme = i)), lt.createElement(n, At({ref: s || t, classes: u}, d))
                }));
            return u.defaultProps = n.defaultProps, Fa(u, n), u
        }
    }, Ha = wr();

    function ja(e)
    {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return Ea(e, At({defaultTheme: Ha}, t))
    }

    function Va()
    {
        return Fi() || Ha
    }

    function qa(e, t)
    {
        return t ? Ft(e, t, {clone: !1}) : e
    }

    var Ua = {xs: 0, sm: 600, md: 960, lg: 1280, xl: 1920}, Ga = {
        keys: ["xs", "sm", "md", "lg", "xl"], up: function (e)
        {
            return "@media (min-width:".concat(Ua[e], "px)")
        }
    };

    function Za(e, t, n)
    {
        if (Array.isArray(t))
        {
            var r = e.theme.breakpoints || Ga;
            return t.reduce((function (e, i, o)
            {
                return e[r.up(r.keys[o])] = n(t[o]), e
            }), {})
        }
        if ("object" === Dt(t))
        {
            var i = e.theme.breakpoints || Ga;
            return Object.keys(t).reduce((function (e, r)
            {
                return e[i.up(r)] = n(t[r]), e
            }), {})
        }
        return n(t)
    }

    function Ka(e, t)
    {
        return t && "string" == typeof t ? t.split(".").reduce((function (e, t)
        {
            return e && e[t] ? e[t] : null
        }), e) : null
    }

    function Ya(e)
    {
        var t = e.prop, n = e.cssProperty, r = void 0 === n ? e.prop : n, i = e.themeKey, o = e.transform,
            a = function (e)
            {
                if (null == e[t]) return null;
                var n = e[t], a = Ka(e.theme, i) || {};
                return Za(e, n, (function (e)
                {
                    var t;
                    return "function" == typeof a ? t = a(e) : Array.isArray(a) ? t = a[e] || e : (t = Ka(a, e) || e, o && (t = o(t))), !1 === r ? t : Rt({}, r, t)
                }))
            };
        return a.propTypes = {}, a.filterProps = [t], a
    }

    function Xa()
    {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
        var r = function (e)
        {
            return t.reduce((function (t, n)
            {
                var r = n(e);
                return r ? qa(t, r) : t
            }), {})
        };
        return r.propTypes = {}, r.filterProps = t.reduce((function (e, t)
        {
            return e.concat(t.filterProps)
        }), []), r
    }

    function Ja(e)
    {
        return "number" != typeof e ? e : "".concat(e, "px solid")
    }

    var Qa = Xa(Ya({prop: "border", themeKey: "borders", transform: Ja}), Ya({
        prop: "borderTop",
        themeKey: "borders",
        transform: Ja
    }), Ya({prop: "borderRight", themeKey: "borders", transform: Ja}), Ya({
        prop: "borderBottom",
        themeKey: "borders",
        transform: Ja
    }), Ya({prop: "borderLeft", themeKey: "borders", transform: Ja}), Ya({
        prop: "borderColor",
        themeKey: "palette"
    }), Ya({prop: "borderRadius", themeKey: "shape"}));
    var es = Xa(Ya({
            prop: "displayPrint", cssProperty: !1, transform: function (e)
            {
                return {"@media print": {display: e}}
            }
        }), Ya({prop: "display"}), Ya({prop: "overflow"}), Ya({prop: "textOverflow"}), Ya({prop: "visibility"}), Ya({prop: "whiteSpace"})),
        ts = Xa(Ya({prop: "flexBasis"}), Ya({prop: "flexDirection"}), Ya({prop: "flexWrap"}), Ya({prop: "justifyContent"}), Ya({prop: "alignItems"}), Ya({prop: "alignContent"}), Ya({prop: "order"}), Ya({prop: "flex"}), Ya({prop: "flexGrow"}), Ya({prop: "flexShrink"}), Ya({prop: "alignSelf"}), Ya({prop: "justifyItems"}), Ya({prop: "justifySelf"})),
        ns = Xa(Ya({prop: "gridGap"}), Ya({prop: "gridColumnGap"}), Ya({prop: "gridRowGap"}), Ya({prop: "gridColumn"}), Ya({prop: "gridRow"}), Ya({prop: "gridAutoFlow"}), Ya({prop: "gridAutoColumns"}), Ya({prop: "gridAutoRows"}), Ya({prop: "gridTemplateColumns"}), Ya({prop: "gridTemplateRows"}), Ya({prop: "gridTemplateAreas"}), Ya({prop: "gridArea"})),
        rs = Xa(Ya({prop: "color", themeKey: "palette"}), Ya({
            prop: "bgcolor",
            cssProperty: "backgroundColor",
            themeKey: "palette"
        })), is = Xa(Ya({prop: "position"}), Ya({
            prop: "zIndex",
            themeKey: "zIndex"
        }), Ya({prop: "top"}), Ya({prop: "right"}), Ya({prop: "bottom"}), Ya({prop: "left"})),
        os = Ya({prop: "boxShadow", themeKey: "shadows"});

    function as(e)
    {
        return e <= 1 ? "".concat(100 * e, "%") : e
    }

    var ss = Ya({prop: "width", transform: as}), ls = Ya({prop: "maxWidth", transform: as}),
        cs = Ya({prop: "minWidth", transform: as}), us = Ya({prop: "height", transform: as}),
        ds = Ya({prop: "maxHeight", transform: as}), ps = Ya({prop: "minHeight", transform: as}),
        fs = (Ya({prop: "size", cssProperty: "width", transform: as}), Ya({
            prop: "size",
            cssProperty: "height",
            transform: as
        }), Xa(ss, ls, cs, us, ds, ps, Ya({prop: "boxSizing"})));

    function hs(e, t)
    {
        return function (e)
        {
            if (Array.isArray(e)) return e
        }(e) || function (e, t)
        {
            if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e))
            {
                var n = [], r = !0, i = !1, o = void 0;
                try
                {
                    for (var a, s = e[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) ;
                } catch (e)
                {
                    i = !0, o = e
                } finally
                {
                    try
                    {
                        r || null == s.return || s.return()
                    } finally
                    {
                        if (i) throw o
                    }
                }
                return n
            }
        }(e, t) || function ()
        {
            throw new TypeError("Invalid attempt to destructure non-iterable instance")
        }()
    }

    var ms, vs, gs = {m: "margin", p: "padding"},
        ys = {t: "Top", r: "Right", b: "Bottom", l: "Left", x: ["Left", "Right"], y: ["Top", "Bottom"]},
        bs = {marginX: "mx", marginY: "my", paddingX: "px", paddingY: "py"}, ws = (ms = function (e)
        {
            if (e.length > 2)
            {
                if (!bs[e]) return [e];
                e = bs[e]
            }
            var t = hs(e.split(""), 2), n = t[0], r = t[1], i = gs[n], o = ys[r] || "";
            return Array.isArray(o) ? o.map((function (e)
            {
                return i + e
            })) : [i + o]
        }, vs = {}, function (e)
        {
            return void 0 === vs[e] && (vs[e] = ms(e)), vs[e]
        }),
        xs = ["m", "mt", "mr", "mb", "ml", "mx", "my", "p", "pt", "pr", "pb", "pl", "px", "py", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY"];

    function _s(e, t)
    {
        return function (n)
        {
            return e.reduce((function (e, r)
            {
                return e[r] = function (e, t)
                {
                    if ("string" == typeof t) return t;
                    var n = e(Math.abs(t));
                    return t >= 0 ? n : "number" == typeof n ? -n : "-".concat(n)
                }(t, n), e
            }), {})
        }
    }

    function Cs(e)
    {
        var t = function (e)
        {
            var t = e.spacing || 8;
            return "number" == typeof t ? function (e)
            {
                return t * e
            } : Array.isArray(t) ? function (e)
            {
                return t[e]
            } : "function" == typeof t ? t : function ()
            {
            }
        }(e.theme);
        return Object.keys(e).map((function (n)
        {
            if (-1 === xs.indexOf(n)) return null;
            var r = _s(ws(n), t), i = e[n];
            return Za(e, i, r)
        })).reduce(qa, {})
    }

    Cs.propTypes = {}, Cs.filterProps = xs;
    var Es, Ss, ks, Ts = Xa(Ya({prop: "fontFamily", themeKey: "typography"}), Ya({
            prop: "fontSize",
            themeKey: "typography"
        }), Ya({prop: "fontStyle", themeKey: "typography"}), Ya({
            prop: "fontWeight",
            themeKey: "typography"
        }), Ya({prop: "letterSpacing"}), Ya({prop: "lineHeight"}), Ya({prop: "textAlign"})),
        Os = (Es = Xa(Qa, es, ts, ns, is, rs, os, fs, Cs, Ts), (Ss = function (e)
        {
            var t = Es(e);
            return e.css ? At({}, qa(t, Es(At({theme: e.theme}, e.css))), {}, function (e, t)
            {
                var n = {};
                return Object.keys(e).forEach((function (r)
                {
                    -1 === t.indexOf(r) && (n[r] = e[r])
                })), n
            }(e.css, [Es.filterProps])) : t
        }).propTypes = {}, Ss.filterProps = ["css"].concat(mo(Es.filterProps)), Ss), Ms = (ks = function (e)
        {
            return function (t)
            {
                var n, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, i = r.name,
                    o = zt(r, ["name"]), a = i, s = Ea("function" == typeof t ? function (e)
                    {
                        return {
                            root: function (n)
                            {
                                return t(At({theme: e}, n))
                            }
                        }
                    } : {root: t}, At({Component: e, name: i || e.displayName, classNamePrefix: a}, o));
                t.filterProps && (n = t.filterProps, delete t.filterProps), t.propTypes && (t.propTypes, delete t.propTypes);
                var l = lt.forwardRef((function (t, r)
                {
                    var i = t.children, o = t.className, a = t.clone, l = t.component,
                        c = zt(t, ["children", "className", "clone", "component"]), u = s(t), d = ka(u.root, o), p = c;
                    if (n && (p = Ba(p, n)), a) return lt.cloneElement(i, At({className: ka(i.props.className, d)}, p));
                    if ("function" == typeof i) return i(At({className: d}, p));
                    var f = l || e;
                    return lt.createElement(f, At({ref: r, className: d}, p), i)
                }));
                return Fa(l, e), l
            }
        }("div"), function (e, t)
        {
            return ks(e, At({defaultTheme: Ha}, t))
        })(Os, {name: "PwzrBox"});

    function Rs(e, t)
    {
        return $a(e, At({defaultTheme: Ha}, t))
    }

    function Ps(e, t)
    {
        "function" == typeof e ? e(t) : e && (e.current = t)
    }

    function zs(e, t)
    {
        return lt.useMemo((function ()
        {
            return null == e && null == t ? null : function (n)
            {
                Ps(e, n), Ps(t, n)
            }
        }), [e, t])
    }

    var Is = "undefined" != typeof window ? lt.useLayoutEffect : lt.useEffect;

    function As(e)
    {
        var t = lt.useRef(e);
        return Is((function ()
        {
            t.current = e
        })), lt.useCallback((function ()
        {
            return t.current.apply(void 0, arguments)
        }), [])
    }

    var Ls = "undefined" != typeof window ? lt.useLayoutEffect : lt.useEffect;

    function Ds(e)
    {
        var t = e.children, n = e.defer, r = void 0 !== n && n, i = e.fallback, o = void 0 === i ? null : i,
            a = lt.useState(!1), s = a[0], l = a[1];
        return Ls((function ()
        {
            r || l(!0)
        }), [r]), lt.useEffect((function ()
        {
            r && l(!0)
        }), [r]), lt.createElement(lt.Fragment, null, s ? t : o)
    }

    var Ns = !0, Fs = !1, Bs = null, Ws = {
        text: !0,
        search: !0,
        url: !0,
        tel: !0,
        email: !0,
        password: !0,
        number: !0,
        date: !0,
        month: !0,
        week: !0,
        time: !0,
        datetime: !0,
        "datetime-local": !0
    };

    function $s(e)
    {
        e.metaKey || e.altKey || e.ctrlKey || (Ns = !0)
    }

    function Hs()
    {
        Ns = !1
    }

    function js()
    {
        "hidden" === this.visibilityState && Fs && (Ns = !0)
    }

    function Vs(e)
    {
        var t, n, r, i = e.target;
        try
        {
            return i.matches(":focus-visible")
        } catch (e)
        {
        }
        return Ns || (n = (t = i).type, !("INPUT" !== (r = t.tagName) || !Ws[n] || t.readOnly) || "TEXTAREA" === r && !t.readOnly || !!t.isContentEditable)
    }

    function qs()
    {
        Fs = !0, window.clearTimeout(Bs), Bs = window.setTimeout((function ()
        {
            Fs = !1
        }), 100)
    }

    function Us()
    {
        return {
            isFocusVisible: Vs, onBlurVisible: qs, ref: lt.useCallback((function (e)
            {
                var t, n = lt.findDOMNode(e);
                null != n && ((t = n.ownerDocument).addEventListener("keydown", $s, !0), t.addEventListener("mousedown", Hs, !0), t.addEventListener("pointerdown", Hs, !0), t.addEventListener("touchstart", Hs, !0), t.addEventListener("visibilitychange", js, !0))
            }), [])
        }
    }

    var Gs = lt.createContext(null);

    function Zs(e, t)
    {
        var n = Object.create(null);
        return e && Me.map(e, (function (e)
        {
            return e
        })).forEach((function (e)
        {
            n[e.key] = function (e)
            {
                return t && nt(e) ? t(e) : e
            }(e)
        })), n
    }

    function Ks(e, t, n)
    {
        return null != n[t] ? n[t] : e.props[t]
    }

    function Ys(e, t, n)
    {
        var r = Zs(e.children), i = function (e, t)
        {
            function n(n)
            {
                return n in t ? t[n] : e[n]
            }

            e = e || {}, t = t || {};
            var r, i = Object.create(null), o = [];
            for (var a in e) a in t ? o.length && (i[a] = o, o = []) : o.push(a);
            var s = {};
            for (var l in t)
            {
                if (i[l]) for (r = 0; r < i[l].length; r++)
                {
                    var c = i[l][r];
                    s[i[l][r]] = n(c)
                }
                s[l] = n(l)
            }
            for (r = 0; r < o.length; r++) s[o[r]] = n(o[r]);
            return s
        }(t, r);
        return Object.keys(i).forEach((function (o)
        {
            var a = i[o];
            if (nt(a))
            {
                var s = o in t, l = o in r, c = t[o], u = nt(c) && !c.props.in;
                !l || s && !u ? l || !s || u ? l && s && nt(c) && (i[o] = rt(a, {
                    onExited: n.bind(null, a),
                    in: c.props.in,
                    exit: Ks(a, "exit", e),
                    enter: Ks(a, "enter", e)
                })) : i[o] = rt(a, {in: !1}) : i[o] = rt(a, {
                    onExited: n.bind(null, a),
                    in: !0,
                    exit: Ks(a, "exit", e),
                    enter: Ks(a, "enter", e)
                })
            }
        })), i
    }

    var Xs = Object.values || function (e)
    {
        return Object.keys(e).map((function (t)
        {
            return e[t]
        }))
    }, Js = function (e)
    {
        function t(t, n)
        {
            var r, i = (r = e.call(this, t, n) || this).handleExited.bind(Tr(Tr(r)));
            return r.state = {contextValue: {isMounting: !0}, handleExited: i, firstRender: !0}, r
        }

        kr(t, e);
        var n = t.prototype;
        return n.componentDidMount = function ()
        {
            this.mounted = !0, this.setState({contextValue: {isMounting: !1}})
        }, n.componentWillUnmount = function ()
        {
            this.mounted = !1
        }, t.getDerivedStateFromProps = function (e, t)
        {
            var n, r, i = t.children, o = t.handleExited;
            return {
                children: t.firstRender ? (n = e, r = o, Zs(n.children, (function (e)
                {
                    return rt(e, {
                        onExited: r.bind(null, e),
                        in: !0,
                        appear: Ks(e, "appear", n),
                        enter: Ks(e, "enter", n),
                        exit: Ks(e, "exit", n)
                    })
                }))) : Ys(e, i, o), firstRender: !1
            }
        }, n.handleExited = function (e, t)
        {
            var n = Zs(this.props.children);
            e.key in n || (e.props.onExited && e.props.onExited(t), this.mounted && this.setState((function (t)
            {
                var n = At({}, t.children);
                return delete n[e.key], {children: n}
            })))
        }, n.render = function ()
        {
            var e = this.props, t = e.component, n = e.childFactory, r = Pt(e, ["component", "childFactory"]),
                i = this.state.contextValue, o = Xs(this.state.children).map(n);
            return delete r.appear, delete r.enter, delete r.exit, null === t ? lt.createElement(Gs.Provider, {value: i}, o) : lt.createElement(Gs.Provider, {value: i}, lt.createElement(t, r, o))
        }, t
    }(lt.Component);
    Js.propTypes = {}, Js.defaultProps = {
        component: "div", childFactory: function (e)
        {
            return e
        }
    };
    var Qs = !1, el = "unmounted", tl = "exited", nl = "entering", rl = "entered", il = "exiting", ol = function (e)
    {
        function t(t, n)
        {
            var r;
            r = e.call(this, t, n) || this;
            var i, o = n && !n.isMounting ? t.enter : t.appear;
            return r.appearStatus = null, t.in ? o ? (i = tl, r.appearStatus = nl) : i = rl : i = t.unmountOnExit || t.mountOnEnter ? el : tl, r.state = {status: i}, r.nextCallback = null, r
        }

        kr(t, e), t.getDerivedStateFromProps = function (e, t)
        {
            return e.in && t.status === el ? {status: tl} : null
        };
        var n = t.prototype;
        return n.componentDidMount = function ()
        {
            this.updateStatus(!0, this.appearStatus)
        }, n.componentDidUpdate = function (e)
        {
            var t = null;
            if (e !== this.props)
            {
                var n = this.state.status;
                this.props.in ? n !== nl && n !== rl && (t = nl) : n !== nl && n !== rl || (t = il)
            }
            this.updateStatus(!1, t)
        }, n.componentWillUnmount = function ()
        {
            this.cancelNextCallback()
        }, n.getTimeouts = function ()
        {
            var e, t, n, r = this.props.timeout;
            return e = t = n = r, null != r && "number" != typeof r && (e = r.exit, t = r.enter, n = void 0 !== r.appear ? r.appear : t), {
                exit: e,
                enter: t,
                appear: n
            }
        }, n.updateStatus = function (e, t)
        {
            if (void 0 === e && (e = !1), null !== t)
            {
                this.cancelNextCallback();
                var n = lt.findDOMNode(this);
                t === nl ? this.performEnter(n, e) : this.performExit(n)
            } else this.props.unmountOnExit && this.state.status === tl && this.setState({status: el})
        }, n.performEnter = function (e, t)
        {
            var n = this, r = this.props.enter, i = this.context ? this.context.isMounting : t, o = this.getTimeouts(),
                a = i ? o.appear : o.enter;
            !t && !r || Qs ? this.safeSetState({status: rl}, (function ()
            {
                n.props.onEntered(e)
            })) : (this.props.onEnter(e, i), this.safeSetState({status: nl}, (function ()
            {
                n.props.onEntering(e, i), n.onTransitionEnd(e, a, (function ()
                {
                    n.safeSetState({status: rl}, (function ()
                    {
                        n.props.onEntered(e, i)
                    }))
                }))
            })))
        }, n.performExit = function (e)
        {
            var t = this, n = this.props.exit, r = this.getTimeouts();
            n && !Qs ? (this.props.onExit(e), this.safeSetState({status: il}, (function ()
            {
                t.props.onExiting(e), t.onTransitionEnd(e, r.exit, (function ()
                {
                    t.safeSetState({status: tl}, (function ()
                    {
                        t.props.onExited(e)
                    }))
                }))
            }))) : this.safeSetState({status: tl}, (function ()
            {
                t.props.onExited(e)
            }))
        }, n.cancelNextCallback = function ()
        {
            null !== this.nextCallback && (this.nextCallback.cancel(), this.nextCallback = null)
        }, n.safeSetState = function (e, t)
        {
            t = this.setNextCallback(t), this.setState(e, t)
        }, n.setNextCallback = function (e)
        {
            var t = this, n = !0;
            return this.nextCallback = function (r)
            {
                n && (n = !1, t.nextCallback = null, e(r))
            }, this.nextCallback.cancel = function ()
            {
                n = !1
            }, this.nextCallback
        }, n.onTransitionEnd = function (e, t, n)
        {
            this.setNextCallback(n);
            var r = null == t && !this.props.addEndListener;
            e && !r ? (this.props.addEndListener && this.props.addEndListener(e, this.nextCallback), null != t && setTimeout(this.nextCallback, t)) : setTimeout(this.nextCallback, 0)
        }, n.render = function ()
        {
            var e = this.state.status;
            if (e === el) return null;
            var t = this.props, n = t.children, r = Pt(t, ["children"]);
            if (delete r.in, delete r.mountOnEnter, delete r.unmountOnExit, delete r.appear, delete r.enter, delete r.exit, delete r.timeout, delete r.addEndListener, delete r.onEnter, delete r.onEntering, delete r.onEntered, delete r.onExit, delete r.onExiting, delete r.onExited, "function" == typeof n) return lt.createElement(Gs.Provider, {value: null}, n(e, r));
            var i = lt.Children.only(n);
            return lt.createElement(Gs.Provider, {value: null}, lt.cloneElement(i, r))
        }, t
    }(lt.Component);

    function al()
    {
    }

    ol.contextType = Gs, ol.propTypes = {}, ol.defaultProps = {
        in: !1,
        mountOnEnter: !1,
        unmountOnExit: !1,
        appear: !1,
        enter: !0,
        exit: !0,
        onEnter: al,
        onEntering: al,
        onEntered: al,
        onExit: al,
        onExiting: al,
        onExited: al
    }, ol.UNMOUNTED = 0, ol.EXITED = 1, ol.ENTERING = 2, ol.ENTERED = 3, ol.EXITING = 4;
    var sl = "undefined" == typeof window ? lt.useEffect : lt.useLayoutEffect;

    function ll(e)
    {
        var t = e.classes, n = e.pulsate, r = void 0 !== n && n, i = e.rippleX, o = e.rippleY, a = e.rippleSize,
            s = e.in, l = e.onExited, c = void 0 === l ? function ()
            {
            } : l, u = e.timeout, d = lt.useState(!1), p = d[0], f = d[1],
            h = ka(t.ripple, t.rippleVisible, r && t.ripplePulsate),
            m = {width: a, height: a, top: -a / 2 + o, left: -a / 2 + i},
            v = ka(t.child, p && t.childLeaving, r && t.childPulsate), g = As(c);
        return sl((function ()
        {
            if (!s)
            {
                f(!0);
                var e = setTimeout(g, u);
                return function ()
                {
                    clearTimeout(e)
                }
            }
        }), [g, s, u]), lt.createElement("span", {className: h, style: m}, lt.createElement("span", {className: v}))
    }

    var cl = lt.forwardRef((function (e, t)
    {
        var n = e.center, r = void 0 !== n && n, i = e.classes, o = e.className,
            a = zt(e, ["center", "classes", "className"]), s = lt.useState([]), l = s[0], c = s[1], u = lt.useRef(0),
            d = lt.useRef(null);
        lt.useEffect((function ()
        {
            d.current && (d.current(), d.current = null)
        }), [l]);
        var p = lt.useRef(!1), f = lt.useRef(null), h = lt.useRef(null), m = lt.useRef(null);
        lt.useEffect((function ()
        {
            return function ()
            {
                clearTimeout(f.current)
            }
        }), []);
        var v = lt.useCallback((function (e)
        {
            var t = e.pulsate, n = e.rippleX, r = e.rippleY, o = e.rippleSize, a = e.cb;
            c((function (e)
            {
                return [].concat(mo(e), [lt.createElement(ll, {
                    key: u.current,
                    classes: i,
                    timeout: 550,
                    pulsate: t,
                    rippleX: n,
                    rippleY: r,
                    rippleSize: o
                })])
            })), u.current += 1, d.current = a
        }), [i]), g = lt.useCallback((function ()
        {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                n = arguments.length > 2 ? arguments[2] : void 0, i = t.pulsate, o = void 0 !== i && i, a = t.center,
                s = void 0 === a ? r || t.pulsate : a, l = t.fakeElement, c = void 0 !== l && l;
            if ("mousedown" === e.type && p.current) p.current = !1; else
            {
                "touchstart" === e.type && (p.current = !0);
                var u, d, g, y = c ? null : m.current,
                    b = y ? y.getBoundingClientRect() : {width: 0, height: 0, left: 0, top: 0};
                if (s || 0 === e.clientX && 0 === e.clientY || !e.clientX && !e.touches) u = Math.round(b.width / 2), d = Math.round(b.height / 2); else
                {
                    var w = e.clientX ? e.clientX : e.touches[0].clientX,
                        x = e.clientY ? e.clientY : e.touches[0].clientY;
                    u = Math.round(w - b.left), d = Math.round(x - b.top)
                }
                if (s) (g = Math.sqrt((2 * Math.pow(b.width, 2) + Math.pow(b.height, 2)) / 3)) % 2 == 0 && (g += 1); else
                {
                    var _ = 2 * Math.max(Math.abs((y ? y.clientWidth : 0) - u), u) + 2,
                        C = 2 * Math.max(Math.abs((y ? y.clientHeight : 0) - d), d) + 2;
                    g = Math.sqrt(Math.pow(_, 2) + Math.pow(C, 2))
                }
                e.touches ? null === h.current && (h.current = function ()
                {
                    v({pulsate: o, rippleX: u, rippleY: d, rippleSize: g, cb: n})
                }, f.current = setTimeout((function ()
                {
                    h.current && (h.current(), h.current = null)
                }), 80)) : v({pulsate: o, rippleX: u, rippleY: d, rippleSize: g, cb: n})
            }
        }), [r, v]), y = lt.useCallback((function ()
        {
            g({}, {pulsate: !0})
        }), [g]), b = lt.useCallback((function (e, t)
        {
            if (clearTimeout(f.current), "touchend" === e.type && h.current) return e.persist(), h.current(), h.current = null, void (f.current = setTimeout((function ()
            {
                b(e, t)
            })));
            h.current = null, c((function (e)
            {
                return e.length > 0 ? e.slice(1) : e
            })), d.current = t
        }), []);
        return lt.useImperativeHandle(t, (function ()
        {
            return {pulsate: y, start: g, stop: b}
        }), [y, g, b]), lt.createElement("span", At({
            className: ka(i.root, o),
            ref: m
        }, a), lt.createElement(Js, {component: null, exit: !0}, l))
    })), ul = Rs((function (e)
    {
        return {
            root: {
                overflow: "hidden",
                pointerEvents: "none",
                position: "absolute",
                zIndex: 0,
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                borderRadius: "inherit"
            },
            ripple: {opacity: 0, position: "absolute"},
            rippleVisible: {
                opacity: .3,
                transform: "scale(1)",
                animation: "$enter ".concat(550, "ms ").concat(e.transitions.easing.easeInOut)
            },
            ripplePulsate: {animationDuration: "".concat(e.transitions.duration.shorter, "ms")},
            child: {
                opacity: 1,
                display: "block",
                width: "100%",
                height: "100%",
                borderRadius: "50%",
                backgroundColor: "currentColor"
            },
            childLeaving: {opacity: 0, animation: "$exit ".concat(550, "ms ").concat(e.transitions.easing.easeInOut)},
            childPulsate: {
                position: "absolute",
                left: 0,
                top: 0,
                animation: "$pulsate 2500ms ".concat(e.transitions.easing.easeInOut, " 200ms infinite")
            },
            "@keyframes enter": {
                "0%": {transform: "scale(0)", opacity: .1},
                "100%": {transform: "scale(1)", opacity: .3}
            },
            "@keyframes exit": {"0%": {opacity: 1}, "100%": {opacity: 0}},
            "@keyframes pulsate": {
                "0%": {transform: "scale(1)"},
                "50%": {transform: "scale(0.92)"},
                "100%": {transform: "scale(1)"}
            }
        }
    }), {flip: !1, name: "PwzrTouchRipple"})(lt.memo(cl)), dl = lt.forwardRef((function (e, t)
    {
        var n = e.action, r = e.buttonRef, i = e.centerRipple, o = void 0 !== i && i, a = e.children, s = e.classes,
            l = e.className, c = e.component, u = void 0 === c ? "button" : c, d = e.disabled, p = void 0 !== d && d,
            f = e.disableRipple, h = void 0 !== f && f, m = e.disableTouchRipple, v = void 0 !== m && m,
            g = e.focusRipple, y = void 0 !== g && g, b = e.focusVisibleClassName, w = e.onBlur, x = e.onClick,
            _ = e.onFocus, C = e.onFocusVisible, E = e.onKeyDown, S = e.onKeyUp, k = e.onMouseDown, T = e.onMouseLeave,
            O = e.onMouseUp, M = e.onTouchEnd, R = e.onTouchMove, P = e.onTouchStart, z = e.onDragLeave, I = e.tabIndex,
            A = void 0 === I ? 0 : I, L = e.TouchRippleProps, D = e.type, N = void 0 === D ? "button" : D,
            F = zt(e, ["action", "buttonRef", "centerRipple", "children", "classes", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "onBlur", "onClick", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "onDragLeave", "tabIndex", "TouchRippleProps", "type"]),
            B = lt.useRef(null);
        var W = lt.useRef(null), $ = lt.useState(!1), H = $[0], j = $[1];
        p && H && j(!1);
        var V = Us(), q = V.isFocusVisible, U = V.onBlurVisible, G = V.ref;

        function Z(e, t)
        {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : v;
            return As((function (r)
            {
                return t && t(r), !n && W.current && W.current[e](r), !0
            }))
        }

        lt.useImperativeHandle(n, (function ()
        {
            return {
                focusVisible: function ()
                {
                    j(!0), B.current.focus()
                }
            }
        }), []), lt.useEffect((function ()
        {
            H && y && !h && W.current.pulsate()
        }), [h, y, H]);
        var K = Z("start", k), Y = Z("stop", z), X = Z("stop", O), J = Z("stop", (function (e)
        {
            H && e.preventDefault(), T && T(e)
        })), Q = Z("start", P), ee = Z("stop", M), te = Z("stop", R), ne = Z("stop", (function (e)
        {
            H && (U(e), j(!1)), w && w(e)
        }), !1), re = As((function (e)
        {
            p || (B.current || (B.current = e.currentTarget), q(e) && (j(!0), C && C(e)), _ && _(e))
        })), ie = function ()
        {
            var e = lt.findDOMNode(B.current);
            return u && "button" !== u && !("A" === e.tagName && e.href)
        }, oe = lt.useRef(!1), ae = As((function (e)
        {
            y && !oe.current && H && W.current && " " === e.key && (oe.current = !0, e.persist(), W.current.stop(e, (function ()
            {
                W.current.start(e)
            }))), E && E(e), e.target === e.currentTarget && ie() && "Enter" === e.key && (e.preventDefault(), x && x(e))
        })), se = As((function (e)
        {
            y && " " === e.key && W.current && H && !e.defaultPrevented && (oe.current = !1, e.persist(), W.current.stop(e, (function ()
            {
                W.current.pulsate(e)
            }))), S && S(e), e.target === e.currentTarget && ie() && " " === e.key && !e.defaultPrevented && (e.preventDefault(), x && x(e))
        })), le = u;
        "button" === le && F.href && (le = "a");
        var ce = {};
        "button" === le ? (ce.type = N, ce.disabled = p) : ("a" === le && F.href || (ce.role = "button"), ce["aria-disabled"] = p);
        var ue = zs(r, t), de = zs(G, B), pe = zs(ue, de);
        return lt.createElement(le, At({
            className: ka(s.root, l, H && [s.focusVisible, b], p && s.disabled),
            onBlur: ne,
            onClick: x,
            onFocus: re,
            onKeyDown: ae,
            onKeyUp: se,
            onMouseDown: K,
            onMouseLeave: J,
            onMouseUp: X,
            onDragLeave: Y,
            onTouchEnd: ee,
            onTouchMove: te,
            onTouchStart: Q,
            ref: pe,
            tabIndex: p ? -1 : A
        }, ce, F), a, h || p ? null : lt.createElement(Ds, null, lt.createElement(ul, At({ref: W, center: o}, L))))
    })), pl = Rs({
        root: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            WebkitTapHighlightColor: "transparent",
            backgroundColor: "transparent",
            outline: 0,
            border: 0,
            margin: 0,
            borderRadius: 0,
            padding: 0,
            cursor: "pointer",
            userSelect: "none",
            verticalAlign: "middle",
            "-moz-appearance": "none",
            "-webkit-appearance": "none",
            textDecoration: "none",
            color: "inherit",
            "&::-moz-focus-inner": {borderStyle: "none"},
            "&$disabled": {pointerEvents: "none", cursor: "default"}
        }, disabled: {}, focusVisible: {}
    }, {name: "PwzrButtonBase"})(dl);

    function fl(e)
    {
        return e.charAt(0).toUpperCase() + e.slice(1)
    }

    var hl = lt.forwardRef((function (e, t)
    {
        var n = e.children, r = e.classes, i = e.className, o = e.color, a = void 0 === o ? "default" : o,
            s = e.component, l = void 0 === s ? "button" : s, c = e.disabled, u = void 0 !== c && c,
            d = e.disableElevation, p = void 0 !== d && d, f = e.disableFocusRipple, h = void 0 !== f && f,
            m = e.endIcon, v = e.focusVisibleClassName, g = e.fullWidth, y = void 0 !== g && g, b = e.size,
            w = void 0 === b ? "medium" : b, x = e.startIcon, _ = e.type, C = void 0 === _ ? "button" : _,
            E = e.variant, S = void 0 === E ? "text" : E,
            k = zt(e, ["children", "classes", "className", "color", "component", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"]),
            T = x && lt.createElement("span", {className: ka(r.startIcon, r["iconSize".concat(fl(w))])}, x),
            O = m && lt.createElement("span", {className: ka(r.endIcon, r["iconSize".concat(fl(w))])}, m);
        return lt.createElement(pl, At({
            className: ka(r.root, r[S], i, "inherit" === a ? r.colorInherit : "default" !== a && r["".concat(S).concat(fl(a))], "medium" !== w && [r["".concat(S, "Size").concat(fl(w))], r["size".concat(fl(w))]], p && r.disableElevation, u && r.disabled, y && r.fullWidth),
            component: l,
            disabled: u,
            focusRipple: !h,
            focusVisibleClassName: ka(r.focusVisible, v),
            ref: t,
            type: C
        }, k), lt.createElement("span", {className: r.label}, T, n, O))
    })), ml = Rs((function (e)
    {
        return {
            root: At({}, e.typography.button, {
                boxSizing: "border-box",
                minWidth: 64,
                padding: "6px 16px",
                borderRadius: e.shape.borderRadius,
                color: e.palette.text.primary,
                transition: e.transitions.create(["background-color", "box-shadow", "border"], {duration: e.transitions.duration.short}),
                "&:hover": {
                    textDecoration: "none",
                    backgroundColor: nr(e.palette.text.primary, e.palette.action.hoverOpacity),
                    "@media (hover: none)": {backgroundColor: "transparent"},
                    "&$disabled": {backgroundColor: "transparent"}
                },
                "&$disabled": {color: e.palette.action.disabled}
            }),
            label: {width: "100%", display: "inherit", alignItems: "inherit", justifyContent: "inherit"},
            text: {padding: "6px 8px"},
            textPrimary: {
                color: e.palette.primary.main,
                "&:hover": {
                    backgroundColor: nr(e.palette.primary.main, e.palette.action.hoverOpacity),
                    "@media (hover: none)": {backgroundColor: "transparent"}
                }
            },
            textSecondary: {
                color: e.palette.secondary.main,
                "&:hover": {
                    backgroundColor: nr(e.palette.secondary.main, e.palette.action.hoverOpacity),
                    "@media (hover: none)": {backgroundColor: "transparent"}
                }
            },
            outlined: {
                padding: "5px 15px",
                border: "1px solid ".concat("light" === e.palette.type ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"),
                "&$disabled": {border: "1px solid ".concat(e.palette.action.disabledBackground)}
            },
            outlinedPrimary: {
                color: e.palette.primary.main,
                border: "1px solid ".concat(nr(e.palette.primary.main, .5)),
                "&:hover": {
                    border: "1px solid ".concat(e.palette.primary.main),
                    backgroundColor: nr(e.palette.primary.main, e.palette.action.hoverOpacity),
                    "@media (hover: none)": {backgroundColor: "transparent"}
                }
            },
            outlinedSecondary: {
                color: e.palette.secondary.main,
                border: "1px solid ".concat(nr(e.palette.secondary.main, .5)),
                "&:hover": {
                    border: "1px solid ".concat(e.palette.secondary.main),
                    backgroundColor: nr(e.palette.secondary.main, e.palette.action.hoverOpacity),
                    "@media (hover: none)": {backgroundColor: "transparent"}
                },
                "&$disabled": {border: "1px solid ".concat(e.palette.action.disabled)}
            },
            contained: {
                color: e.palette.getContrastText(e.palette.grey[300]),
                backgroundColor: e.palette.grey[300],
                boxShadow: e.shadows[2],
                "&:hover": {
                    backgroundColor: e.palette.grey.A100,
                    boxShadow: e.shadows[4],
                    "@media (hover: none)": {boxShadow: e.shadows[2], backgroundColor: e.palette.grey[300]},
                    "&$disabled": {backgroundColor: e.palette.action.disabledBackground}
                },
                "&$focusVisible": {boxShadow: e.shadows[6]},
                "&:active": {boxShadow: e.shadows[8]},
                "&$disabled": {
                    color: e.palette.action.disabled,
                    boxShadow: e.shadows[0],
                    backgroundColor: e.palette.action.disabledBackground
                }
            },
            containedPrimary: {
                color: e.palette.primary.contrastText,
                backgroundColor: e.palette.primary.main,
                "&:hover": {
                    backgroundColor: e.palette.primary.dark,
                    "@media (hover: none)": {backgroundColor: e.palette.primary.main}
                }
            },
            containedSecondary: {
                color: e.palette.secondary.contrastText,
                backgroundColor: e.palette.secondary.main,
                "&:hover": {
                    backgroundColor: e.palette.secondary.dark,
                    "@media (hover: none)": {backgroundColor: e.palette.secondary.main}
                }
            },
            disableElevation: {
                boxShadow: "none",
                "&:hover": {boxShadow: "none"},
                "&$focusVisible": {boxShadow: "none"},
                "&:active": {boxShadow: "none"},
                "&$disabled": {boxShadow: "none"}
            },
            focusVisible: {},
            disabled: {},
            colorInherit: {color: "inherit", borderColor: "currentColor"},
            textSizeSmall: {padding: "4px 5px", fontSize: e.typography.pxToRem(13)},
            textSizeLarge: {padding: "8px 11px", fontSize: e.typography.pxToRem(15)},
            outlinedSizeSmall: {padding: "3px 9px", fontSize: e.typography.pxToRem(13)},
            outlinedSizeLarge: {padding: "7px 21px", fontSize: e.typography.pxToRem(15)},
            containedSizeSmall: {padding: "4px 10px", fontSize: e.typography.pxToRem(13)},
            containedSizeLarge: {padding: "8px 22px", fontSize: e.typography.pxToRem(15)},
            sizeSmall: {},
            sizeLarge: {},
            fullWidth: {width: "100%"},
            startIcon: {display: "inherit", marginRight: 8, marginLeft: -4, "&$iconSizeSmall": {marginLeft: -2}},
            endIcon: {display: "inherit", marginRight: -4, marginLeft: 8, "&$iconSizeSmall": {marginRight: -2}},
            iconSizeSmall: {"& > *:first-child": {fontSize: 18}},
            iconSizeMedium: {"& > *:first-child": {fontSize: 20}},
            iconSizeLarge: {"& > *:first-child": {fontSize: 22}}
        }
    }), {name: "PwzrButton"})(hl);
    var vl = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10], gl = ["auto", !0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

    function yl(e)
    {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, n = parseFloat(e);
        return "".concat(n / t).concat(String(e).replace(String(n), "") || "px")
    }

    var bl = lt.forwardRef((function (e, t)
    {
        var n = e.alignContent, r = void 0 === n ? "stretch" : n, i = e.alignItems, o = void 0 === i ? "stretch" : i,
            a = e.classes, s = e.className, l = e.component, c = void 0 === l ? "div" : l, u = e.container,
            d = void 0 !== u && u, p = e.direction, f = void 0 === p ? "row" : p, h = e.item, m = void 0 !== h && h,
            v = e.justify, g = void 0 === v ? "flex-start" : v, y = e.lg, b = void 0 !== y && y, w = e.md,
            x = void 0 !== w && w, _ = e.sm, C = void 0 !== _ && _, E = e.spacing, S = void 0 === E ? 0 : E, k = e.wrap,
            T = void 0 === k ? "wrap" : k, O = e.xl, M = void 0 !== O && O, R = e.xs, P = void 0 !== R && R,
            z = e.zeroMinWidth, I = void 0 !== z && z,
            A = zt(e, ["alignContent", "alignItems", "classes", "className", "component", "container", "direction", "item", "justify", "lg", "md", "sm", "spacing", "wrap", "xl", "xs", "zeroMinWidth"]),
            L = ka(a.root, s, d && [a.container, 0 !== S && a["spacing-xs-".concat(String(S))]], m && a.item, I && a.zeroMinWidth, "row" !== f && a["direction-xs-".concat(String(f))], "wrap" !== T && a["wrap-xs-".concat(String(T))], "stretch" !== o && a["align-items-xs-".concat(String(o))], "stretch" !== r && a["align-content-xs-".concat(String(r))], "flex-start" !== g && a["justify-xs-".concat(String(g))], !1 !== P && a["grid-xs-".concat(String(P))], !1 !== C && a["grid-sm-".concat(String(C))], !1 !== x && a["grid-md-".concat(String(x))], !1 !== b && a["grid-lg-".concat(String(b))], !1 !== M && a["grid-xl-".concat(String(M))]);
        return lt.createElement(c, At({className: L, ref: t}, A))
    })), wl = Rs((function (e)
    {
        return At({
            root: {},
            container: {boxSizing: "border-box", display: "flex", flexWrap: "wrap", width: "100%"},
            item: {boxSizing: "border-box", margin: "0"},
            zeroMinWidth: {minWidth: 0},
            "direction-xs-column": {flexDirection: "column"},
            "direction-xs-column-reverse": {flexDirection: "column-reverse"},
            "direction-xs-row-reverse": {flexDirection: "row-reverse"},
            "wrap-xs-nowrap": {flexWrap: "nowrap"},
            "wrap-xs-wrap-reverse": {flexWrap: "wrap-reverse"},
            "align-items-xs-center": {alignItems: "center"},
            "align-items-xs-flex-start": {alignItems: "flex-start"},
            "align-items-xs-flex-end": {alignItems: "flex-end"},
            "align-items-xs-baseline": {alignItems: "baseline"},
            "align-content-xs-center": {alignContent: "center"},
            "align-content-xs-flex-start": {alignContent: "flex-start"},
            "align-content-xs-flex-end": {alignContent: "flex-end"},
            "align-content-xs-space-between": {alignContent: "space-between"},
            "align-content-xs-space-around": {alignContent: "space-around"},
            "justify-xs-center": {justifyContent: "center"},
            "justify-xs-flex-end": {justifyContent: "flex-end"},
            "justify-xs-space-between": {justifyContent: "space-between"},
            "justify-xs-space-around": {justifyContent: "space-around"},
            "justify-xs-space-evenly": {justifyContent: "space-evenly"}
        }, function (e, t)
        {
            var n = {};
            return vl.forEach((function (r)
            {
                var i = e.spacing(r);
                0 !== i && (n["spacing-".concat(t, "-").concat(r)] = {
                    margin: "-".concat(yl(i, 2)),
                    width: "calc(100% + ".concat(yl(i), ")"),
                    "& > $item": {padding: yl(i, 2)}
                })
            })), n
        }(e, "xs"), {}, e.breakpoints.keys.reduce((function (t, n)
        {
            return function (e, t, n)
            {
                var r = {};
                gl.forEach((function (e)
                {
                    var t = "grid-".concat(n, "-").concat(e);
                    if (!0 !== e) if ("auto" !== e)
                    {
                        var i = "".concat(Math.round(e / 12 * 1e8) / 1e6, "%");
                        r[t] = {flexBasis: i, flexGrow: 0, maxWidth: i}
                    } else r[t] = {flexBasis: "auto", flexGrow: 0, maxWidth: "none"}; else r[t] = {
                        flexBasis: 0,
                        flexGrow: 1,
                        maxWidth: "100%"
                    }
                })), "xs" === n ? At(e, r) : e[t.breakpoints.up(n)] = r
            }(t, e, n), t
        }), {}))
    }), {name: "PwzrGrid"})(bl), xl = lt.forwardRef((function (e, t)
    {
        var n = e.edge, r = void 0 !== n && n, i = e.children, o = e.classes, a = e.className, s = e.color,
            l = void 0 === s ? "default" : s, c = e.disabled, u = void 0 !== c && c, d = e.disableFocusRipple,
            p = void 0 !== d && d, f = e.size, h = void 0 === f ? "medium" : f,
            m = zt(e, ["edge", "children", "classes", "className", "color", "disabled", "disableFocusRipple", "size"]);
        return lt.createElement(pl, At({
            className: ka(o.root, a, "default" !== l && o["color".concat(fl(l))], u && o.disabled, "small" === h && o["size".concat(fl(h))], {
                start: o.edgeStart,
                end: o.edgeEnd
            }[r]), centerRipple: !0, focusRipple: !p, disabled: u, ref: t
        }, m), lt.createElement("span", {className: o.label}, i))
    })), _l = Rs((function (e)
    {
        return {
            root: {
                textAlign: "center",
                flex: "0 0 auto",
                fontSize: e.typography.pxToRem(24),
                padding: 12,
                borderRadius: "50%",
                overflow: "visible",
                color: e.palette.action.active,
                transition: e.transitions.create("background-color", {duration: e.transitions.duration.shortest}),
                "&:hover": {
                    backgroundColor: nr(e.palette.action.active, e.palette.action.hoverOpacity),
                    "@media (hover: none)": {backgroundColor: "transparent"}
                },
                "&$disabled": {backgroundColor: "transparent", color: e.palette.action.disabled}
            },
            edgeStart: {marginLeft: -12, "$sizeSmall&": {marginLeft: -3}},
            edgeEnd: {marginRight: -12, "$sizeSmall&": {marginRight: -3}},
            colorInherit: {color: "inherit"},
            colorPrimary: {
                color: e.palette.primary.main,
                "&:hover": {
                    backgroundColor: nr(e.palette.primary.main, e.palette.action.hoverOpacity),
                    "@media (hover: none)": {backgroundColor: "transparent"}
                }
            },
            colorSecondary: {
                color: e.palette.secondary.main,
                "&:hover": {
                    backgroundColor: nr(e.palette.secondary.main, e.palette.action.hoverOpacity),
                    "@media (hover: none)": {backgroundColor: "transparent"}
                }
            },
            disabled: {},
            sizeSmall: {padding: 3, fontSize: e.typography.pxToRem(18)},
            label: {width: "100%", display: "flex", alignItems: "inherit", justifyContent: "inherit"}
        }
    }), {name: "PwzrIconButton"})(xl), Cl = {
        h1: "h1",
        h2: "h2",
        h3: "h3",
        h4: "h4",
        h5: "h5",
        h6: "h6",
        subtitle1: "h6",
        subtitle2: "h6",
        body1: "p",
        body2: "p"
    }, El = lt.forwardRef((function (e, t)
    {
        var n = e.align, r = void 0 === n ? "inherit" : n, i = e.classes, o = e.className, a = e.color,
            s = void 0 === a ? "initial" : a, l = e.component, c = e.display, u = void 0 === c ? "initial" : c,
            d = e.gutterBottom, p = void 0 !== d && d, f = e.noWrap, h = void 0 !== f && f, m = e.paragraph,
            v = void 0 !== m && m, g = e.variant, y = void 0 === g ? "body1" : g, b = e.variantMapping,
            w = void 0 === b ? Cl : b,
            x = zt(e, ["align", "classes", "className", "color", "component", "display", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"]),
            _ = l || (v ? "p" : w[y] || Cl[y]) || "span";
        return lt.createElement(_, At({
            className: ka(i.root, o, "inherit" !== y && i[y], "initial" !== s && i["color".concat(fl(s))], h && i.noWrap, p && i.gutterBottom, v && i.paragraph, "inherit" !== r && i["align".concat(fl(r))], "initial" !== u && i["display".concat(fl(u))]),
            ref: t
        }, x))
    })), Sl = Rs((function (e)
    {
        return {
            root: {margin: 0},
            body2: e.typography.body2,
            body1: e.typography.body1,
            caption: e.typography.caption,
            button: e.typography.button,
            h1: e.typography.h1,
            h2: e.typography.h2,
            h3: e.typography.h3,
            h4: e.typography.h4,
            h5: e.typography.h5,
            h6: e.typography.h6,
            subtitle1: e.typography.subtitle1,
            subtitle2: e.typography.subtitle2,
            overline: e.typography.overline,
            srOnly: {position: "absolute", height: 1, width: 1, overflow: "hidden"},
            alignLeft: {textAlign: "left"},
            alignCenter: {textAlign: "center"},
            alignRight: {textAlign: "right"},
            alignJustify: {textAlign: "justify"},
            noWrap: {overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"},
            gutterBottom: {marginBottom: "0.35em"},
            paragraph: {marginBottom: 16},
            colorInherit: {color: "inherit"},
            colorPrimary: {color: e.palette.primary.main},
            colorSecondary: {color: e.palette.secondary.main},
            colorTextPrimary: {color: e.palette.text.primary},
            colorTextSecondary: {color: e.palette.text.secondary},
            colorError: {color: e.palette.error.main},
            displayInline: {display: "inline"},
            displayBlock: {display: "block"}
        }
    }), {name: "PwzrTypography"})(El), kl = lt.forwardRef((function (e, t)
    {
        var n = e.classes, r = e.className, i = e.color, o = void 0 === i ? "primary" : i, a = e.component,
            s = void 0 === a ? "a" : a, l = e.onBlur, c = e.onFocus, u = e.TypographyClasses, d = e.underline,
            p = void 0 === d ? "hover" : d, f = e.variant, h = void 0 === f ? "inherit" : f,
            m = zt(e, ["classes", "className", "color", "component", "onBlur", "onFocus", "TypographyClasses", "underline", "variant"]),
            v = Us(), g = v.isFocusVisible, y = v.onBlurVisible, b = v.ref, w = lt.useState(!1), x = w[0], _ = w[1],
            C = zs(t, b);
        return lt.createElement(Sl, At({
            className: ka(n.root, n["underline".concat(fl(p))], r, x && n.focusVisible, "button" === s && n.button),
            classes: u,
            color: o,
            component: s,
            onBlur: function (e)
            {
                x && (y(), _(!1)), l && l(e)
            },
            onFocus: function (e)
            {
                g(e) && _(!0), c && c(e)
            },
            ref: C,
            variant: h
        }, m))
    })), Tl = Rs({
        root: {},
        underlineNone: {textDecoration: "none"},
        underlineHover: {textDecoration: "none", "&:hover": {textDecoration: "underline"}},
        underlineAlways: {textDecoration: "underline"},
        button: {
            position: "relative",
            WebkitTapHighlightColor: "transparent",
            backgroundColor: "transparent",
            outline: 0,
            border: 0,
            margin: 0,
            borderRadius: 0,
            padding: 0,
            cursor: "pointer",
            userSelect: "none",
            verticalAlign: "middle",
            "-moz-appearance": "none",
            "-webkit-appearance": "none",
            "&::-moz-focus-inner": {borderStyle: "none"},
            "&$focusVisible": {outline: "auto"}
        },
        focusVisible: {}
    }, {name: "PwzrLink"})(kl);

    function Ol(e, t)
    {
        return lt.isValidElement(e) && -1 !== t.indexOf(e.type.muiName)
    }

    var Ml = lt.createContext({});
    var Rl = "undefined" == typeof window ? lt.useEffect : lt.useLayoutEffect, Pl = lt.forwardRef((function (e, t)
    {
        var n = e.alignItems, r = void 0 === n ? "center" : n, i = e.autoFocus, o = void 0 !== i && i, a = e.button,
            s = void 0 !== a && a, l = e.children, c = e.classes, u = e.className, d = e.component,
            p = e.ContainerComponent, f = void 0 === p ? "li" : p, h = e.ContainerProps,
            m = (h = void 0 === h ? {} : h).className, v = zt(h, ["className"]), g = e.dense, y = void 0 !== g && g,
            b = e.disabled, w = void 0 !== b && b, x = e.disableGutters, _ = void 0 !== x && x, C = e.divider,
            E = void 0 !== C && C, S = e.focusVisibleClassName, k = e.selected, T = void 0 !== k && k,
            O = zt(e, ["alignItems", "autoFocus", "button", "children", "classes", "className", "component", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "divider", "focusVisibleClassName", "selected"]),
            M = lt.useContext(Ml), R = {dense: y || M.dense || !1, alignItems: r}, P = lt.useRef(null);
        Rl((function ()
        {
            o && P.current && P.current.focus()
        }), [o]);
        var z = lt.Children.toArray(l), I = z.length && Ol(z[z.length - 1], ["ListItemSecondaryAction"]),
            A = zs(lt.useCallback((function (e)
            {
                P.current = lt.findDOMNode(e)
            }), []), t), L = At({
                className: ka(c.root, u, R.dense && c.dense, !_ && c.gutters, E && c.divider, w && c.disabled, s && c.button, "center" !== r && c.alignItemsFlexStart, I && c.secondaryAction, T && c.selected),
                disabled: w
            }, O), D = d || "li";
        return s && (L.component = d || "div", L.focusVisibleClassName = ka(c.focusVisible, S), D = pl), I ? (D = L.component || d ? D : "div", "li" === f && ("li" === D ? D = "div" : "li" === L.component && (L.component = "div")), lt.createElement(Ml.Provider, {value: R}, lt.createElement(f, At({
            className: ka(c.container, m),
            ref: A
        }, v), lt.createElement(D, L, z), z.pop()))) : lt.createElement(Ml.Provider, {value: R}, lt.createElement(D, At({ref: A}, L), z))
    })), zl = Rs((function (e)
    {
        return {
            root: {
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                position: "relative",
                textDecoration: "none",
                width: "100%",
                boxSizing: "border-box",
                textAlign: "left",
                paddingTop: 8,
                paddingBottom: 8,
                "&$focusVisible": {backgroundColor: e.palette.action.selected},
                "&$selected, &$selected:hover": {backgroundColor: e.palette.action.selected},
                "&$disabled": {opacity: .5}
            },
            container: {position: "relative"},
            focusVisible: {},
            dense: {paddingTop: 4, paddingBottom: 4},
            alignItemsFlexStart: {alignItems: "flex-start"},
            disabled: {},
            divider: {borderBottom: "1px solid ".concat(e.palette.divider), backgroundClip: "padding-box"},
            gutters: {paddingLeft: 16, paddingRight: 16},
            button: {
                transition: e.transitions.create("background-color", {duration: e.transitions.duration.shortest}),
                "&:hover": {
                    textDecoration: "none",
                    backgroundColor: e.palette.action.hover,
                    "@media (hover: none)": {backgroundColor: "transparent"}
                }
            },
            secondaryAction: {paddingRight: 48},
            selected: {}
        }
    }), {name: "PwzrListItem"})(Pl), Il = lt.forwardRef((function (e, t)
    {
        var n, r = e.classes, i = e.className, o = e.component, a = void 0 === o ? "li" : o, s = e.disableGutters,
            l = void 0 !== s && s, c = e.role, u = void 0 === c ? "menuitem" : c, d = e.selected, p = e.tabIndex,
            f = zt(e, ["classes", "className", "component", "disableGutters", "role", "selected", "tabIndex"]);
        return e.disabled || (n = void 0 !== p ? p : -1), lt.createElement(zl, At({
            button: !0,
            role: u,
            tabIndex: n,
            component: a,
            selected: d,
            disableGutters: l,
            classes: {dense: r.dense},
            className: ka(r.root, i, d && r.selected, !l && r.gutters),
            ref: t
        }, f))
    })), Al = Rs((function (e)
    {
        return {
            root: At({}, e.typography.body1, Rt({
                minHeight: 48,
                paddingTop: 6,
                paddingBottom: 6,
                boxSizing: "border-box",
                width: "auto",
                overflow: "hidden",
                whiteSpace: "nowrap"
            }, e.breakpoints.up("sm"), {minHeight: "auto"})),
            gutters: {},
            selected: {},
            dense: At({}, e.typography.body2, {minHeight: "auto"})
        }
    }), {name: "PwzrMenuItem"})(Il);

    function Ll(e)
    {
        var t, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 166;

        function r()
        {
            for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
            var a = this, s = function ()
            {
                e.apply(a, i)
            };
            clearTimeout(t), t = setTimeout(s, n)
        }

        return r.clear = function ()
        {
            clearTimeout(t)
        }, r
    }

    function Dl(e)
    {
        return e && e.ownerDocument || document
    }

    function Nl(e)
    {
        return Dl(e).defaultView || window
    }

    function Fl()
    {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
        return t.reduce((function (e, t)
        {
            return null == t ? e : function ()
            {
                for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) r[i] = arguments[i];
                e.apply(this, r), t.apply(this, r)
            }
        }), (function ()
        {
        }))
    }

    var Bl = "undefined" != typeof window ? lt.useLayoutEffect : lt.useEffect, Wl = lt.forwardRef((function (e, t)
    {
        var n = e.children, r = e.container, i = e.disablePortal, o = void 0 !== i && i, a = e.onRendered,
            s = lt.useState(null), l = s[0], c = s[1], u = zs(lt.isValidElement(n) ? n.ref : null, t);
        return Bl((function ()
        {
            o || c(function (e)
            {
                return e = "function" == typeof e ? e() : e, lt.findDOMNode(e)
            }(r) || document.body)
        }), [r, o]), Bl((function ()
        {
            if (l && !o) return Ps(t, l), function ()
            {
                Ps(t, null)
            }
        }), [t, l, o]), Bl((function ()
        {
            a && (l || o) && a()
        }), [a, l, o]), o ? lt.isValidElement(n) ? lt.cloneElement(n, {ref: u}) : n : l ? lt.createPortal(n, l) : l
    }));

    function $l()
    {
        var e = document.createElement("div");
        e.style.width = "99px", e.style.height = "99px", e.style.position = "absolute", e.style.top = "-9999px", e.style.overflow = "scroll", document.body.appendChild(e);
        var t = e.offsetWidth - e.clientWidth;
        return document.body.removeChild(e), t
    }

    function Hl(e, t)
    {
        t ? e.setAttribute("aria-hidden", "true") : e.removeAttribute("aria-hidden")
    }

    function jl(e)
    {
        return parseInt(window.getComputedStyle(e)["padding-right"], 10) || 0
    }

    function Vl(e, t, n)
    {
        var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : [],
            i = arguments.length > 4 ? arguments[4] : void 0, o = [t, n].concat(mo(r)),
            a = ["TEMPLATE", "SCRIPT", "STYLE"];
        [].forEach.call(e.children, (function (e)
        {
            1 === e.nodeType && -1 === o.indexOf(e) && -1 === a.indexOf(e.tagName) && Hl(e, i)
        }))
    }

    function ql(e, t)
    {
        var n = -1;
        return e.some((function (e, r)
        {
            return !!t(e) && (n = r, !0)
        })), n
    }

    function Ul(e, t)
    {
        var n, r = [], i = [], o = e.container;
        if (!t.disableScrollLock)
        {
            if (function (e)
            {
                var t = Dl(e);
                return t.body === e ? Nl(t).innerWidth > t.documentElement.clientWidth : e.scrollHeight > e.clientHeight
            }(o))
            {
                var a = $l();
                r.push({
                    value: o.style.paddingRight,
                    key: "padding-right",
                    el: o
                }), o.style["padding-right"] = "".concat(jl(o) + a, "px"), n = Dl(o).querySelectorAll(".mui-fixed"), [].forEach.call(n, (function (e)
                {
                    i.push(e.style.paddingRight), e.style.paddingRight = "".concat(jl(e) + a, "px")
                }))
            }
            var s = o.parentElement,
                l = "HTML" === s.nodeName && "scroll" === window.getComputedStyle(s)["overflow-y"] ? s : o;
            r.push({value: l.style.overflow, key: "overflow", el: l}), l.style.overflow = "hidden"
        }
        return function ()
        {
            n && [].forEach.call(n, (function (e, t)
            {
                i[t] ? e.style.paddingRight = i[t] : e.style.removeProperty("padding-right")
            })), r.forEach((function (e)
            {
                var t = e.value, n = e.el, r = e.key;
                t ? n.style.setProperty(r, t) : n.style.removeProperty(r)
            }))
        }
    }

    var Gl = function ()
    {
        function e()
        {
            !function (e, t)
            {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
            }(this, e), this.modals = [], this.containers = []
        }

        return Sr(e, [{
            key: "add", value: function (e, t)
            {
                var n = this.modals.indexOf(e);
                if (-1 !== n) return n;
                n = this.modals.length, this.modals.push(e), e.modalRef && Hl(e.modalRef, !1);
                var r = function (e)
                {
                    var t = [];
                    return [].forEach.call(e.children, (function (e)
                    {
                        e.getAttribute && "true" === e.getAttribute("aria-hidden") && t.push(e)
                    })), t
                }(t);
                Vl(t, e.mountNode, e.modalRef, r, !0);
                var i = ql(this.containers, (function (e)
                {
                    return e.container === t
                }));
                return -1 !== i ? (this.containers[i].modals.push(e), n) : (this.containers.push({
                    modals: [e],
                    container: t,
                    restore: null,
                    hiddenSiblingNodes: r
                }), n)
            }
        }, {
            key: "mount", value: function (e, t)
            {
                var n = ql(this.containers, (function (t)
                {
                    return -1 !== t.modals.indexOf(e)
                })), r = this.containers[n];
                r.restore || (r.restore = Ul(r, t))
            }
        }, {
            key: "remove", value: function (e)
            {
                var t = this.modals.indexOf(e);
                if (-1 === t) return t;
                var n = ql(this.containers, (function (t)
                {
                    return -1 !== t.modals.indexOf(e)
                })), r = this.containers[n];
                if (r.modals.splice(r.modals.indexOf(e), 1), this.modals.splice(t, 1), 0 === r.modals.length) r.restore && r.restore(), e.modalRef && Hl(e.modalRef, !0), Vl(r.container, e.mountNode, e.modalRef, r.hiddenSiblingNodes, !1), this.containers.splice(n, 1); else
                {
                    var i = r.modals[r.modals.length - 1];
                    i.modalRef && Hl(i.modalRef, !1)
                }
                return t
            }
        }, {
            key: "isTopModal", value: function (e)
            {
                return this.modals.length > 0 && this.modals[this.modals.length - 1] === e
            }
        }]), e
    }();

    function Zl(e)
    {
        var t = e.children, n = e.disableAutoFocus, r = void 0 !== n && n, i = e.disableEnforceFocus,
            o = void 0 !== i && i, a = e.disableRestoreFocus, s = void 0 !== a && a, l = e.getDoc, c = e.isEnabled,
            u = e.open, d = lt.useRef(), p = lt.useRef(null), f = lt.useRef(null), h = lt.useRef(), m = lt.useRef(null),
            v = lt.useCallback((function (e)
            {
                m.current = lt.findDOMNode(e)
            }), []), g = zs(t.ref, v);
        return lt.useMemo((function ()
        {
            u && "undefined" != typeof window && (h.current = l().activeElement)
        }), [u]), lt.useEffect((function ()
        {
            if (u)
            {
                var e = Dl(m.current);
                r || !m.current || m.current.contains(e.activeElement) || (m.current.hasAttribute("tabIndex") || m.current.setAttribute("tabIndex", -1), m.current.focus());
                var t = function ()
                {
                    o || !c() || d.current ? d.current = !1 : m.current && !m.current.contains(e.activeElement) && m.current.focus()
                }, n = function (t)
                {
                    !o && c() && 9 === t.keyCode && e.activeElement === m.current && (d.current = !0, t.shiftKey ? f.current.focus() : p.current.focus())
                };
                e.addEventListener("focus", t, !0), e.addEventListener("keydown", n, !0);
                var i = setInterval((function ()
                {
                    t()
                }), 50);
                return function ()
                {
                    clearInterval(i), e.removeEventListener("focus", t, !0), e.removeEventListener("keydown", n, !0), s || (h.current && h.current.focus && h.current.focus(), h.current = null)
                }
            }
        }), [r, o, s, c, u]), lt.createElement(lt.Fragment, null, lt.createElement("div", {
            tabIndex: 0,
            ref: p,
            "data-test": "sentinelStart"
        }), lt.cloneElement(t, {ref: g}), lt.createElement("div", {tabIndex: 0, ref: f, "data-test": "sentinelEnd"}))
    }

    var Kl = {
        root: {
            zIndex: -1,
            position: "fixed",
            right: 0,
            bottom: 0,
            top: 0,
            left: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            WebkitTapHighlightColor: "transparent"
        }, invisible: {backgroundColor: "transparent"}
    }, Yl = lt.forwardRef((function (e, t)
    {
        var n = e.invisible, r = void 0 !== n && n, i = e.open, o = zt(e, ["invisible", "open"]);
        return i ? lt.createElement("div", At({
            "aria-hidden": !0,
            ref: t
        }, o, {style: At({}, Kl.root, {}, r ? Kl.invisible : {}, {}, o.style)})) : null
    }));
    var Xl = new Gl, Jl = lt.forwardRef((function (e, t)
    {
        var n = Fi(), r = xr({name: "PwzrModal", props: At({}, e), theme: n}), i = r.BackdropComponent,
            o = void 0 === i ? Yl : i, a = r.BackdropProps, s = r.children, l = r.closeAfterTransition,
            c = void 0 !== l && l, u = r.container, d = r.disableAutoFocus, p = void 0 !== d && d,
            f = r.disableBackdropClick, h = void 0 !== f && f, m = r.disableEnforceFocus, v = void 0 !== m && m,
            g = r.disableEscapeKeyDown, y = void 0 !== g && g, b = r.disablePortal, w = void 0 !== b && b,
            x = r.disableRestoreFocus, _ = void 0 !== x && x, C = r.disableScrollLock, E = void 0 !== C && C,
            S = r.hideBackdrop, k = void 0 !== S && S, T = r.keepMounted, O = void 0 !== T && T, M = r.manager,
            R = void 0 === M ? Xl : M, P = r.onBackdropClick, z = r.onClose, I = r.onEscapeKeyDown, A = r.onRendered,
            L = r.open,
            D = zt(r, ["BackdropComponent", "BackdropProps", "children", "closeAfterTransition", "container", "disableAutoFocus", "disableBackdropClick", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onEscapeKeyDown", "onRendered", "open"]),
            N = lt.useState(!0), F = N[0], B = N[1], W = lt.useRef({}), $ = lt.useRef(null), H = lt.useRef(null),
            j = zs(H, t), V = function (e)
            {
                return !!e.children && e.children.props.hasOwnProperty("in")
            }(r), q = function ()
            {
                return Dl($.current)
            }, U = function ()
            {
                return W.current.modalRef = H.current, W.current.mountNode = $.current, W.current
            }, G = function ()
            {
                R.mount(U(), {disableScrollLock: E}), H.current.scrollTop = 0
            }, Z = As((function ()
            {
                var e = function (e)
                {
                    return e = "function" == typeof e ? e() : e, lt.findDOMNode(e)
                }(u) || q().body;
                R.add(U(), e), H.current && G()
            })), K = lt.useCallback((function ()
            {
                return R.isTopModal(U())
            }), [R]), Y = As((function (e)
            {
                $.current = e, e && (A && A(), L && K() ? G() : Hl(H.current, !0))
            })), X = lt.useCallback((function ()
            {
                R.remove(U())
            }), [R]);
        if (lt.useEffect((function ()
        {
            return function ()
            {
                X()
            }
        }), [X]), lt.useEffect((function ()
        {
            L ? Z() : V && c || X()
        }), [L, X, V, c, Z]), !O && !L && (!V || F)) return null;
        var J = function (e)
        {
            return {
                root: {position: "fixed", zIndex: e.zIndex.modal, right: 0, bottom: 0, top: 0, left: 0},
                hidden: {visibility: "hidden"}
            }
        }(n || {zIndex: br}), Q = {};
        return void 0 === s.props.tabIndex && (Q.tabIndex = s.props.tabIndex || "-1"), V && (Q.onEnter = Fl((function ()
        {
            B(!1)
        }), s.props.onEnter), Q.onExited = Fl((function ()
        {
            B(!0), c && X()
        }), s.props.onExited)), lt.createElement(Wl, {
            ref: Y,
            container: u,
            disablePortal: w
        }, lt.createElement("div", At({
            ref: j, onKeyDown: function (e)
            {
                "Escape" === e.key && K() && (e.stopPropagation(), I && I(e), !y && z && z(e, "escapeKeyDown"))
            }, role: "presentation"
        }, D, {style: At({}, J.root, {}, !L && F ? J.hidden : {}, {}, D.style)}), k ? null : lt.createElement(o, At({
            open: L,
            onClick: function (e)
            {
                e.target === e.currentTarget && (P && P(e), !h && z && z(e, "backdropClick"))
            }
        }, a)), lt.createElement(Zl, {
            disableEnforceFocus: v,
            disableAutoFocus: p,
            disableRestoreFocus: _,
            getDoc: q,
            isEnabled: K,
            open: L
        }, lt.cloneElement(s, Q))))
    }));

    function Ql(e, t)
    {
        var n = e.timeout, r = e.style, i = void 0 === r ? {} : r;
        return {duration: i.transitionDuration || "number" == typeof n ? n : n[t.mode] || 0, delay: i.transitionDelay}
    }

    function ec(e)
    {
        return "scale(".concat(e, ", ").concat(Math.pow(e, 2), ")")
    }

    var tc = {entering: {opacity: 1, transform: ec(1)}, entered: {opacity: 1, transform: "none"}},
        nc = lt.forwardRef((function (e, t)
        {
            var n = e.children, r = e.in, i = e.onEnter, o = e.onExit, a = e.style, s = e.timeout,
                l = void 0 === s ? "auto" : s, c = zt(e, ["children", "in", "onEnter", "onExit", "style", "timeout"]),
                u = lt.useRef(), d = lt.useRef(), p = zs(n.ref, t), f = Va();
            return lt.useEffect((function ()
            {
                return function ()
                {
                    clearTimeout(u.current)
                }
            }), []), lt.createElement(ol, At({
                appear: !0, in: r, onEnter: function (e, t)
                {
                    !function (e)
                    {
                        e.scrollTop
                    }(e);
                    var n, r = Ql({style: a, timeout: l}, {mode: "enter"}), o = r.duration, s = r.delay;
                    "auto" === l ? (n = f.transitions.getAutoHeightDuration(e.clientHeight), d.current = n) : n = o, e.style.transition = [f.transitions.create("opacity", {
                        duration: n,
                        delay: s
                    }), f.transitions.create("transform", {duration: .666 * n, delay: s})].join(","), i && i(e, t)
                }, onExit: function (e)
                {
                    var t, n = Ql({style: a, timeout: l}, {mode: "exit"}), r = n.duration, i = n.delay;
                    "auto" === l ? (t = f.transitions.getAutoHeightDuration(e.clientHeight), d.current = t) : t = r, e.style.transition = [f.transitions.create("opacity", {
                        duration: t,
                        delay: i
                    }), f.transitions.create("transform", {
                        duration: .666 * t,
                        delay: i || .333 * t
                    })].join(","), e.style.opacity = "0", e.style.transform = ec(.75), o && o(e)
                }, addEndListener: function (e, t)
                {
                    "auto" === l && (u.current = setTimeout(t, d.current || 0))
                }, timeout: "auto" === l ? null : l
            }, c), (function (e, t)
            {
                return lt.cloneElement(n, At({
                    style: At({
                        opacity: 0,
                        transform: ec(.75),
                        visibility: "exited" !== e || r ? void 0 : "hidden"
                    }, tc[e], {}, a, {}, n.props.style), ref: p
                }, t))
            }))
        }));
    nc.muiSupportAuto = !0;
    var rc = lt.forwardRef((function (e, t)
    {
        var n = e.classes, r = e.className, i = e.component, o = void 0 === i ? "div" : i, a = e.square,
            s = void 0 !== a && a, l = e.elevation, c = void 0 === l ? 1 : l, u = e.variant,
            d = void 0 === u ? "elevation" : u,
            p = zt(e, ["classes", "className", "component", "square", "elevation", "variant"]);
        return lt.createElement(o, At({
            className: ka(n.root, r, "outlined" === d ? n.outlined : n["elevation".concat(c)], !s && n.rounded),
            ref: t
        }, p))
    })), ic = Rs((function (e)
    {
        var t = {};
        return e.shadows.forEach((function (e, n)
        {
            t["elevation".concat(n)] = {boxShadow: e}
        })), At({
            root: {
                backgroundColor: e.palette.background.paper,
                color: e.palette.text.primary,
                transition: e.transitions.create("box-shadow")
            }, rounded: {borderRadius: e.shape.borderRadius}, outlined: {border: "1px solid ".concat(e.palette.divider)}
        }, t)
    }), {name: "PwzrPaper"})(rc);

    function oc(e, t)
    {
        var n = 0;
        return "number" == typeof t ? n = t : "center" === t ? n = e.height / 2 : "bottom" === t && (n = e.height), n
    }

    function ac(e, t)
    {
        var n = 0;
        return "number" == typeof t ? n = t : "center" === t ? n = e.width / 2 : "right" === t && (n = e.width), n
    }

    function sc(e)
    {
        return [e.horizontal, e.vertical].map((function (e)
        {
            return "number" == typeof e ? "".concat(e, "px") : e
        })).join(" ")
    }

    function lc(e)
    {
        return "function" == typeof e ? e() : e
    }

    var cc = lt.forwardRef((function (e, t)
    {
        var n = e.action, r = e.anchorEl, i = e.anchorOrigin,
            o = void 0 === i ? {vertical: "top", horizontal: "left"} : i, a = e.anchorPosition, s = e.anchorReference,
            l = void 0 === s ? "anchorEl" : s, c = e.children, u = e.classes, d = e.className, p = e.container,
            f = e.elevation, h = void 0 === f ? 8 : f, m = e.getContentAnchorEl, v = e.marginThreshold,
            g = void 0 === v ? 16 : v, y = e.onEnter, b = e.onEntered, w = e.onEntering, x = e.onExit, _ = e.onExited,
            C = e.onExiting, E = e.open, S = e.PaperProps, k = void 0 === S ? {} : S, T = e.transformOrigin,
            O = void 0 === T ? {vertical: "top", horizontal: "left"} : T, M = e.TransitionComponent,
            R = void 0 === M ? nc : M, P = e.transitionDuration, z = void 0 === P ? "auto" : P, I = e.TransitionProps,
            A = void 0 === I ? {} : I,
            L = zt(e, ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "classes", "className", "container", "elevation", "getContentAnchorEl", "marginThreshold", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "open", "PaperProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"]),
            D = lt.useRef(), N = lt.useCallback((function (e)
            {
                if ("anchorPosition" === l) return a;
                var t = lc(r), n = t instanceof Nl(t).Element ? t : Dl(D.current).body, i = n.getBoundingClientRect(),
                    s = 0 === e ? o.vertical : "center";
                return {top: i.top + oc(i, s), left: i.left + ac(i, o.horizontal)}
            }), [r, o.horizontal, o.vertical, a, l]), F = lt.useCallback((function (e)
            {
                var t = 0;
                if (m && "anchorEl" === l)
                {
                    var n = m(e);
                    if (n && e.contains(n))
                    {
                        var r = function (e, t)
                        {
                            for (var n = t, r = 0; n && n !== e;) r += (n = n.parentElement).scrollTop;
                            return r
                        }(e, n);
                        t = n.offsetTop + n.clientHeight / 2 - r || 0
                    }
                    0
                }
                return t
            }), [o.vertical, l, m]), B = lt.useCallback((function (e)
            {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return {vertical: oc(e, O.vertical) + t, horizontal: ac(e, O.horizontal)}
            }), [O.horizontal, O.vertical]), W = lt.useCallback((function (e)
            {
                var t = F(e), n = {width: e.offsetWidth, height: e.offsetHeight}, i = B(n, t);
                if ("none" === l) return {top: null, left: null, transformOrigin: sc(i)};
                var o = N(t), a = o.top - i.vertical, s = o.left - i.horizontal, c = a + n.height, u = s + n.width,
                    d = Nl(lc(r)), p = d.innerHeight - g, f = d.innerWidth - g;
                if (a < g)
                {
                    var h = a - g;
                    a -= h, i.vertical += h
                } else if (c > p)
                {
                    var m = c - p;
                    a -= m, i.vertical += m
                }
                if (s < g)
                {
                    var v = s - g;
                    s -= v, i.horizontal += v
                } else if (u > f)
                {
                    var y = u - f;
                    s -= y, i.horizontal += y
                }
                return {top: "".concat(Math.round(a), "px"), left: "".concat(Math.round(s), "px"), transformOrigin: sc(i)}
            }), [r, l, N, F, B, g]), $ = lt.useCallback((function ()
            {
                var e = D.current;
                if (e)
                {
                    var t = W(e);
                    null !== t.top && (e.style.top = t.top), null !== t.left && (e.style.left = t.left), e.style.transformOrigin = t.transformOrigin
                }
            }), [W]), H = lt.useCallback((function (e)
            {
                D.current = lt.findDOMNode(e)
            }), []);
        lt.useEffect((function ()
        {
            E && $()
        })), lt.useImperativeHandle(n, (function ()
        {
            return E ? {
                updatePosition: function ()
                {
                    $()
                }
            } : null
        }), [E, $]), lt.useEffect((function ()
        {
            if (E)
            {
                var e = Ll((function ()
                {
                    $()
                }));
                return window.addEventListener("resize", e), function ()
                {
                    e.clear(), window.removeEventListener("rezise", e)
                }
            }
        }), [E, $]);
        var j = z;
        "auto" !== z || R.muiSupportAuto || (j = void 0);
        var V = p || (r ? Dl(lc(r)).body : void 0);
        return lt.createElement(Jl, At({
            container: V,
            open: E,
            ref: t,
            BackdropProps: {invisible: !0},
            className: ka(u.root, d)
        }, L), lt.createElement(R, At({
            appear: !0,
            in: E,
            onEnter: y,
            onEntered: b,
            onExit: x,
            onExited: _,
            onExiting: C,
            timeout: j
        }, A, {
            onEntering: Fl((function (e, t)
            {
                w && w(e, t), $()
            }), A.onEntering)
        }), lt.createElement(ic, At({elevation: h, ref: H}, k, {className: ka(u.paper, k.className)}), c)))
    })), uc = Rs({
        root: {},
        paper: {
            position: "absolute",
            overflowY: "auto",
            overflowX: "hidden",
            minWidth: 16,
            minHeight: 16,
            maxWidth: "calc(100% - 32px)",
            maxHeight: "calc(100% - 32px)",
            outline: 0
        }
    }, {name: "PwzrPopover"})(cc), dc = lt.forwardRef((function (e, t)
    {
        var n = e.children, r = e.classes, i = e.className, o = e.component, a = void 0 === o ? "ul" : o, s = e.dense,
            l = void 0 !== s && s, c = e.disablePadding, u = void 0 !== c && c, d = e.subheader,
            p = zt(e, ["children", "classes", "className", "component", "dense", "disablePadding", "subheader"]),
            f = lt.useMemo((function ()
            {
                return {dense: l}
            }), [l]);
        return lt.createElement(Ml.Provider, {value: f}, lt.createElement(a, At({
            className: ka(r.root, i, l && r.dense, !u && r.padding, d && r.subheader),
            ref: t
        }, p), d, n))
    })), pc = Rs({
        root: {listStyle: "none", margin: 0, padding: 0, position: "relative"},
        padding: {paddingTop: 8, paddingBottom: 8},
        dense: {},
        subheader: {paddingTop: 0}
    }, {name: "PwzrList"})(dc);

    function fc(e, t, n)
    {
        return e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : n ? null : e.firstChild
    }

    function hc(e, t, n)
    {
        return e === t ? n ? e.firstChild : e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : n ? null : e.lastChild
    }

    function mc(e, t)
    {
        if (void 0 === t) return !0;
        var n = e.innerText;
        return void 0 === n && (n = e.textContent), 0 !== (n = n.trim().toLowerCase()).length && (t.repeating ? n[0] === t.keys[0] : 0 === n.indexOf(t.keys.join("")))
    }

    function vc(e, t, n, r, i)
    {
        for (var o = !1, a = r(e, t, !!t && n); a;)
        {
            if (a === e.firstChild)
            {
                if (o) return !1;
                o = !0
            }
            if (a.hasAttribute("tabindex") && !a.disabled && "true" !== a.getAttribute("aria-disabled") && mc(a, i)) return a.focus(), !0;
            a = r(e, a, n)
        }
        return !1
    }

    var gc = "undefined" == typeof window ? lt.useEffect : lt.useLayoutEffect, yc = lt.forwardRef((function (e, t)
        {
            var n = e.actions, r = e.autoFocus, i = void 0 !== r && r, o = e.autoFocusItem, a = void 0 !== o && o,
                s = e.children, l = e.className, c = e.onKeyDown, u = e.disableListWrap, d = void 0 !== u && u,
                p = e.variant, f = void 0 === p ? "selectedMenu" : p,
                h = zt(e, ["actions", "autoFocus", "autoFocusItem", "children", "className", "onKeyDown", "disableListWrap", "variant"]),
                m = lt.useRef(null), v = lt.useRef({keys: [], repeating: !0, previousKeyMatched: !0, lastTime: null});
            gc((function ()
            {
                i && m.current.focus()
            }), [i]), lt.useImperativeHandle(n, (function ()
            {
                return {
                    adjustStyleForScrollbar: function (e, t)
                    {
                        var n = !m.current.style.width;
                        if (e.clientHeight < m.current.clientHeight && n)
                        {
                            var r = "".concat($l(), "px");
                            m.current.style["rtl" === t.direction ? "paddingLeft" : "paddingRight"] = r, m.current.style.width = "calc(100% + ".concat(r, ")")
                        }
                        return m.current
                    }
                }
            }), []);
            var g = zs(lt.useCallback((function (e)
            {
                m.current = lt.findDOMNode(e)
            }), []), t), y = -1;
            lt.Children.forEach(s, (function (e, t)
            {
                lt.isValidElement(e) && (e.props.disabled || ("selectedMenu" === f && e.props.selected || -1 === y) && (y = t))
            }));
            var b = lt.Children.map(s, (function (e, t)
            {
                if (t === y)
                {
                    var n = {};
                    if (a && (n.autoFocus = !0), void 0 === e.props.tabIndex && "selectedMenu" === f && (n.tabIndex = 0), null !== n) return lt.cloneElement(e, n)
                }
                return e
            }));
            return lt.createElement(pc, At({
                role: "menu", ref: g, className: l, onKeyDown: function (e)
                {
                    var t = m.current, n = e.key, r = Dl(t).activeElement;
                    if ("ArrowDown" === n) e.preventDefault(), vc(t, r, d, fc); else if ("ArrowUp" === n) e.preventDefault(), vc(t, r, d, hc); else if ("Home" === n) e.preventDefault(), vc(t, null, d, fc); else if ("End" === n) e.preventDefault(), vc(t, null, d, hc); else if (1 === n.length)
                    {
                        var i = v.current, o = n.toLowerCase(), a = performance.now();
                        i.keys.length > 0 && (a - i.lastTime > 500 ? (i.keys = [], i.repeating = !0, i.previousKeyMatched = !0) : i.repeating && o !== i.keys[0] && (i.repeating = !1)), i.lastTime = a, i.keys.push(o);
                        var s = r && !i.repeating && mc(r, i);
                        i.previousKeyMatched && (s || vc(t, r, !1, fc, i)) ? e.preventDefault() : i.previousKeyMatched = !1
                    }
                    c && c(e)
                }, tabIndex: i ? 0 : -1
            }, h), b)
        })), bc = {vertical: "top", horizontal: "right"}, wc = {vertical: "top", horizontal: "left"},
        xc = lt.forwardRef((function (e, t)
        {
            var n = e.autoFocus, r = void 0 === n || n, i = e.children, o = e.classes, a = e.disableAutoFocusItem,
                s = void 0 !== a && a, l = e.MenuListProps, c = void 0 === l ? {} : l, u = e.onClose, d = e.onEntering,
                p = e.open, f = e.PaperProps, h = void 0 === f ? {} : f, m = e.PopoverClasses, v = e.transitionDuration,
                g = void 0 === v ? "auto" : v, y = e.variant, b = void 0 === y ? "selectedMenu" : y,
                w = zt(e, ["autoFocus", "children", "classes", "disableAutoFocusItem", "MenuListProps", "onClose", "onEntering", "open", "PaperProps", "PopoverClasses", "transitionDuration", "variant"]),
                x = Va(), _ = r && !s && p, C = lt.useRef(null), E = lt.useRef(null), S = -1;
            lt.Children.map(i, (function (e, t)
            {
                lt.isValidElement(e) && (e.props.disabled || ("menu" !== b && e.props.selected || -1 === S) && (S = t))
            }));
            var k = lt.Children.map(i, (function (e, t)
            {
                return t === S ? lt.cloneElement(e, {
                    ref: function (t)
                    {
                        E.current = lt.findDOMNode(t), Ps(e.ref, t)
                    }
                }) : e
            }));
            return lt.createElement(uc, At({
                getContentAnchorEl: function ()
                {
                    return E.current
                },
                classes: m,
                onClose: u,
                onEntering: function (e, t)
                {
                    C.current && C.current.adjustStyleForScrollbar(e, x), d && d(e, t)
                },
                anchorOrigin: "rtl" === x.direction ? bc : wc,
                transformOrigin: "rtl" === x.direction ? bc : wc,
                PaperProps: At({}, h, {classes: At({}, h.classes, {root: o.paper})}),
                open: p,
                ref: t,
                transitionDuration: g
            }, w), lt.createElement(yc, At({
                onKeyDown: function (e)
                {
                    "Tab" === e.key && (e.preventDefault(), u && u(e, "tabKeyDown"))
                }, actions: C, autoFocus: r && (-1 === S || s), autoFocusItem: _, variant: b
            }, c, {className: ka(o.list, c.className)}), k))
        })), _c = Rs({
            paper: {maxHeight: "calc(100% - 96px)", WebkitOverflowScrolling: "touch"},
            list: {outline: 0}
        }, {name: "PwzrMenu"})(xc);

    function Cc(e)
    {
        return null != e && !(Array.isArray(e) && 0 === e.length)
    }

    function Ec(e)
    {
        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        return e && (Cc(e.value) && "" !== e.value || t && Cc(e.defaultValue) && "" !== e.defaultValue)
    }

    function Sc(e)
    {
        var t = e.controlled, n = e.default, r = (e.name, lt.useRef(void 0 !== t).current), i = lt.useState(n),
            o = i[0], a = i[1];
        return [r ? t : o, lt.useCallback((function (e)
        {
            r || a(e)
        }), [])]
    }

    function kc(e, t)
    {
        return "object" === Dt(t) && null !== t ? e === t : String(e) === String(t)
    }

    var Tc = lt.forwardRef((function (e, t)
    {
        var n = e.autoFocus, r = e.autoWidth, i = e.children, o = e.classes, a = e.className, s = e.defaultValue,
            l = e.disabled, c = e.displayEmpty, u = e.IconComponent, d = e.inputRef, p = e.labelId, f = e.MenuProps,
            h = void 0 === f ? {} : f, m = e.multiple, v = e.name, g = e.onBlur, y = e.onChange, b = e.onClose,
            w = e.onFocus, x = e.onOpen, _ = e.open, C = e.readOnly, E = e.renderValue,
            S = (e.required, e.SelectDisplayProps), k = void 0 === S ? {} : S, T = e.tabIndex, O = (e.type, e.value),
            M = e.variant, R = void 0 === M ? "standard" : M,
            P = zt(e, ["autoFocus", "autoWidth", "children", "classes", "className", "defaultValue", "disabled", "displayEmpty", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "required", "SelectDisplayProps", "tabIndex", "type", "value", "variant"]),
            z = hs(Sc({controlled: O, default: s, name: "SelectInput"}), 2), I = z[0], A = z[1], L = lt.useRef(null),
            D = lt.useState(null), N = D[0], F = D[1], B = lt.useRef(null != _).current, W = lt.useState(), $ = W[0],
            H = W[1], j = lt.useState(!1), V = j[0], q = j[1], U = zs(t, d);
        lt.useImperativeHandle(U, (function ()
        {
            return {
                focus: function ()
                {
                    N.focus()
                }, node: L.current, value: I
            }
        }), [N, I]), lt.useEffect((function ()
        {
            n && N && N.focus()
        }), [n, N]);
        var G, Z, K = function (e, t)
        {
            e ? x && x(t) : b && b(t), B || (H(r ? null : N.clientWidth), q(e))
        }, Y = function (e)
        {
            return function (t)
            {
                var n;
                if (m || K(!1, t), m)
                {
                    n = Array.isArray(I) ? mo(I) : [];
                    var r = I.indexOf(e.props.value);
                    -1 === r ? n.push(e.props.value) : n.splice(r, 1)
                } else n = e.props.value;
                A(n), y && (t.persist(), Object.defineProperty(t, "target", {
                    writable: !0,
                    value: {value: n, name: v}
                }), y(t, e))
            }
        }, X = null !== N && (B ? _ : V);
        delete P["aria-invalid"];
        var J = [], Q = !1;
        (Ec({value: I}) || c) && (E ? G = E(I) : Q = !0);
        var ee = lt.Children.map(i, (function (e)
        {
            if (!lt.isValidElement(e)) return null;
            var t;
            if (m)
            {
                if (!Array.isArray(I)) throw new Error("Material-UI: the `value` prop must be an array when using the `Select` component with `multiple`.");
                (t = I.some((function (t)
                {
                    return kc(t, e.props.value)
                }))) && Q && J.push(e.props.children)
            } else (t = kc(I, e.props.value)) && Q && (Z = e.props.children);
            return t && !0, lt.cloneElement(e, {
                "aria-selected": t ? "true" : void 0,
                onClick: Y(e),
                onKeyUp: function (t)
                {
                    " " === t.key && t.preventDefault();
                    var n = e.props.onKeyUp;
                    "function" == typeof n && n(t)
                },
                role: "option",
                selected: t,
                value: void 0,
                "data-value": e.props.value
            })
        }));
        Q && (G = m ? J.join(", ") : Z);
        var te, ne = $;
        !r && B && N && (ne = N.clientWidth), te = void 0 !== T ? T : l ? null : 0;
        var re = k.id || (v ? "mui-component-select-".concat(v) : void 0);
        return lt.createElement(lt.Fragment, null, lt.createElement("div", At({
            className: ka(o.root, o.select, o.selectMenu, o[R], a, l && o.disabled),
            ref: F,
            tabIndex: te,
            role: "button",
            "aria-expanded": X ? "true" : void 0,
            "aria-labelledby": "".concat(p || "", " ").concat(re || ""),
            "aria-haspopup": "listbox",
            onKeyDown: function (e)
            {
                if (!C)
                {
                    -1 !== [" ", "ArrowUp", "ArrowDown", "Enter"].indexOf(e.key) && (e.preventDefault(), K(!0, e))
                }
            },
            onMouseDown: l || C ? null : function (e)
            {
                0 === e.button && (e.preventDefault(), N.focus(), K(!0, e))
            },
            onBlur: function (e)
            {
                !X && g && (e.persist(), Object.defineProperty(e, "target", {
                    writable: !0,
                    value: {value: I, name: v}
                }), g(e))
            },
            onFocus: w
        }, k, {id: re}), function (e)
        {
            return null == e || "string" == typeof e && !e.trim()
        }(G) ? lt.createElement("span", {dangerouslySetInnerHTML: {__html: "&#8203;"}}) : G), lt.createElement("input", At({
            value: Array.isArray(I) ? I.join(",") : I,
            name: v,
            ref: L,
            type: "hidden",
            autoFocus: n
        }, P)), lt.createElement(u, {className: ka(o.icon, o["icon".concat(fl(R))], X && o.iconOpen)}), lt.createElement(_c, At({
            id: "menu-".concat(v || ""),
            anchorEl: N,
            open: X,
            onClose: function (e)
            {
                K(!1, e)
            }
        }, h, {
            MenuListProps: At({"aria-labelledby": p, role: "listbox", disableListWrap: !0}, h.MenuListProps),
            PaperProps: At({}, h.PaperProps, {style: At({minWidth: ne}, null != h.PaperProps ? h.PaperProps.style : null)})
        }), ee))
    }));

    function Oc(e)
    {
        var t = e.props, n = e.states, r = e.muiFormControl;
        return n.reduce((function (e, n)
        {
            return e[n] = t[n], r && void 0 === t[n] && (e[n] = r[n]), e
        }), {})
    }

    var Mc = lt.createContext();

    function Rc()
    {
        return lt.useContext(Mc)
    }

    var Pc = {}, zc = lt.forwardRef((function (e, t)
    {
        var n = e.children, r = e.classes, i = e.className, o = e.color, a = void 0 === o ? "inherit" : o,
            s = e.component, l = void 0 === s ? "svg" : s, c = e.fontSize, u = void 0 === c ? "default" : c,
            d = e.htmlColor, p = e.titleAccess, f = e.viewBox, h = void 0 === f ? "0 0 24 24" : f,
            m = zt(e, ["children", "classes", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"]);
        return lt.createElement(l, At({
            className: ka(r.root, i, "inherit" !== a && r["color".concat(fl(a))], "default" !== u && r["fontSize".concat(fl(u))]),
            focusable: "false",
            viewBox: h,
            color: d,
            "aria-hidden": p ? void 0 : "true",
            role: p ? "img" : "presentation",
            ref: t
        }, m), n, p ? lt.createElement("title", null, p) : null)
    }));
    zc.muiName = "SvgIcon";
    var Ic = Rs((function (e)
    {
        return {
            root: {
                userSelect: "none",
                width: "1em",
                height: "1em",
                display: "inline-block",
                fill: "currentColor",
                flexShrink: 0,
                fontSize: e.typography.pxToRem(24),
                transition: e.transitions.create("fill", {duration: e.transitions.duration.shorter})
            },
            colorPrimary: {color: e.palette.primary.main},
            colorSecondary: {color: e.palette.secondary.main},
            colorAction: {color: e.palette.action.active},
            colorError: {color: e.palette.error.main},
            colorDisabled: {color: e.palette.action.disabled},
            fontSizeInherit: {fontSize: "inherit"},
            fontSizeSmall: {fontSize: e.typography.pxToRem(20)},
            fontSizeLarge: {fontSize: e.typography.pxToRem(35)}
        }
    }), {name: "PwzrSvgIcon"})(zc);
    r(Pc, "default", (function ()
    {
        return Ic
    })), n(Pc);
    var Ac = function (e, t)
    {
        var n = lt.memo(lt.forwardRef((function (t, n)
        {
            return lt.createElement(Ic, At({}, t, {ref: n}), e)
        })));
        return n.muiName = Ic.muiName, n
    }(lt.createElement("path", {d: "M7 10l5 5 5-5z"}));

    function Lc(e, t)
    {
        return parseInt(e[t], 10) || 0
    }

    var Dc = "undefined" != typeof window ? lt.useLayoutEffect : lt.useEffect, Nc = {
        visibility: "hidden",
        position: "absolute",
        overflow: "hidden",
        height: 0,
        top: 0,
        left: 0,
        transform: "translateZ(0)"
    }, Fc = lt.forwardRef((function (e, t)
    {
        var n = e.onChange, r = e.rows, i = e.rowsMax, o = e.rowsMin, a = void 0 === o ? 1 : o, s = e.style,
            l = e.value, c = zt(e, ["onChange", "rows", "rowsMax", "rowsMin", "style", "value"]), u = r || a,
            d = lt.useRef(null != l).current, p = lt.useRef(null), f = zs(t, p), h = lt.useRef(null),
            m = lt.useState({}), v = m[0], g = m[1], y = lt.useCallback((function ()
            {
                var t = p.current, n = window.getComputedStyle(t), r = h.current;
                r.style.width = n.width, r.value = t.value || e.placeholder || "x";
                var o = n["box-sizing"], a = Lc(n, "padding-bottom") + Lc(n, "padding-top"),
                    s = Lc(n, "border-bottom-width") + Lc(n, "border-top-width"), l = r.scrollHeight - a;
                r.value = "x";
                var c = r.scrollHeight - a, d = l;
                u && (d = Math.max(Number(u) * c, d)), i && (d = Math.min(Number(i) * c, d));
                var f = (d = Math.max(d, c)) + ("border-box" === o ? a + s : 0), m = Math.abs(d - l) <= 1;
                g((function (e)
                {
                    return f > 0 && Math.abs((e.outerHeightStyle || 0) - f) > 1 || e.overflow !== m ? {
                        overflow: m,
                        outerHeightStyle: f
                    } : e
                }))
            }), [i, u, e.placeholder]);
        lt.useEffect((function ()
        {
            var e = Ll((function ()
            {
                y()
            }));
            return window.addEventListener("resize", e), function ()
            {
                e.clear(), window.removeEventListener("resize", e)
            }
        }), [y]), Dc((function ()
        {
            y()
        }));
        return lt.createElement(lt.Fragment, null, lt.createElement("textarea", At({
            value: l, onChange: function (e)
            {
                d || y(), n && n(e)
            }, ref: f, rows: u, style: At({height: v.outerHeightStyle, overflow: v.overflow ? "hidden" : null}, s)
        }, c)), lt.createElement("textarea", {
            "aria-hidden": !0,
            className: e.className,
            readOnly: !0,
            ref: h,
            tabIndex: -1,
            style: At({}, Nc, {}, s)
        }))
    })), Bc = "undefined" == typeof window ? lt.useEffect : lt.useLayoutEffect, Wc = lt.forwardRef((function (e, t)
    {
        var n = e["aria-describedby"], r = e.autoComplete, i = e.autoFocus, o = e.classes, a = e.className,
            s = (e.color, e.defaultValue), l = e.disabled, c = e.endAdornment, u = (e.error, e.fullWidth),
            d = void 0 !== u && u, p = e.id, f = e.inputComponent, h = void 0 === f ? "input" : f, m = e.inputProps,
            v = void 0 === m ? {} : m, g = e.inputRef, y = (e.margin, e.multiline), b = void 0 !== y && y, w = e.name,
            x = e.onBlur, _ = e.onChange, C = e.onClick, E = e.onFocus, S = e.onKeyDown, k = e.onKeyUp,
            T = e.placeholder, O = e.readOnly, M = e.renderSuffix, R = e.rows, P = e.rowsMax, z = e.rowsMin,
            I = e.startAdornment, A = e.type, L = void 0 === A ? "text" : A, D = e.value,
            N = zt(e, ["aria-describedby", "autoComplete", "autoFocus", "classes", "className", "color", "defaultValue", "disabled", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "rowsMax", "rowsMin", "startAdornment", "type", "value"]),
            F = null != v.value ? v.value : D, B = lt.useRef(null != F).current, W = lt.useRef(),
            $ = lt.useCallback((function (e)
            {
                0
            }), []), H = zs(v.ref, $), j = zs(g, H), V = zs(W, j), q = lt.useState(!1), U = q[0], G = q[1],
            Z = lt.useContext(Mc);
        var K = Oc({
            props: e,
            muiFormControl: Z,
            states: ["color", "disabled", "error", "hiddenLabel", "margin", "required", "filled"]
        });
        K.focused = Z ? Z.focused : U, lt.useEffect((function ()
        {
            !Z && l && U && (G(!1), x && x())
        }), [Z, l, U, x]);
        var Y = Z && Z.onFilled, X = Z && Z.onEmpty, J = lt.useCallback((function (e)
        {
            Ec(e) ? Y && Y() : X && X()
        }), [Y, X]);
        Bc((function ()
        {
            B && J({value: F})
        }), [F, J, B]);
        lt.useEffect((function ()
        {
            J(W.current)
        }), []);
        var Q = h, ee = At({}, v, {ref: V});
        "string" != typeof Q ? ee = At({inputRef: V, type: L}, ee, {ref: null}) : b ? !R || P || z ? (ee = At({
            rows: R,
            rowsMax: P
        }, ee), Q = Fc) : Q = "textarea" : ee = At({type: L}, ee);
        return lt.useEffect((function ()
        {
            Z && Z.setAdornedStart(Boolean(I))
        }), [Z, I]), lt.createElement("div", At({
            className: ka(o.root, o["color".concat(fl(K.color || "primary"))], a, K.disabled && o.disabled, K.error && o.error, d && o.fullWidth, K.focused && o.focused, Z && o.formControl, b && o.multiline, I && o.adornedStart, c && o.adornedEnd, "dense" === K.margin && o.marginDense),
            onClick: function (e)
            {
                W.current && e.currentTarget === e.target && W.current.focus(), C && C(e)
            },
            ref: t
        }, N), I, lt.createElement(Mc.Provider, {value: null}, lt.createElement(Q, At({
            "aria-invalid": K.error,
            "aria-describedby": n,
            autoComplete: r,
            autoFocus: i,
            defaultValue: s,
            disabled: K.disabled,
            id: p,
            onAnimationStart: function (e)
            {
                J("mui-auto-fill-cancel" === e.animationName ? W.current : {value: "x"})
            },
            name: w,
            placeholder: T,
            readOnly: O,
            required: K.required,
            rows: R,
            value: F,
            onKeyDown: S,
            onKeyUp: k
        }, ee, {
            className: ka(o.input, v.className, K.disabled && o.disabled, b && o.inputMultiline, K.hiddenLabel && o.inputHiddenLabel, I && o.inputAdornedStart, c && o.inputAdornedEnd, "search" === L && o.inputTypeSearch, "dense" === K.margin && o.inputMarginDense),
            onBlur: function (e)
            {
                x && x(e), v.onBlur && v.onBlur(e), Z && Z.onBlur ? Z.onBlur(e) : G(!1)
            },
            onChange: function (e)
            {
                if (!B)
                {
                    var t = e.target || W.current;
                    if (null == t) throw new TypeError("Material-UI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://material-ui.com/r/input-component-ref-interface for more info.");
                    J({value: t.value})
                }
                for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) r[i - 1] = arguments[i];
                v.onChange && v.onChange.apply(v, [e].concat(r)), _ && _.apply(void 0, [e].concat(r))
            },
            onFocus: function (e)
            {
                K.disabled ? e.stopPropagation() : (E && E(e), v.onFocus && v.onFocus(e), Z && Z.onFocus ? Z.onFocus(e) : G(!0))
            }
        }))), c, M ? M(At({}, K, {startAdornment: I})) : null)
    })), $c = Rs((function (e)
    {
        var t = "light" === e.palette.type, n = {
            color: "currentColor",
            opacity: t ? .42 : .5,
            transition: e.transitions.create("opacity", {duration: e.transitions.duration.shorter})
        }, r = {opacity: "0 !important"}, i = {opacity: t ? .42 : .5};
        return {
            "@global": {"@keyframes mui-auto-fill": {from: {}}, "@keyframes mui-auto-fill-cancel": {from: {}}},
            root: At({}, e.typography.body1, {
                color: e.palette.text.primary,
                lineHeight: "1.1875em",
                boxSizing: "border-box",
                position: "relative",
                cursor: "text",
                display: "inline-flex",
                alignItems: "center",
                "&$disabled": {color: e.palette.text.disabled, cursor: "default"}
            }),
            formControl: {},
            focused: {},
            disabled: {},
            adornedStart: {},
            adornedEnd: {},
            error: {},
            marginDense: {},
            multiline: {padding: "".concat(6, "px 0 ").concat(7, "px"), "&$marginDense": {paddingTop: 3}},
            colorSecondary: {},
            fullWidth: {width: "100%"},
            input: {
                font: "inherit",
                color: "currentColor",
                padding: "".concat(6, "px 0 ").concat(7, "px"),
                border: 0,
                boxSizing: "content-box",
                background: "none",
                height: "1.1875em",
                margin: 0,
                WebkitTapHighlightColor: "transparent",
                display: "block",
                minWidth: 0,
                width: "100%",
                animationName: "mui-auto-fill-cancel",
                "&::-webkit-input-placeholder": n,
                "&::-moz-placeholder": n,
                "&:-ms-input-placeholder": n,
                "&::-ms-input-placeholder": n,
                "&:focus": {outline: 0},
                "&:invalid": {boxShadow: "none"},
                "&::-webkit-search-decoration": {"-webkit-appearance": "none"},
                "label[data-shrink=false] + $formControl &": {
                    "&::-webkit-input-placeholder": r,
                    "&::-moz-placeholder": r,
                    "&:-ms-input-placeholder": r,
                    "&::-ms-input-placeholder": r,
                    "&:focus::-webkit-input-placeholder": i,
                    "&:focus::-moz-placeholder": i,
                    "&:focus:-ms-input-placeholder": i,
                    "&:focus::-ms-input-placeholder": i
                },
                "&$disabled": {opacity: 1},
                "&:-webkit-autofill": {animationDuration: "5000s", animationName: "mui-auto-fill"}
            },
            inputMarginDense: {paddingTop: 3},
            inputMultiline: {height: "auto", resize: "none", padding: 0},
            inputTypeSearch: {"-moz-appearance": "textfield", "-webkit-appearance": "textfield"},
            inputAdornedStart: {},
            inputAdornedEnd: {},
            inputHiddenLabel: {}
        }
    }), {name: "PwzrInputBase"})(Wc), Hc = lt.forwardRef((function (e, t)
    {
        var n = e.disableUnderline, r = e.classes, i = e.fullWidth, o = void 0 !== i && i, a = e.inputComponent,
            s = void 0 === a ? "input" : a, l = e.multiline, c = void 0 !== l && l, u = e.type,
            d = void 0 === u ? "text" : u,
            p = zt(e, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);
        return lt.createElement($c, At({
            classes: At({}, r, {root: ka(r.root, !n && r.underline), underline: null}),
            fullWidth: o,
            inputComponent: s,
            multiline: c,
            ref: t,
            type: d
        }, p))
    }));
    Hc.muiName = "Input";
    var jc = Rs((function (e)
    {
        var t = "light" === e.palette.type ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
        return {
            root: {position: "relative"},
            formControl: {"label + &": {marginTop: 16}},
            focused: {},
            disabled: {},
            colorSecondary: {"&$underline:after": {borderBottomColor: e.palette.secondary.main}},
            underline: {
                "&:after": {
                    borderBottom: "2px solid ".concat(e.palette.primary.main),
                    left: 0,
                    bottom: 0,
                    content: '""',
                    position: "absolute",
                    right: 0,
                    transform: "scaleX(0)",
                    transition: e.transitions.create("transform", {
                        duration: e.transitions.duration.shorter,
                        easing: e.transitions.easing.easeOut
                    }),
                    pointerEvents: "none"
                },
                "&$focused:after": {transform: "scaleX(1)"},
                "&$error:after": {borderBottomColor: e.palette.error.main, transform: "scaleX(1)"},
                "&:before": {
                    borderBottom: "1px solid ".concat(t),
                    left: 0,
                    bottom: 0,
                    content: '"\\00a0"',
                    position: "absolute",
                    right: 0,
                    transition: e.transitions.create("border-bottom-color", {duration: e.transitions.duration.shorter}),
                    pointerEvents: "none"
                },
                "&:hover:not($disabled):before": {
                    borderBottom: "2px solid ".concat(e.palette.text.primary),
                    "@media (hover: none)": {borderBottom: "1px solid ".concat(t)}
                },
                "&$disabled:before": {borderBottomStyle: "dotted"}
            },
            error: {},
            marginDense: {},
            multiline: {},
            fullWidth: {},
            input: {},
            inputMarginDense: {},
            inputMultiline: {},
            inputTypeSearch: {}
        }
    }), {name: "PwzrInput"})(Hc), Vc = lt.forwardRef((function (e, t)
    {
        var n = e.classes, r = e.className, i = e.disabled, o = e.IconComponent, a = e.inputRef, s = e.variant,
            l = void 0 === s ? "standard" : s,
            c = zt(e, ["classes", "className", "disabled", "IconComponent", "inputRef", "variant"]);
        return lt.createElement(lt.Fragment, null, lt.createElement("select", At({
            className: ka(n.root, n.select, n[l], r, i && n.disabled),
            disabled: i,
            ref: a || t
        }, c)), e.multiple ? null : lt.createElement(o, {className: ka(n.icon, n["icon".concat(fl(l))])}))
    })), qc = function (e)
    {
        return {
            root: {},
            select: {
                "-moz-appearance": "none",
                "-webkit-appearance": "none",
                userSelect: "none",
                borderRadius: 0,
                minWidth: 16,
                cursor: "pointer",
                "&:focus": {
                    backgroundColor: "light" === e.palette.type ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)",
                    borderRadius: 0
                },
                "&::-ms-expand": {display: "none"},
                "&$disabled": {cursor: "default"},
                "&[multiple]": {height: "auto"},
                "&:not([multiple]) option, &:not([multiple]) optgroup": {backgroundColor: e.palette.background.paper},
                "&&": {paddingRight: 24}
            },
            filled: {"&&": {paddingRight: 32}},
            outlined: {borderRadius: e.shape.borderRadius, "&&": {paddingRight: 32}},
            selectMenu: {height: "auto", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden"},
            disabled: {},
            icon: {
                position: "absolute",
                right: 0,
                top: "calc(50% - 12px)",
                color: e.palette.action.active,
                pointerEvents: "none"
            },
            iconOpen: {transform: "rotate(180deg)"},
            iconFilled: {right: 7},
            iconOutlined: {right: 7}
        }
    }, Uc = lt.createElement(jc, null), Gc = lt.forwardRef((function (e, t)
    {
        var n = e.children, r = e.classes, i = e.IconComponent, o = void 0 === i ? Ac : i, a = e.input,
            s = void 0 === a ? Uc : a, l = e.inputProps,
            c = (e.variant, zt(e, ["children", "classes", "IconComponent", "input", "inputProps", "variant"])),
            u = Oc({props: e, muiFormControl: Rc(), states: ["variant"]});
        return lt.cloneElement(s, At({
            inputComponent: Vc,
            inputProps: At({
                children: n,
                classes: r,
                IconComponent: o,
                variant: u.variant,
                type: void 0
            }, l, {}, s ? s.props.inputProps : {}),
            ref: t
        }, c))
    }));
    Gc.muiName = "Select";
    Rs(qc, {name: "PwzrNativeSelect"})(Gc);
    var Zc = lt.forwardRef((function (e, t)
    {
        var n = e.disableUnderline, r = e.classes, i = e.fullWidth, o = void 0 !== i && i, a = e.inputComponent,
            s = void 0 === a ? "input" : a, l = e.multiline, c = void 0 !== l && l, u = e.type,
            d = void 0 === u ? "text" : u,
            p = zt(e, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);
        return lt.createElement($c, At({
            classes: At({}, r, {root: ka(r.root, !n && r.underline), underline: null}),
            fullWidth: o,
            inputComponent: s,
            multiline: c,
            ref: t,
            type: d
        }, p))
    }));
    Zc.muiName = "Input";
    var Kc = Rs((function (e)
    {
        var t = "light" === e.palette.type, n = t ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)",
            r = t ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.09)";
        return {
            root: {
                position: "relative",
                backgroundColor: r,
                borderTopLeftRadius: e.shape.borderRadius,
                borderTopRightRadius: e.shape.borderRadius,
                transition: e.transitions.create("background-color", {
                    duration: e.transitions.duration.shorter,
                    easing: e.transitions.easing.easeOut
                }),
                "&:hover": {
                    backgroundColor: t ? "rgba(0, 0, 0, 0.13)" : "rgba(255, 255, 255, 0.13)",
                    "@media (hover: none)": {backgroundColor: r}
                },
                "&$focused": {backgroundColor: t ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.09)"},
                "&$disabled": {backgroundColor: t ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)"}
            },
            colorSecondary: {"&$underline:after": {borderBottomColor: e.palette.secondary.main}},
            underline: {
                "&:after": {
                    borderBottom: "2px solid ".concat(e.palette.primary.main),
                    left: 0,
                    bottom: 0,
                    content: '""',
                    position: "absolute",
                    right: 0,
                    transform: "scaleX(0)",
                    transition: e.transitions.create("transform", {
                        duration: e.transitions.duration.shorter,
                        easing: e.transitions.easing.easeOut
                    }),
                    pointerEvents: "none"
                },
                "&$focused:after": {transform: "scaleX(1)"},
                "&$error:after": {borderBottomColor: e.palette.error.main, transform: "scaleX(1)"},
                "&:before": {
                    borderBottom: "1px solid ".concat(n),
                    left: 0,
                    bottom: 0,
                    content: '"\\00a0"',
                    position: "absolute",
                    right: 0,
                    transition: e.transitions.create("border-bottom-color", {duration: e.transitions.duration.shorter}),
                    pointerEvents: "none"
                },
                "&:hover:before": {borderBottom: "1px solid ".concat(e.palette.text.primary)},
                "&$disabled:before": {borderBottomStyle: "dotted"}
            },
            focused: {},
            disabled: {},
            adornedStart: {paddingLeft: 12},
            adornedEnd: {paddingRight: 12},
            error: {},
            marginDense: {},
            multiline: {padding: "27px 12px 10px", "&$marginDense": {paddingTop: 23, paddingBottom: 6}},
            input: {
                padding: "27px 12px 10px",
                "&:-webkit-autofill": {
                    WebkitBoxShadow: "dark" === e.palette.type ? "0 0 0 100px #266798 inset" : null,
                    WebkitTextFillColor: "dark" === e.palette.type ? "#fff" : null,
                    borderTopLeftRadius: "inherit",
                    borderTopRightRadius: "inherit"
                }
            },
            inputMarginDense: {paddingTop: 23, paddingBottom: 6},
            inputHiddenLabel: {
                paddingTop: 18,
                paddingBottom: 19,
                "&$inputMarginDense": {paddingTop: 10, paddingBottom: 11}
            },
            inputMultiline: {padding: 0},
            inputAdornedStart: {paddingLeft: 0},
            inputAdornedEnd: {paddingRight: 0}
        }
    }), {name: "PwzrFilledInput"})(Zc), Yc = lt.forwardRef((function (e, t)
    {
        e.children;
        var n = e.classes, r = e.className, i = e.label, o = e.labelWidth, a = e.notched, s = e.style,
            l = zt(e, ["children", "classes", "className", "label", "labelWidth", "notched", "style"]),
            c = "rtl" === Va().direction ? "right" : "left";
        if (void 0 !== i) return lt.createElement("fieldset", At({
            "aria-hidden": !0,
            className: ka(n.root, r),
            ref: t,
            style: s
        }, l), lt.createElement("legend", {className: ka(n.legendLabelled, a && n.legendNotched)}, i ? lt.createElement("span", null, i) : lt.createElement("span", {dangerouslySetInnerHTML: {__html: "&#8203;"}})));
        var u = o > 0 ? .75 * o + 8 : .01;
        return lt.createElement("fieldset", At({
            "aria-hidden": !0,
            style: At(Rt({}, "padding".concat(fl(c)), 8), s),
            className: ka(n.root, r),
            ref: t
        }, l), lt.createElement("legend", {
            className: n.legend,
            style: {width: a ? u : .01}
        }, lt.createElement("span", {dangerouslySetInnerHTML: {__html: "&#8203;"}})))
    })), Xc = Rs((function (e)
    {
        return {
            root: {
                position: "absolute",
                bottom: 0,
                right: 0,
                top: -5,
                left: 0,
                margin: 0,
                padding: 0,
                paddingLeft: 8,
                pointerEvents: "none",
                borderRadius: "inherit",
                borderStyle: "solid",
                borderWidth: 1
            },
            legend: {
                textAlign: "left",
                padding: 0,
                lineHeight: "11px",
                transition: e.transitions.create("width", {duration: 150, easing: e.transitions.easing.easeOut})
            },
            legendLabelled: {
                display: "block",
                width: "auto",
                textAlign: "left",
                padding: 0,
                height: 11,
                fontSize: "0.75em",
                visibility: "hidden",
                maxWidth: .01,
                transition: e.transitions.create("max-width", {duration: 50, easing: e.transitions.easing.easeOut}),
                "& span": {paddingLeft: 5, paddingRight: 5}
            },
            legendNotched: {
                maxWidth: 1e3,
                transition: e.transitions.create("max-width", {
                    duration: 100,
                    easing: e.transitions.easing.easeOut,
                    delay: 50
                })
            }
        }
    }), {name: "PrivateNotchedOutline"})(Yc), Jc = lt.forwardRef((function (e, t)
    {
        var n = e.classes, r = e.fullWidth, i = void 0 !== r && r, o = e.inputComponent, a = void 0 === o ? "input" : o,
            s = e.label, l = e.labelWidth, c = void 0 === l ? 0 : l, u = e.multiline, d = void 0 !== u && u,
            p = e.notched, f = e.type, h = void 0 === f ? "text" : f,
            m = zt(e, ["classes", "fullWidth", "inputComponent", "label", "labelWidth", "multiline", "notched", "type"]);
        return lt.createElement($c, At({
            renderSuffix: function (e)
            {
                return lt.createElement(Xc, {
                    className: n.notchedOutline,
                    label: s,
                    labelWidth: c,
                    notched: void 0 !== p ? p : Boolean(e.startAdornment || e.filled || e.focused)
                })
            },
            classes: At({}, n, {root: ka(n.root, n.underline), notchedOutline: null}),
            fullWidth: i,
            inputComponent: a,
            multiline: d,
            ref: t,
            type: h
        }, m))
    }));
    Jc.muiName = "Input";
    var Qc = Rs((function (e)
        {
            var t = "light" === e.palette.type ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
            return {
                root: {
                    position: "relative",
                    borderRadius: e.shape.borderRadius,
                    "&:hover $notchedOutline": {borderColor: e.palette.text.primary},
                    "@media (hover: none)": {"&:hover $notchedOutline": {borderColor: t}},
                    "&$focused $notchedOutline": {borderColor: e.palette.primary.main, borderWidth: 2},
                    "&$error $notchedOutline": {borderColor: e.palette.error.main},
                    "&$disabled $notchedOutline": {borderColor: e.palette.action.disabled}
                },
                colorSecondary: {"&$focused $notchedOutline": {borderColor: e.palette.secondary.main}},
                focused: {},
                disabled: {},
                adornedStart: {paddingLeft: 14},
                adornedEnd: {paddingRight: 14},
                error: {},
                marginDense: {},
                multiline: {padding: "18.5px 14px", "&$marginDense": {paddingTop: 10.5, paddingBottom: 10.5}},
                notchedOutline: {borderColor: t},
                input: {
                    padding: "18.5px 14px",
                    "&:-webkit-autofill": {
                        WebkitBoxShadow: "dark" === e.palette.type ? "0 0 0 100px #266798 inset" : null,
                        WebkitTextFillColor: "dark" === e.palette.type ? "#fff" : null,
                        borderRadius: "inherit"
                    }
                },
                inputMarginDense: {paddingTop: 10.5, paddingBottom: 10.5},
                inputMultiline: {padding: 0},
                inputAdornedStart: {paddingLeft: 0},
                inputAdornedEnd: {paddingRight: 0}
            }
        }), {name: "PwzrOutlinedInput"})(Jc), eu = qc, tu = lt.createElement(jc, null), nu = lt.createElement(Kc, null),
        ru = lt.forwardRef((function e(t, n)
        {
            var r = t.autoWidth, i = void 0 !== r && r, o = t.children, a = t.classes, s = t.displayEmpty,
                l = void 0 !== s && s, c = t.IconComponent, u = void 0 === c ? Ac : c, d = t.id, p = t.input,
                f = t.inputProps, h = t.label, m = t.labelId, v = t.labelWidth, g = void 0 === v ? 0 : v,
                y = t.MenuProps, b = t.multiple, w = void 0 !== b && b, x = t.native, _ = void 0 !== x && x,
                C = t.onClose, E = t.onOpen, S = t.open, k = t.renderValue, T = t.SelectDisplayProps, O = t.variant,
                M = void 0 === O ? "standard" : O,
                R = zt(t, ["autoWidth", "children", "classes", "displayEmpty", "IconComponent", "id", "input", "inputProps", "label", "labelId", "labelWidth", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"]),
                P = _ ? Vc : Tc, z = Oc({props: t, muiFormControl: Rc(), states: ["variant"]}).variant || M,
                I = p || {standard: tu, outlined: lt.createElement(Qc, {label: h, labelWidth: g}), filled: nu}[z];
            return lt.cloneElement(I, At({
                inputComponent: P,
                inputProps: At({
                    children: o,
                    IconComponent: u,
                    variant: z,
                    type: void 0,
                    multiple: w
                }, _ ? {id: d} : {
                    autoWidth: i,
                    displayEmpty: l,
                    labelId: m,
                    MenuProps: y,
                    onClose: C,
                    onOpen: E,
                    open: S,
                    renderValue: k,
                    SelectDisplayProps: At({id: d}, T)
                }, {}, f, {
                    classes: f ? Ii({
                        baseClasses: a,
                        newClasses: f.classes,
                        Component: e
                    }) : a
                }, p ? p.props.inputProps : {}),
                ref: n
            }, R))
        }));
    ru.muiName = "Select";
    var iu = Rs(eu, {name: "PwzrSelect"})(ru),
        ou = "undefined" != typeof window && "undefined" != typeof document && "undefined" != typeof navigator,
        au = function ()
        {
            for (var e = ["Edge", "Trident", "Firefox"], t = 0; t < e.length; t += 1) if (ou && navigator.userAgent.indexOf(e[t]) >= 0) return 1;
            return 0
        }();
    /**!
     * @fileOverview Kickass library to create and place poppers near their reference elements.
     * @version 1.16.1
     * @license
     * Copyright (c) 2016 Federico Zivolo and contributors
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in all
     * copies or substantial portions of the Software.
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
     * SOFTWARE.
     */var su = ou && window.Promise ? function (e)
    {
        var t = !1;
        return function ()
        {
            t || (t = !0, window.Promise.resolve().then((function ()
            {
                t = !1, e()
            })))
        }
    } : function (e)
    {
        var t = !1;
        return function ()
        {
            t || (t = !0, setTimeout((function ()
            {
                t = !1, e()
            }), au))
        }
    };

    function lu(e)
    {
        return e && "[object Function]" === {}.toString.call(e)
    }

    function cu(e, t)
    {
        if (1 !== e.nodeType) return [];
        var n = e.ownerDocument.defaultView.getComputedStyle(e, null);
        return t ? n[t] : n
    }

    function uu(e)
    {
        return "HTML" === e.nodeName ? e : e.parentNode || e.host
    }

    function du(e)
    {
        if (!e) return document.body;
        switch (e.nodeName)
        {
            case"HTML":
            case"BODY":
                return e.ownerDocument.body;
            case"#document":
                return e.body
        }
        var t = cu(e), n = t.overflow, r = t.overflowX, i = t.overflowY;
        return /(auto|scroll|overlay)/.test(n + i + r) ? e : du(uu(e))
    }

    function pu(e)
    {
        return e && e.referenceNode ? e.referenceNode : e
    }

    var fu = ou && !(!window.MSInputMethodContext || !document.documentMode),
        hu = ou && /MSIE 10/.test(navigator.userAgent);

    function mu(e)
    {
        return 11 === e ? fu : 10 === e ? hu : fu || hu
    }

    function vu(e)
    {
        if (!e) return document.documentElement;
        for (var t = mu(10) ? document.body : null, n = e.offsetParent || null; n === t && e.nextElementSibling;) n = (e = e.nextElementSibling).offsetParent;
        var r = n && n.nodeName;
        return r && "BODY" !== r && "HTML" !== r ? -1 !== ["TH", "TD", "TABLE"].indexOf(n.nodeName) && "static" === cu(n, "position") ? vu(n) : n : e ? e.ownerDocument.documentElement : document.documentElement
    }

    function gu(e)
    {
        return null !== e.parentNode ? gu(e.parentNode) : e
    }

    function yu(e, t)
    {
        if (!(e && e.nodeType && t && t.nodeType)) return document.documentElement;
        var n = e.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_FOLLOWING, r = n ? e : t, i = n ? t : e,
            o = document.createRange();
        o.setStart(r, 0), o.setEnd(i, 0);
        var a, s, l = o.commonAncestorContainer;
        if (e !== l && t !== l || r.contains(i)) return "BODY" === (s = (a = l).nodeName) || "HTML" !== s && vu(a.firstElementChild) !== a ? vu(l) : l;
        var c = gu(e);
        return c.host ? yu(c.host, t) : yu(e, gu(t).host)
    }

    function bu(e)
    {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "top",
            n = "top" === t ? "scrollTop" : "scrollLeft", r = e.nodeName;
        if ("BODY" === r || "HTML" === r)
        {
            var i = e.ownerDocument.documentElement, o = e.ownerDocument.scrollingElement || i;
            return o[n]
        }
        return e[n]
    }

    function wu(e, t)
    {
        var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], r = bu(t, "top"), i = bu(t, "left"),
            o = n ? -1 : 1;
        return e.top += r * o, e.bottom += r * o, e.left += i * o, e.right += i * o, e
    }

    function xu(e, t)
    {
        var n = "x" === t ? "Left" : "Top", r = "Left" === n ? "Right" : "Bottom";
        return parseFloat(e["border" + n + "Width"]) + parseFloat(e["border" + r + "Width"])
    }

    function _u(e, t, n, r)
    {
        return Math.max(t["offset" + e], t["scroll" + e], n["client" + e], n["offset" + e], n["scroll" + e], mu(10) ? parseInt(n["offset" + e]) + parseInt(r["margin" + ("Height" === e ? "Top" : "Left")]) + parseInt(r["margin" + ("Height" === e ? "Bottom" : "Right")]) : 0)
    }

    function Cu(e)
    {
        var t = e.body, n = e.documentElement, r = mu(10) && getComputedStyle(n);
        return {height: _u("Height", t, n, r), width: _u("Width", t, n, r)}
    }

    var Eu = function (e, t)
    {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
    }, Su = function ()
    {
        function e(e, t)
        {
            for (var n = 0; n < t.length; n++)
            {
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r)
            }
        }

        return function (t, n, r)
        {
            return n && e(t.prototype, n), r && e(t, r), t
        }
    }(), ku = function (e, t, n)
    {
        return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n, e
    }, Tu = Object.assign || function (e)
    {
        for (var t = 1; t < arguments.length; t++)
        {
            var n = arguments[t];
            for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r])
        }
        return e
    };

    function Ou(e)
    {
        return Tu({}, e, {right: e.left + e.width, bottom: e.top + e.height})
    }

    function Mu(e)
    {
        var t = {};
        try
        {
            if (mu(10))
            {
                t = e.getBoundingClientRect();
                var n = bu(e, "top"), r = bu(e, "left");
                t.top += n, t.left += r, t.bottom += n, t.right += r
            } else t = e.getBoundingClientRect()
        } catch (e)
        {
        }
        var i = {left: t.left, top: t.top, width: t.right - t.left, height: t.bottom - t.top},
            o = "HTML" === e.nodeName ? Cu(e.ownerDocument) : {}, a = o.width || e.clientWidth || i.width,
            s = o.height || e.clientHeight || i.height, l = e.offsetWidth - a, c = e.offsetHeight - s;
        if (l || c)
        {
            var u = cu(e);
            l -= xu(u, "x"), c -= xu(u, "y"), i.width -= l, i.height -= c
        }
        return Ou(i)
    }

    function Ru(e, t)
    {
        var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], r = mu(10), i = "HTML" === t.nodeName,
            o = Mu(e), a = Mu(t), s = du(e), l = cu(t), c = parseFloat(l.borderTopWidth),
            u = parseFloat(l.borderLeftWidth);
        n && i && (a.top = Math.max(a.top, 0), a.left = Math.max(a.left, 0));
        var d = Ou({top: o.top - a.top - c, left: o.left - a.left - u, width: o.width, height: o.height});
        if (d.marginTop = 0, d.marginLeft = 0, !r && i)
        {
            var p = parseFloat(l.marginTop), f = parseFloat(l.marginLeft);
            d.top -= c - p, d.bottom -= c - p, d.left -= u - f, d.right -= u - f, d.marginTop = p, d.marginLeft = f
        }
        return (r && !n ? t.contains(s) : t === s && "BODY" !== s.nodeName) && (d = wu(d, t)), d
    }

    function Pu(e)
    {
        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], n = e.ownerDocument.documentElement,
            r = Ru(e, n), i = Math.max(n.clientWidth, window.innerWidth || 0),
            o = Math.max(n.clientHeight, window.innerHeight || 0), a = t ? 0 : bu(n), s = t ? 0 : bu(n, "left"),
            l = {top: a - r.top + r.marginTop, left: s - r.left + r.marginLeft, width: i, height: o};
        return Ou(l)
    }

    function zu(e)
    {
        var t = e.nodeName;
        if ("BODY" === t || "HTML" === t) return !1;
        if ("fixed" === cu(e, "position")) return !0;
        var n = uu(e);
        return !!n && zu(n)
    }

    function Iu(e)
    {
        if (!e || !e.parentElement || mu()) return document.documentElement;
        for (var t = e.parentElement; t && "none" === cu(t, "transform");) t = t.parentElement;
        return t || document.documentElement
    }

    function Au(e, t, n, r)
    {
        var i = arguments.length > 4 && void 0 !== arguments[4] && arguments[4], o = {top: 0, left: 0},
            a = i ? Iu(e) : yu(e, pu(t));
        if ("viewport" === r) o = Pu(a, i); else
        {
            var s = void 0;
            "scrollParent" === r ? "BODY" === (s = du(uu(t))).nodeName && (s = e.ownerDocument.documentElement) : s = "window" === r ? e.ownerDocument.documentElement : r;
            var l = Ru(s, a, i);
            if ("HTML" !== s.nodeName || zu(a)) o = l; else
            {
                var c = Cu(e.ownerDocument), u = c.height, d = c.width;
                o.top += l.top - l.marginTop, o.bottom = u + l.top, o.left += l.left - l.marginLeft, o.right = d + l.left
            }
        }
        var p = "number" == typeof (n = n || 0);
        return o.left += p ? n : n.left || 0, o.top += p ? n : n.top || 0, o.right -= p ? n : n.right || 0, o.bottom -= p ? n : n.bottom || 0, o
    }

    function Lu(e)
    {
        return e.width * e.height
    }

    function Du(e, t, n, r, i)
    {
        var o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0;
        if (-1 === e.indexOf("auto")) return e;
        var a = Au(n, r, o, i), s = {
            top: {width: a.width, height: t.top - a.top},
            right: {width: a.right - t.right, height: a.height},
            bottom: {width: a.width, height: a.bottom - t.bottom},
            left: {width: t.left - a.left, height: a.height}
        }, l = Object.keys(s).map((function (e)
        {
            return Tu({key: e}, s[e], {area: Lu(s[e])})
        })).sort((function (e, t)
        {
            return t.area - e.area
        })), c = l.filter((function (e)
        {
            var t = e.width, r = e.height;
            return t >= n.clientWidth && r >= n.clientHeight
        })), u = c.length > 0 ? c[0].key : l[0].key, d = e.split("-")[1];
        return u + (d ? "-" + d : "")
    }

    function Nu(e, t, n)
    {
        var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null, i = r ? Iu(t) : yu(t, pu(n));
        return Ru(n, i, r)
    }

    function Fu(e)
    {
        var t = e.ownerDocument.defaultView.getComputedStyle(e),
            n = parseFloat(t.marginTop || 0) + parseFloat(t.marginBottom || 0),
            r = parseFloat(t.marginLeft || 0) + parseFloat(t.marginRight || 0);
        return {width: e.offsetWidth + r, height: e.offsetHeight + n}
    }

    function Bu(e)
    {
        var t = {left: "right", right: "left", bottom: "top", top: "bottom"};
        return e.replace(/left|right|bottom|top/g, (function (e)
        {
            return t[e]
        }))
    }

    function Wu(e, t, n)
    {
        n = n.split("-")[0];
        var r = Fu(e), i = {width: r.width, height: r.height}, o = -1 !== ["right", "left"].indexOf(n),
            a = o ? "top" : "left", s = o ? "left" : "top", l = o ? "height" : "width", c = o ? "width" : "height";
        return i[a] = t[a] + t[l] / 2 - r[l] / 2, i[s] = n === s ? t[s] - r[c] : t[Bu(s)], i
    }

    function $u(e, t)
    {
        return Array.prototype.find ? e.find(t) : e.filter(t)[0]
    }

    function Hu(e, t, n)
    {
        return (void 0 === n ? e : e.slice(0, function (e, t, n)
        {
            if (Array.prototype.findIndex) return e.findIndex((function (e)
            {
                return e[t] === n
            }));
            var r = $u(e, (function (e)
            {
                return e[t] === n
            }));
            return e.indexOf(r)
        }(e, "name", n))).forEach((function (e)
        {
            e.function && console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
            var n = e.function || e.fn;
            e.enabled && lu(n) && (t.offsets.popper = Ou(t.offsets.popper), t.offsets.reference = Ou(t.offsets.reference), t = n(t, e))
        })), t
    }

    function ju()
    {
        if (!this.state.isDestroyed)
        {
            var e = {instance: this, styles: {}, arrowStyles: {}, attributes: {}, flipped: !1, offsets: {}};
            e.offsets.reference = Nu(this.state, this.popper, this.reference, this.options.positionFixed), e.placement = Du(this.options.placement, e.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding), e.originalPlacement = e.placement, e.positionFixed = this.options.positionFixed, e.offsets.popper = Wu(this.popper, e.offsets.reference, e.placement), e.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute", e = Hu(this.modifiers, e), this.state.isCreated ? this.options.onUpdate(e) : (this.state.isCreated = !0, this.options.onCreate(e))
        }
    }

    function Vu(e, t)
    {
        return e.some((function (e)
        {
            var n = e.name;
            return e.enabled && n === t
        }))
    }

    function qu(e)
    {
        for (var t = [!1, "ms", "Webkit", "Moz", "O"], n = e.charAt(0).toUpperCase() + e.slice(1), r = 0; r < t.length; r++)
        {
            var i = t[r], o = i ? "" + i + n : e;
            if (void 0 !== document.body.style[o]) return o
        }
        return null
    }

    function Uu()
    {
        return this.state.isDestroyed = !0, Vu(this.modifiers, "applyStyle") && (this.popper.removeAttribute("x-placement"), this.popper.style.position = "", this.popper.style.top = "", this.popper.style.left = "", this.popper.style.right = "", this.popper.style.bottom = "", this.popper.style.willChange = "", this.popper.style[qu("transform")] = ""), this.disableEventListeners(), this.options.removeOnDestroy && this.popper.parentNode.removeChild(this.popper), this
    }

    function Gu(e)
    {
        var t = e.ownerDocument;
        return t ? t.defaultView : window
    }

    function Zu(e, t, n, r)
    {
        var i = "BODY" === e.nodeName, o = i ? e.ownerDocument.defaultView : e;
        o.addEventListener(t, n, {passive: !0}), i || Zu(du(o.parentNode), t, n, r), r.push(o)
    }

    function Ku(e, t, n, r)
    {
        n.updateBound = r, Gu(e).addEventListener("resize", n.updateBound, {passive: !0});
        var i = du(e);
        return Zu(i, "scroll", n.updateBound, n.scrollParents), n.scrollElement = i, n.eventsEnabled = !0, n
    }

    function Yu()
    {
        this.state.eventsEnabled || (this.state = Ku(this.reference, this.options, this.state, this.scheduleUpdate))
    }

    function Xu()
    {
        var e, t;
        this.state.eventsEnabled && (cancelAnimationFrame(this.scheduleUpdate), this.state = (e = this.reference, t = this.state, Gu(e).removeEventListener("resize", t.updateBound), t.scrollParents.forEach((function (e)
        {
            e.removeEventListener("scroll", t.updateBound)
        })), t.updateBound = null, t.scrollParents = [], t.scrollElement = null, t.eventsEnabled = !1, t))
    }

    function Ju(e)
    {
        return "" !== e && !isNaN(parseFloat(e)) && isFinite(e)
    }

    function Qu(e, t)
    {
        Object.keys(t).forEach((function (n)
        {
            var r = "";
            -1 !== ["width", "height", "top", "right", "bottom", "left"].indexOf(n) && Ju(t[n]) && (r = "px"), e.style[n] = t[n] + r
        }))
    }

    var ed = ou && /Firefox/i.test(navigator.userAgent);

    function td(e, t, n)
    {
        var r = $u(e, (function (e)
        {
            return e.name === t
        })), i = !!r && e.some((function (e)
        {
            return e.name === n && e.enabled && e.order < r.order
        }));
        if (!i)
        {
            var o = "`" + t + "`", a = "`" + n + "`";
            console.warn(a + " modifier is required by " + o + " modifier in order to work, be sure to include it before " + o + "!")
        }
        return i
    }

    var nd = ["auto-start", "auto", "auto-end", "top-start", "top", "top-end", "right-start", "right", "right-end", "bottom-end", "bottom", "bottom-start", "left-end", "left", "left-start"],
        rd = nd.slice(3);

    function id(e)
    {
        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], n = rd.indexOf(e),
            r = rd.slice(n + 1).concat(rd.slice(0, n));
        return t ? r.reverse() : r
    }

    var od = "flip", ad = "clockwise", sd = "counterclockwise";

    function ld(e, t, n, r)
    {
        var i = [0, 0], o = -1 !== ["right", "left"].indexOf(r), a = e.split(/(\+|\-)/).map((function (e)
        {
            return e.trim()
        })), s = a.indexOf($u(a, (function (e)
        {
            return -1 !== e.search(/,|\s/)
        })));
        a[s] && -1 === a[s].indexOf(",") && console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
        var l = /\s*,\s*|\s+/,
            c = -1 !== s ? [a.slice(0, s).concat([a[s].split(l)[0]]), [a[s].split(l)[1]].concat(a.slice(s + 1))] : [a];
        return (c = c.map((function (e, r)
        {
            var i = (1 === r ? !o : o) ? "height" : "width", a = !1;
            return e.reduce((function (e, t)
            {
                return "" === e[e.length - 1] && -1 !== ["+", "-"].indexOf(t) ? (e[e.length - 1] = t, a = !0, e) : a ? (e[e.length - 1] += t, a = !1, e) : e.concat(t)
            }), []).map((function (e)
            {
                return function (e, t, n, r)
                {
                    var i = e.match(/((?:\-|\+)?\d*\.?\d*)(.*)/), o = +i[1], a = i[2];
                    if (!o) return e;
                    if (0 === a.indexOf("%"))
                    {
                        var s = void 0;
                        switch (a)
                        {
                            case"%p":
                                s = n;
                                break;
                            case"%":
                            case"%r":
                            default:
                                s = r
                        }
                        return Ou(s)[t] / 100 * o
                    }
                    if ("vh" === a || "vw" === a) return ("vh" === a ? Math.max(document.documentElement.clientHeight, window.innerHeight || 0) : Math.max(document.documentElement.clientWidth, window.innerWidth || 0)) / 100 * o;
                    return o
                }(e, i, t, n)
            }))
        }))).forEach((function (e, t)
        {
            e.forEach((function (n, r)
            {
                Ju(n) && (i[t] += n * ("-" === e[r - 1] ? -1 : 1))
            }))
        })), i
    }

    var cd = {
        placement: "bottom", positionFixed: !1, eventsEnabled: !0, removeOnDestroy: !1, onCreate: function ()
        {
        }, onUpdate: function ()
        {
        }, modifiers: {
            shift: {
                order: 100, enabled: !0, fn: function (e)
                {
                    var t = e.placement, n = t.split("-")[0], r = t.split("-")[1];
                    if (r)
                    {
                        var i = e.offsets, o = i.reference, a = i.popper, s = -1 !== ["bottom", "top"].indexOf(n),
                            l = s ? "left" : "top", c = s ? "width" : "height",
                            u = {start: ku({}, l, o[l]), end: ku({}, l, o[l] + o[c] - a[c])};
                        e.offsets.popper = Tu({}, a, u[r])
                    }
                    return e
                }
            }, offset: {
                order: 200, enabled: !0, fn: function (e, t)
                {
                    var n = t.offset, r = e.placement, i = e.offsets, o = i.popper, a = i.reference,
                        s = r.split("-")[0], l = void 0;
                    return l = Ju(+n) ? [+n, 0] : ld(n, o, a, s), "left" === s ? (o.top += l[0], o.left -= l[1]) : "right" === s ? (o.top += l[0], o.left += l[1]) : "top" === s ? (o.left += l[0], o.top -= l[1]) : "bottom" === s && (o.left += l[0], o.top += l[1]), e.popper = o, e
                }, offset: 0
            }, preventOverflow: {
                order: 300, enabled: !0, fn: function (e, t)
                {
                    var n = t.boundariesElement || vu(e.instance.popper);
                    e.instance.reference === n && (n = vu(n));
                    var r = qu("transform"), i = e.instance.popper.style, o = i.top, a = i.left, s = i[r];
                    i.top = "", i.left = "", i[r] = "";
                    var l = Au(e.instance.popper, e.instance.reference, t.padding, n, e.positionFixed);
                    i.top = o, i.left = a, i[r] = s, t.boundaries = l;
                    var c = t.priority, u = e.offsets.popper, d = {
                        primary: function (e)
                        {
                            var n = u[e];
                            return u[e] < l[e] && !t.escapeWithReference && (n = Math.max(u[e], l[e])), ku({}, e, n)
                        }, secondary: function (e)
                        {
                            var n = "right" === e ? "left" : "top", r = u[n];
                            return u[e] > l[e] && !t.escapeWithReference && (r = Math.min(u[n], l[e] - ("right" === e ? u.width : u.height))), ku({}, n, r)
                        }
                    };
                    return c.forEach((function (e)
                    {
                        var t = -1 !== ["left", "top"].indexOf(e) ? "primary" : "secondary";
                        u = Tu({}, u, d[t](e))
                    })), e.offsets.popper = u, e
                }, priority: ["left", "right", "top", "bottom"], padding: 5, boundariesElement: "scrollParent"
            }, keepTogether: {
                order: 400, enabled: !0, fn: function (e)
                {
                    var t = e.offsets, n = t.popper, r = t.reference, i = e.placement.split("-")[0], o = Math.floor,
                        a = -1 !== ["top", "bottom"].indexOf(i), s = a ? "right" : "bottom", l = a ? "left" : "top",
                        c = a ? "width" : "height";
                    return n[s] < o(r[l]) && (e.offsets.popper[l] = o(r[l]) - n[c]), n[l] > o(r[s]) && (e.offsets.popper[l] = o(r[s])), e
                }
            }, arrow: {
                order: 500, enabled: !0, fn: function (e, t)
                {
                    var n;
                    if (!td(e.instance.modifiers, "arrow", "keepTogether")) return e;
                    var r = t.element;
                    if ("string" == typeof r)
                    {
                        if (!(r = e.instance.popper.querySelector(r))) return e
                    } else if (!e.instance.popper.contains(r)) return console.warn("WARNING: `arrow.element` must be child of its popper element!"), e;
                    var i = e.placement.split("-")[0], o = e.offsets, a = o.popper, s = o.reference,
                        l = -1 !== ["left", "right"].indexOf(i), c = l ? "height" : "width", u = l ? "Top" : "Left",
                        d = u.toLowerCase(), p = l ? "left" : "top", f = l ? "bottom" : "right", h = Fu(r)[c];
                    s[f] - h < a[d] && (e.offsets.popper[d] -= a[d] - (s[f] - h)), s[d] + h > a[f] && (e.offsets.popper[d] += s[d] + h - a[f]), e.offsets.popper = Ou(e.offsets.popper);
                    var m = s[d] + s[c] / 2 - h / 2, v = cu(e.instance.popper), g = parseFloat(v["margin" + u]),
                        y = parseFloat(v["border" + u + "Width"]), b = m - e.offsets.popper[d] - g - y;
                    return b = Math.max(Math.min(a[c] - h, b), 0), e.arrowElement = r, e.offsets.arrow = (ku(n = {}, d, Math.round(b)), ku(n, p, ""), n), e
                }, element: "[x-arrow]"
            }, flip: {
                order: 600,
                enabled: !0,
                fn: function (e, t)
                {
                    if (Vu(e.instance.modifiers, "inner")) return e;
                    if (e.flipped && e.placement === e.originalPlacement) return e;
                    var n = Au(e.instance.popper, e.instance.reference, t.padding, t.boundariesElement, e.positionFixed),
                        r = e.placement.split("-")[0], i = Bu(r), o = e.placement.split("-")[1] || "", a = [];
                    switch (t.behavior)
                    {
                        case od:
                            a = [r, i];
                            break;
                        case ad:
                            a = id(r);
                            break;
                        case sd:
                            a = id(r, !0);
                            break;
                        default:
                            a = t.behavior
                    }
                    return a.forEach((function (s, l)
                    {
                        if (r !== s || a.length === l + 1) return e;
                        r = e.placement.split("-")[0], i = Bu(r);
                        var c = e.offsets.popper, u = e.offsets.reference, d = Math.floor,
                            p = "left" === r && d(c.right) > d(u.left) || "right" === r && d(c.left) < d(u.right) || "top" === r && d(c.bottom) > d(u.top) || "bottom" === r && d(c.top) < d(u.bottom),
                            f = d(c.left) < d(n.left), h = d(c.right) > d(n.right), m = d(c.top) < d(n.top),
                            v = d(c.bottom) > d(n.bottom),
                            g = "left" === r && f || "right" === r && h || "top" === r && m || "bottom" === r && v,
                            y = -1 !== ["top", "bottom"].indexOf(r),
                            b = !!t.flipVariations && (y && "start" === o && f || y && "end" === o && h || !y && "start" === o && m || !y && "end" === o && v),
                            w = !!t.flipVariationsByContent && (y && "start" === o && h || y && "end" === o && f || !y && "start" === o && v || !y && "end" === o && m),
                            x = b || w;
                        (p || g || x) && (e.flipped = !0, (p || g) && (r = a[l + 1]), x && (o = function (e)
                        {
                            return "end" === e ? "start" : "start" === e ? "end" : e
                        }(o)), e.placement = r + (o ? "-" + o : ""), e.offsets.popper = Tu({}, e.offsets.popper, Wu(e.instance.popper, e.offsets.reference, e.placement)), e = Hu(e.instance.modifiers, e, "flip"))
                    })), e
                },
                behavior: "flip",
                padding: 5,
                boundariesElement: "viewport",
                flipVariations: !1,
                flipVariationsByContent: !1
            }, inner: {
                order: 700, enabled: !1, fn: function (e)
                {
                    var t = e.placement, n = t.split("-")[0], r = e.offsets, i = r.popper, o = r.reference,
                        a = -1 !== ["left", "right"].indexOf(n), s = -1 === ["top", "left"].indexOf(n);
                    return i[a ? "left" : "top"] = o[n] - (s ? i[a ? "width" : "height"] : 0), e.placement = Bu(t), e.offsets.popper = Ou(i), e
                }
            }, hide: {
                order: 800, enabled: !0, fn: function (e)
                {
                    if (!td(e.instance.modifiers, "hide", "preventOverflow")) return e;
                    var t = e.offsets.reference, n = $u(e.instance.modifiers, (function (e)
                    {
                        return "preventOverflow" === e.name
                    })).boundaries;
                    if (t.bottom < n.top || t.left > n.right || t.top > n.bottom || t.right < n.left)
                    {
                        if (!0 === e.hide) return e;
                        e.hide = !0, e.attributes["x-out-of-boundaries"] = ""
                    } else
                    {
                        if (!1 === e.hide) return e;
                        e.hide = !1, e.attributes["x-out-of-boundaries"] = !1
                    }
                    return e
                }
            }, computeStyle: {
                order: 850, enabled: !0, fn: function (e, t)
                {
                    var n = t.x, r = t.y, i = e.offsets.popper, o = $u(e.instance.modifiers, (function (e)
                    {
                        return "applyStyle" === e.name
                    })).gpuAcceleration;
                    void 0 !== o && console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
                    var a = void 0 !== o ? o : t.gpuAcceleration, s = vu(e.instance.popper), l = Mu(s),
                        c = {position: i.position}, u = function (e, t)
                        {
                            var n = e.offsets, r = n.popper, i = n.reference, o = Math.round, a = Math.floor,
                                s = function (e)
                                {
                                    return e
                                }, l = o(i.width), c = o(r.width), u = -1 !== ["left", "right"].indexOf(e.placement),
                                d = -1 !== e.placement.indexOf("-"), p = t ? u || d || l % 2 == c % 2 ? o : a : s,
                                f = t ? o : s;
                            return {
                                left: p(l % 2 == 1 && c % 2 == 1 && !d && t ? r.left - 1 : r.left),
                                top: f(r.top),
                                bottom: f(r.bottom),
                                right: p(r.right)
                            }
                        }(e, window.devicePixelRatio < 2 || !ed), d = "bottom" === n ? "top" : "bottom",
                        p = "right" === r ? "left" : "right", f = qu("transform"), h = void 0, m = void 0;
                    if (m = "bottom" === d ? "HTML" === s.nodeName ? -s.clientHeight + u.bottom : -l.height + u.bottom : u.top, h = "right" === p ? "HTML" === s.nodeName ? -s.clientWidth + u.right : -l.width + u.right : u.left, a && f) c[f] = "translate3d(" + h + "px, " + m + "px, 0)", c[d] = 0, c[p] = 0, c.willChange = "transform"; else
                    {
                        var v = "bottom" === d ? -1 : 1, g = "right" === p ? -1 : 1;
                        c[d] = m * v, c[p] = h * g, c.willChange = d + ", " + p
                    }
                    var y = {"x-placement": e.placement};
                    return e.attributes = Tu({}, y, e.attributes), e.styles = Tu({}, c, e.styles), e.arrowStyles = Tu({}, e.offsets.arrow, e.arrowStyles), e
                }, gpuAcceleration: !0, x: "bottom", y: "right"
            }, applyStyle: {
                order: 900, enabled: !0, fn: function (e)
                {
                    var t, n;
                    return Qu(e.instance.popper, e.styles), t = e.instance.popper, n = e.attributes, Object.keys(n).forEach((function (e)
                    {
                        !1 !== n[e] ? t.setAttribute(e, n[e]) : t.removeAttribute(e)
                    })), e.arrowElement && Object.keys(e.arrowStyles).length && Qu(e.arrowElement, e.arrowStyles), e
                }, onLoad: function (e, t, n, r, i)
                {
                    var o = Nu(i, t, e, n.positionFixed),
                        a = Du(n.placement, o, t, e, n.modifiers.flip.boundariesElement, n.modifiers.flip.padding);
                    return t.setAttribute("x-placement", a), Qu(t, {position: n.positionFixed ? "fixed" : "absolute"}), n
                }, gpuAcceleration: void 0
            }
        }
    }, ud = function ()
    {
        function e(t, n)
        {
            var r = this, i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            Eu(this, e), this.scheduleUpdate = function ()
            {
                return requestAnimationFrame(r.update)
            }, this.update = su(this.update.bind(this)), this.options = Tu({}, e.Defaults, i), this.state = {
                isDestroyed: !1,
                isCreated: !1,
                scrollParents: []
            }, this.reference = t && t.jquery ? t[0] : t, this.popper = n && n.jquery ? n[0] : n, this.options.modifiers = {}, Object.keys(Tu({}, e.Defaults.modifiers, i.modifiers)).forEach((function (t)
            {
                r.options.modifiers[t] = Tu({}, e.Defaults.modifiers[t] || {}, i.modifiers ? i.modifiers[t] : {})
            })), this.modifiers = Object.keys(this.options.modifiers).map((function (e)
            {
                return Tu({name: e}, r.options.modifiers[e])
            })).sort((function (e, t)
            {
                return e.order - t.order
            })), this.modifiers.forEach((function (e)
            {
                e.enabled && lu(e.onLoad) && e.onLoad(r.reference, r.popper, r.options, e, r.state)
            })), this.update();
            var o = this.options.eventsEnabled;
            o && this.enableEventListeners(), this.state.eventsEnabled = o
        }

        return Su(e, [{
            key: "update", value: function ()
            {
                return ju.call(this)
            }
        }, {
            key: "destroy", value: function ()
            {
                return Uu.call(this)
            }
        }, {
            key: "enableEventListeners", value: function ()
            {
                return Yu.call(this)
            }
        }, {
            key: "disableEventListeners", value: function ()
            {
                return Xu.call(this)
            }
        }]), e
    }();

    function dd(e)
    {
        return "function" == typeof e ? e() : e
    }

    ud.Utils = ("undefined" != typeof window ? window : e).PopperUtils, ud.placements = nd, ud.Defaults = cd;
    var pd = "undefined" != typeof window ? lt.useLayoutEffect : lt.useEffect, fd = {},
        hd = lt.forwardRef((function (e, t)
        {
            var n = e.anchorEl, r = e.children, i = e.container, o = e.disablePortal, a = void 0 !== o && o,
                s = e.keepMounted, l = void 0 !== s && s, c = e.modifiers, u = e.open, d = e.placement,
                p = void 0 === d ? "bottom" : d, f = e.popperOptions, h = void 0 === f ? fd : f, m = e.popperRef,
                v = e.transition, g = void 0 !== v && v,
                y = zt(e, ["anchorEl", "children", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "transition"]),
                b = lt.useRef(null), w = zs(b, t), x = lt.useRef(null), _ = zs(x, m), C = lt.useRef(_);
            pd((function ()
            {
                C.current = _
            }), [_]), lt.useImperativeHandle(m, (function ()
            {
                return x.current
            }), []);
            var E = lt.useState(!0), S = E[0], k = E[1], T = function (e, t)
            {
                if ("ltr" === (t && t.direction || "ltr")) return e;
                switch (e)
                {
                    case"bottom-end":
                        return "bottom-start";
                    case"bottom-start":
                        return "bottom-end";
                    case"top-end":
                        return "top-start";
                    case"top-start":
                        return "top-end";
                    default:
                        return e
                }
            }(p, Fi()), O = lt.useState(T), M = O[0], R = O[1];
            lt.useEffect((function ()
            {
                x.current && x.current.update()
            }));
            var P = lt.useCallback((function ()
            {
                if (b.current && n && u)
                {
                    x.current && (x.current.destroy(), C.current(null));
                    var e = function (e)
                    {
                        R(e.placement)
                    }, t = (dd(n), new ud(dd(n), b.current, At({placement: T}, h, {
                        modifiers: At({}, a ? {} : {preventOverflow: {boundariesElement: "window"}}, {}, c, {}, h.modifiers),
                        onCreate: Fl(e, h.onCreate),
                        onUpdate: Fl(e, h.onUpdate)
                    })));
                    C.current(t)
                }
            }), [n, a, c, u, T, h]), z = lt.useCallback((function (e)
            {
                Ps(w, e), P()
            }), [w, P]), I = function ()
            {
                x.current && (x.current.destroy(), C.current(null))
            };
            if (lt.useEffect((function ()
            {
                P()
            }), [P]), lt.useEffect((function ()
            {
                return function ()
                {
                    I()
                }
            }), []), lt.useEffect((function ()
            {
                u || g || I()
            }), [u, g]), !l && !u && (!g || S)) return null;
            var A = {placement: M};
            return g && (A.TransitionProps = {
                in: u, onEnter: function ()
                {
                    k(!1)
                }, onExited: function ()
                {
                    k(!0), I()
                }
            }), lt.createElement(Wl, {disablePortal: a, container: i}, lt.createElement("div", At({
                ref: z,
                role: "tooltip"
            }, y, {style: At({position: "fixed", top: 0, left: 0}, y.style)}), "function" == typeof r ? r(A) : r))
        }));

    function md(e)
    {
        return Math.round(1e5 * e) / 1e5
    }

    var vd = !1, gd = null, yd = lt.forwardRef((function (e, t)
    {
        var n = e.arrow, r = void 0 !== n && n, i = e.children, o = e.classes, a = e.disableFocusListener,
            s = void 0 !== a && a, l = e.disableHoverListener, c = void 0 !== l && l, u = e.disableTouchListener,
            d = void 0 !== u && u, p = e.enterDelay, f = void 0 === p ? 0 : p, h = e.enterTouchDelay,
            m = void 0 === h ? 700 : h, v = e.id, g = e.interactive, y = void 0 !== g && g, b = e.leaveDelay,
            w = void 0 === b ? 0 : b, x = e.leaveTouchDelay, _ = void 0 === x ? 1500 : x, C = e.onClose, E = e.onOpen,
            S = e.open, k = e.placement, T = void 0 === k ? "bottom" : k, O = e.PopperProps, M = e.title,
            R = e.TransitionComponent, P = void 0 === R ? nc : R, z = e.TransitionProps,
            I = zt(e, ["arrow", "children", "classes", "disableFocusListener", "disableHoverListener", "disableTouchListener", "enterDelay", "enterTouchDelay", "id", "interactive", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperProps", "title", "TransitionComponent", "TransitionProps"]),
            A = Va(), L = lt.useState(), D = L[0], N = L[1], F = lt.useState(null), B = F[0], W = F[1],
            $ = lt.useRef(!1), H = lt.useRef(), j = lt.useRef(), V = lt.useRef(), q = lt.useRef(),
            U = hs(Sc({controlled: S, default: !1, name: "Tooltip"}), 2), G = U[0], Z = U[1], K = G, Y = lt.useState(),
            X = Y[0], J = Y[1], Q = v || X;
        lt.useEffect((function ()
        {
            K && !X && J("mui-tooltip-".concat(Math.round(1e5 * Math.random())))
        }), [K, X]), lt.useEffect((function ()
        {
            return function ()
            {
                clearTimeout(H.current), clearTimeout(j.current), clearTimeout(V.current), clearTimeout(q.current)
            }
        }), []);
        var ee = function (e)
            {
                clearTimeout(gd), vd = !0, Z(!0), E && E(e)
            }, te = function (e)
            {
                var t = i.props;
                "mouseover" === e.type && t.onMouseOver && e.currentTarget === D && t.onMouseOver(e), $.current && "touchstart" !== e.type || (D && D.removeAttribute("title"), clearTimeout(j.current), clearTimeout(V.current), f && !vd ? (e.persist(), j.current = setTimeout((function ()
                {
                    ee(e)
                }), f)) : ee(e))
            }, ne = Us(), re = ne.isFocusVisible, ie = ne.onBlurVisible, oe = ne.ref, ae = lt.useState(!1), se = ae[0],
            le = ae[1], ce = function (e)
            {
                clearTimeout(gd), gd = setTimeout((function ()
                {
                    vd = !1
                }), 500), Z(!1), C && C(e), clearTimeout(H.current), H.current = setTimeout((function ()
                {
                    $.current = !1
                }), A.transitions.duration.shortest)
            }, ue = function (e)
            {
                var t = i.props;
                "blur" === e.type && (t.onBlur && e.currentTarget === D && t.onBlur(e), se && (le(!1), ie())), "mouseleave" === e.type && t.onMouseLeave && e.currentTarget === D && t.onMouseLeave(e), clearTimeout(j.current), clearTimeout(V.current), e.persist(), V.current = setTimeout((function ()
                {
                    ce(e)
                }), w)
            }, de = zs(N, t), pe = zs(oe, de), fe = lt.useCallback((function (e)
            {
                Ps(pe, lt.findDOMNode(e))
            }), [pe]), he = zs(i.ref, fe);
        "" === M && (K = !1);
        var me = At({
            "aria-describedby": K ? Q : null,
            title: !K && !c && "string" == typeof M ? M : null
        }, I, {}, i.props, {className: ka(I.className, i.props.className)});
        d || (me.onTouchStart = function (e)
        {
            $.current = !0;
            var t = i.props;
            t.onTouchStart && t.onTouchStart(e), clearTimeout(V.current), clearTimeout(H.current), clearTimeout(q.current), e.persist(), q.current = setTimeout((function ()
            {
                te(e)
            }), m)
        }, me.onTouchEnd = function (e)
        {
            i.props.onTouchEnd && i.props.onTouchEnd(e), clearTimeout(q.current), clearTimeout(V.current), e.persist(), V.current = setTimeout((function ()
            {
                ce(e)
            }), _)
        }), c || (me.onMouseOver = te, me.onMouseLeave = ue), s || (me.onFocus = function (e)
        {
            D || N(e.currentTarget), re(e) && (le(!0), te(e));
            var t = i.props;
            t.onFocus && e.currentTarget === D && t.onFocus(e)
        }, me.onBlur = ue);
        var ve = y ? {
            onMouseOver: me.onMouseOver,
            onMouseLeave: me.onMouseLeave,
            onFocus: me.onFocus,
            onBlur: me.onBlur
        } : {};
        var ge = lt.useMemo((function ()
        {
            return {modifiers: {arrow: {enabled: Boolean(B), element: B}}}
        }), [B]);
        return lt.createElement(lt.Fragment, null, lt.cloneElement(i, At({ref: he}, me)), lt.createElement(hd, At({
            className: ka(o.popper, y && o.popperInteractive, r && o.popperArrow),
            placement: T,
            anchorEl: D,
            open: !!D && K,
            id: me["aria-describedby"],
            transition: !0,
            popperOptions: ge
        }, ve, O), (function (e)
        {
            var t = e.placement, n = e.TransitionProps;
            return lt.createElement(P, At({timeout: A.transitions.duration.shorter}, n, z), lt.createElement("div", {className: ka(o.tooltip, o["tooltipPlacement".concat(fl(t.split("-")[0]))], $.current && o.touch, r && o.tooltipArrow)}, M, r ? lt.createElement("span", {
                className: o.arrow,
                ref: W
            }) : null))
        })))
    })), bd = Rs((function (e)
    {
        return {
            popper: {zIndex: e.zIndex.tooltip, pointerEvents: "none", flip: !1},
            popperInteractive: {pointerEvents: "auto"},
            popperArrow: {
                '&[x-placement*="bottom"] $arrow': {
                    flip: !1,
                    top: 0,
                    left: 0,
                    marginTop: "-0.95em",
                    marginLeft: 4,
                    marginRight: 4,
                    width: "2em",
                    height: "1em",
                    "&::before": {
                        flip: !1,
                        borderWidth: "0 1em 1em 1em",
                        borderColor: "transparent transparent currentcolor transparent"
                    }
                },
                '&[x-placement*="top"] $arrow': {
                    flip: !1,
                    bottom: 0,
                    left: 0,
                    marginBottom: "-0.95em",
                    marginLeft: 4,
                    marginRight: 4,
                    width: "2em",
                    height: "1em",
                    "&::before": {
                        flip: !1,
                        borderWidth: "1em 1em 0 1em",
                        borderColor: "currentcolor transparent transparent transparent"
                    }
                },
                '&[x-placement*="right"] $arrow': {
                    flip: !1,
                    left: 0,
                    marginLeft: "-0.95em",
                    marginTop: 4,
                    marginBottom: 4,
                    height: "2em",
                    width: "1em",
                    "&::before": {
                        flip: !1,
                        borderWidth: "1em 1em 1em 0",
                        borderColor: "transparent currentcolor transparent transparent"
                    }
                },
                '&[x-placement*="left"] $arrow': {
                    flip: !1,
                    right: 0,
                    marginRight: "-0.95em",
                    marginTop: 4,
                    marginBottom: 4,
                    height: "2em",
                    width: "1em",
                    "&::before": {
                        flip: !1,
                        borderWidth: "1em 0 1em 1em",
                        borderColor: "transparent transparent transparent currentcolor"
                    }
                }
            },
            tooltip: {
                backgroundColor: nr(e.palette.grey[700], .9),
                borderRadius: e.shape.borderRadius,
                color: e.palette.common.white,
                fontFamily: e.typography.fontFamily,
                padding: "4px 8px",
                fontSize: e.typography.pxToRem(10),
                lineHeight: "".concat(md(1.4), "em"),
                maxWidth: 300,
                wordWrap: "break-word",
                fontWeight: e.typography.fontWeightMedium
            },
            tooltipArrow: {position: "relative", margin: "0"},
            arrow: {
                position: "absolute",
                fontSize: 6,
                color: nr(e.palette.grey[700], .9),
                "&::before": {
                    content: '""',
                    margin: "auto",
                    display: "block",
                    width: 0,
                    height: 0,
                    borderStyle: "solid"
                }
            },
            touch: {
                padding: "8px 16px",
                fontSize: e.typography.pxToRem(14),
                lineHeight: "".concat(md(16 / 14), "em"),
                fontWeight: e.typography.fontWeightRegular
            },
            tooltipPlacementLeft: Rt({
                transformOrigin: "right center",
                margin: "0 24px "
            }, e.breakpoints.up("sm"), {margin: "0 14px"}),
            tooltipPlacementRight: Rt({
                transformOrigin: "left center",
                margin: "0 24px"
            }, e.breakpoints.up("sm"), {margin: "0 14px"}),
            tooltipPlacementTop: Rt({
                transformOrigin: "center bottom",
                margin: "24px 0"
            }, e.breakpoints.up("sm"), {margin: "14px 0"}),
            tooltipPlacementBottom: Rt({
                transformOrigin: "center top",
                margin: "24px 0"
            }, e.breakpoints.up("sm"), {margin: "14px 0"})
        }
    }), {name: "PwzrTooltip"})(yd);

    function wd(e)
    {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = Fi(),
            r = xr({theme: n, name: "PwzrUseMediaQuery", props: {}});
        var i = "function" == typeof e ? e(n) : e;
        i = i.replace(/^@media( ?)/m, "");
        var o = "undefined" != typeof window && void 0 !== window.matchMedia, a = At({}, r, {}, t),
            s = a.defaultMatches, l = void 0 !== s && s, c = a.matchMedia,
            u = void 0 === c ? o ? window.matchMedia : null : c, d = a.noSsr, p = void 0 !== d && d,
            f = a.ssrMatchMedia, h = void 0 === f ? null : f, m = lt.useState((function ()
            {
                return p && o ? u(i).matches : h ? h(i).matches : l
            })), v = m[0], g = m[1];
        return lt.useEffect((function ()
        {
            var e = !0;
            if (o)
            {
                var t = u(i), n = function ()
                {
                    e && g(t.matches)
                };
                return n(), t.addListener(n), function ()
                {
                    e = !1, t.removeListener(n)
                }
            }
        }), [i, u, o]), v
    }

    var xd, _d = !1;

    function Cd()
    {
        xd = {}, xd = () =>
        {
            var e;
            !function ()
            {
                if ("function" == typeof window.CustomEvent) return !1;
                window.CustomEvent = function (e, t)
                {
                    t = t || {bubbles: !1, cancelable: !1, detail: null};
                    var n = document.createEvent("CustomEvent");
                    return n.initCustomEvent(e, t.bubbles, t.cancelable, t.detail), n
                }
            }(), history.pushState = (e = history.pushState, function ()
            {
                var t = e.apply(this, arguments);
                return window.dispatchEvent(new CustomEvent("pushState")), window.dispatchEvent(new CustomEvent("locationchange")), t
            }), history.replaceState = function (e)
            {
                return function ()
                {
                    var t = e.apply(this, arguments);
                    return window.dispatchEvent(new CustomEvent("replaceState")), window.dispatchEvent(new CustomEvent("locationchange")), t
                }
            }(history.replaceState), window.addEventListener("popstate", (function ()
            {
                window.dispatchEvent(new CustomEvent("locationchange"))
            }))
        }
    }

    var Ed, Sd = {};
    var kd = Ed = function (e)
    {
        return e && e.__esModule ? e : {default: e}
    };
    Object.defineProperty(Sd, "__esModule", {value: !0});
    var Td = void 0;
    Sd.default = Td;
    var Od = {};

    function Md()
    {
        return Od = Md = Object.assign || function (e)
        {
            for (var t = 1; t < arguments.length; t++)
            {
                var n = arguments[t];
                for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r])
            }
            return e
        }, Md.apply(this, arguments)
    }

    var Rd = t(Od = Md), Pd = kd(Od), zd = {}, Id = Ed;
    Object.defineProperty(zd, "__esModule", {value: !0});
    var Ad = void 0;
    zd.default = Ad;
    var Ld = {}, Dd = Ed;
    Object.defineProperty(Ld, "__esModule", {value: !0});
    var Nd = void 0;
    Ld.default = Nd;
    var Fd;
    var Bd, Wd = t(Fd = function (e, t, n)
    {
        return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n, e
    });
    Dd(Fd);
    var $d = function (e, t)
    {
        if (null == e) return {};
        var n, r, i = {}, o = Object.keys(e);
        for (r = 0; r < o.length; r++) n = o[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
        return i
    };
    var Hd = Dd(Bd = function (e, t)
    {
        if (null == e) return {};
        var n, r, i = $d(e, t);
        if (Object.getOwnPropertySymbols)
        {
            var o = Object.getOwnPropertySymbols(e);
            for (r = 0; r < o.length; r++) n = o[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n])
        }
        return i
    }), jd = {}, Vd = Ed;
    Object.defineProperty(jd, "__esModule", {value: !0});
    var qd = function (e)
    {
        var t = e.values, n = void 0 === t ? {xs: 0, sm: 600, md: 960, lg: 1280, xl: 1920} : t, r = e.unit,
            i = void 0 === r ? "px" : r, o = e.step, a = void 0 === o ? 5 : o,
            s = (0, Zd.default)(e, ["values", "unit", "step"]);

        function l(e)
        {
            var t = "number" == typeof n[e] ? n[e] : e;
            return "@media (min-width:".concat(t).concat(i, ")")
        }

        function c(e, t)
        {
            var r = Kd.indexOf(t);
            return r === Kd.length - 1 ? l(e) : "@media (min-width:".concat("number" == typeof n[e] ? n[e] : e).concat(i, ") and ") + "(max-width:".concat((-1 !== r && "number" == typeof n[Kd[r + 1]] ? n[Kd[r + 1]] : t) - a / 100).concat(i, ")")
        }

        return (0, Gd.default)({
            keys: Kd, values: n, up: l, down: function (e)
            {
                var t = Kd.indexOf(e) + 1, r = n[Kd[t]];
                return t === Kd.length ? l("xs") : "@media (max-width:".concat(("number" == typeof r && t > 0 ? r : e) - a / 100).concat(i, ")")
            }, between: c, only: function (e)
            {
                return c(e, e)
            }, width: function (e)
            {
                return n[e]
            }
        }, s)
    };
    jd.default = qd;
    var Ud = void 0;
    jd.keys = Ud;
    var Gd = Vd(Od), Zd = Vd(Bd), Kd = ["xs", "sm", "md", "lg", "xl"];
    Ud = Kd, jd.keys = Ud;
    var Yd = Dd(jd), Xd = {}, Jd = Ed;
    Object.defineProperty(Xd, "__esModule", {value: !0});
    var Qd = function (e, t, n)
    {
        var r;
        return (0, tp.default)({
            gutters: function ()
            {
                var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                return (0, tp.default)({
                    paddingLeft: t(2),
                    paddingRight: t(2)
                }, n, (0, ep.default)({}, e.up("sm"), (0, tp.default)({
                    paddingLeft: t(3),
                    paddingRight: t(3)
                }, n[e.up("sm")])))
            },
            toolbar: (r = {minHeight: 56}, (0, ep.default)(r, "".concat(e.up("xs"), " and (orientation: landscape)"), {minHeight: 48}), (0, ep.default)(r, e.up("sm"), {minHeight: 64}), r)
        }, n)
    };
    Xd.default = Qd;
    var ep = Jd(Fd), tp = Jd(Od);
    var np = Dd(Xd), rp = {}, ip = Ed;
    Object.defineProperty(rp, "__esModule", {value: !0});
    var op = function (e)
    {
        var t = e.primary,
            n = void 0 === t ? {light: gp.default[300], main: gp.default[500], dark: gp.default[700]} : t,
            r = e.secondary,
            i = void 0 === r ? {light: wp.default.A200, main: wp.default.A400, dark: wp.default.A700} : r, o = e.error,
            a = void 0 === o ? {light: Cp.default[300], main: Cp.default[500], dark: Cp.default[700]} : o,
            s = e.warning,
            l = void 0 === s ? {light: kp.default[300], main: kp.default[500], dark: kp.default[700]} : s, c = e.info,
            u = void 0 === c ? {light: Mp.default[300], main: Mp.default[500], dark: Mp.default[700]} : c,
            d = e.success,
            p = void 0 === d ? {light: zp.default[300], main: zp.default[500], dark: zp.default[700]} : d, f = e.type,
            h = void 0 === f ? "light" : f, m = e.contrastThreshold, v = void 0 === m ? 3 : m, g = e.tonalOffset,
            y = void 0 === g ? .2 : g,
            b = (0, lp.default)(e, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]);

        function w(e)
        {
            if (!e) throw new TypeError("Material-UI: missing background argument in getContrastText(".concat(e, ")."));
            var t = (0, Ip.getContrastRatio)(e, tf.text.primary) >= v ? tf.text.primary : Qp.text.primary;
            return t
        }

        function x(e)
        {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 500,
                n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 300,
                r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 700;
            return !(e = (0, sp.default)({}, e)).main && e[t] && (e.main = e[t]), nf(e, "light", n, y), nf(e, "dark", r, y), e.contrastText || (e.contrastText = w(e.main)), e
        }

        var _ = {dark: tf, light: Qp};
        0;
        return Ft((0, sp.default)({
            common: dp.default,
            type: h,
            primary: x(n),
            secondary: x(i, "A400", "A200", "A700"),
            error: x(a),
            warning: x(l),
            info: x(u),
            success: x(p),
            grey: hp.default,
            contrastThreshold: v,
            getContrastText: w,
            augmentColor: x,
            tonalOffset: y
        }, _[h]), b)
    };
    rp.default = op;
    var ap = (ef = void 0, rp.light = ef);
    rp.dark = ap;
    var sp = ip(Od), lp = ip(Bd), cp = {};
    Object.defineProperty(cp, "__esModule", {value: !0});
    var up = void 0;
    cp.default = up;
    up = {black: "#000", white: "#fff"}, cp.default = up;
    var dp = ip(cp), pp = {};
    Object.defineProperty(pp, "__esModule", {value: !0});
    var fp = void 0;
    pp.default = fp;
    fp = {
        50: "#fafafa",
        100: "#f5f5f5",
        200: "#eeeeee",
        300: "#e0e0e0",
        400: "#bdbdbd",
        500: "#9e9e9e",
        600: "#757575",
        700: "#616161",
        800: "#424242",
        900: "#212121",
        A100: "#d5d5d5",
        A200: "#aaaaaa",
        A400: "#303030",
        A700: "#616161"
    }, pp.default = fp;
    var hp = ip(pp), mp = {};
    Object.defineProperty(mp, "__esModule", {value: !0});
    var vp = void 0;
    mp.default = vp;
    vp = {
        50: "#e8eaf6",
        100: "#c5cae9",
        200: "#9fa8da",
        300: "#7986cb",
        400: "#5c6bc0",
        500: "#3f51b5",
        600: "#3949ab",
        700: "#303f9f",
        800: "#283593",
        900: "#1a237e",
        A100: "#8c9eff",
        A200: "#536dfe",
        A400: "#3d5afe",
        A700: "#304ffe"
    }, mp.default = vp;
    var gp = ip(mp), yp = {};
    Object.defineProperty(yp, "__esModule", {value: !0});
    var bp = void 0;
    yp.default = bp;
    bp = {
        50: "#fce4ec",
        100: "#f8bbd0",
        200: "#f48fb1",
        300: "#f06292",
        400: "#ec407a",
        500: "#e91e63",
        600: "#d81b60",
        700: "#c2185b",
        800: "#ad1457",
        900: "#880e4f",
        A100: "#ff80ab",
        A200: "#ff4081",
        A400: "#f50057",
        A700: "#c51162"
    }, yp.default = bp;
    var wp = ip(yp), xp = {};
    Object.defineProperty(xp, "__esModule", {value: !0});
    var _p = void 0;
    xp.default = _p;
    _p = {
        50: "#ffebee",
        100: "#ffcdd2",
        200: "#ef9a9a",
        300: "#e57373",
        400: "#ef5350",
        500: "#f44336",
        600: "#e53935",
        700: "#d32f2f",
        800: "#c62828",
        900: "#b71c1c",
        A100: "#ff8a80",
        A200: "#ff5252",
        A400: "#ff1744",
        A700: "#d50000"
    }, xp.default = _p;
    var Cp = ip(xp), Ep = {};
    Object.defineProperty(Ep, "__esModule", {value: !0});
    var Sp = void 0;
    Ep.default = Sp;
    Sp = {
        50: "#fff3e0",
        100: "#ffe0b2",
        200: "#ffcc80",
        300: "#ffb74d",
        400: "#ffa726",
        500: "#ff9800",
        600: "#fb8c00",
        700: "#f57c00",
        800: "#ef6c00",
        900: "#e65100",
        A100: "#ffd180",
        A200: "#ffab40",
        A400: "#ff9100",
        A700: "#ff6d00"
    }, Ep.default = Sp;
    var kp = ip(Ep), Tp = {};
    Object.defineProperty(Tp, "__esModule", {value: !0});
    var Op = void 0;
    Tp.default = Op;
    Op = {
        50: "#e3f2fd",
        100: "#bbdefb",
        200: "#90caf9",
        300: "#64b5f6",
        400: "#42a5f5",
        500: "#2196f3",
        600: "#1e88e5",
        700: "#1976d2",
        800: "#1565c0",
        900: "#0d47a1",
        A100: "#82b1ff",
        A200: "#448aff",
        A400: "#2979ff",
        A700: "#2962ff"
    }, Tp.default = Op;
    var Mp = ip(Tp), Rp = {};
    Object.defineProperty(Rp, "__esModule", {value: !0});
    var Pp = void 0;
    Rp.default = Pp;
    Pp = {
        50: "#e8f5e9",
        100: "#c8e6c9",
        200: "#a5d6a7",
        300: "#81c784",
        400: "#66bb6a",
        500: "#4caf50",
        600: "#43a047",
        700: "#388e3c",
        800: "#2e7d32",
        900: "#1b5e20",
        A100: "#b9f6ca",
        A200: "#69f0ae",
        A400: "#00e676",
        A700: "#00c853"
    }, Rp.default = Pp;
    var zp = ip(Rp), Ip = {};
    Object.defineProperty(Ip, "__esModule", {value: !0});
    var Ap = Up;
    Ip.hexToRgb = Ap;
    var Lp = function (e)
    {
        if (0 === e.indexOf("#")) return e;
        var t = Zp(e).values;
        return "#".concat(t.map((function (e)
        {
            return 1 === (t = e.toString(16)).length ? "0".concat(t) : t;
            var t
        })).join(""))
    };
    Ip.rgbToHex = Lp;
    var Dp = Gp;
    Ip.hslToRgb = Dp;
    var Np = Zp;
    Ip.decomposeColor = Np;
    var Fp = Kp;
    Ip.recomposeColor = Fp;
    var Bp = function (e, t)
    {
        var n = Yp(e), r = Yp(t);
        return (Math.max(n, r) + .05) / (Math.min(n, r) + .05)
    };
    Ip.getContrastRatio = Bp;
    var Wp = Yp;
    Ip.getLuminance = Wp;
    var $p = function (e)
    {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : .15;
        return Yp(e) > .5 ? Xp(e, t) : Jp(e, t)
    };
    Ip.emphasize = $p;
    var Hp = function (e, t)
    {
        e = Zp(e), t = qp(t), ("rgb" === e.type || "hsl" === e.type) && (e.type += "a");
        return e.values[3] = t, Kp(e)
    };
    Ip.fade = Hp;
    var jp = Xp;
    Ip.darken = jp;
    var Vp = Jp;

    function qp(e)
    {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
        return Math.min(Math.max(t, e), n)
    }

    function Up(e)
    {
        e = e.substr(1);
        var t = new RegExp(".{1,".concat(e.length / 3, "}"), "g"), n = e.match(t);
        return n && 1 === n[0].length && (n = n.map((function (e)
        {
            return e + e
        }))), n ? "rgb(".concat(n.map((function (e)
        {
            return parseInt(e, 16)
        })).join(", "), ")") : ""
    }

    function Gp(e)
    {
        var t = (e = Zp(e)).values, n = t[0], r = t[1] / 100, i = t[2] / 100, o = r * Math.min(i, 1 - i),
            a = function (e)
            {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : (e + n / 30) % 12;
                return i - o * Math.max(Math.min(t - 3, 9 - t, 1), -1)
            }, s = "rgb", l = [Math.round(255 * a(0)), Math.round(255 * a(8)), Math.round(255 * a(4))];
        return "hsla" === e.type && (s += "a", l.push(t[3])), Kp({type: s, values: l})
    }

    function Zp(e)
    {
        if (e.type) return e;
        if ("#" === e.charAt(0)) return Zp(Up(e));
        var t = e.indexOf("("), n = e.substring(0, t);
        if (-1 === ["rgb", "rgba", "hsl", "hsla"].indexOf(n)) throw new Error(["Material-UI: unsupported `".concat(e, "` color."), "We support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()."].join("\n"));
        var r = e.substring(t + 1, e.length - 1).split(",");
        return {
            type: n, values: r = r.map((function (e)
            {
                return parseFloat(e)
            }))
        }
    }

    function Kp(e)
    {
        var t = e.type, n = e.values;
        return -1 !== t.indexOf("rgb") ? n = n.map((function (e, t)
        {
            return t < 3 ? parseInt(e, 10) : e
        })) : -1 !== t.indexOf("hsl") && (n[1] = "".concat(n[1], "%"), n[2] = "".concat(n[2], "%")), "".concat(t, "(").concat(n.join(", "), ")")
    }

    function Yp(e)
    {
        var t = "hsl" === (e = Zp(e)).type ? Zp(Gp(e)).values : e.values;
        return t = t.map((function (e)
        {
            return (e /= 255) <= .03928 ? e / 12.92 : Math.pow((e + .055) / 1.055, 2.4)
        })), Number((.2126 * t[0] + .7152 * t[1] + .0722 * t[2]).toFixed(3))
    }

    function Xp(e, t)
    {
        if (e = Zp(e), t = qp(t), -1 !== e.type.indexOf("hsl")) e.values[2] *= 1 - t; else if (-1 !== e.type.indexOf("rgb")) for (var n = 0; n < 3; n += 1) e.values[n] *= 1 - t;
        return Kp(e)
    }

    function Jp(e, t)
    {
        if (e = Zp(e), t = qp(t), -1 !== e.type.indexOf("hsl")) e.values[2] += (100 - e.values[2]) * t; else if (-1 !== e.type.indexOf("rgb")) for (var n = 0; n < 3; n += 1) e.values[n] += (255 - e.values[n]) * t;
        return Kp(e)
    }

    Ip.lighten = Vp;
    var Qp = {
        text: {
            primary: "rgba(0, 0, 0, 0.87)",
            secondary: "rgba(0, 0, 0, 0.54)",
            disabled: "rgba(0, 0, 0, 0.38)",
            hint: "rgba(0, 0, 0, 0.38)"
        },
        divider: "rgba(0, 0, 0, 0.12)",
        background: {paper: dp.default.white, default: hp.default[50]},
        action: {
            active: "rgba(0, 0, 0, 0.54)",
            hover: "rgba(0, 0, 0, 0.04)",
            hoverOpacity: .04,
            selected: "rgba(0, 0, 0, 0.08)",
            selectedOpacity: .08,
            disabled: "rgba(0, 0, 0, 0.26)",
            disabledBackground: "rgba(0, 0, 0, 0.12)",
            disabledOpacity: .38,
            focus: "rgba(0, 0, 0, 0.12)",
            focusOpacity: .12,
            activatedOpaciy: .12
        }
    }, ef = Qp;
    rp.light = ef;
    var tf = {
        text: {
            primary: dp.default.white,
            secondary: "rgba(255, 255, 255, 0.7)",
            disabled: "rgba(255, 255, 255, 0.5)",
            hint: "rgba(255, 255, 255, 0.5)",
            icon: "rgba(255, 255, 255, 0.5)"
        },
        divider: "rgba(255, 255, 255, 0.12)",
        background: {paper: hp.default[800], default: "#303030"},
        action: {
            active: dp.default.white,
            hover: "rgba(255, 255, 255, 0.08)",
            hoverOpacity: .08,
            selected: "rgba(255, 255, 255, 0.16)",
            selectedOpacity: .16,
            disabled: "rgba(255, 255, 255, 0.3)",
            disabledBackground: "rgba(255, 255, 255, 0.12)",
            disabledOpacity: .38,
            focus: "rgba(255, 255, 255, 0.12)",
            focusOpacity: .12,
            activatedOpaciy: .24
        }
    };

    function nf(e, t, n, r)
    {
        e[t] || (e.hasOwnProperty(n) ? e[t] = e[n] : "light" === t ? e.light = (0, Ip.lighten)(e.main, r) : "dark" === t && (e.dark = (0, Ip.darken)(e.main, 1.5 * r)))
    }

    ap = tf, rp.dark = ap;
    var rf = Dd(rp), of = {}, af = Ed;
    Object.defineProperty(of, "__esModule", {value: !0});
    var sf = function (e, t)
    {
        var n = "function" == typeof t ? t(e) : t, r = n.fontFamily, i = void 0 === r ? pf : r, o = n.fontSize,
            a = void 0 === o ? 14 : o, s = n.fontWeightLight, l = void 0 === s ? 300 : s, c = n.fontWeightRegular,
            u = void 0 === c ? 400 : c, d = n.fontWeightMedium, p = void 0 === d ? 500 : d, f = n.fontWeightBold,
            h = void 0 === f ? 700 : f, m = n.htmlFontSize, v = void 0 === m ? 16 : m, g = n.allVariants, y = n.pxToRem,
            b = (0, cf.default)(n, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);
        0;
        var w = a / 14, x = y || function (e)
        {
            return "".concat(e / v * w, "rem")
        }, _ = function (e, t, n, r, o)
        {
            return (0, lf.default)({
                fontFamily: i,
                fontWeight: e,
                fontSize: x(t),
                lineHeight: n
            }, i === pf ? {letterSpacing: "".concat(uf(r / t), "em")} : {}, {}, o, {}, g)
        }, C = {
            h1: _(l, 96, 1.167, -1.5),
            h2: _(l, 60, 1.2, -.5),
            h3: _(u, 48, 1.167, 0),
            h4: _(u, 34, 1.235, .25),
            h5: _(u, 24, 1.334, 0),
            h6: _(p, 20, 1.6, .15),
            subtitle1: _(u, 16, 1.75, .15),
            subtitle2: _(p, 14, 1.57, .1),
            body1: _(u, 16, 1.5, .15),
            body2: _(u, 14, 1.43, .15),
            button: _(p, 14, 1.75, .4, df),
            caption: _(u, 12, 1.66, .4),
            overline: _(u, 12, 2.66, 1, df)
        };
        return Ft((0, lf.default)({
            htmlFontSize: v,
            pxToRem: x,
            round: uf,
            fontFamily: i,
            fontSize: a,
            fontWeightLight: l,
            fontWeightRegular: u,
            fontWeightMedium: p,
            fontWeightBold: h
        }, C), b, {clone: !1})
    };
    of.default = sf;
    var lf = af(Od), cf = af(Bd);

    function uf(e)
    {
        return Math.round(1e5 * e) / 1e5
    }

    var df = {textTransform: "uppercase"}, pf = '"Poppins", "Helvetica", "Arial", sans-serif';
    var ff = Dd(of), hf = {};
    Object.defineProperty(hf, "__esModule", {value: !0});
    var mf = void 0;
    hf.default = mf;

    function vf()
    {
        return ["".concat(arguments.length <= 0 ? void 0 : arguments[0], "px ").concat(arguments.length <= 1 ? void 0 : arguments[1], "px ").concat(arguments.length <= 2 ? void 0 : arguments[2], "px ").concat(arguments.length <= 3 ? void 0 : arguments[3], "px rgba(0,0,0,").concat(.2, ")"), "".concat(arguments.length <= 4 ? void 0 : arguments[4], "px ").concat(arguments.length <= 5 ? void 0 : arguments[5], "px ").concat(arguments.length <= 6 ? void 0 : arguments[6], "px ").concat(arguments.length <= 7 ? void 0 : arguments[7], "px rgba(0,0,0,").concat(.14, ")"), "".concat(arguments.length <= 8 ? void 0 : arguments[8], "px ").concat(arguments.length <= 9 ? void 0 : arguments[9], "px ").concat(arguments.length <= 10 ? void 0 : arguments[10], "px ").concat(arguments.length <= 11 ? void 0 : arguments[11], "px rgba(0,0,0,").concat(.12, ")")].join(",")
    }

    mf = ["none", vf(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), vf(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), vf(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), vf(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), vf(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), vf(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), vf(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), vf(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), vf(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), vf(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), vf(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), vf(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), vf(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), vf(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), vf(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), vf(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), vf(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), vf(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), vf(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), vf(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), vf(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), vf(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), vf(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), vf(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], hf.default = mf;
    var gf = Dd(hf), yf = {};
    Object.defineProperty(yf, "__esModule", {value: !0});
    var bf = void 0;
    yf.default = bf;
    bf = {borderRadius: 4}, yf.default = bf;
    var wf = Dd(yf), xf = {};
    Object.defineProperty(xf, "__esModule", {value: !0});
    var _f = function ()
    {
        var e, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 8;
        if (t.mui) return t;
        e = "function" == typeof t ? t : function (e)
        {
            return t * e
        };
        var n = function ()
        {
            for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
            return 0 === n.length ? e(1) : 1 === n.length ? e(n[0]) : n.map((function (t)
            {
                var n = e(t);
                return "number" == typeof n ? "".concat(n, "px") : n
            })).join(" ")
        };
        return Object.defineProperty(n, "unit", {
            get: function ()
            {
                return t
            }
        }), n.mui = !0, n
    };
    xf.default = _f;
    var Cf = Dd(xf), Ef = {}, Sf = Ed;
    Object.defineProperty(Ef, "__esModule", {value: !0});
    var kf = (Mf = void 0, Pf = Ef.easing = Mf, Ef.duration = Pf);
    Ef.default = kf;
    var Tf = Sf(Bd), Of = {
        easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
        easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
        easeIn: "cubic-bezier(0.4, 0, 1, 1)",
        sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
    }, Mf = Of;
    Ef.easing = Mf;
    var Rf = {
        shortest: 150,
        shorter: 200,
        short: 250,
        standard: 300,
        complex: 375,
        enteringScreen: 225,
        leavingScreen: 195
    }, Pf = Rf;

    function zf(e)
    {
        return "".concat(Math.round(e), "ms")
    }

    Ef.duration = Pf, kf = {
        easing: Of, duration: Rf, create: function ()
        {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ["all"],
                t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = t.duration,
                r = void 0 === n ? Rf.standard : n, i = t.easing, o = void 0 === i ? Of.easeInOut : i, a = t.delay,
                s = void 0 === a ? 0 : a;
            (0, Tf.default)(t, ["duration", "easing", "delay"]);
            return (Array.isArray(e) ? e : [e]).map((function (e)
            {
                return "".concat(e, " ").concat("string" == typeof r ? r : zf(r), " ").concat(o, " ").concat("string" == typeof s ? s : zf(s))
            })).join(",")
        }, getAutoHeightDuration: function (e)
        {
            if (!e) return 0;
            var t = e / 36;
            return Math.round(10 * (4 + 15 * Math.pow(t, .25) + t / 5))
        }
    }, Ef.default = kf;
    var If = Dd(Ef), Af = {};
    Object.defineProperty(Af, "__esModule", {value: !0});
    var Lf = void 0;
    Af.default = Lf;
    Lf = {
        mobileStepper: 1e3,
        speedDial: 1050,
        appBar: 1100,
        drawer: 1200,
        modal: 1300,
        snackbar: 1400,
        tooltip: 1500
    }, Af.default = Lf;
    var Df = Dd(Af);
    Nd = function ()
    {
        for (var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e.breakpoints, n = void 0 === t ? {} : t, r = e.mixins, i = void 0 === r ? {} : r, o = e.palette, a = void 0 === o ? {} : o, s = e.spacing, l = e.typography, c = void 0 === l ? {} : l, u = (0, Hd.default)(e, ["breakpoints", "mixins", "palette", "spacing", "typography"]), d = (0, rf.default)(a), p = (0, Yd.default)(n), f = (0, Cf.default)(s), h = Ft({
            breakpoints: p,
            direction: "ltr",
            mixins: (0, np.default)(p, f, i),
            overrides: {},
            palette: d,
            props: {},
            shadows: gf.default,
            typography: (0, ff.default)(d, c),
            spacing: f,
            shape: wf.default,
            transitions: If.default,
            zIndex: Df.default
        }, u), m = arguments.length, v = new Array(m > 1 ? m - 1 : 0), g = 1; g < m; g++) v[g - 1] = arguments[g];
        return h = v.reduce((function (e, t)
        {
            return Ft(e, t)
        }), h)
    }, Ld.default = Nd, Ad = (0, Id(Ld).default)(), zd.default = Ad;
    var Nf = kd(zd);
    Td = function (e)
    {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return Ea(e, (0, Pd.default)({defaultTheme: Nf.default}, t))
    }, Sd.default = Td;
    var Ff = t(Sd), Bf = {}, Wf = Ed;
    Object.defineProperty(Bf, "__esModule", {value: !0});
    var $f = function ()
    {
        return Fi() || Hf.default
    };
    Bf.default = $f;
    var Hf = Wf(zd);
    var jf = t(Bf), Vf = function ()
        {
            if ("undefined" != typeof Map) return Map;

            function e(e, t)
            {
                var n = -1;
                return e.some((function (e, r)
                {
                    return e[0] === t && (n = r, !0)
                })), n
            }

            return function ()
            {
                function t()
                {
                    this.__entries__ = []
                }

                return Object.defineProperty(t.prototype, "size", {
                    get: function ()
                    {
                        return this.__entries__.length
                    }, enumerable: !0, configurable: !0
                }), t.prototype.get = function (t)
                {
                    var n = e(this.__entries__, t), r = this.__entries__[n];
                    return r && r[1]
                }, t.prototype.set = function (t, n)
                {
                    var r = e(this.__entries__, t);
                    ~r ? this.__entries__[r][1] = n : this.__entries__.push([t, n])
                }, t.prototype.delete = function (t)
                {
                    var n = this.__entries__, r = e(n, t);
                    ~r && n.splice(r, 1)
                }, t.prototype.has = function (t)
                {
                    return !!~e(this.__entries__, t)
                }, t.prototype.clear = function ()
                {
                    this.__entries__.splice(0)
                }, t.prototype.forEach = function (e, t)
                {
                    void 0 === t && (t = null);
                    for (var n = 0, r = this.__entries__; n < r.length; n++)
                    {
                        var i = r[n];
                        e.call(t, i[1], i[0])
                    }
                }, t
            }()
        }(), qf = "undefined" != typeof window && "undefined" != typeof document && window.document === document,
        Uf = void 0 !== e && e.Math === Math ? e : "undefined" != typeof self && self.Math === Math ? self : "undefined" != typeof window && window.Math === Math ? window : Function("return this")(),
        Gf = "function" == typeof requestAnimationFrame ? requestAnimationFrame.bind(Uf) : function (e)
        {
            return setTimeout((function ()
            {
                return e(Date.now())
            }), 1e3 / 60)
        };
    var Zf = ["top", "right", "bottom", "left", "width", "height", "size", "weight"],
        Kf = "undefined" != typeof MutationObserver, Yf = function ()
        {
            function e()
            {
                this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = function (e, t)
                {
                    var n = !1, r = !1, i = 0;

                    function o()
                    {
                        n && (n = !1, e()), r && s()
                    }

                    function a()
                    {
                        Gf(o)
                    }

                    function s()
                    {
                        var e = Date.now();
                        if (n)
                        {
                            if (e - i < 2) return;
                            r = !0
                        } else n = !0, r = !1, setTimeout(a, t);
                        i = e
                    }

                    return s
                }(this.refresh.bind(this), 20)
            }

            return e.prototype.addObserver = function (e)
            {
                ~this.observers_.indexOf(e) || this.observers_.push(e), this.connected_ || this.connect_()
            }, e.prototype.removeObserver = function (e)
            {
                var t = this.observers_, n = t.indexOf(e);
                ~n && t.splice(n, 1), !t.length && this.connected_ && this.disconnect_()
            }, e.prototype.refresh = function ()
            {
                this.updateObservers_() && this.refresh()
            }, e.prototype.updateObservers_ = function ()
            {
                var e = this.observers_.filter((function (e)
                {
                    return e.gatherActive(), e.hasActive()
                }));
                return e.forEach((function (e)
                {
                    return e.broadcastActive()
                })), e.length > 0
            }, e.prototype.connect_ = function ()
            {
                qf && !this.connected_ && (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), Kf ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
                    attributes: !0,
                    childList: !0,
                    characterData: !0,
                    subtree: !0
                })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0)
            }, e.prototype.disconnect_ = function ()
            {
                qf && this.connected_ && (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1)
            }, e.prototype.onTransitionEnd_ = function (e)
            {
                var t = e.propertyName, n = void 0 === t ? "" : t;
                Zf.some((function (e)
                {
                    return !!~n.indexOf(e)
                })) && this.refresh()
            }, e.getInstance = function ()
            {
                return this.instance_ || (this.instance_ = new e), this.instance_
            }, e.instance_ = null, e
        }(), Xf = function (e, t)
        {
            for (var n = 0, r = Object.keys(t); n < r.length; n++)
            {
                var i = r[n];
                Object.defineProperty(e, i, {value: t[i], enumerable: !1, writable: !1, configurable: !0})
            }
            return e
        }, Jf = function (e)
        {
            return e && e.ownerDocument && e.ownerDocument.defaultView || Uf
        }, Qf = oh(0, 0, 0, 0);

    function eh(e)
    {
        return parseFloat(e) || 0
    }

    function th(e)
    {
        for (var t = [], n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
        return t.reduce((function (t, n)
        {
            return t + eh(e["border-" + n + "-width"])
        }), 0)
    }

    function nh(e)
    {
        var t = e.clientWidth, n = e.clientHeight;
        if (!t && !n) return Qf;
        var r = Jf(e).getComputedStyle(e), i = function (e)
        {
            for (var t = {}, n = 0, r = ["top", "right", "bottom", "left"]; n < r.length; n++)
            {
                var i = r[n], o = e["padding-" + i];
                t[i] = eh(o)
            }
            return t
        }(r), o = i.left + i.right, a = i.top + i.bottom, s = eh(r.width), l = eh(r.height);
        if ("border-box" === r.boxSizing && (Math.round(s + o) !== t && (s -= th(r, "left", "right") + o), Math.round(l + a) !== n && (l -= th(r, "top", "bottom") + a)), !function (e)
        {
            return e === Jf(e).document.documentElement
        }(e))
        {
            var c = Math.round(s + o) - t, u = Math.round(l + a) - n;
            1 !== Math.abs(c) && (s -= c), 1 !== Math.abs(u) && (l -= u)
        }
        return oh(i.left, i.top, s, l)
    }

    var rh = "undefined" != typeof SVGGraphicsElement ? function (e)
    {
        return e instanceof Jf(e).SVGGraphicsElement
    } : function (e)
    {
        return e instanceof Jf(e).SVGElement && "function" == typeof e.getBBox
    };

    function ih(e)
    {
        return qf ? rh(e) ? function (e)
        {
            var t = e.getBBox();
            return oh(0, 0, t.width, t.height)
        }(e) : nh(e) : Qf
    }

    function oh(e, t, n, r)
    {
        return {x: e, y: t, width: n, height: r}
    }

    var ah = function ()
    {
        function e(e)
        {
            this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = oh(0, 0, 0, 0), this.target = e
        }

        return e.prototype.isActive = function ()
        {
            var e = ih(this.target);
            return this.contentRect_ = e, e.width !== this.broadcastWidth || e.height !== this.broadcastHeight
        }, e.prototype.broadcastRect = function ()
        {
            var e = this.contentRect_;
            return this.broadcastWidth = e.width, this.broadcastHeight = e.height, e
        }, e
    }(), sh = function (e, t)
    {
        var n, r, i, o, a, s, l,
            c = (r = (n = t).x, i = n.y, o = n.width, a = n.height, s = "undefined" != typeof DOMRectReadOnly ? DOMRectReadOnly : Object, l = Object.create(s.prototype), Xf(l, {
                x: r,
                y: i,
                width: o,
                height: a,
                top: i,
                right: r + o,
                bottom: a + i,
                left: r
            }), l);
        Xf(this, {target: e, contentRect: c})
    }, lh = function ()
    {
        function e(e, t, n)
        {
            if (this.activeObservations_ = [], this.observations_ = new Vf, "function" != typeof e) throw new TypeError("The callback provided as parameter 1 is not a function.");
            this.callback_ = e, this.controller_ = t, this.callbackCtx_ = n
        }

        return e.prototype.observe = function (e)
        {
            if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
            if ("undefined" != typeof Element && Element instanceof Object)
            {
                if (!(e instanceof Jf(e).Element)) throw new TypeError('parameter 1 is not of type "Element".');
                var t = this.observations_;
                t.has(e) || (t.set(e, new ah(e)), this.controller_.addObserver(this), this.controller_.refresh())
            }
        }, e.prototype.unobserve = function (e)
        {
            if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
            if ("undefined" != typeof Element && Element instanceof Object)
            {
                if (!(e instanceof Jf(e).Element)) throw new TypeError('parameter 1 is not of type "Element".');
                var t = this.observations_;
                t.has(e) && (t.delete(e), t.size || this.controller_.removeObserver(this))
            }
        }, e.prototype.disconnect = function ()
        {
            this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this)
        }, e.prototype.gatherActive = function ()
        {
            var e = this;
            this.clearActive(), this.observations_.forEach((function (t)
            {
                t.isActive() && e.activeObservations_.push(t)
            }))
        }, e.prototype.broadcastActive = function ()
        {
            if (this.hasActive())
            {
                var e = this.callbackCtx_, t = this.activeObservations_.map((function (e)
                {
                    return new sh(e.target, e.broadcastRect())
                }));
                this.callback_.call(e, t, e), this.clearActive()
            }
        }, e.prototype.clearActive = function ()
        {
            this.activeObservations_.splice(0)
        }, e.prototype.hasActive = function ()
        {
            return this.activeObservations_.length > 0
        }, e
    }(), ch = "undefined" != typeof WeakMap ? new WeakMap : new Vf, uh = function e(t)
    {
        if (!(this instanceof e)) throw new TypeError("Cannot call a class as a function.");
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        var n = Yf.getInstance(), r = new lh(t, n, this);
        ch.set(this, r)
    };
    ["observe", "unobserve", "disconnect"].forEach((function (e)
    {
        uh.prototype[e] = function ()
        {
            var t;
            return (t = ch.get(this))[e].apply(t, arguments)
        }
    }));
    var dh = void 0 !== Uf.ResizeObserver ? Uf.ResizeObserver : uh;

    function ph(e)
    {
        var t = typeof e;
        return null != e && ("object" == t || "function" == t)
    }

    var fh = "object" == typeof e && e && e.Object === Object && e,
        hh = "object" == typeof self && self && self.Object === Object && self,
        mh = fh || hh || Function("return this")(), vh = function ()
        {
            return mh.Date.now()
        }, gh = mh.Symbol, yh = Object.prototype, bh = yh.hasOwnProperty, wh = yh.toString,
        xh = gh ? gh.toStringTag : void 0;
    var _h = Object.prototype.toString;
    var Ch = gh ? gh.toStringTag : void 0;

    function Eh(e)
    {
        return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : Ch && Ch in Object(e) ? function (e)
        {
            var t = bh.call(e, xh), n = e[xh];
            try
            {
                e[xh] = void 0;
                var r = !0
            } catch (e)
            {
            }
            var i = wh.call(e);
            return r && (t ? e[xh] = n : delete e[xh]), i
        }(e) : function (e)
        {
            return _h.call(e)
        }(e)
    }

    var Sh = /^\s+|\s+$/g, kh = /^[-+]0x[0-9a-f]+$/i, Th = /^0b[01]+$/i, Oh = /^0o[0-7]+$/i, Mh = parseInt;

    function Rh(e)
    {
        if ("number" == typeof e) return e;
        if (function (e)
        {
            return "symbol" == typeof e || function (e)
            {
                return null != e && "object" == typeof e
            }(e) && "[object Symbol]" == Eh(e)
        }(e)) return NaN;
        if (ph(e))
        {
            var t = "function" == typeof e.valueOf ? e.valueOf() : e;
            e = ph(t) ? t + "" : t
        }
        if ("string" != typeof e) return 0 === e ? e : +e;
        e = e.replace(Sh, "");
        var n = Th.test(e);
        return n || Oh.test(e) ? Mh(e.slice(2), n ? 2 : 8) : kh.test(e) ? NaN : +e
    }

    var Ph = Math.max, zh = Math.min;

    function Ih(e, t, n)
    {
        var r, i, o, a, s, l, c = 0, u = !1, d = !1, p = !0;
        if ("function" != typeof e) throw new TypeError("Expected a function");

        function f(t)
        {
            var n = r, o = i;
            return r = i = void 0, c = t, a = e.apply(o, n)
        }

        function h(e)
        {
            return c = e, s = setTimeout(v, t), u ? f(e) : a
        }

        function m(e)
        {
            var n = e - l;
            return void 0 === l || n >= t || n < 0 || d && e - c >= o
        }

        function v()
        {
            var e = vh();
            if (m(e)) return g(e);
            s = setTimeout(v, function (e)
            {
                var n = t - (e - l);
                return d ? zh(n, o - (e - c)) : n
            }(e))
        }

        function g(e)
        {
            return s = void 0, p && r ? f(e) : (r = i = void 0, a)
        }

        function y()
        {
            var e = vh(), n = m(e);
            if (r = arguments, i = this, l = e, n)
            {
                if (void 0 === s) return h(l);
                if (d) return clearTimeout(s), s = setTimeout(v, t), f(l)
            }
            return void 0 === s && (s = setTimeout(v, t)), a
        }

        return t = Rh(t) || 0, ph(n) && (u = !!n.leading, o = (d = "maxWait" in n) ? Ph(Rh(n.maxWait) || 0, t) : o, p = "trailing" in n ? !!n.trailing : p), y.cancel = function ()
        {
            void 0 !== s && clearTimeout(s), c = 0, r = l = i = s = void 0
        }, y.flush = function ()
        {
            return void 0 === s ? a : g(vh())
        }, y
    }

    var Ah = {
        debounce: Ih, throttle: function (e, t, n)
        {
            var r = !0, i = !0;
            if ("function" != typeof e) throw new TypeError("Expected a function");
            return ph(n) && (r = "leading" in n ? !!n.leading : r, i = "trailing" in n ? !!n.trailing : i), Ih(e, t, {
                leading: r,
                maxWait: t,
                trailing: i
            })
        }
    }, Lh = function (e)
    {
        return "function" == typeof e
    }, Dh = function ()
    {
        return "undefined" == typeof window
    };

    function Nh(e)
    {
        return (Nh = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e)
        {
            return typeof e
        } : function (e)
        {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function Fh(e, t)
    {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
    }

    function Bh(e, t)
    {
        for (var n = 0; n < t.length; n++)
        {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r)
        }
    }

    function Wh(e, t)
    {
        return !t || "object" !== Nh(t) && "function" != typeof t ? function (e)
        {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e
        }(e) : t
    }

    function $h(e)
    {
        return ($h = Object.setPrototypeOf ? Object.getPrototypeOf : function (e)
        {
            return e.__proto__ || Object.getPrototypeOf(e)
        })(e)
    }

    function Hh(e, t)
    {
        return (Hh = Object.setPrototypeOf || function (e, t)
        {
            return e.__proto__ = t, e
        })(e, t)
    }

    var jh = function (e)
    {
        function t()
        {
            return Fh(this, t), Wh(this, $h(t).apply(this, arguments))
        }

        var n, r, i;
        return function (e, t)
        {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
                constructor: {
                    value: e,
                    writable: !0,
                    configurable: !0
                }
            }), t && Hh(e, t)
        }(t, e), n = t, (r = [{
            key: "render", value: function ()
            {
                return this.props.children
            }
        }]) && Bh(n.prototype, r), i && Bh(n, i), t
    }(Ce);

    function Vh(e)
    {
        return (Vh = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e)
        {
            return typeof e
        } : function (e)
        {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function qh(e, t)
    {
        for (var n = 0; n < t.length; n++)
        {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r)
        }
    }

    function Uh(e)
    {
        return (Uh = Object.setPrototypeOf ? Object.getPrototypeOf : function (e)
        {
            return e.__proto__ || Object.getPrototypeOf(e)
        })(e)
    }

    function Gh(e)
    {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e
    }

    function Zh(e, t)
    {
        return (Zh = Object.setPrototypeOf || function (e, t)
        {
            return e.__proto__ = t, e
        })(e, t)
    }

    function Kh(e, t, n)
    {
        return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n, e
    }

    var Yh = function (e)
    {
        function t(e)
        {
            var n;
            !function (e, t)
            {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
            }(this, t), n = function (e, t)
            {
                return !t || "object" !== Vh(t) && "function" != typeof t ? Gh(e) : t
            }(this, Uh(t).call(this, e)), Kh(Gh(n), "cancelHandler", (function ()
            {
                n.resizeHandler && n.resizeHandler.cancel && (n.resizeHandler.cancel(), n.resizeHandler = null)
            })), Kh(Gh(n), "rafClean", (function ()
            {
                n.raf && n.raf.cancel && (n.raf.cancel(), n.raf = null)
            })), Kh(Gh(n), "toggleObserver", (function (e)
            {
                var t = n.getElement();
                t && n.resizeObserver[e] && n.resizeObserver[e](t)
            })), Kh(Gh(n), "getElement", (function ()
            {
                var e = n.props, t = e.querySelector, r = e.targetDomEl;
                if (!Dh())
                {
                    if (t) return document.querySelector(t);
                    if (r && ((i = r) instanceof Element || i instanceof HTMLDocument)) return r;
                    var i, o = n.element && ot(n.element);
                    if (o) return o.parentElement
                }
            })), Kh(Gh(n), "createUpdater", (function ()
            {
                return n.rafClean(), n.raf = function (e)
                {
                    var t = [], n = null, r = function ()
                    {
                        for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
                        t = i, n || (n = requestAnimationFrame((function ()
                        {
                            n = null, e.apply(void 0, t)
                        })))
                    };
                    return r.cancel = function ()
                    {
                        n && (cancelAnimationFrame(n), n = null)
                    }, r
                }((function (e)
                {
                    var t = e.width, r = e.height, i = n.props.onResize;
                    Lh(i) && i(t, r), n.setState({width: t, height: r})
                })), n.raf
            })), Kh(Gh(n), "createResizeHandler", (function (e)
            {
                var t = n.state, r = t.width, i = t.height, o = n.props, a = o.handleWidth, s = o.handleHeight;
                if (a || s)
                {
                    var l = n.createUpdater();
                    e.forEach((function (e)
                    {
                        var t = e && e.contentRect || {}, o = t.width, c = t.height, u = a && r !== o || s && i !== c;
                        !n.skipOnMount && u && !Dh() && l({width: o, height: c}), n.skipOnMount = !1
                    }))
                }
            })), Kh(Gh(n), "onRef", (function (e)
            {
                n.element = e
            })), Kh(Gh(n), "getRenderType", (function ()
            {
                var e = n.props, t = e.render, r = e.children;
                return Lh(t) ? "renderProp" : Lh(r) ? "childFunction" : nt(r) ? "child" : Array.isArray(r) ? "childArray" : "parent"
            })), Kh(Gh(n), "getTargetComponent", (function ()
            {
                var e = n.props, t = e.render, r = e.children, i = e.nodeType, o = n.state,
                    a = {width: o.width, height: o.height};
                switch (n.getRenderType())
                {
                    case"renderProp":
                        return rt(t(a), {key: "resize-detector"});
                    case"childFunction":
                        return rt(r(a));
                    case"child":
                        return rt(r, a);
                    case"childArray":
                        return r.map((function (e)
                        {
                            return !!e && rt(e, a)
                        }));
                    default:
                        return V().createElement(i)
                }
            }));
            var r = e.skipOnMount, i = e.refreshMode, o = e.refreshRate, a = e.refreshOptions;
            n.state = {
                width: void 0,
                height: void 0
            }, n.skipOnMount = r, n.raf = null, n.element = null, n.unmounted = !1;
            var s = Ah[i];
            return n.resizeHandler = s ? s(n.createResizeHandler, o, a) : n.createResizeHandler, n.resizeObserver = new dh(n.resizeHandler), n
        }

        var n, r, i;
        return function (e, t)
        {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
                constructor: {
                    value: e,
                    writable: !0,
                    configurable: !0
                }
            }), t && Zh(e, t)
        }(t, e), n = t, (r = [{
            key: "componentDidMount", value: function ()
            {
                this.toggleObserver("observe")
            }
        }, {
            key: "componentWillUnmount", value: function ()
            {
                this.toggleObserver("unobserve"), this.rafClean(), this.cancelHandler(), this.unmounted = !0
            }
        }, {
            key: "render", value: function ()
            {
                return lt.createElement(jh, {ref: this.onRef}, this.getTargetComponent())
            }
        }]) && qh(n.prototype, r), i && qh(n, i), t
    }(Ce);
    Yh.propTypes = {
        handleWidth: Gt.bool,
        handleHeight: Gt.bool,
        skipOnMount: Gt.bool,
        refreshRate: Gt.number,
        refreshMode: Gt.string,
        refreshOptions: Gt.shape({leading: Gt.bool, trailing: Gt.bool}),
        querySelector: Gt.string,
        targetDomEl: Gt.any,
        onResize: Gt.func,
        render: Gt.func,
        children: Gt.any,
        nodeType: Gt.node
    }, Yh.defaultProps = {
        handleWidth: !1,
        handleHeight: !1,
        skipOnMount: !1,
        refreshRate: 1e3,
        refreshMode: void 0,
        refreshOptions: void 0,
        querySelector: null,
        targetDomEl: null,
        onResize: null,
        render: void 0,
        children: null,
        nodeType: "div"
    };
    var Xh = Yh, Jh = {}, Qh = Ed;
    Object.defineProperty(Jh, "__esModule", {value: !0});
    var em = void 0;
    Jh.default = em;
    var tm = Qh(f), nm = {}, rm = Ed;
    Object.defineProperty(nm, "__esModule", {value: !0});
    var im = function (e, t)
    {
        var n = am.default.memo(am.default.forwardRef((function (t, n)
        {
            return am.default.createElement(sm.default, (0, om.default)({ref: n}, t), e)
        })));
        0;
        return n.muiName = sm.default.muiName, n
    };
    nm.default = im;
    var om = rm(Od), am = rm(f), sm = rm(Pc);
    em = (0, Qh(nm).default)(tm.default.createElement("path", {d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"}), "KeyboardArrowLeft"), Jh.default = em;
    var lm = t(Jh), cm = {}, um = Ed;
    Object.defineProperty(cm, "__esModule", {value: !0});
    var dm = void 0;
    cm.default = dm;
    var pm = um(f);
    dm = (0, um(nm).default)(pm.default.createElement("path", {d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"}), "KeyboardArrowRight"), cm.default = dm;
    var fm = t(cm), hm = {}, mm = Ed;
    Object.defineProperty(hm, "__esModule", {value: !0});
    var vm = void 0;
    hm.default = vm;
    var gm = mm(f);
    vm = (0, mm(nm).default)(gm.default.createElement("path", {d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"}), "KeyboardArrowDown"), hm.default = vm;
    var ym = t(hm), bm = {}, wm = Ed;
    Object.defineProperty(bm, "__esModule", {value: !0});
    var xm = void 0;
    bm.default = xm;
    var _m = wm(f);
    xm = (0, wm(nm).default)(_m.default.createElement("path", {d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"}), "KeyboardArrowUp"), bm.default = xm;
    var Cm = t(bm), Em = {}, Sm = {},
        km = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof window.msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto);
    if (km)
    {
        var Tm = new Uint8Array(16);
        Sm = function ()
        {
            return km(Tm), Tm
        }
    } else
    {
        var Om = new Array(16);
        Sm = function ()
        {
            for (var e, t = 0; t < 16; t++) 0 == (3 & t) && (e = 4294967296 * Math.random()), Om[t] = e >>> ((3 & t) << 3) & 255;
            return Om
        }
    }
    for (var Mm, Rm = Sm, Pm = [], zm = 0; zm < 256; ++zm) Pm[zm] = (zm + 256).toString(16).substr(1);
    var Im, Am, Lm = Mm = function (e, t)
    {
        var n = t || 0, r = Pm;
        return [r[e[n++]], r[e[n++]], r[e[n++]], r[e[n++]], "-", r[e[n++]], r[e[n++]], "-", r[e[n++]], r[e[n++]], "-", r[e[n++]], r[e[n++]], "-", r[e[n++]], r[e[n++]], r[e[n++]], r[e[n++]], r[e[n++]], r[e[n++]]].join("")
    }, Dm = 0, Nm = 0;
    var Fm = function (e, t, n)
    {
        var r = t && n || 0, i = t || [], o = (e = e || {}).node || Im, a = void 0 !== e.clockseq ? e.clockseq : Am;
        if (null == o || null == a)
        {
            var s = Rm();
            null == o && (o = Im = [1 | s[0], s[1], s[2], s[3], s[4], s[5]]), null == a && (a = Am = 16383 & (s[6] << 8 | s[7]))
        }
        var l = void 0 !== e.msecs ? e.msecs : (new Date).getTime(), c = void 0 !== e.nsecs ? e.nsecs : Nm + 1,
            u = l - Dm + (c - Nm) / 1e4;
        if (u < 0 && void 0 === e.clockseq && (a = a + 1 & 16383), (u < 0 || l > Dm) && void 0 === e.nsecs && (c = 0), c >= 1e4) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
        Dm = l, Nm = c, Am = a;
        var d = (1e4 * (268435455 & (l += 122192928e5)) + c) % 4294967296;
        i[r++] = d >>> 24 & 255, i[r++] = d >>> 16 & 255, i[r++] = d >>> 8 & 255, i[r++] = 255 & d;
        var p = l / 4294967296 * 1e4 & 268435455;
        i[r++] = p >>> 8 & 255, i[r++] = 255 & p, i[r++] = p >>> 24 & 15 | 16, i[r++] = p >>> 16 & 255, i[r++] = a >>> 8 | 128, i[r++] = 255 & a;
        for (var f = 0; f < 6; ++f) i[r + f] = o[f];
        return t || Lm(i)
    }, Bm = Sm, Wm = Mm;
    var $m = function (e, t, n)
    {
        var r = t && n || 0;
        "string" == typeof e && (t = "binary" === e ? new Array(16) : null, e = null);
        var i = (e = e || {}).random || (e.rng || Bm)();
        if (i[6] = 15 & i[6] | 64, i[8] = 63 & i[8] | 128, t) for (var o = 0; o < 16; ++o) t[r + o] = i[o];
        return t || Wm(i)
    }, Hm = $m;
    Hm.v1 = Fm, Hm.v4 = $m, Em = Hm;
    var jm, Vm, qm = !1;

    function Um(e)
    {
        return (Um = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e)
        {
            return typeof e
        } : function (e)
        {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }

    function Gm(e)
    {
        return Vm ? e instanceof HTMLElement : e && "object" === Um(e) && null !== e && 1 === e.nodeType && "string" == typeof e.nodeName
    }

    function Zm(e, t)
    {
        t.forEach((function (t)
        {
            e.classList.add(t)
        }))
    }

    function Km(e, t)
    {
        t.forEach((function (t)
        {
            e.classList.remove(t)
        }))
    }

    function Ym()
    {
        return qm || (qm = !0, jm = {}, Vm = "object" === ("undefined" == typeof HTMLElement ? "undefined" : Um(HTMLElement)), r(jm, "isDOMElement", (function ()
        {
            return Gm
        })), r(jm, "addClasses", (function ()
        {
            return Zm
        })), r(jm, "removeClasses", (function ()
        {
            return Km
        }))), jm
    }

    var Xm, Jm, Qm = !1;

    function ev()
    {
        if (!document.querySelector(".pwzrdrift-base-styles"))
        {
            var e = document.createElement("style");
            e.type = "text/css", e.classList.add("pwzrdrift-base-styles"), e.appendChild(document.createTextNode(Jm));
            var t = document.head;
            t.insertBefore(e, t.firstChild)
        }
    }

    function tv()
    {
        return Qm || (Qm = !0, Jm = ".pwzrdrift-bounding-box,.pwzrdrift-zoom-pane{position:absolute;pointer-events:none}@keyframes pwzrnoop{0%{zoom:1}}@-webkit-keyframes pwzrnoop{0%{zoom:1}}.pwzrdrift-zoom-pane.pwzrdrift-open{display:block}.pwzrdrift-zoom-pane.pwzrdrift-closing,.pwzrdrift-zoom-pane.pwzrdrift-opening{animation:pwzrnoop 1ms;-webkit-animation:pwzrnoop 1ms}.pwzrdrift-zoom-pane{overflow:hidden;width:100%;height:100%;top:0;left:0}.pwzrdrift-zoom-pane-loader{display:none}.pwzrdrift-zoom-pane img{position:absolute;display:block;max-width:none;max-height:none}", r(Xm = {}, "default", (function ()
        {
            return ev
        }))), Xm
    }

    var nv, rv = !1;

    function iv()
    {
        throw new Error("Missing parameter")
    }

    function ov()
    {
        return rv || (rv = !0, r(nv = {}, "default", (function ()
        {
            return iv
        }))), nv
    }

    var av, sv, lv = !1;

    function cv(e, t)
    {
        for (var n = 0; n < t.length; n++)
        {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r)
        }
    }

    function uv()
    {
        av = {}, ov(), Ym(), sv = function ()
        {
            function e(t)
            {
                !function (e, t)
                {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                }(this, e), this.isShowing = !1;
                var n = t.namespace, r = void 0 === n ? null : n, i = t.zoomFactor,
                    o = void 0 === i ? ov().default() : i, a = t.containerEl, s = void 0 === a ? ov().default() : a;
                this.settings = {
                    namespace: r,
                    zoomFactor: o,
                    containerEl: s
                }, this.openClasses = this._buildClasses("open"), this._buildElement()
            }

            var t, n, r;
            return t = e, (n = [{
                key: "_buildClasses", value: function (e)
                {
                    var t = ["pwzrdrift-".concat(e)], n = this.settings.namespace;
                    return n && t.push("".concat(n, "-").concat(e)), t
                }
            }, {
                key: "_buildElement", value: function ()
                {
                    this.el = document.createElement("div"), Ym().addClasses(this.el, this._buildClasses("bounding-box"))
                }
            }, {
                key: "show", value: function (e, t)
                {
                    this.isShowing = !0, this.settings.containerEl.appendChild(this.el);
                    var n = this.el.style;
                    n.width = "".concat(Math.round(e / this.settings.zoomFactor), "px"), n.height = "".concat(Math.round(t / this.settings.zoomFactor), "px"), Ym().addClasses(this.el, this.openClasses)
                }
            }, {
                key: "hide", value: function ()
                {
                    this.isShowing && this.settings.containerEl.removeChild(this.el), this.isShowing = !1, Ym().removeClasses(this.el, this.openClasses)
                }
            }, {
                key: "setPosition", value: function (e, t, n)
                {
                    var r = window.pageXOffset, i = window.pageYOffset,
                        o = n.left + e * n.width - this.el.clientWidth / 2 + r,
                        a = n.top + t * n.height - this.el.clientHeight / 2 + i;
                    o < n.left + r ? o = n.left + r : o + this.el.clientWidth > n.left + n.width + r && (o = n.left + n.width - this.el.clientWidth + r), a < n.top + i ? a = n.top + i : a + this.el.clientHeight > n.top + n.height + i && (a = n.top + n.height - this.el.clientHeight + i), this.el.style.left = "".concat(o, "px"), this.el.style.top = "".concat(a, "px")
                }
            }]) && cv(t.prototype, n), r && cv(t, r), e
        }(), r(av, "default", (function ()
        {
            return sv
        }))
    }

    function dv()
    {
        return lv || (lv = !0, uv()), av
    }

    var pv, fv, hv = !1;

    function mv(e, t)
    {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
    }

    function vv(e, t)
    {
        for (var n = 0; n < t.length; n++)
        {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r)
        }
    }

    function gv()
    {
        pv = {}, ov(), dv(), fv = function ()
        {
            function e()
            {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                mv(this, e), this._show = this._show.bind(this), this._hide = this._hide.bind(this), this._handleEntry = this._handleEntry.bind(this), this._handleMovement = this._handleMovement.bind(this);
                var n = t.el, r = void 0 === n ? ov().default() : n, i = t.zoomPane,
                    o = void 0 === i ? ov().default() : i, a = t.sourceAttribute, s = void 0 === a ? ov().default() : a,
                    l = t.handleTouch, c = void 0 === l ? ov().default() : l, u = t.onShow, d = void 0 === u ? null : u,
                    p = t.onHide, f = void 0 === p ? null : p, h = t.hoverDelay, m = void 0 === h ? 0 : h,
                    v = t.touchDelay, g = void 0 === v ? 0 : v, y = t.hoverBoundingBox,
                    b = void 0 === y ? ov().default() : y, w = t.touchBoundingBox,
                    x = void 0 === w ? ov().default() : w, _ = t.namespace, C = void 0 === _ ? null : _,
                    E = t.zoomFactor, S = void 0 === E ? ov().default() : E, k = t.boundingBoxContainer,
                    T = void 0 === k ? ov().default() : k, O = t.inlineContainer, M = void 0 === O ? ov().default() : O;
                this.settings = {
                    el: r,
                    zoomPane: o,
                    sourceAttribute: s,
                    handleTouch: c,
                    onShow: d,
                    onHide: f,
                    hoverDelay: m,
                    touchDelay: g,
                    hoverBoundingBox: b,
                    touchBoundingBox: x,
                    namespace: C,
                    zoomFactor: S,
                    boundingBoxContainer: T,
                    inlineContainer: M
                }, (this.settings.hoverBoundingBox || this.settings.touchBoundingBox) && (this.boundingBox = new (dv().default)({
                    namespace: this.settings.namespace,
                    zoomFactor: this.settings.zoomFactor,
                    containerEl: this.settings.boundingBoxContainer
                })), this.enabled = !0, this._bindEvents()
            }

            var t, n, r;
            return t = e, (n = [{
                key: "_preventDefault", value: function (e)
                {
                    e.preventDefault()
                }
            }, {
                key: "_preventDefaultAllowTouchScroll", value: function (e)
                {
                    this.settings.touchDelay && this._isTouchEvent(e) && !this.isShowing || e.preventDefault()
                }
            }, {
                key: "_isTouchEvent", value: function (e)
                {
                    return !!e.touches
                }
            }, {
                key: "_bindEvents", value: function ()
                {
                    this.settings.el.addEventListener("mouseenter", this._handleEntry, !1), this.settings.el.addEventListener("mouseleave", this._hide, !1), this.settings.el.addEventListener("mousemove", this._handleMovement, !1), this.settings.handleTouch ? (this.settings.el.addEventListener("touchstart", this._handleEntry, !1), this.settings.el.addEventListener("touchend", this._hide, !1), this.settings.el.addEventListener("touchmove", this._handleMovement, !1)) : (this.settings.el.addEventListener("touchstart", this._preventDefault, !1), this.settings.el.addEventListener("touchend", this._preventDefault, !1), this.settings.el.addEventListener("touchmove", this._preventDefault, !1))
                }
            }, {
                key: "_unbindEvents", value: function ()
                {
                    this.settings.el.removeEventListener("mouseenter", this._handleEntry, !1), this.settings.el.removeEventListener("mouseleave", this._hide, !1), this.settings.el.removeEventListener("mousemove", this._handleMovement, !1), this.settings.handleTouch ? (this.settings.el.removeEventListener("touchstart", this._handleEntry, !1), this.settings.el.removeEventListener("touchend", this._hide, !1), this.settings.el.removeEventListener("touchmove", this._handleMovement, !1)) : (this.settings.el.removeEventListener("touchstart", this._preventDefault, !1), this.settings.el.removeEventListener("touchend", this._preventDefault, !1), this.settings.el.removeEventListener("touchmove", this._preventDefault, !1))
                }
            }, {
                key: "_handleEntry", value: function (e)
                {
                    this._preventDefaultAllowTouchScroll(e), this._lastMovement = e, "mouseenter" == e.type && this.settings.hoverDelay ? this.entryTimeout = setTimeout(this._show, this.settings.hoverDelay) : this.settings.touchDelay ? this.entryTimeout = setTimeout(this._show, this.settings.touchDelay) : this._show()
                }
            }, {
                key: "_show", value: function ()
                {
                    if (this.enabled)
                    {
                        var e = this.settings.onShow;
                        if (e && "function" == typeof e && e(), this.settings.zoomPane.show(this.settings.el.getAttribute(this.settings.sourceAttribute), this.settings.el.clientWidth, this.settings.el.clientHeight), this._lastMovement)
                        {
                            var t = this._lastMovement.touches;
                            (t && this.settings.touchBoundingBox || !t && this.settings.hoverBoundingBox) && this.boundingBox.show(this.settings.zoomPane.el.clientWidth, this.settings.zoomPane.el.clientHeight)
                        }
                        this._handleMovement()
                    }
                }
            }, {
                key: "_hide", value: function (e)
                {
                    e && this._preventDefaultAllowTouchScroll(e), this._lastMovement = null, this.entryTimeout && clearTimeout(this.entryTimeout), this.boundingBox && this.boundingBox.hide();
                    var t = this.settings.onHide;
                    t && "function" == typeof t && t(), this.settings.zoomPane.hide()
                }
            }, {
                key: "_handleMovement", value: function (e)
                {
                    if (e) this._preventDefaultAllowTouchScroll(e), this._lastMovement = e; else
                    {
                        if (!this._lastMovement) return;
                        e = this._lastMovement
                    }
                    var t, n;
                    if (e.touches)
                    {
                        var r = e.touches[0];
                        t = r.clientX, n = r.clientY
                    } else t = e.clientX, n = e.clientY;
                    var i = this.settings.el.getBoundingClientRect(), o = t - i.left, a = n - i.top,
                        s = o / this.settings.el.clientWidth, l = a / this.settings.el.clientHeight,
                        c = this.settings.inlineContainer.getBoundingClientRect(),
                        u = {left: i.left - c.left, top: i.top - c.top, width: i.width, height: i.height};
                    this.boundingBox && this.boundingBox.setPosition(s, l, u), this.settings.zoomPane.setPosition(s, l, u)
                }
            }, {
                key: "isShowing", get: function ()
                {
                    return this.settings.zoomPane.isShowing
                }
            }]) && vv(t.prototype, n), r && vv(t, r), e
        }(), r(pv, "default", (function ()
        {
            return fv
        }))
    }

    function yv()
    {
        return hv || (hv = !0, gv()), pv
    }

    var bv, wv, xv, _v, Cv = !1;

    function Ev(e, t)
    {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
    }

    function Sv(e, t)
    {
        for (var n = 0; n < t.length; n++)
        {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r)
        }
    }

    function kv()
    {
        bv = {}, ov(), Ym(), wv = document.createElement("div").style, xv = "undefined" != typeof document && ("animation" in wv || "webkitAnimation" in wv), _v = function ()
        {
            function e()
            {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                Ev(this, e), this._completeShow = this._completeShow.bind(this), this._completeHide = this._completeHide.bind(this), this._handleLoad = this._handleLoad.bind(this), this.isShowing = !1;
                var n = t.container, r = void 0 === n ? null : n, i = t.zoomFactor,
                    o = void 0 === i ? ov().default() : i, a = t.inline, s = void 0 === a ? ov().default() : a,
                    l = t.namespace, c = void 0 === l ? null : l, u = t.showWhitespaceAtEdges,
                    d = void 0 === u ? ov().default() : u, p = t.containInline, f = void 0 === p ? ov().default() : p,
                    h = t.inlineOffsetX, m = void 0 === h ? 0 : h, v = t.inlineOffsetY, g = void 0 === v ? 0 : v,
                    y = t.inlineContainer, b = void 0 === y ? document.body : y;
                this.settings = {
                    container: r,
                    zoomFactor: o,
                    inline: s,
                    namespace: c,
                    showWhitespaceAtEdges: d,
                    containInline: f,
                    inlineOffsetX: m,
                    inlineOffsetY: g,
                    inlineContainer: b
                }, this.openClasses = this._buildClasses("open"), this.openingClasses = this._buildClasses("opening"), this.closingClasses = this._buildClasses("closing"), this.inlineClasses = this._buildClasses("inline"), this.loadingClasses = this._buildClasses("loading"), this._buildElement()
            }

            var t, n, r;
            return t = e, (n = [{
                key: "_buildClasses", value: function (e)
                {
                    var t = ["pwzrdrift-".concat(e)], n = this.settings.namespace;
                    return n && t.push("".concat(n, "-").concat(e)), t
                }
            }, {
                key: "_buildElement", value: function ()
                {
                    this.el = document.createElement("div"), Ym().addClasses(this.el, this._buildClasses("zoom-pane"));
                    var e = document.createElement("div");
                    Ym().addClasses(e, this._buildClasses("zoom-pane-loader")), this.el.appendChild(e), this.imgEl = document.createElement("img"), this.el.appendChild(this.imgEl)
                }
            }, {
                key: "_setImageURL", value: function (e)
                {
                    this.imgEl.setAttribute("src", e)
                }
            }, {
                key: "_setImageSize", value: function (e, t)
                {
                    this.imgEl.style.width = "".concat(e * this.settings.zoomFactor, "px"), this.imgEl.style.height = "".concat(t * this.settings.zoomFactor, "px"), this.imgEl.style.maxWidth = "none"
                }
            }, {
                key: "setPosition", value: function (e, t, n)
                {
                    var r = this.imgEl.offsetWidth, i = this.imgEl.offsetHeight, o = this.el.offsetWidth,
                        a = this.el.offsetHeight, s = o / 2 - r * e, l = a / 2 - i * t, c = o - r, u = a - i, d = c > 0,
                        p = u > 0, f = d ? c / 2 : 0, h = p ? u / 2 : 0, m = d ? c / 2 : c, v = p ? u / 2 : u;
                    if (this.el.parentElement === this.settings.inlineContainer)
                    {
                        var g = n.left + e * n.width - o / 2 + this.settings.inlineOffsetX + 0,
                            y = n.top + t * n.height - a / 2 + this.settings.inlineOffsetY + 0;
                        this.settings.containInline && (g < n.left + 0 ? g = n.left + 0 : g + o > n.left + n.width + 0 && (g = n.left + n.width - o + 0), y < n.top + 0 ? y = n.top + 0 : y + a > n.top + n.height + 0 && (y = n.top + n.height - a + 0)), "yes" === getComputedStyle(this.el).getPropertyValue("--magnify-width-full") && (g = 0), "yes" === getComputedStyle(this.el).getPropertyValue("--magnify-height-full") && (y = 0), this.el.style.left = "".concat(g, "px"), this.el.style.top = "".concat(y, "px")
                    }
                    this.settings.showWhitespaceAtEdges || (s > f ? s = f : s < m && (s = m), l > h ? l = h : l < v && (l = v)), this.imgEl.style.transform = "translate(".concat(s, "px, ").concat(l, "px)"), this.imgEl.style.webkitTransform = "translate(".concat(s, "px, ").concat(l, "px)")
                }
            }, {
                key: "_removeListenersAndResetClasses", value: function ()
                {
                    this.el.removeEventListener("animationend", this._completeShow, !1), this.el.removeEventListener("animationend", this._completeHide, !1), this.el.removeEventListener("webkitAnimationEnd", this._completeShow, !1), this.el.removeEventListener("webkitAnimationEnd", this._completeHide, !1), Ym().removeClasses(this.el, this.openClasses), Ym().removeClasses(this.el, this.closingClasses)
                }
            }, {
                key: "show", value: function (e, t, n)
                {
                    if (this._removeListenersAndResetClasses(), this.isShowing = !0, Ym().addClasses(this.el, this.openClasses), this.imgEl.getAttribute("src") != e)
                    {
                        var r = this.el.querySelector(".pwzrdrift-zoom-pane-loader");
                        r && (r.style.display = "block"), Ym().addClasses(this.el, this.loadingClasses), this.imgEl.addEventListener("load", this._handleLoad, !1), this._setImageURL(e)
                    }
                    this._setImageSize(t, n), this._isInline ? this._showInline() : this._showInContainer(), xv && (this.el.addEventListener("animationend", this._completeShow, !1), this.el.addEventListener("webkitAnimationEnd", this._completeShow, !1), Ym().addClasses(this.el, this.openingClasses))
                }
            }, {
                key: "_showInline", value: function ()
                {
                    this.settings.inlineContainer.appendChild(this.el), Ym().addClasses(this.el, this.inlineClasses)
                }
            }, {
                key: "_showInContainer", value: function ()
                {
                    this.settings.container.appendChild(this.el)
                }
            }, {
                key: "hide", value: function ()
                {
                    this._removeListenersAndResetClasses(), this.isShowing = !1, xv ? (this.el.addEventListener("animationend", this._completeHide, !1), this.el.addEventListener("webkitAnimationEnd", this._completeHide, !1), Ym().addClasses(this.el, this.closingClasses)) : (Ym().removeClasses(this.el, this.openClasses), Ym().removeClasses(this.el, this.inlineClasses))
                }
            }, {
                key: "_completeShow", value: function ()
                {
                    this.el.removeEventListener("animationend", this._completeShow, !1), this.el.removeEventListener("webkitAnimationEnd", this._completeShow, !1), Ym().removeClasses(this.el, this.openingClasses)
                }
            }, {
                key: "_completeHide", value: function ()
                {
                    this.el.removeEventListener("animationend", this._completeHide, !1), this.el.removeEventListener("webkitAnimationEnd", this._completeHide, !1), Ym().removeClasses(this.el, this.openClasses), Ym().removeClasses(this.el, this.closingClasses), Ym().removeClasses(this.el, this.inlineClasses), this.el.setAttribute("style", ""), this.el.parentElement === this.settings.container ? this.settings.container.removeChild(this.el) : this.el.parentElement === this.settings.inlineContainer && this.settings.inlineContainer.removeChild(this.el)
                }
            }, {
                key: "_handleLoad", value: function ()
                {
                    var e = this.el.querySelector(".pwzrdrift-zoom-pane-loader");
                    e && (e.style.display = "none"), this.imgEl.removeEventListener("load", this._handleLoad, !1), Ym().removeClasses(this.el, this.loadingClasses)
                }
            }, {
                key: "_isInline", get: function ()
                {
                    var e = this.settings.inline;
                    return !0 === e || "number" == typeof e && window.innerWidth <= e
                }
            }]) && Sv(t.prototype, n), r && Sv(t, r), e
        }(), r(bv, "default", (function ()
        {
            return _v
        }))
    }

    function Tv()
    {
        return Cv || (Cv = !0, kv()), bv
    }

    var Ov, Mv, Rv = !1;

    function Pv(e, t)
    {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
    }

    function zv(e, t)
    {
        for (var n = 0; n < t.length; n++)
        {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r)
        }
    }

    function Iv()
    {
        Ov = {}, Ym(), tv(), yv(), Tv(), Mv = function ()
        {
            function e(t)
            {
                var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                if (Pv(this, e), this.VERSION = "1.4.0", this.triggerEl = t, this.destroy = this.destroy.bind(this), !Ym().isDOMElement(this.triggerEl)) throw new TypeError("`new Drift` requires a DOM element as its first argument.");
                var r = n.namespace || null, i = n.showWhitespaceAtEdges || !1, o = n.containInline || !1,
                    a = n.inlineOffsetX || 0, s = n.inlineOffsetY || 0, l = n.inlineContainer || document.body,
                    c = n.sourceAttribute || "data-zoom", u = n.zoomFactor || 3,
                    d = void 0 === n.paneContainer ? document.body : n.paneContainer, p = n.inlinePane || 375,
                    f = !("handleTouch" in n) || !!n.handleTouch, h = n.onShow || null, m = n.onHide || null,
                    v = !("injectBaseStyles" in n) || !!n.injectBaseStyles, g = n.hoverDelay || 0,
                    y = n.touchDelay || 0, b = n.hoverBoundingBox || !1, w = n.touchBoundingBox || !1,
                    x = n.boundingBoxContainer || document.body;
                if (!0 !== p && !Ym().isDOMElement(d)) throw new TypeError("`paneContainer` must be a DOM element when `inlinePane !== true`");
                if (!Ym().isDOMElement(l)) throw new TypeError("`inlineContainer` must be a DOM element");
                this.settings = {
                    namespace: r,
                    showWhitespaceAtEdges: i,
                    containInline: o,
                    inlineOffsetX: a,
                    inlineOffsetY: s,
                    inlineContainer: l,
                    sourceAttribute: c,
                    zoomFactor: u,
                    paneContainer: d,
                    inlinePane: p,
                    handleTouch: f,
                    onShow: h,
                    onHide: m,
                    injectBaseStyles: v,
                    hoverDelay: g,
                    touchDelay: y,
                    hoverBoundingBox: b,
                    touchBoundingBox: w,
                    boundingBoxContainer: x
                }, this.settings.injectBaseStyles && tv().default(), this._buildZoomPane(), this._buildTrigger()
            }

            var t, n, r;
            return t = e, (n = [{
                key: "_buildZoomPane", value: function ()
                {
                    this.zoomPane = new (Tv().default)({
                        container: this.settings.paneContainer,
                        zoomFactor: this.settings.zoomFactor,
                        showWhitespaceAtEdges: this.settings.showWhitespaceAtEdges,
                        containInline: this.settings.containInline,
                        inline: this.settings.inlinePane,
                        namespace: this.settings.namespace,
                        inlineOffsetX: this.settings.inlineOffsetX,
                        inlineOffsetY: this.settings.inlineOffsetY,
                        inlineContainer: this.settings.inlineContainer
                    })
                }
            }, {
                key: "_buildTrigger", value: function ()
                {
                    this.trigger = new (yv().default)({
                        el: this.triggerEl,
                        zoomPane: this.zoomPane,
                        handleTouch: this.settings.handleTouch,
                        onShow: this.settings.onShow,
                        onHide: this.settings.onHide,
                        sourceAttribute: this.settings.sourceAttribute,
                        hoverDelay: this.settings.hoverDelay,
                        touchDelay: this.settings.touchDelay,
                        hoverBoundingBox: this.settings.hoverBoundingBox,
                        touchBoundingBox: this.settings.touchBoundingBox,
                        namespace: this.settings.namespace,
                        zoomFactor: this.settings.zoomFactor,
                        boundingBoxContainer: this.settings.boundingBoxContainer,
                        inlineContainer: this.settings.inlineContainer
                    })
                }
            }, {
                key: "setZoomImageURL", value: function (e)
                {
                    this.zoomPane._setImageURL(e)
                }
            }, {
                key: "disable", value: function ()
                {
                    this.trigger.enabled = !1
                }
            }, {
                key: "enable", value: function ()
                {
                    this.trigger.enabled = !0
                }
            }, {
                key: "destroy", value: function ()
                {
                    this.trigger._hide(), this.trigger._unbindEvents()
                }
            }, {
                key: "isShowing", get: function ()
                {
                    return this.zoomPane.isShowing
                }
            }, {
                key: "zoomFactor", get: function ()
                {
                    return this.settings.zoomFactor
                }, set: function (e)
                {
                    this.settings.zoomFactor = e, this.zoomPane.settings.zoomFactor = e, this.trigger.settings.zoomFactor = e, this.boundingBox.settings.zoomFactor = e
                }
            }]) && zv(t.prototype, n), r && zv(t, r), e
        }(), r(Ov, "default", (function ()
        {
            return Mv
        })), Object.defineProperty(Mv.prototype, "isShowing", {
            get: function ()
            {
                return this.isShowing
            }
        }), Object.defineProperty(Mv.prototype, "zoomFactor", {
            get: function ()
            {
                return this.zoomFactor
            }, set: function (e)
            {
                this.zoomFactor = e
            }
        }), Mv.prototype.setZoomImageURL = Mv.prototype.setZoomImageURL, Mv.prototype.disable = Mv.prototype.disable, Mv.prototype.enable = Mv.prototype.enable, Mv.prototype.destroy = Mv.prototype.destroy
    }

    var Av = {}, Lv = Ed;
    Object.defineProperty(Av, "__esModule", {value: !0});
    var Dv = void 0;
    Av.default = Dv;
    var Nv = Lv(Od), Fv = Lv(zd);
    Dv = function (e, t)
    {
        return $a(e, (0, Nv.default)({defaultTheme: Fv.default}, t))
    }, Av.default = Dv;
    var Bv = t(Av);

    function Wv(e)
    {
        return null !== e && "object" == typeof e && "constructor" in e && e.constructor === Object
    }

    function $v(e, t)
    {
        void 0 === e && (e = {}), void 0 === t && (t = {}), Object.keys(t).forEach((function (n)
        {
            void 0 === e[n] ? e[n] = t[n] : Wv(t[n]) && Wv(e[n]) && Object.keys(t[n]).length > 0 && $v(e[n], t[n])
        }))
    }

    var Hv = {
        body: {}, addEventListener: function ()
        {
        }, removeEventListener: function ()
        {
        }, activeElement: {
            blur: function ()
            {
            }, nodeName: ""
        }, querySelector: function ()
        {
            return null
        }, querySelectorAll: function ()
        {
            return []
        }, getElementById: function ()
        {
            return null
        }, createEvent: function ()
        {
            return {
                initEvent: function ()
                {
                }
            }
        }, createElement: function ()
        {
            return {
                children: [], childNodes: [], style: {}, setAttribute: function ()
                {
                }, getElementsByTagName: function ()
                {
                    return []
                }
            }
        }, createElementNS: function ()
        {
            return {}
        }, importNode: function ()
        {
            return null
        }, location: {hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: ""}
    };

    function jv()
    {
        var e = "undefined" != typeof document ? document : {};
        return $v(e, Hv), e
    }

    var Vv = {
        document: Hv,
        navigator: {userAgent: ""},
        location: {hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: ""},
        history: {
            replaceState: function ()
            {
            }, pushState: function ()
            {
            }, go: function ()
            {
            }, back: function ()
            {
            }
        },
        CustomEvent: function ()
        {
            return this
        },
        addEventListener: function ()
        {
        },
        removeEventListener: function ()
        {
        },
        getComputedStyle: function ()
        {
            return {
                getPropertyValue: function ()
                {
                    return ""
                }
            }
        },
        Image: function ()
        {
        },
        Date: function ()
        {
        },
        screen: {},
        setTimeout: function ()
        {
        },
        clearTimeout: function ()
        {
        },
        matchMedia: function ()
        {
            return {}
        },
        requestAnimationFrame: function (e)
        {
            return "undefined" == typeof setTimeout ? (e(), null) : setTimeout(e, 0)
        },
        cancelAnimationFrame: function (e)
        {
            "undefined" != typeof setTimeout && clearTimeout(e)
        }
    };

    function qv()
    {
        var e = "undefined" != typeof window ? window : {};
        return $v(e, Vv), e
    }

    function Uv(e)
    {
        return (Uv = Object.setPrototypeOf ? Object.getPrototypeOf : function (e)
        {
            return e.__proto__ || Object.getPrototypeOf(e)
        })(e)
    }

    function Gv(e, t)
    {
        return (Gv = Object.setPrototypeOf || function (e, t)
        {
            return e.__proto__ = t, e
        })(e, t)
    }

    function Zv()
    {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try
        {
            return Date.prototype.toString.call(Reflect.construct(Date, [], (function ()
            {
            }))), !0
        } catch (e)
        {
            return !1
        }
    }

    function Kv(e, t, n)
    {
        return (Kv = Zv() ? Reflect.construct : function (e, t, n)
        {
            var r = [null];
            r.push.apply(r, t);
            var i = new (Function.bind.apply(e, r));
            return n && Gv(i, n.prototype), i
        }).apply(null, arguments)
    }

    function Yv(e)
    {
        var t = "function" == typeof Map ? new Map : void 0;
        return (Yv = function (e)
        {
            if (null === e || !function (e)
            {
                return -1 !== Function.toString.call(e).indexOf("[native code]")
            }(e)) return e;
            if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== t)
            {
                if (t.has(e)) return t.get(e);
                t.set(e, n)
            }

            function n()
            {
                return Kv(e, arguments, Uv(this).constructor)
            }

            return n.prototype = Object.create(e.prototype, {
                constructor: {
                    value: n,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                }
            }), Gv(n, e)
        })(e)
    }

    var Xv = function (e)
    {
        var t, n;

        function r(t)
        {
            var n, r, i;
            return n = e.call.apply(e, [this].concat(t)) || this, r = function (e)
            {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e
            }(n), i = r.__proto__, Object.defineProperty(r, "__proto__", {
                get: function ()
                {
                    return i
                }, set: function (e)
                {
                    i.__proto__ = e
                }
            }), n
        }

        return n = e, (t = r).prototype = Object.create(n.prototype), t.prototype.constructor = t, t.__proto__ = n, r
    }(Yv(Array));

    function Jv(e)
    {
        void 0 === e && (e = []);
        var t = [];
        return e.forEach((function (e)
        {
            Array.isArray(e) ? t.push.apply(t, Jv(e)) : t.push(e)
        })), t
    }

    function Qv(e, t)
    {
        return Array.prototype.filter.call(e, t)
    }

    function eg(e, t)
    {
        var n = qv(), r = jv(), i = [];
        if (!t && e instanceof Xv) return e;
        if (!e) return new Xv(i);
        if ("string" == typeof e)
        {
            var o = e.trim();
            if (o.indexOf("<") >= 0 && o.indexOf(">") >= 0)
            {
                var a = "div";
                0 === o.indexOf("<li") && (a = "ul"), 0 === o.indexOf("<tr") && (a = "tbody"), 0 !== o.indexOf("<td") && 0 !== o.indexOf("<th") || (a = "tr"), 0 === o.indexOf("<tbody") && (a = "table"), 0 === o.indexOf("<option") && (a = "select");
                var s = r.createElement(a);
                s.innerHTML = o;
                for (var l = 0; l < s.childNodes.length; l += 1) i.push(s.childNodes[l])
            } else i = function (e, t)
            {
                if ("string" != typeof e) return [e];
                for (var n = [], r = t.querySelectorAll(e), i = 0; i < r.length; i += 1) n.push(r[i]);
                return n
            }(e.trim(), t || r)
        } else if (e.nodeType || e === n || e === r) i.push(e); else if (Array.isArray(e))
        {
            if (e instanceof Xv) return e;
            i = e
        }
        return new Xv(function (e)
        {
            for (var t = [], n = 0; n < e.length; n += 1) -1 === t.indexOf(e[n]) && t.push(e[n]);
            return t
        }(i))
    }

    eg.fn = Xv.prototype;
    var tg = "resize scroll".split(" ");

    function ng(e)
    {
        return function ()
        {
            for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
            if (void 0 === n[0])
            {
                for (var i = 0; i < this.length; i += 1) tg.indexOf(e) < 0 && (e in this[i] ? this[i][e]() : eg(this[i]).trigger(e));
                return this
            }
            return this.on.apply(this, [e].concat(n))
        }
    }

    ng("click"), ng("blur"), ng("focus"), ng("focusin"), ng("focusout"), ng("keyup"), ng("keydown"), ng("keypress"), ng("submit"), ng("change"), ng("mousedown"), ng("mousemove"), ng("mouseup"), ng("mouseenter"), ng("mouseleave"), ng("mouseout"), ng("mouseover"), ng("touchstart"), ng("touchend"), ng("touchmove"), ng("resize"), ng("scroll");
    var rg = {
        addClass: function ()
        {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
            var r = Jv(t.map((function (e)
            {
                return e.split(" ")
            })));
            return this.forEach((function (e)
            {
                var t;
                (t = e.classList).add.apply(t, r)
            })), this
        }, removeClass: function ()
        {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
            var r = Jv(t.map((function (e)
            {
                return e.split(" ")
            })));
            return this.forEach((function (e)
            {
                var t;
                (t = e.classList).remove.apply(t, r)
            })), this
        }, hasClass: function ()
        {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
            var r = Jv(t.map((function (e)
            {
                return e.split(" ")
            })));
            return Qv(this, (function (e)
            {
                return r.filter((function (t)
                {
                    return e.classList.contains(t)
                })).length > 0
            })).length > 0
        }, toggleClass: function ()
        {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
            var r = Jv(t.map((function (e)
            {
                return e.split(" ")
            })));
            this.forEach((function (e)
            {
                r.forEach((function (t)
                {
                    e.classList.toggle(t)
                }))
            }))
        }, attr: function (e, t)
        {
            if (1 === arguments.length && "string" == typeof e) return this[0] ? this[0].getAttribute(e) : void 0;
            for (var n = 0; n < this.length; n += 1) if (2 === arguments.length) this[n].setAttribute(e, t); else for (var r in e) this[n][r] = e[r], this[n].setAttribute(r, e[r]);
            return this
        }, removeAttr: function (e)
        {
            for (var t = 0; t < this.length; t += 1) this[t].removeAttribute(e);
            return this
        }, transform: function (e)
        {
            for (var t = 0; t < this.length; t += 1) this[t].style.transform = e;
            return this
        }, transition: function (e)
        {
            for (var t = 0; t < this.length; t += 1) this[t].style.transitionDuration = "string" != typeof e ? e + "ms" : e;
            return this
        }, on: function ()
        {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
            var r = t[0], i = t[1], o = t[2], a = t[3];

            function s(e)
            {
                var t = e.target;
                if (t)
                {
                    var n = e.target.dom7EventData || [];
                    if (n.indexOf(e) < 0 && n.unshift(e), eg(t).is(i)) o.apply(t, n); else for (var r = eg(t).parents(), a = 0; a < r.length; a += 1) eg(r[a]).is(i) && o.apply(r[a], n)
                }
            }

            function l(e)
            {
                var t = e && e.target && e.target.dom7EventData || [];
                t.indexOf(e) < 0 && t.unshift(e), o.apply(this, t)
            }

            "function" == typeof t[1] && (r = t[0], o = t[1], a = t[2], i = void 0), a || (a = !1);
            for (var c, u = r.split(" "), d = 0; d < this.length; d += 1)
            {
                var p = this[d];
                if (i) for (c = 0; c < u.length; c += 1)
                {
                    var f = u[c];
                    p.dom7LiveListeners || (p.dom7LiveListeners = {}), p.dom7LiveListeners[f] || (p.dom7LiveListeners[f] = []), p.dom7LiveListeners[f].push({
                        listener: o,
                        proxyListener: s
                    }), p.addEventListener(f, s, a)
                } else for (c = 0; c < u.length; c += 1)
                {
                    var h = u[c];
                    p.dom7Listeners || (p.dom7Listeners = {}), p.dom7Listeners[h] || (p.dom7Listeners[h] = []), p.dom7Listeners[h].push({
                        listener: o,
                        proxyListener: l
                    }), p.addEventListener(h, l, a)
                }
            }
            return this
        }, off: function ()
        {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
            var r = t[0], i = t[1], o = t[2], a = t[3];
            "function" == typeof t[1] && (r = t[0], o = t[1], a = t[2], i = void 0), a || (a = !1);
            for (var s = r.split(" "), l = 0; l < s.length; l += 1) for (var c = s[l], u = 0; u < this.length; u += 1)
            {
                var d = this[u], p = void 0;
                if (!i && d.dom7Listeners ? p = d.dom7Listeners[c] : i && d.dom7LiveListeners && (p = d.dom7LiveListeners[c]), p && p.length) for (var f = p.length - 1; f >= 0; f -= 1)
                {
                    var h = p[f];
                    o && h.listener === o || o && h.listener && h.listener.dom7proxy && h.listener.dom7proxy === o ? (d.removeEventListener(c, h.proxyListener, a), p.splice(f, 1)) : o || (d.removeEventListener(c, h.proxyListener, a), p.splice(f, 1))
                }
            }
            return this
        }, trigger: function ()
        {
            for (var e = qv(), t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
            for (var i = n[0].split(" "), o = n[1], a = 0; a < i.length; a += 1) for (var s = i[a], l = 0; l < this.length; l += 1)
            {
                var c = this[l];
                if (e.CustomEvent)
                {
                    var u = new e.CustomEvent(s, {detail: o, bubbles: !0, cancelable: !0});
                    c.dom7EventData = n.filter((function (e, t)
                    {
                        return t > 0
                    })), c.dispatchEvent(u), c.dom7EventData = [], delete c.dom7EventData
                }
            }
            return this
        }, transitionEnd: function (e)
        {
            var t = this;
            return e && t.on("transitionend", (function n(r)
            {
                r.target === this && (e.call(this, r), t.off("transitionend", n))
            })), this
        }, outerWidth: function (e)
        {
            if (this.length > 0)
            {
                if (e)
                {
                    var t = this.styles();
                    return this[0].offsetWidth + parseFloat(t.getPropertyValue("margin-right")) + parseFloat(t.getPropertyValue("margin-left"))
                }
                return this[0].offsetWidth
            }
            return null
        }, outerHeight: function (e)
        {
            if (this.length > 0)
            {
                if (e)
                {
                    var t = this.styles();
                    return this[0].offsetHeight + parseFloat(t.getPropertyValue("margin-top")) + parseFloat(t.getPropertyValue("margin-bottom"))
                }
                return this[0].offsetHeight
            }
            return null
        }, styles: function ()
        {
            var e = qv();
            return this[0] ? e.getComputedStyle(this[0], null) : {}
        }, offset: function ()
        {
            if (this.length > 0)
            {
                var e = qv(), t = jv(), n = this[0], r = n.getBoundingClientRect(), i = t.body,
                    o = n.clientTop || i.clientTop || 0, a = n.clientLeft || i.clientLeft || 0,
                    s = n === e ? e.scrollY : n.scrollTop, l = n === e ? e.scrollX : n.scrollLeft;
                return {top: r.top + s - o, left: r.left + l - a}
            }
            return null
        }, css: function (e, t)
        {
            var n, r = qv();
            if (1 === arguments.length)
            {
                if ("string" != typeof e)
                {
                    for (n = 0; n < this.length; n += 1) for (var i in e) this[n].style[i] = e[i];
                    return this
                }
                if (this[0]) return r.getComputedStyle(this[0], null).getPropertyValue(e)
            }
            if (2 === arguments.length && "string" == typeof e)
            {
                for (n = 0; n < this.length; n += 1) this[n].style[e] = t;
                return this
            }
            return this
        }, each: function (e)
        {
            return e ? (this.forEach((function (t, n)
            {
                e.apply(t, [t, n])
            })), this) : this
        }, html: function (e)
        {
            if (void 0 === e) return this[0] ? this[0].innerHTML : null;
            for (var t = 0; t < this.length; t += 1) this[t].innerHTML = e;
            return this
        }, text: function (e)
        {
            if (void 0 === e) return this[0] ? this[0].textContent.trim() : null;
            for (var t = 0; t < this.length; t += 1) this[t].textContent = e;
            return this
        }, is: function (e)
        {
            var t, n, r = qv(), i = jv(), o = this[0];
            if (!o || void 0 === e) return !1;
            if ("string" == typeof e)
            {
                if (o.matches) return o.matches(e);
                if (o.webkitMatchesSelector) return o.webkitMatchesSelector(e);
                if (o.msMatchesSelector) return o.msMatchesSelector(e);
                for (t = eg(e), n = 0; n < t.length; n += 1) if (t[n] === o) return !0;
                return !1
            }
            if (e === i) return o === i;
            if (e === r) return o === r;
            if (e.nodeType || e instanceof Xv)
            {
                for (t = e.nodeType ? [e] : e, n = 0; n < t.length; n += 1) if (t[n] === o) return !0;
                return !1
            }
            return !1
        }, index: function ()
        {
            var e, t = this[0];
            if (t)
            {
                for (e = 0; null !== (t = t.previousSibling);) 1 === t.nodeType && (e += 1);
                return e
            }
        }, eq: function (e)
        {
            if (void 0 === e) return this;
            var t = this.length;
            if (e > t - 1) return eg([]);
            if (e < 0)
            {
                var n = t + e;
                return eg(n < 0 ? [] : [this[n]])
            }
            return eg([this[e]])
        }, append: function ()
        {
            for (var e, t = jv(), n = 0; n < arguments.length; n += 1)
            {
                e = n < 0 || arguments.length <= n ? void 0 : arguments[n];
                for (var r = 0; r < this.length; r += 1) if ("string" == typeof e)
                {
                    var i = t.createElement("div");
                    for (i.innerHTML = e; i.firstChild;) this[r].appendChild(i.firstChild)
                } else if (e instanceof Xv) for (var o = 0; o < e.length; o += 1) this[r].appendChild(e[o]); else this[r].appendChild(e)
            }
            return this
        }, prepend: function (e)
        {
            var t, n, r = jv();
            for (t = 0; t < this.length; t += 1) if ("string" == typeof e)
            {
                var i = r.createElement("div");
                for (i.innerHTML = e, n = i.childNodes.length - 1; n >= 0; n -= 1) this[t].insertBefore(i.childNodes[n], this[t].childNodes[0])
            } else if (e instanceof Xv) for (n = 0; n < e.length; n += 1) this[t].insertBefore(e[n], this[t].childNodes[0]); else this[t].insertBefore(e, this[t].childNodes[0]);
            return this
        }, next: function (e)
        {
            return this.length > 0 ? e ? this[0].nextElementSibling && eg(this[0].nextElementSibling).is(e) ? eg([this[0].nextElementSibling]) : eg([]) : this[0].nextElementSibling ? eg([this[0].nextElementSibling]) : eg([]) : eg([])
        }, nextAll: function (e)
        {
            var t = [], n = this[0];
            if (!n) return eg([]);
            for (; n.nextElementSibling;)
            {
                var r = n.nextElementSibling;
                e ? eg(r).is(e) && t.push(r) : t.push(r), n = r
            }
            return eg(t)
        }, prev: function (e)
        {
            if (this.length > 0)
            {
                var t = this[0];
                return e ? t.previousElementSibling && eg(t.previousElementSibling).is(e) ? eg([t.previousElementSibling]) : eg([]) : t.previousElementSibling ? eg([t.previousElementSibling]) : eg([])
            }
            return eg([])
        }, prevAll: function (e)
        {
            var t = [], n = this[0];
            if (!n) return eg([]);
            for (; n.previousElementSibling;)
            {
                var r = n.previousElementSibling;
                e ? eg(r).is(e) && t.push(r) : t.push(r), n = r
            }
            return eg(t)
        }, parent: function (e)
        {
            for (var t = [], n = 0; n < this.length; n += 1) null !== this[n].parentNode && (e ? eg(this[n].parentNode).is(e) && t.push(this[n].parentNode) : t.push(this[n].parentNode));
            return eg(t)
        }, parents: function (e)
        {
            for (var t = [], n = 0; n < this.length; n += 1) for (var r = this[n].parentNode; r;) e ? eg(r).is(e) && t.push(r) : t.push(r), r = r.parentNode;
            return eg(t)
        }, closest: function (e)
        {
            var t = this;
            return void 0 === e ? eg([]) : (t.is(e) || (t = t.parents(e).eq(0)), t)
        }, find: function (e)
        {
            for (var t = [], n = 0; n < this.length; n += 1) for (var r = this[n].querySelectorAll(e), i = 0; i < r.length; i += 1) t.push(r[i]);
            return eg(t)
        }, children: function (e)
        {
            for (var t = [], n = 0; n < this.length; n += 1) for (var r = this[n].children, i = 0; i < r.length; i += 1) e && !eg(r[i]).is(e) || t.push(r[i]);
            return eg(t)
        }, filter: function (e)
        {
            return eg(Qv(this, e))
        }, remove: function ()
        {
            for (var e = 0; e < this.length; e += 1) this[e].parentNode && this[e].parentNode.removeChild(this[e]);
            return this
        }
    };
    Object.keys(rg).forEach((function (e)
    {
        eg.fn[e] = rg[e]
    }));
    var ig, og, ag, sg = eg;

    function lg(e, t)
    {
        return void 0 === t && (t = 0), setTimeout(e, t)
    }

    function cg()
    {
        return Date.now()
    }

    function ug(e)
    {
        return "object" == typeof e && null !== e && e.constructor && e.constructor === Object
    }

    function dg()
    {
        for (var e = Object(arguments.length <= 0 ? void 0 : arguments[0]), t = 1; t < arguments.length; t += 1)
        {
            var n = t < 0 || arguments.length <= t ? void 0 : arguments[t];
            if (null != n) for (var r = Object.keys(Object(n)), i = 0, o = r.length; i < o; i += 1)
            {
                var a = r[i], s = Object.getOwnPropertyDescriptor(n, a);
                void 0 !== s && s.enumerable && (ug(e[a]) && ug(n[a]) ? dg(e[a], n[a]) : !ug(e[a]) && ug(n[a]) ? (e[a] = {}, dg(e[a], n[a])) : e[a] = n[a])
            }
        }
        return e
    }

    function pg(e, t)
    {
        Object.keys(t).forEach((function (n)
        {
            ug(t[n]) && Object.keys(t[n]).forEach((function (r)
            {
                "function" == typeof t[n][r] && (t[n][r] = t[n][r].bind(e))
            })), e[n] = t[n]
        }))
    }

    function fg()
    {
        return ig || (ig = function ()
        {
            var e = qv(), t = jv();
            return {
                touch: !!("ontouchstart" in e || e.DocumentTouch && t instanceof e.DocumentTouch),
                pointerEvents: !!e.PointerEvent && "maxTouchPoints" in e.navigator && e.navigator.maxTouchPoints >= 0,
                observer: "MutationObserver" in e || "WebkitMutationObserver" in e,
                passiveListener: function ()
                {
                    var t = !1;
                    try
                    {
                        var n = Object.defineProperty({}, "passive", {
                            get: function ()
                            {
                                t = !0
                            }
                        });
                        e.addEventListener("testPassiveListener", null, n)
                    } catch (e)
                    {
                    }
                    return t
                }(),
                gestures: "ongesturestart" in e
            }
        }()), ig
    }

    function hg(e)
    {
        return void 0 === e && (e = {}), og || (og = function (e)
        {
            var t = (void 0 === e ? {} : e).userAgent, n = fg(), r = qv(), i = r.navigator.platform,
                o = t || r.navigator.userAgent, a = {ios: !1, android: !1}, s = r.screen.width, l = r.screen.height,
                c = o.match(/(Android);?[\s\/]+([\d.]+)?/), u = o.match(/(iPad).*OS\s([\d_]+)/),
                d = o.match(/(iPod)(.*OS\s([\d_]+))?/), p = !u && o.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
                f = "Win32" === i, h = "MacIntel" === i;
            return !u && h && n.touch && ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"].indexOf(s + "x" + l) >= 0 && ((u = o.match(/(Version)\/([\d.]+)/)) || (u = [0, 1, "13_0_0"]), h = !1), c && !f && (a.os = "android", a.android = !0), (u || p || d) && (a.os = "ios", a.ios = !0), a
        }(e)), og
    }

    function mg()
    {
        return ag || (ag = function ()
        {
            var e, t = qv();
            return {
                isEdge: !!t.navigator.userAgent.match(/Edge/g),
                isSafari: (e = t.navigator.userAgent.toLowerCase(), e.indexOf("safari") >= 0 && e.indexOf("chrome") < 0 && e.indexOf("android") < 0),
                isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(t.navigator.userAgent)
            }
        }()), ag
    }

    var vg = {
        name: "resize", create: function ()
        {
            var e = this;
            dg(e, {
                resize: {
                    observer: null, createObserver: function ()
                    {
                        e && !e.destroyed && e.initialized && (e.resize.observer = new ResizeObserver((function (t)
                        {
                            var n = e.width, r = e.height, i = n, o = r;
                            t.forEach((function (t)
                            {
                                var n = t.contentBoxSize, r = t.contentRect, a = t.target;
                                a && a !== e.el || (i = r ? r.width : (n[0] || n).inlineSize, o = r ? r.height : (n[0] || n).blockSize)
                            })), i === n && o === r || e.resize.resizeHandler()
                        })), e.resize.observer.observe(e.el))
                    }, removeObserver: function ()
                    {
                        e.resize.observer && e.resize.observer.unobserve && e.el && (e.resize.observer.unobserve(e.el), e.resize.observer = null)
                    }, resizeHandler: function ()
                    {
                        e && !e.destroyed && e.initialized && (e.emit("beforeResize"), e.emit("resize"))
                    }, orientationChangeHandler: function ()
                    {
                        e && !e.destroyed && e.initialized && e.emit("orientationchange")
                    }
                }
            })
        }, on: {
            init: function (e)
            {
                var t = qv();
                e.params.resizeObserver && void 0 !== qv().ResizeObserver ? e.resize.createObserver() : (t.addEventListener("resize", e.resize.resizeHandler), t.addEventListener("orientationchange", e.resize.orientationChangeHandler))
            }, destroy: function (e)
            {
                var t = qv();
                e.resize.removeObserver(), t.removeEventListener("resize", e.resize.resizeHandler), t.removeEventListener("orientationchange", e.resize.orientationChangeHandler)
            }
        }
    };

    function gg()
    {
        return (gg = Object.assign || function (e)
        {
            for (var t = 1; t < arguments.length; t++)
            {
                var n = arguments[t];
                for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r])
            }
            return e
        }).apply(this, arguments)
    }

    var yg = {
        attach: function (e, t)
        {
            void 0 === t && (t = {});
            var n = qv(), r = this, i = new (n.MutationObserver || n.WebkitMutationObserver)((function (e)
            {
                if (1 !== e.length)
                {
                    var t = function ()
                    {
                        r.emit("observerUpdate", e[0])
                    };
                    n.requestAnimationFrame ? n.requestAnimationFrame(t) : n.setTimeout(t, 0)
                } else r.emit("observerUpdate", e[0])
            }));
            i.observe(e, {
                attributes: void 0 === t.attributes || t.attributes,
                childList: void 0 === t.childList || t.childList,
                characterData: void 0 === t.characterData || t.characterData
            }), r.observer.observers.push(i)
        }, init: function ()
        {
            var e = this;
            if (e.support.observer && e.params.observer)
            {
                if (e.params.observeParents) for (var t = e.$el.parents(), n = 0; n < t.length; n += 1) e.observer.attach(t[n]);
                e.observer.attach(e.$el[0], {childList: e.params.observeSlideChildren}), e.observer.attach(e.$wrapperEl[0], {attributes: !1})
            }
        }, destroy: function ()
        {
            this.observer.observers.forEach((function (e)
            {
                e.disconnect()
            })), this.observer.observers = []
        }
    }, bg = {
        name: "observer", params: {observer: !1, observeParents: !1, observeSlideChildren: !1}, create: function ()
        {
            pg(this, {observer: gg({}, yg, {observers: []})})
        }, on: {
            init: function (e)
            {
                e.observer.init()
            }, destroy: function (e)
            {
                e.observer.destroy()
            }
        }
    };

    function wg(e)
    {
        var t = this, n = jv(), r = qv(), i = t.touchEventsData, o = t.params, a = t.touches;
        if (!t.animating || !o.preventInteractionOnTransition)
        {
            var s = e;
            s.originalEvent && (s = s.originalEvent);
            var l = sg(s.target);
            if ("wrapper" !== o.touchEventsTarget || l.closest(t.wrapperEl).length) if (i.isTouchEvent = "touchstart" === s.type, i.isTouchEvent || !("which" in s) || 3 !== s.which) if (!(!i.isTouchEvent && "button" in s && s.button > 0)) if (!i.isTouched || !i.isMoved) if (!!o.noSwipingClass && "" !== o.noSwipingClass && s.target && s.target.shadowRoot && e.path && e.path[0] && (l = sg(e.path[0])), o.noSwiping && l.closest(o.noSwipingSelector ? o.noSwipingSelector : "." + o.noSwipingClass)[0]) t.allowClick = !0; else if (!o.swipeHandler || l.closest(o.swipeHandler)[0])
            {
                a.currentX = "touchstart" === s.type ? s.targetTouches[0].pageX : s.pageX, a.currentY = "touchstart" === s.type ? s.targetTouches[0].pageY : s.pageY;
                var c = a.currentX, u = a.currentY, d = o.edgeSwipeDetection || o.iOSEdgeSwipeDetection,
                    p = o.edgeSwipeThreshold || o.iOSEdgeSwipeThreshold;
                if (d && (c <= p || c >= r.innerWidth - p))
                {
                    if ("prevent" !== d) return;
                    e.preventDefault()
                }
                if (dg(i, {
                    isTouched: !0,
                    isMoved: !1,
                    allowTouchCallbacks: !0,
                    isScrolling: void 0,
                    startMoving: void 0
                }), a.startX = c, a.startY = u, i.touchStartTime = cg(), t.allowClick = !0, t.updateSize(), t.swipeDirection = void 0, o.threshold > 0 && (i.allowThresholdMove = !1), "touchstart" !== s.type)
                {
                    var f = !0;
                    l.is(i.formElements) && (f = !1), n.activeElement && sg(n.activeElement).is(i.formElements) && n.activeElement !== l[0] && n.activeElement.blur();
                    var h = f && t.allowTouchMove && o.touchStartPreventDefault;
                    !o.touchStartForcePreventDefault && !h || l[0].isContentEditable || s.preventDefault()
                }
                t.emit("touchStart", s)
            }
        }
    }

    function xg(e)
    {
        var t = jv(), n = this, r = n.touchEventsData, i = n.params, o = n.touches, a = n.rtlTranslate, s = e;
        if (s.originalEvent && (s = s.originalEvent), r.isTouched)
        {
            if (!r.isTouchEvent || "touchmove" === s.type)
            {
                var l = "touchmove" === s.type && s.targetTouches && (s.targetTouches[0] || s.changedTouches[0]),
                    c = "touchmove" === s.type ? l.pageX : s.pageX, u = "touchmove" === s.type ? l.pageY : s.pageY;
                if (s.preventedByNestedSwiper) return o.startX = c, void (o.startY = u);
                if (!n.allowTouchMove) return n.allowClick = !1, void (r.isTouched && (dg(o, {
                    startX: c,
                    startY: u,
                    currentX: c,
                    currentY: u
                }), r.touchStartTime = cg()));
                if (r.isTouchEvent && i.touchReleaseOnEdges && !i.loop) if (n.isVertical())
                {
                    if (u < o.startY && n.translate <= n.maxTranslate() || u > o.startY && n.translate >= n.minTranslate()) return r.isTouched = !1, void (r.isMoved = !1)
                } else if (c < o.startX && n.translate <= n.maxTranslate() || c > o.startX && n.translate >= n.minTranslate()) return;
                if (r.isTouchEvent && t.activeElement && s.target === t.activeElement && sg(s.target).is(r.formElements)) return r.isMoved = !0, void (n.allowClick = !1);
                if (r.allowTouchCallbacks && n.emit("touchMove", s), !(s.targetTouches && s.targetTouches.length > 1))
                {
                    o.currentX = c, o.currentY = u;
                    var d = o.currentX - o.startX, p = o.currentY - o.startY;
                    if (!(n.params.threshold && Math.sqrt(Math.pow(d, 2) + Math.pow(p, 2)) < n.params.threshold))
                    {
                        var f;
                        if (void 0 === r.isScrolling) n.isHorizontal() && o.currentY === o.startY || n.isVertical() && o.currentX === o.startX ? r.isScrolling = !1 : d * d + p * p >= 25 && (f = 180 * Math.atan2(Math.abs(p), Math.abs(d)) / Math.PI, r.isScrolling = n.isHorizontal() ? f > i.touchAngle : 90 - f > i.touchAngle);
                        if (r.isScrolling && n.emit("touchMoveOpposite", s), void 0 === r.startMoving && (o.currentX === o.startX && o.currentY === o.startY || (r.startMoving = !0)), r.isScrolling) r.isTouched = !1; else if (r.startMoving)
                        {
                            n.allowClick = !1, !i.cssMode && s.cancelable && s.preventDefault(), i.touchMoveStopPropagation && !i.nested && s.stopPropagation(), r.isMoved || (i.loop && n.loopFix(), r.startTranslate = n.getTranslate(), n.setTransition(0), n.animating && n.$wrapperEl.trigger("webkitTransitionEnd transitionend"), r.allowMomentumBounce = !1, !i.grabCursor || !0 !== n.allowSlideNext && !0 !== n.allowSlidePrev || n.setGrabCursor(!0), n.emit("sliderFirstMove", s)), n.emit("sliderMove", s), r.isMoved = !0;
                            var h = n.isHorizontal() ? d : p;
                            o.diff = h, h *= i.touchRatio, a && (h = -h), n.swipeDirection = h > 0 ? "prev" : "next", r.currentTranslate = h + r.startTranslate;
                            var m = !0, v = i.resistanceRatio;
                            if (i.touchReleaseOnEdges && (v = 0), h > 0 && r.currentTranslate > n.minTranslate() ? (m = !1, i.resistance && (r.currentTranslate = n.minTranslate() - 1 + Math.pow(-n.minTranslate() + r.startTranslate + h, v))) : h < 0 && r.currentTranslate < n.maxTranslate() && (m = !1, i.resistance && (r.currentTranslate = n.maxTranslate() + 1 - Math.pow(n.maxTranslate() - r.startTranslate - h, v))), m && (s.preventedByNestedSwiper = !0), !n.allowSlideNext && "next" === n.swipeDirection && r.currentTranslate < r.startTranslate && (r.currentTranslate = r.startTranslate), !n.allowSlidePrev && "prev" === n.swipeDirection && r.currentTranslate > r.startTranslate && (r.currentTranslate = r.startTranslate), n.allowSlidePrev || n.allowSlideNext || (r.currentTranslate = r.startTranslate), i.threshold > 0)
                            {
                                if (!(Math.abs(h) > i.threshold || r.allowThresholdMove)) return void (r.currentTranslate = r.startTranslate);
                                if (!r.allowThresholdMove) return r.allowThresholdMove = !0, o.startX = o.currentX, o.startY = o.currentY, r.currentTranslate = r.startTranslate, void (o.diff = n.isHorizontal() ? o.currentX - o.startX : o.currentY - o.startY)
                            }
                            i.followFinger && !i.cssMode && ((i.freeMode || i.watchSlidesProgress || i.watchSlidesVisibility) && (n.updateActiveIndex(), n.updateSlidesClasses()), i.freeMode && (0 === r.velocities.length && r.velocities.push({
                                position: o[n.isHorizontal() ? "startX" : "startY"],
                                time: r.touchStartTime
                            }), r.velocities.push({
                                position: o[n.isHorizontal() ? "currentX" : "currentY"],
                                time: cg()
                            })), n.updateProgress(r.currentTranslate), n.setTranslate(r.currentTranslate))
                        }
                    }
                }
            }
        } else r.startMoving && r.isScrolling && n.emit("touchMoveOpposite", s)
    }

    function _g(e)
    {
        var t = this, n = t.touchEventsData, r = t.params, i = t.touches, o = t.rtlTranslate, a = t.$wrapperEl,
            s = t.slidesGrid, l = t.snapGrid, c = e;
        if (c.originalEvent && (c = c.originalEvent), n.allowTouchCallbacks && t.emit("touchEnd", c), n.allowTouchCallbacks = !1, !n.isTouched) return n.isMoved && r.grabCursor && t.setGrabCursor(!1), n.isMoved = !1, void (n.startMoving = !1);
        r.grabCursor && n.isMoved && n.isTouched && (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) && t.setGrabCursor(!1);
        var u, d = cg(), p = d - n.touchStartTime;
        if (t.allowClick && (t.updateClickedSlide(c), t.emit("tap click", c), p < 300 && d - n.lastClickTime < 300 && t.emit("doubleTap doubleClick", c)), n.lastClickTime = cg(), lg((function ()
        {
            t.destroyed || (t.allowClick = !0)
        })), !n.isTouched || !n.isMoved || !t.swipeDirection || 0 === i.diff || n.currentTranslate === n.startTranslate) return n.isTouched = !1, n.isMoved = !1, void (n.startMoving = !1);
        if (n.isTouched = !1, n.isMoved = !1, n.startMoving = !1, u = r.followFinger ? o ? t.translate : -t.translate : -n.currentTranslate, !r.cssMode) if (r.freeMode)
        {
            if (u < -t.minTranslate()) return void t.slideTo(t.activeIndex);
            if (u > -t.maxTranslate()) return void (t.slides.length < l.length ? t.slideTo(l.length - 1) : t.slideTo(t.slides.length - 1));
            if (r.freeModeMomentum)
            {
                if (n.velocities.length > 1)
                {
                    var f = n.velocities.pop(), h = n.velocities.pop(), m = f.position - h.position,
                        v = f.time - h.time;
                    t.velocity = m / v, t.velocity /= 2, Math.abs(t.velocity) < r.freeModeMinimumVelocity && (t.velocity = 0), (v > 150 || cg() - f.time > 300) && (t.velocity = 0)
                } else t.velocity = 0;
                t.velocity *= r.freeModeMomentumVelocityRatio, n.velocities.length = 0;
                var g = 1e3 * r.freeModeMomentumRatio, y = t.velocity * g, b = t.translate + y;
                o && (b = -b);
                var w, x, _ = !1, C = 20 * Math.abs(t.velocity) * r.freeModeMomentumBounceRatio;
                if (b < t.maxTranslate()) r.freeModeMomentumBounce ? (b + t.maxTranslate() < -C && (b = t.maxTranslate() - C), w = t.maxTranslate(), _ = !0, n.allowMomentumBounce = !0) : b = t.maxTranslate(), r.loop && r.centeredSlides && (x = !0); else if (b > t.minTranslate()) r.freeModeMomentumBounce ? (b - t.minTranslate() > C && (b = t.minTranslate() + C), w = t.minTranslate(), _ = !0, n.allowMomentumBounce = !0) : b = t.minTranslate(), r.loop && r.centeredSlides && (x = !0); else if (r.freeModeSticky)
                {
                    for (var E, S = 0; S < l.length; S += 1) if (l[S] > -b)
                    {
                        E = S;
                        break
                    }
                    b = -(b = Math.abs(l[E] - b) < Math.abs(l[E - 1] - b) || "next" === t.swipeDirection ? l[E] : l[E - 1])
                }
                if (x && t.once("transitionEnd", (function ()
                {
                    t.loopFix()
                })), 0 !== t.velocity)
                {
                    if (g = o ? Math.abs((-b - t.translate) / t.velocity) : Math.abs((b - t.translate) / t.velocity), r.freeModeSticky)
                    {
                        var k = Math.abs((o ? -b : b) - t.translate), T = t.slidesSizesGrid[t.activeIndex];
                        g = k < T ? r.speed : k < 2 * T ? 1.5 * r.speed : 2.5 * r.speed
                    }
                } else if (r.freeModeSticky) return void t.slideToClosest();
                r.freeModeMomentumBounce && _ ? (t.updateProgress(w), t.setTransition(g), t.setTranslate(b), t.transitionStart(!0, t.swipeDirection), t.animating = !0, a.transitionEnd((function ()
                {
                    t && !t.destroyed && n.allowMomentumBounce && (t.emit("momentumBounce"), t.setTransition(r.speed), setTimeout((function ()
                    {
                        t.setTranslate(w), a.transitionEnd((function ()
                        {
                            t && !t.destroyed && t.transitionEnd()
                        }))
                    }), 0))
                }))) : t.velocity ? (t.updateProgress(b), t.setTransition(g), t.setTranslate(b), t.transitionStart(!0, t.swipeDirection), t.animating || (t.animating = !0, a.transitionEnd((function ()
                {
                    t && !t.destroyed && t.transitionEnd()
                })))) : (t.emit("_freeModeNoMomentumRelease"), t.updateProgress(b)), t.updateActiveIndex(), t.updateSlidesClasses()
            } else
            {
                if (r.freeModeSticky) return void t.slideToClosest();
                r.freeMode && t.emit("_freeModeNoMomentumRelease")
            }
            (!r.freeModeMomentum || p >= r.longSwipesMs) && (t.updateProgress(), t.updateActiveIndex(), t.updateSlidesClasses())
        } else
        {
            for (var O = 0, M = t.slidesSizesGrid[0], R = 0; R < s.length; R += R < r.slidesPerGroupSkip ? 1 : r.slidesPerGroup)
            {
                var P = R < r.slidesPerGroupSkip - 1 ? 1 : r.slidesPerGroup;
                void 0 !== s[R + P] ? u >= s[R] && u < s[R + P] && (O = R, M = s[R + P] - s[R]) : u >= s[R] && (O = R, M = s[s.length - 1] - s[s.length - 2])
            }
            var z = (u - s[O]) / M, I = O < r.slidesPerGroupSkip - 1 ? 1 : r.slidesPerGroup;
            if (p > r.longSwipesMs)
            {
                if (!r.longSwipes) return void t.slideTo(t.activeIndex);
                "next" === t.swipeDirection && (z >= r.longSwipesRatio ? t.slideTo(O + I) : t.slideTo(O)), "prev" === t.swipeDirection && (z > 1 - r.longSwipesRatio ? t.slideTo(O + I) : t.slideTo(O))
            } else
            {
                if (!r.shortSwipes) return void t.slideTo(t.activeIndex);
                t.navigation && (c.target === t.navigation.nextEl || c.target === t.navigation.prevEl) ? c.target === t.navigation.nextEl ? t.slideTo(O + I) : t.slideTo(O) : ("next" === t.swipeDirection && t.slideTo(O + I), "prev" === t.swipeDirection && t.slideTo(O))
            }
        }
    }

    function Cg()
    {
        var e = this, t = e.params, n = e.el;
        if (!n || 0 !== n.offsetWidth)
        {
            t.breakpoints && e.setBreakpoint();
            var r = e.allowSlideNext, i = e.allowSlidePrev, o = e.snapGrid;
            e.allowSlideNext = !0, e.allowSlidePrev = !0, e.updateSize(), e.updateSlides(), e.updateSlidesClasses(), ("auto" === t.slidesPerView || t.slidesPerView > 1) && e.isEnd && !e.isBeginning && !e.params.centeredSlides ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0), e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.run(), e.allowSlidePrev = i, e.allowSlideNext = r, e.params.watchOverflow && o !== e.snapGrid && e.checkOverflow()
        }
    }

    function Eg(e)
    {
        var t = this;
        t.allowClick || (t.params.preventClicks && e.preventDefault(), t.params.preventClicksPropagation && t.animating && (e.stopPropagation(), e.stopImmediatePropagation()))
    }

    function Sg()
    {
        var e = this, t = e.wrapperEl, n = e.rtlTranslate;
        e.previousTranslate = e.translate, e.isHorizontal() ? e.translate = n ? t.scrollWidth - t.offsetWidth - t.scrollLeft : -t.scrollLeft : e.translate = -t.scrollTop, -0 === e.translate && (e.translate = 0), e.updateActiveIndex(), e.updateSlidesClasses();
        var r = e.maxTranslate() - e.minTranslate();
        (0 === r ? 0 : (e.translate - e.minTranslate()) / r) !== e.progress && e.updateProgress(n ? -e.translate : e.translate), e.emit("setTranslate", e.translate, !1)
    }

    var kg = !1;

    function Tg()
    {
    }

    var Og = {
        init: !0,
        direction: "horizontal",
        touchEventsTarget: "container",
        initialSlide: 0,
        speed: 300,
        cssMode: !1,
        updateOnWindowResize: !0,
        resizeObserver: !1,
        nested: !1,
        width: null,
        height: null,
        preventInteractionOnTransition: !1,
        userAgent: null,
        url: null,
        edgeSwipeDetection: !1,
        edgeSwipeThreshold: 20,
        freeMode: !1,
        freeModeMomentum: !0,
        freeModeMomentumRatio: 1,
        freeModeMomentumBounce: !0,
        freeModeMomentumBounceRatio: 1,
        freeModeMomentumVelocityRatio: 1,
        freeModeSticky: !1,
        freeModeMinimumVelocity: .02,
        autoHeight: !1,
        setWrapperSize: !1,
        virtualTranslate: !1,
        effect: "slide",
        breakpoints: void 0,
        breakpointsBase: "window",
        spaceBetween: 0,
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerColumnFill: "column",
        slidesPerGroup: 1,
        slidesPerGroupSkip: 0,
        centeredSlides: !1,
        centeredSlidesBounds: !1,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        normalizeSlideIndex: !0,
        centerInsufficientSlides: !1,
        watchOverflow: !1,
        roundLengths: !1,
        touchRatio: 1,
        touchAngle: 45,
        simulateTouch: !0,
        shortSwipes: !0,
        longSwipes: !0,
        longSwipesRatio: .5,
        longSwipesMs: 300,
        followFinger: !0,
        allowTouchMove: !0,
        threshold: 0,
        touchMoveStopPropagation: !1,
        touchStartPreventDefault: !0,
        touchStartForcePreventDefault: !1,
        touchReleaseOnEdges: !1,
        uniqueNavElements: !0,
        resistance: !0,
        resistanceRatio: .85,
        watchSlidesProgress: !1,
        watchSlidesVisibility: !1,
        grabCursor: !1,
        preventClicks: !0,
        preventClicksPropagation: !0,
        slideToClickedSlide: !1,
        preloadImages: !0,
        updateOnImagesReady: !0,
        loop: !1,
        loopAdditionalSlides: 0,
        loopedSlides: null,
        loopFillGroupWithBlank: !1,
        loopPreventsSlide: !0,
        allowSlidePrev: !0,
        allowSlideNext: !0,
        swipeHandler: null,
        noSwiping: !0,
        noSwipingClass: "pwzrswiper-no-swiping",
        noSwipingSelector: null,
        passiveListeners: !0,
        containerModifierClass: "pwzrswiper-container-",
        slideClass: "pwzrswiper-slide",
        slideBlankClass: "pwzrswiper-slide-invisible-blank",
        slideActiveClass: "pwzrswiper-slide-active",
        slideDuplicateActiveClass: "pwzrswiper-slide-duplicate-active",
        slideVisibleClass: "pwzrswiper-slide-visible",
        slideDuplicateClass: "pwzrswiper-slide-duplicate",
        slideNextClass: "pwzrswiper-slide-next",
        slideDuplicateNextClass: "pwzrswiper-slide-duplicate-next",
        slidePrevClass: "pwzrswiper-slide-prev",
        slideDuplicatePrevClass: "pwzrswiper-slide-duplicate-prev",
        wrapperClass: "pwzrswiper-wrapper",
        runCallbacksOnInit: !0,
        _emitClasses: !1
    };

    function Mg(e, t)
    {
        for (var n = 0; n < t.length; n++)
        {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r)
        }
    }

    var Rg = {
        modular: {
            useParams: function (e)
            {
                var t = this;
                t.modules && Object.keys(t.modules).forEach((function (n)
                {
                    var r = t.modules[n];
                    r.params && dg(e, r.params)
                }))
            }, useModules: function (e)
            {
                void 0 === e && (e = {});
                var t = this;
                t.modules && Object.keys(t.modules).forEach((function (n)
                {
                    var r = t.modules[n], i = e[n] || {};
                    r.on && t.on && Object.keys(r.on).forEach((function (e)
                    {
                        t.on(e, r.on[e])
                    })), r.create && r.create.bind(t)(i)
                }))
            }
        }, eventsEmitter: {
            on: function (e, t, n)
            {
                var r = this;
                if ("function" != typeof t) return r;
                var i = n ? "unshift" : "push";
                return e.split(" ").forEach((function (e)
                {
                    r.eventsListeners[e] || (r.eventsListeners[e] = []), r.eventsListeners[e][i](t)
                })), r
            }, once: function (e, t, n)
            {
                var r = this;
                if ("function" != typeof t) return r;

                function i()
                {
                    r.off(e, i), i.__emitterProxy && delete i.__emitterProxy;
                    for (var n = arguments.length, o = new Array(n), a = 0; a < n; a++) o[a] = arguments[a];
                    t.apply(r, o)
                }

                return i.__emitterProxy = t, r.on(e, i, n)
            }, onAny: function (e, t)
            {
                var n = this;
                if ("function" != typeof e) return n;
                var r = t ? "unshift" : "push";
                return n.eventsAnyListeners.indexOf(e) < 0 && n.eventsAnyListeners[r](e), n
            }, offAny: function (e)
            {
                var t = this;
                if (!t.eventsAnyListeners) return t;
                var n = t.eventsAnyListeners.indexOf(e);
                return n >= 0 && t.eventsAnyListeners.splice(n, 1), t
            }, off: function (e, t)
            {
                var n = this;
                return n.eventsListeners ? (e.split(" ").forEach((function (e)
                {
                    void 0 === t ? n.eventsListeners[e] = [] : n.eventsListeners[e] && n.eventsListeners[e].forEach((function (r, i)
                    {
                        (r === t || r.__emitterProxy && r.__emitterProxy === t) && n.eventsListeners[e].splice(i, 1)
                    }))
                })), n) : n
            }, emit: function ()
            {
                var e, t, n, r = this;
                if (!r.eventsListeners) return r;
                for (var i = arguments.length, o = new Array(i), a = 0; a < i; a++) o[a] = arguments[a];
                "string" == typeof o[0] || Array.isArray(o[0]) ? (e = o[0], t = o.slice(1, o.length), n = r) : (e = o[0].events, t = o[0].data, n = o[0].context || r), t.unshift(n);
                var s = Array.isArray(e) ? e : e.split(" ");
                return s.forEach((function (e)
                {
                    r.eventsAnyListeners && r.eventsAnyListeners.length && r.eventsAnyListeners.forEach((function (r)
                    {
                        r.apply(n, [e].concat(t))
                    })), r.eventsListeners && r.eventsListeners[e] && r.eventsListeners[e].forEach((function (e)
                    {
                        e.apply(n, t)
                    }))
                })), r
            }
        }, update: {
            updateSize: function ()
            {
                var e, t, n = this, r = n.$el;
                e = void 0 !== n.params.width && null !== n.params.width ? n.params.width : r[0].clientWidth, t = void 0 !== n.params.height && null !== n.params.height ? n.params.height : r[0].clientHeight, 0 === e && n.isHorizontal() || 0 === t && n.isVertical() || (e = e - parseInt(r.css("padding-left") || 0, 10) - parseInt(r.css("padding-right") || 0, 10), t = t - parseInt(r.css("padding-top") || 0, 10) - parseInt(r.css("padding-bottom") || 0, 10), Number.isNaN(e) && (e = 0), Number.isNaN(t) && (t = 0), dg(n, {
                    width: e,
                    height: t,
                    size: n.isHorizontal() ? e : t
                }))
            }, updateSlides: function ()
            {
                var e = this, t = function (t)
                    {
                        return e.isHorizontal() ? t : {
                            width: "height",
                            "margin-top": "margin-left",
                            "margin-bottom ": "margin-right",
                            "margin-left": "margin-top",
                            "margin-right": "margin-bottom",
                            "padding-left": "padding-top",
                            "padding-right": "padding-bottom",
                            marginRight: "marginBottom"
                        }[t]
                    }, n = function (e, n)
                    {
                        return parseFloat(e.getPropertyValue(t(n)) || 0)
                    }, r = qv(), i = e.params, o = e.$wrapperEl, a = e.size, s = e.rtlTranslate, l = e.wrongRTL,
                    c = e.virtual && i.virtual.enabled, u = c ? e.virtual.slides.length : e.slides.length,
                    d = o.children("." + e.params.slideClass), p = c ? e.virtual.slides.length : d.length, f = [],
                    h = [], m = [], v = i.slidesOffsetBefore;
                "function" == typeof v && (v = i.slidesOffsetBefore.call(e));
                var g = i.slidesOffsetAfter;
                "function" == typeof g && (g = i.slidesOffsetAfter.call(e));
                var y = e.snapGrid.length, b = e.slidesGrid.length, w = i.spaceBetween, x = -v, _ = 0, C = 0;
                if (void 0 !== a)
                {
                    var E, S;
                    "string" == typeof w && w.indexOf("%") >= 0 && (w = parseFloat(w.replace("%", "")) / 100 * a), e.virtualSize = -w, s ? d.css({
                        marginLeft: "",
                        marginTop: ""
                    }) : d.css({
                        marginRight: "",
                        marginBottom: ""
                    }), i.slidesPerColumn > 1 && (E = Math.floor(p / i.slidesPerColumn) === p / e.params.slidesPerColumn ? p : Math.ceil(p / i.slidesPerColumn) * i.slidesPerColumn, "auto" !== i.slidesPerView && "row" === i.slidesPerColumnFill && (E = Math.max(E, i.slidesPerView * i.slidesPerColumn)));
                    for (var k, T, O, M = i.slidesPerColumn, R = E / M, P = Math.floor(p / i.slidesPerColumn), z = 0; z < p; z += 1)
                    {
                        S = 0;
                        var I = d.eq(z);
                        if (i.slidesPerColumn > 1)
                        {
                            var A = void 0, L = void 0, D = void 0;
                            if ("row" === i.slidesPerColumnFill && i.slidesPerGroup > 1)
                            {
                                var N = Math.floor(z / (i.slidesPerGroup * i.slidesPerColumn)),
                                    F = z - i.slidesPerColumn * i.slidesPerGroup * N,
                                    B = 0 === N ? i.slidesPerGroup : Math.min(Math.ceil((p - N * M * i.slidesPerGroup) / M), i.slidesPerGroup);
                                A = (L = F - (D = Math.floor(F / B)) * B + N * i.slidesPerGroup) + D * E / M, I.css({
                                    "-webkit-box-ordinal-group": A,
                                    "-moz-box-ordinal-group": A,
                                    "-ms-flex-order": A,
                                    "-webkit-order": A,
                                    order: A
                                })
                            } else "column" === i.slidesPerColumnFill ? (D = z - (L = Math.floor(z / M)) * M, (L > P || L === P && D === M - 1) && (D += 1) >= M && (D = 0, L += 1)) : L = z - (D = Math.floor(z / R)) * R;
                            I.css(t("margin-top"), 0 !== D && i.spaceBetween && i.spaceBetween + "px")
                        }
                        if ("none" !== I.css("display"))
                        {
                            if ("auto" === i.slidesPerView)
                            {
                                var W = r.getComputedStyle(I[0], null), $ = I[0].style.transform,
                                    H = I[0].style.webkitTransform;
                                if ($ && (I[0].style.transform = "none"), H && (I[0].style.webkitTransform = "none"), i.roundLengths) S = e.isHorizontal() ? I.outerWidth(!0) : I.outerHeight(!0); else
                                {
                                    var j = n(W, "width"), V = n(W, "padding-left"), q = n(W, "padding-right"),
                                        U = n(W, "margin-left"), G = n(W, "margin-right"),
                                        Z = W.getPropertyValue(W, "box-sizing");
                                    if (Z && "border-box" === Z) S = j + U + G; else
                                    {
                                        var K = I[0], Y = K.clientWidth;
                                        S = j + V + q + U + G + (K.offsetWidth - Y)
                                    }
                                }
                                $ && (I[0].style.transform = $), H && (I[0].style.webkitTransform = H), i.roundLengths && (S = Math.floor(S))
                            } else S = (a - (i.slidesPerView - 1) * w) / i.slidesPerView, i.roundLengths && (S = Math.floor(S)), d[z] && (d[z].style[t("width")] = S + "px");
                            d[z] && (d[z].swiperSlideSize = S), m.push(S), i.centeredSlides ? (x = x + S / 2 + _ / 2 + w, 0 === _ && 0 !== z && (x = x - a / 2 - w), 0 === z && (x = x - a / 2 - w), Math.abs(x) < .001 && (x = 0), i.roundLengths && (x = Math.floor(x)), C % i.slidesPerGroup == 0 && f.push(x), h.push(x)) : (i.roundLengths && (x = Math.floor(x)), (C - Math.min(e.params.slidesPerGroupSkip, C)) % e.params.slidesPerGroup == 0 && f.push(x), h.push(x), x = x + S + w), e.virtualSize += S + w, _ = S, C += 1
                        }
                    }
                    if (e.virtualSize = Math.max(e.virtualSize, a) + g, s && l && ("slide" === i.effect || "coverflow" === i.effect) && o.css({width: e.virtualSize + i.spaceBetween + "px"}), i.setWrapperSize) o.css(((T = {})[t("width")] = e.virtualSize + i.spaceBetween + "px", T));
                    if (i.slidesPerColumn > 1) if (e.virtualSize = (S + i.spaceBetween) * E, e.virtualSize = Math.ceil(e.virtualSize / i.slidesPerColumn) - i.spaceBetween, o.css(((O = {})[t("width")] = e.virtualSize + i.spaceBetween + "px", O)), i.centeredSlides)
                    {
                        k = [];
                        for (var X = 0; X < f.length; X += 1)
                        {
                            var J = f[X];
                            i.roundLengths && (J = Math.floor(J)), f[X] < e.virtualSize + f[0] && k.push(J)
                        }
                        f = k
                    }
                    if (!i.centeredSlides)
                    {
                        k = [];
                        for (var Q = 0; Q < f.length; Q += 1)
                        {
                            var ee = f[Q];
                            i.roundLengths && (ee = Math.floor(ee)), f[Q] <= e.virtualSize - a && k.push(ee)
                        }
                        f = k, Math.floor(e.virtualSize - a) - Math.floor(f[f.length - 1]) > 1 && f.push(e.virtualSize - a)
                    }
                    if (0 === f.length && (f = [0]), 0 !== i.spaceBetween)
                    {
                        var te, ne = e.isHorizontal() && s ? "marginLeft" : t("marginRight");
                        d.filter((function (e, t)
                        {
                            return !i.cssMode || t !== d.length - 1
                        })).css(((te = {})[ne] = w + "px", te))
                    }
                    if (i.centeredSlides && i.centeredSlidesBounds)
                    {
                        var re = 0;
                        m.forEach((function (e)
                        {
                            re += e + (i.spaceBetween ? i.spaceBetween : 0)
                        }));
                        var ie = (re -= i.spaceBetween) - a;
                        f = f.map((function (e)
                        {
                            return e < 0 ? -v : e > ie ? ie + g : e
                        }))
                    }
                    if (i.centerInsufficientSlides)
                    {
                        var oe = 0;
                        if (m.forEach((function (e)
                        {
                            oe += e + (i.spaceBetween ? i.spaceBetween : 0)
                        })), (oe -= i.spaceBetween) < a)
                        {
                            var ae = (a - oe) / 2;
                            f.forEach((function (e, t)
                            {
                                f[t] = e - ae
                            })), h.forEach((function (e, t)
                            {
                                h[t] = e + ae
                            }))
                        }
                    }
                    dg(e, {
                        slides: d,
                        snapGrid: f,
                        slidesGrid: h,
                        slidesSizesGrid: m
                    }), p !== u && e.emit("slidesLengthChange"), f.length !== y && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")), h.length !== b && e.emit("slidesGridLengthChange"), (i.watchSlidesProgress || i.watchSlidesVisibility) && e.updateSlidesOffset()
                }
            }, updateAutoHeight: function (e)
            {
                var t, n = this, r = [], i = 0;
                if ("number" == typeof e ? n.setTransition(e) : !0 === e && n.setTransition(n.params.speed), "auto" !== n.params.slidesPerView && n.params.slidesPerView > 1) if (n.params.centeredSlides) n.visibleSlides.each((function (e)
                {
                    r.push(e)
                })); else for (t = 0; t < Math.ceil(n.params.slidesPerView); t += 1)
                {
                    var o = n.activeIndex + t;
                    if (o > n.slides.length) break;
                    r.push(n.slides.eq(o)[0])
                } else r.push(n.slides.eq(n.activeIndex)[0]);
                for (t = 0; t < r.length; t += 1) if (void 0 !== r[t])
                {
                    var a = r[t].offsetHeight;
                    i = a > i ? a : i
                }
                i && n.$wrapperEl.css("height", i + "px")
            }, updateSlidesOffset: function ()
            {
                for (var e = this.slides, t = 0; t < e.length; t += 1) e[t].swiperSlideOffset = this.isHorizontal() ? e[t].offsetLeft : e[t].offsetTop
            }, updateSlidesProgress: function (e)
            {
                void 0 === e && (e = this && this.translate || 0);
                var t = this, n = t.params, r = t.slides, i = t.rtlTranslate;
                if (0 !== r.length)
                {
                    void 0 === r[0].swiperSlideOffset && t.updateSlidesOffset();
                    var o = -e;
                    i && (o = e), r.removeClass(n.slideVisibleClass), t.visibleSlidesIndexes = [], t.visibleSlides = [];
                    for (var a = 0; a < r.length; a += 1)
                    {
                        var s = r[a],
                            l = (o + (n.centeredSlides ? t.minTranslate() : 0) - s.swiperSlideOffset) / (s.swiperSlideSize + n.spaceBetween);
                        if (n.watchSlidesVisibility || n.centeredSlides && n.autoHeight)
                        {
                            var c = -(o - s.swiperSlideOffset), u = c + t.slidesSizesGrid[a];
                            (c >= 0 && c < t.size - 1 || u > 1 && u <= t.size || c <= 0 && u >= t.size) && (t.visibleSlides.push(s), t.visibleSlidesIndexes.push(a), r.eq(a).addClass(n.slideVisibleClass))
                        }
                        s.progress = i ? -l : l
                    }
                    t.visibleSlides = sg(t.visibleSlides)
                }
            }, updateProgress: function (e)
            {
                var t = this;
                if (void 0 === e)
                {
                    var n = t.rtlTranslate ? -1 : 1;
                    e = t && t.translate && t.translate * n || 0
                }
                var r = t.params, i = t.maxTranslate() - t.minTranslate(), o = t.progress, a = t.isBeginning,
                    s = t.isEnd, l = a, c = s;
                0 === i ? (o = 0, a = !0, s = !0) : (a = (o = (e - t.minTranslate()) / i) <= 0, s = o >= 1), dg(t, {
                    progress: o,
                    isBeginning: a,
                    isEnd: s
                }), (r.watchSlidesProgress || r.watchSlidesVisibility || r.centeredSlides && r.autoHeight) && t.updateSlidesProgress(e), a && !l && t.emit("reachBeginning toEdge"), s && !c && t.emit("reachEnd toEdge"), (l && !a || c && !s) && t.emit("fromEdge"), t.emit("progress", o)
            }, updateSlidesClasses: function ()
            {
                var e, t = this, n = t.slides, r = t.params, i = t.$wrapperEl, o = t.activeIndex, a = t.realIndex,
                    s = t.virtual && r.virtual.enabled;
                n.removeClass(r.slideActiveClass + " " + r.slideNextClass + " " + r.slidePrevClass + " " + r.slideDuplicateActiveClass + " " + r.slideDuplicateNextClass + " " + r.slideDuplicatePrevClass), (e = s ? t.$wrapperEl.find("." + r.slideClass + '[data-pwzrswiper-slide-index="' + o + '"]') : n.eq(o)).addClass(r.slideActiveClass), r.loop && (e.hasClass(r.slideDuplicateClass) ? i.children("." + r.slideClass + ":not(." + r.slideDuplicateClass + ')[data-pwzrswiper-slide-index="' + a + '"]').addClass(r.slideDuplicateActiveClass) : i.children("." + r.slideClass + "." + r.slideDuplicateClass + '[data-pwzrswiper-slide-index="' + a + '"]').addClass(r.slideDuplicateActiveClass));
                var l = e.nextAll("." + r.slideClass).eq(0).addClass(r.slideNextClass);
                r.loop && 0 === l.length && (l = n.eq(0)).addClass(r.slideNextClass);
                var c = e.prevAll("." + r.slideClass).eq(0).addClass(r.slidePrevClass);
                r.loop && 0 === c.length && (c = n.eq(-1)).addClass(r.slidePrevClass), r.loop && (l.hasClass(r.slideDuplicateClass) ? i.children("." + r.slideClass + ":not(." + r.slideDuplicateClass + ')[data-pwzrswiper-slide-index="' + l.attr("data-pwzrswiper-slide-index") + '"]').addClass(r.slideDuplicateNextClass) : i.children("." + r.slideClass + "." + r.slideDuplicateClass + '[data-pwzrswiper-slide-index="' + l.attr("data-pwzrswiper-slide-index") + '"]').addClass(r.slideDuplicateNextClass), c.hasClass(r.slideDuplicateClass) ? i.children("." + r.slideClass + ":not(." + r.slideDuplicateClass + ')[data-pwzrswiper-slide-index="' + c.attr("data-pwzrswiper-slide-index") + '"]').addClass(r.slideDuplicatePrevClass) : i.children("." + r.slideClass + "." + r.slideDuplicateClass + '[data-pwzrswiper-slide-index="' + c.attr("data-pwzrswiper-slide-index") + '"]').addClass(r.slideDuplicatePrevClass)), t.emitSlidesClasses()
            }, updateActiveIndex: function (e)
            {
                var t, n = this, r = n.rtlTranslate ? n.translate : -n.translate, i = n.slidesGrid, o = n.snapGrid,
                    a = n.params, s = n.activeIndex, l = n.realIndex, c = n.snapIndex, u = e;
                if (void 0 === u)
                {
                    for (var d = 0; d < i.length; d += 1) void 0 !== i[d + 1] ? r >= i[d] && r < i[d + 1] - (i[d + 1] - i[d]) / 2 ? u = d : r >= i[d] && r < i[d + 1] && (u = d + 1) : r >= i[d] && (u = d);
                    a.normalizeSlideIndex && (u < 0 || void 0 === u) && (u = 0)
                }
                if (o.indexOf(r) >= 0) t = o.indexOf(r); else
                {
                    var p = Math.min(a.slidesPerGroupSkip, u);
                    t = p + Math.floor((u - p) / a.slidesPerGroup)
                }
                if (t >= o.length && (t = o.length - 1), u !== s)
                {
                    var f = parseInt(n.slides.eq(u).attr("data-pwzrswiper-slide-index") || u, 10);
                    dg(n, {
                        snapIndex: t,
                        realIndex: f,
                        previousIndex: s,
                        activeIndex: u
                    }), n.emit("activeIndexChange"), n.emit("snapIndexChange"), l !== f && n.emit("realIndexChange"), (n.initialized || n.params.runCallbacksOnInit) && n.emit("slideChange")
                } else t !== c && (n.snapIndex = t, n.emit("snapIndexChange"))
            }, updateClickedSlide: function (e)
            {
                var t, n = this, r = n.params, i = sg(e.target).closest("." + r.slideClass)[0], o = !1;
                if (i) for (var a = 0; a < n.slides.length; a += 1) if (n.slides[a] === i)
                {
                    o = !0, t = a;
                    break
                }
                if (!i || !o) return n.clickedSlide = void 0, void (n.clickedIndex = void 0);
                n.clickedSlide = i, n.virtual && n.params.virtual.enabled ? n.clickedIndex = parseInt(sg(i).attr("data-pwzrswiper-slide-index"), 10) : n.clickedIndex = t, r.slideToClickedSlide && void 0 !== n.clickedIndex && n.clickedIndex !== n.activeIndex && n.slideToClickedSlide()
            }
        }, translate: {
            getTranslate: function (e)
            {
                void 0 === e && (e = this.isHorizontal() ? "x" : "y");
                var t = this, n = t.params, r = t.rtlTranslate, i = t.translate, o = t.$wrapperEl;
                if (n.virtualTranslate) return r ? -i : i;
                if (n.cssMode) return i;
                var a = function (e, t)
                {
                    void 0 === t && (t = "x");
                    var n, r, i, o = qv(), a = o.getComputedStyle(e, null);
                    return o.WebKitCSSMatrix ? ((r = a.transform || a.webkitTransform).split(",").length > 6 && (r = r.split(", ").map((function (e)
                    {
                        return e.replace(",", ".")
                    })).join(", ")), i = new o.WebKitCSSMatrix("none" === r ? "" : r)) : n = (i = a.MozTransform || a.OTransform || a.MsTransform || a.msTransform || a.transform || a.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,")).toString().split(","), "x" === t && (r = o.WebKitCSSMatrix ? i.m41 : 16 === n.length ? parseFloat(n[12]) : parseFloat(n[4])), "y" === t && (r = o.WebKitCSSMatrix ? i.m42 : 16 === n.length ? parseFloat(n[13]) : parseFloat(n[5])), r || 0
                }(o[0], e);
                return r && (a = -a), a || 0
            }, setTranslate: function (e, t)
            {
                var n = this, r = n.rtlTranslate, i = n.params, o = n.$wrapperEl, a = n.wrapperEl, s = n.progress,
                    l = 0, c = 0;
                n.isHorizontal() ? l = r ? -e : e : c = e, i.roundLengths && (l = Math.floor(l), c = Math.floor(c)), i.cssMode ? a[n.isHorizontal() ? "scrollLeft" : "scrollTop"] = n.isHorizontal() ? -l : -c : i.virtualTranslate || o.transform("translate3d(" + l + "px, " + c + "px, 0px)"), n.previousTranslate = n.translate, n.translate = n.isHorizontal() ? l : c;
                var u = n.maxTranslate() - n.minTranslate();
                (0 === u ? 0 : (e - n.minTranslate()) / u) !== s && n.updateProgress(e), n.emit("setTranslate", n.translate, t)
            }, minTranslate: function ()
            {
                return -this.snapGrid[0]
            }, maxTranslate: function ()
            {
                return -this.snapGrid[this.snapGrid.length - 1]
            }, translateTo: function (e, t, n, r, i)
            {
                void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === n && (n = !0), void 0 === r && (r = !0);
                var o = this, a = o.params, s = o.wrapperEl;
                if (o.animating && a.preventInteractionOnTransition) return !1;
                var l, c = o.minTranslate(), u = o.maxTranslate();
                if (l = r && e > c ? c : r && e < u ? u : e, o.updateProgress(l), a.cssMode)
                {
                    var d, p = o.isHorizontal();
                    if (0 === t) s[p ? "scrollLeft" : "scrollTop"] = -l; else if (s.scrollTo) s.scrollTo(((d = {})[p ? "left" : "top"] = -l, d.behavior = "smooth", d)); else s[p ? "scrollLeft" : "scrollTop"] = -l;
                    return !0
                }
                return 0 === t ? (o.setTransition(0), o.setTranslate(l), n && (o.emit("beforeTransitionStart", t, i), o.emit("transitionEnd"))) : (o.setTransition(t), o.setTranslate(l), n && (o.emit("beforeTransitionStart", t, i), o.emit("transitionStart")), o.animating || (o.animating = !0, o.onTranslateToWrapperTransitionEnd || (o.onTranslateToWrapperTransitionEnd = function (e)
                {
                    o && !o.destroyed && e.target === this && (o.$wrapperEl[0].removeEventListener("transitionend", o.onTranslateToWrapperTransitionEnd), o.$wrapperEl[0].removeEventListener("webkitTransitionEnd", o.onTranslateToWrapperTransitionEnd), o.onTranslateToWrapperTransitionEnd = null, delete o.onTranslateToWrapperTransitionEnd, n && o.emit("transitionEnd"))
                }), o.$wrapperEl[0].addEventListener("transitionend", o.onTranslateToWrapperTransitionEnd), o.$wrapperEl[0].addEventListener("webkitTransitionEnd", o.onTranslateToWrapperTransitionEnd))), !0
            }
        }, transition: {
            setTransition: function (e, t)
            {
                var n = this;
                n.params.cssMode || n.$wrapperEl.transition(e), n.emit("setTransition", e, t)
            }, transitionStart: function (e, t)
            {
                void 0 === e && (e = !0);
                var n = this, r = n.activeIndex, i = n.params, o = n.previousIndex;
                if (!i.cssMode)
                {
                    i.autoHeight && n.updateAutoHeight();
                    var a = t;
                    if (a || (a = r > o ? "next" : r < o ? "prev" : "reset"), n.emit("transitionStart"), e && r !== o)
                    {
                        if ("reset" === a) return void n.emit("slideResetTransitionStart");
                        n.emit("slideChangeTransitionStart"), "next" === a ? n.emit("slideNextTransitionStart") : n.emit("slidePrevTransitionStart")
                    }
                }
            }, transitionEnd: function (e, t)
            {
                void 0 === e && (e = !0);
                var n = this, r = n.activeIndex, i = n.previousIndex, o = n.params;
                if (n.animating = !1, !o.cssMode)
                {
                    n.setTransition(0);
                    var a = t;
                    if (a || (a = r > i ? "next" : r < i ? "prev" : "reset"), n.emit("transitionEnd"), e && r !== i)
                    {
                        if ("reset" === a) return void n.emit("slideResetTransitionEnd");
                        n.emit("slideChangeTransitionEnd"), "next" === a ? n.emit("slideNextTransitionEnd") : n.emit("slidePrevTransitionEnd")
                    }
                }
            }
        }, slide: {
            slideTo: function (e, t, n, r)
            {
                if (void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === n && (n = !0), "number" != typeof e && "string" != typeof e) throw new Error("The 'index' argument cannot have type other than 'number' or 'string'. [" + typeof e + "] given.");
                if ("string" == typeof e)
                {
                    var i = parseInt(e, 10);
                    if (!isFinite(i)) throw new Error("The passed-in 'index' (string) couldn't be converted to 'number'. [" + e + "] given.");
                    e = i
                }
                var o = this, a = e;
                a < 0 && (a = 0);
                var s = o.params, l = o.snapGrid, c = o.slidesGrid, u = o.previousIndex, d = o.activeIndex,
                    p = o.rtlTranslate, f = o.wrapperEl;
                if (o.animating && s.preventInteractionOnTransition) return !1;
                var h = Math.min(o.params.slidesPerGroupSkip, a), m = h + Math.floor((a - h) / o.params.slidesPerGroup);
                m >= l.length && (m = l.length - 1), (d || s.initialSlide || 0) === (u || 0) && n && o.emit("beforeSlideChangeStart");
                var v, g = -l[m];
                if (o.updateProgress(g), s.normalizeSlideIndex) for (var y = 0; y < c.length; y += 1)
                {
                    var b = -Math.floor(100 * g), w = Math.floor(100 * c[y]), x = Math.floor(100 * c[y + 1]);
                    void 0 !== c[y + 1] ? b >= w && b < x - (x - w) / 2 ? a = y : b >= w && b < x && (a = y + 1) : b >= w && (a = y)
                }
                if (o.initialized && a !== d)
                {
                    if (!o.allowSlideNext && g < o.translate && g < o.minTranslate()) return !1;
                    if (!o.allowSlidePrev && g > o.translate && g > o.maxTranslate() && (d || 0) !== a) return !1
                }
                if (v = a > d ? "next" : a < d ? "prev" : "reset", p && -g === o.translate || !p && g === o.translate) return o.updateActiveIndex(a), s.autoHeight && o.updateAutoHeight(), o.updateSlidesClasses(), "slide" !== s.effect && o.setTranslate(g), "reset" !== v && (o.transitionStart(n, v), o.transitionEnd(n, v)), !1;
                if (s.cssMode)
                {
                    var _, C = o.isHorizontal(), E = -g;
                    if (p && (E = f.scrollWidth - f.offsetWidth - E), 0 === t) f[C ? "scrollLeft" : "scrollTop"] = E; else if (f.scrollTo) f.scrollTo(((_ = {})[C ? "left" : "top"] = E, _.behavior = "smooth", _)); else f[C ? "scrollLeft" : "scrollTop"] = E;
                    return !0
                }
                return 0 === t ? (o.setTransition(0), o.setTranslate(g), o.updateActiveIndex(a), o.updateSlidesClasses(), o.emit("beforeTransitionStart", t, r), o.transitionStart(n, v), o.transitionEnd(n, v)) : (o.setTransition(t), o.setTranslate(g), o.updateActiveIndex(a), o.updateSlidesClasses(), o.emit("beforeTransitionStart", t, r), o.transitionStart(n, v), o.animating || (o.animating = !0, o.onSlideToWrapperTransitionEnd || (o.onSlideToWrapperTransitionEnd = function (e)
                {
                    o && !o.destroyed && e.target === this && (o.$wrapperEl[0].removeEventListener("transitionend", o.onSlideToWrapperTransitionEnd), o.$wrapperEl[0].removeEventListener("webkitTransitionEnd", o.onSlideToWrapperTransitionEnd), o.onSlideToWrapperTransitionEnd = null, delete o.onSlideToWrapperTransitionEnd, o.transitionEnd(n, v))
                }), o.$wrapperEl[0].addEventListener("transitionend", o.onSlideToWrapperTransitionEnd), o.$wrapperEl[0].addEventListener("webkitTransitionEnd", o.onSlideToWrapperTransitionEnd))), !0
            }, slideToLoop: function (e, t, n, r)
            {
                void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === n && (n = !0);
                var i = this, o = e;
                return i.params.loop && (o += i.loopedSlides), i.slideTo(o, t, n, r)
            }, slideNext: function (e, t, n)
            {
                void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
                var r = this, i = r.params, o = r.animating,
                    a = r.activeIndex < i.slidesPerGroupSkip ? 1 : i.slidesPerGroup;
                if (i.loop)
                {
                    if (o && i.loopPreventsSlide) return !1;
                    r.loopFix(), r._clientLeft = r.$wrapperEl[0].clientLeft
                }
                return r.slideTo(r.activeIndex + a, e, t, n)
            }, slidePrev: function (e, t, n)
            {
                void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
                var r = this, i = r.params, o = r.animating, a = r.snapGrid, s = r.slidesGrid, l = r.rtlTranslate;
                if (i.loop)
                {
                    if (o && i.loopPreventsSlide) return !1;
                    r.loopFix(), r._clientLeft = r.$wrapperEl[0].clientLeft
                }

                function c(e)
                {
                    return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e)
                }

                var u, d = c(l ? r.translate : -r.translate), p = a.map((function (e)
                {
                    return c(e)
                })), f = (a[p.indexOf(d)], a[p.indexOf(d) - 1]);
                return void 0 === f && i.cssMode && a.forEach((function (e)
                {
                    !f && d >= e && (f = e)
                })), void 0 !== f && (u = s.indexOf(f)) < 0 && (u = r.activeIndex - 1), r.slideTo(u, e, t, n)
            }, slideReset: function (e, t, n)
            {
                return void 0 === e && (e = this.params.speed), void 0 === t && (t = !0), this.slideTo(this.activeIndex, e, t, n)
            }, slideToClosest: function (e, t, n, r)
            {
                void 0 === e && (e = this.params.speed), void 0 === t && (t = !0), void 0 === r && (r = .5);
                var i = this, o = i.activeIndex, a = Math.min(i.params.slidesPerGroupSkip, o),
                    s = a + Math.floor((o - a) / i.params.slidesPerGroup),
                    l = i.rtlTranslate ? i.translate : -i.translate;
                if (l >= i.snapGrid[s])
                {
                    var c = i.snapGrid[s];
                    l - c > (i.snapGrid[s + 1] - c) * r && (o += i.params.slidesPerGroup)
                } else
                {
                    var u = i.snapGrid[s - 1];
                    l - u <= (i.snapGrid[s] - u) * r && (o -= i.params.slidesPerGroup)
                }
                return o = Math.max(o, 0), o = Math.min(o, i.slidesGrid.length - 1), i.slideTo(o, e, t, n)
            }, slideToClickedSlide: function ()
            {
                var e, t = this, n = t.params, r = t.$wrapperEl,
                    i = "auto" === n.slidesPerView ? t.slidesPerViewDynamic() : n.slidesPerView, o = t.clickedIndex;
                if (n.loop)
                {
                    if (t.animating) return;
                    e = parseInt(sg(t.clickedSlide).attr("data-pwzrswiper-slide-index"), 10), n.centeredSlides ? o < t.loopedSlides - i / 2 || o > t.slides.length - t.loopedSlides + i / 2 ? (t.loopFix(), o = r.children("." + n.slideClass + '[data-pwzrswiper-slide-index="' + e + '"]:not(.' + n.slideDuplicateClass + ")").eq(0).index(), lg((function ()
                    {
                        t.slideTo(o)
                    }))) : t.slideTo(o) : o > t.slides.length - i ? (t.loopFix(), o = r.children("." + n.slideClass + '[data-pwzrswiper-slide-index="' + e + '"]:not(.' + n.slideDuplicateClass + ")").eq(0).index(), lg((function ()
                    {
                        t.slideTo(o)
                    }))) : t.slideTo(o)
                } else t.slideTo(o)
            }
        }, loop: {
            loopCreate: function ()
            {
                var e = this, t = jv(), n = e.params, r = e.$wrapperEl;
                r.children("." + n.slideClass + "." + n.slideDuplicateClass).remove();
                var i = r.children("." + n.slideClass);
                if (n.loopFillGroupWithBlank)
                {
                    var o = n.slidesPerGroup - i.length % n.slidesPerGroup;
                    if (o !== n.slidesPerGroup)
                    {
                        for (var a = 0; a < o; a += 1)
                        {
                            var s = sg(t.createElement("div")).addClass(n.slideClass + " " + n.slideBlankClass);
                            r.append(s)
                        }
                        i = r.children("." + n.slideClass)
                    }
                }
                "auto" !== n.slidesPerView || n.loopedSlides || (n.loopedSlides = i.length), e.loopedSlides = Math.ceil(parseFloat(n.loopedSlides || n.slidesPerView, 10)), e.loopedSlides += n.loopAdditionalSlides, e.loopedSlides > i.length && (e.loopedSlides = i.length);
                var l = [], c = [];
                i.each((function (t, n)
                {
                    var r = sg(t);
                    n < e.loopedSlides && c.push(t), n < i.length && n >= i.length - e.loopedSlides && l.push(t), r.attr("data-pwzrswiper-slide-index", n)
                }));
                for (var u = 0; u < c.length; u += 1) r.append(sg(c[u].cloneNode(!0)).addClass(n.slideDuplicateClass));
                for (var d = l.length - 1; d >= 0; d -= 1) r.prepend(sg(l[d].cloneNode(!0)).addClass(n.slideDuplicateClass))
            }, loopFix: function ()
            {
                var e = this;
                e.emit("beforeLoopFix");
                var t, n = e.activeIndex, r = e.slides, i = e.loopedSlides, o = e.allowSlidePrev, a = e.allowSlideNext,
                    s = e.snapGrid, l = e.rtlTranslate;
                e.allowSlidePrev = !0, e.allowSlideNext = !0;
                var c = -s[n] - e.getTranslate();
                if (n < i) t = r.length - 3 * i + n, t += i, e.slideTo(t, 0, !1, !0) && 0 !== c && e.setTranslate((l ? -e.translate : e.translate) - c); else if (n >= r.length - i)
                {
                    t = -r.length + n + i, t += i, e.slideTo(t, 0, !1, !0) && 0 !== c && e.setTranslate((l ? -e.translate : e.translate) - c)
                }
                e.allowSlidePrev = o, e.allowSlideNext = a, e.emit("loopFix")
            }, loopDestroy: function ()
            {
                var e = this, t = e.$wrapperEl, n = e.params, r = e.slides;
                t.children("." + n.slideClass + "." + n.slideDuplicateClass + ",." + n.slideClass + "." + n.slideBlankClass).remove(), r.removeAttr("data-pwzrswiper-slide-index")
            }
        }, grabCursor: {
            setGrabCursor: function (e)
            {
                var t = this;
                if (!(t.support.touch || !t.params.simulateTouch || t.params.watchOverflow && t.isLocked || t.params.cssMode))
                {
                    var n = t.el;
                    n.style.cursor = "move", n.style.cursor = e ? "-webkit-grabbing" : "-webkit-grab", n.style.cursor = e ? "-moz-grabbin" : "-moz-grab", n.style.cursor = e ? "grabbing" : "grab"
                }
            }, unsetGrabCursor: function ()
            {
                var e = this;
                e.support.touch || e.params.watchOverflow && e.isLocked || e.params.cssMode || (e.el.style.cursor = "")
            }
        }, manipulation: {
            appendSlide: function (e)
            {
                var t = this, n = t.$wrapperEl, r = t.params;
                if (r.loop && t.loopDestroy(), "object" == typeof e && "length" in e) for (var i = 0; i < e.length; i += 1) e[i] && n.append(e[i]); else n.append(e);
                r.loop && t.loopCreate(), r.observer && t.support.observer || t.update()
            }, prependSlide: function (e)
            {
                var t = this, n = t.params, r = t.$wrapperEl, i = t.activeIndex;
                n.loop && t.loopDestroy();
                var o = i + 1;
                if ("object" == typeof e && "length" in e)
                {
                    for (var a = 0; a < e.length; a += 1) e[a] && r.prepend(e[a]);
                    o = i + e.length
                } else r.prepend(e);
                n.loop && t.loopCreate(), n.observer && t.support.observer || t.update(), t.slideTo(o, 0, !1)
            }, addSlide: function (e, t)
            {
                var n = this, r = n.$wrapperEl, i = n.params, o = n.activeIndex;
                i.loop && (o -= n.loopedSlides, n.loopDestroy(), n.slides = r.children("." + i.slideClass));
                var a = n.slides.length;
                if (e <= 0) n.prependSlide(t); else if (e >= a) n.appendSlide(t); else
                {
                    for (var s = o > e ? o + 1 : o, l = [], c = a - 1; c >= e; c -= 1)
                    {
                        var u = n.slides.eq(c);
                        u.remove(), l.unshift(u)
                    }
                    if ("object" == typeof t && "length" in t)
                    {
                        for (var d = 0; d < t.length; d += 1) t[d] && r.append(t[d]);
                        s = o > e ? o + t.length : o
                    } else r.append(t);
                    for (var p = 0; p < l.length; p += 1) r.append(l[p]);
                    i.loop && n.loopCreate(), i.observer && n.support.observer || n.update(), i.loop ? n.slideTo(s + n.loopedSlides, 0, !1) : n.slideTo(s, 0, !1)
                }
            }, removeSlide: function (e)
            {
                var t = this, n = t.params, r = t.$wrapperEl, i = t.activeIndex;
                n.loop && (i -= t.loopedSlides, t.loopDestroy(), t.slides = r.children("." + n.slideClass));
                var o, a = i;
                if ("object" == typeof e && "length" in e)
                {
                    for (var s = 0; s < e.length; s += 1) o = e[s], t.slides[o] && t.slides.eq(o).remove(), o < a && (a -= 1);
                    a = Math.max(a, 0)
                } else o = e, t.slides[o] && t.slides.eq(o).remove(), o < a && (a -= 1), a = Math.max(a, 0);
                n.loop && t.loopCreate(), n.observer && t.support.observer || t.update(), n.loop ? t.slideTo(a + t.loopedSlides, 0, !1) : t.slideTo(a, 0, !1)
            }, removeAllSlides: function ()
            {
                for (var e = [], t = 0; t < this.slides.length; t += 1) e.push(t);
                this.removeSlide(e)
            }
        }, events: {
            attachEvents: function ()
            {
                var e = this, t = jv(), n = e.params, r = e.touchEvents, i = e.el, o = e.wrapperEl, a = e.device,
                    s = e.support;
                e.onTouchStart = wg.bind(e), e.onTouchMove = xg.bind(e), e.onTouchEnd = _g.bind(e), n.cssMode && (e.onScroll = Sg.bind(e)), e.onClick = Eg.bind(e);
                var l = !!n.nested;
                if (!s.touch && s.pointerEvents) i.addEventListener(r.start, e.onTouchStart, !1), t.addEventListener(r.move, e.onTouchMove, l), t.addEventListener(r.end, e.onTouchEnd, !1); else
                {
                    if (s.touch)
                    {
                        var c = !("touchstart" !== r.start || !s.passiveListener || !n.passiveListeners) && {
                            passive: !0,
                            capture: !1
                        };
                        i.addEventListener(r.start, e.onTouchStart, c), i.addEventListener(r.move, e.onTouchMove, s.passiveListener ? {
                            passive: !1,
                            capture: l
                        } : l), i.addEventListener(r.end, e.onTouchEnd, c), r.cancel && i.addEventListener(r.cancel, e.onTouchEnd, c), kg || (t.addEventListener("touchstart", Tg), kg = !0)
                    }
                    (n.simulateTouch && !a.ios && !a.android || n.simulateTouch && !s.touch && a.ios) && (i.addEventListener("mousedown", e.onTouchStart, !1), t.addEventListener("mousemove", e.onTouchMove, l), t.addEventListener("mouseup", e.onTouchEnd, !1))
                }
                (n.preventClicks || n.preventClicksPropagation) && i.addEventListener("click", e.onClick, !0), n.cssMode && o.addEventListener("scroll", e.onScroll), n.updateOnWindowResize ? e.on(a.ios || a.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", Cg, !0) : e.on("observerUpdate", Cg, !0)
            }, detachEvents: function ()
            {
                var e = this, t = jv(), n = e.params, r = e.touchEvents, i = e.el, o = e.wrapperEl, a = e.device,
                    s = e.support, l = !!n.nested;
                if (!s.touch && s.pointerEvents) i.removeEventListener(r.start, e.onTouchStart, !1), t.removeEventListener(r.move, e.onTouchMove, l), t.removeEventListener(r.end, e.onTouchEnd, !1); else
                {
                    if (s.touch)
                    {
                        var c = !("onTouchStart" !== r.start || !s.passiveListener || !n.passiveListeners) && {
                            passive: !0,
                            capture: !1
                        };
                        i.removeEventListener(r.start, e.onTouchStart, c), i.removeEventListener(r.move, e.onTouchMove, l), i.removeEventListener(r.end, e.onTouchEnd, c), r.cancel && i.removeEventListener(r.cancel, e.onTouchEnd, c)
                    }
                    (n.simulateTouch && !a.ios && !a.android || n.simulateTouch && !s.touch && a.ios) && (i.removeEventListener("mousedown", e.onTouchStart, !1), t.removeEventListener("mousemove", e.onTouchMove, l), t.removeEventListener("mouseup", e.onTouchEnd, !1))
                }
                (n.preventClicks || n.preventClicksPropagation) && i.removeEventListener("click", e.onClick, !0), n.cssMode && o.removeEventListener("scroll", e.onScroll), e.off(a.ios || a.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", Cg)
            }
        }, breakpoints: {
            setBreakpoint: function ()
            {
                var e = this, t = e.activeIndex, n = e.initialized, r = e.loopedSlides, i = void 0 === r ? 0 : r,
                    o = e.params, a = e.$el, s = o.breakpoints;
                if (s && (!s || 0 !== Object.keys(s).length))
                {
                    var l = e.getBreakpoint(s, e.params.breakpointsBase, e.el);
                    if (l && e.currentBreakpoint !== l)
                    {
                        var c = l in s ? s[l] : void 0;
                        c && ["slidesPerView", "spaceBetween", "slidesPerGroup", "slidesPerGroupSkip", "slidesPerColumn"].forEach((function (e)
                        {
                            var t = c[e];
                            void 0 !== t && (c[e] = "slidesPerView" !== e || "AUTO" !== t && "auto" !== t ? "slidesPerView" === e ? parseFloat(t) : parseInt(t, 10) : "auto")
                        }));
                        var u = c || e.originalParams, d = o.slidesPerColumn > 1, p = u.slidesPerColumn > 1;
                        d && !p ? (a.removeClass(o.containerModifierClass + "multirow " + o.containerModifierClass + "multirow-column"), e.emitContainerClasses()) : !d && p && (a.addClass(o.containerModifierClass + "multirow"), "column" === u.slidesPerColumnFill && a.addClass(o.containerModifierClass + "multirow-column"), e.emitContainerClasses());
                        var f = u.direction && u.direction !== o.direction,
                            h = o.loop && (u.slidesPerView !== o.slidesPerView || f);
                        f && n && e.changeDirection(), dg(e.params, u), dg(e, {
                            allowTouchMove: e.params.allowTouchMove,
                            allowSlideNext: e.params.allowSlideNext,
                            allowSlidePrev: e.params.allowSlidePrev
                        }), e.currentBreakpoint = l, e.emit("_beforeBreakpoint", u), h && n && (e.loopDestroy(), e.loopCreate(), e.updateSlides(), e.slideTo(t - i + e.loopedSlides, 0, !1)), e.emit("breakpoint", u)
                    }
                }
            }, getBreakpoint: function (e, t, n)
            {
                if (void 0 === t && (t = "window"), e && ("container" !== t || n))
                {
                    var r = !1, i = qv(), o = "window" === t ? i.innerWidth : n.clientWidth,
                        a = "window" === t ? i.innerHeight : n.clientHeight, s = Object.keys(e).map((function (e)
                        {
                            if ("string" == typeof e && 0 === e.indexOf("@"))
                            {
                                var t = parseFloat(e.substr(1));
                                return {value: a * t, point: e}
                            }
                            return {value: e, point: e}
                        }));
                    s.sort((function (e, t)
                    {
                        return parseInt(e.value, 10) - parseInt(t.value, 10)
                    }));
                    for (var l = 0; l < s.length; l += 1)
                    {
                        var c = s[l], u = c.point;
                        c.value <= o && (r = u)
                    }
                    return r || "max"
                }
            }
        }, checkOverflow: {
            checkOverflow: function ()
            {
                var e = this, t = e.params, n = e.isLocked,
                    r = e.slides.length > 0 && t.slidesOffsetBefore + t.spaceBetween * (e.slides.length - 1) + e.slides[0].offsetWidth * e.slides.length;
                t.slidesOffsetBefore && t.slidesOffsetAfter && r ? e.isLocked = r <= e.size : e.isLocked = 1 === e.snapGrid.length, e.allowSlideNext = !e.isLocked, e.allowSlidePrev = !e.isLocked, n !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock"), n && n !== e.isLocked && (e.isEnd = !1, e.navigation && e.navigation.update())
            }
        }, classes: {
            addClasses: function ()
            {
                var e, t, n, r = this, i = r.classNames, o = r.params, a = r.rtl, s = r.$el, l = r.device,
                    c = r.support,
                    u = (e = ["initialized", o.direction, {"pointer-events": c.pointerEvents && !c.touch}, {"free-mode": o.freeMode}, {autoheight: o.autoHeight}, {rtl: a}, {multirow: o.slidesPerColumn > 1}, {"multirow-column": o.slidesPerColumn > 1 && "column" === o.slidesPerColumnFill}, {android: l.android}, {ios: l.ios}, {"css-mode": o.cssMode}], t = o.containerModifierClass, n = [], e.forEach((function (e)
                    {
                        "object" == typeof e ? Object.entries(e).forEach((function (e)
                        {
                            var r = e[0];
                            e[1] && n.push(t + r)
                        })) : "string" == typeof e && n.push(t + e)
                    })), n);
                i.push.apply(i, u), s.addClass([].concat(i).join(" ")), r.emitContainerClasses()
            }, removeClasses: function ()
            {
                var e = this, t = e.$el, n = e.classNames;
                t.removeClass(n.join(" ")), e.emitContainerClasses()
            }
        }, images: {
            loadImage: function (e, t, n, r, i, o)
            {
                var a, s = qv();

                function l()
                {
                    o && o()
                }

                sg(e).parent("picture")[0] || e.complete && i ? l() : t ? ((a = new s.Image).onload = l, a.onerror = l, r && (a.sizes = r), n && (a.srcset = n), t && (a.src = t)) : l()
            }, preloadImages: function ()
            {
                var e = this;

                function t()
                {
                    null != e && e && !e.destroyed && (void 0 !== e.imagesLoaded && (e.imagesLoaded += 1), e.imagesLoaded === e.imagesToLoad.length && (e.params.updateOnImagesReady && e.update(), e.emit("imagesReady")))
                }

                e.imagesToLoad = e.$el.find("img");
                for (var n = 0; n < e.imagesToLoad.length; n += 1)
                {
                    var r = e.imagesToLoad[n];
                    e.loadImage(r, r.currentSrc || r.getAttribute("src"), r.srcset || r.getAttribute("srcset"), r.sizes || r.getAttribute("sizes"), !0, t)
                }
            }
        }
    }, Pg = {}, zg = function ()
    {
        function e()
        {
            for (var t, n, r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
            if (1 === i.length && i[0].constructor && i[0].constructor === Object ? n = i[0] : (t = i[0], n = i[1]), n || (n = {}), n = dg({}, n), t && !n.el && (n.el = t), n.el && sg(n.el).length > 1)
            {
                var a = [];
                return sg(n.el).each((function (t)
                {
                    var r = dg({}, n, {el: t});
                    a.push(new e(r))
                })), a
            }
            var s = this;
            s.support = fg(), s.device = hg({userAgent: n.userAgent}), s.browser = mg(), s.eventsListeners = {}, s.eventsAnyListeners = [], void 0 === s.modules && (s.modules = {}), Object.keys(s.modules).forEach((function (e)
            {
                var t = s.modules[e];
                if (t.params)
                {
                    var r = Object.keys(t.params)[0], i = t.params[r];
                    if ("object" != typeof i || null === i) return;
                    if (!(r in n) || !("enabled" in i)) return;
                    !0 === n[r] && (n[r] = {enabled: !0}), "object" != typeof n[r] || "enabled" in n[r] || (n[r].enabled = !0), n[r] || (n[r] = {enabled: !1})
                }
            }));
            var l, c, u = dg({}, Og);
            return s.useParams(u), s.params = dg({}, u, Pg, n), s.originalParams = dg({}, s.params), s.passedParams = dg({}, n), s.params && s.params.on && Object.keys(s.params.on).forEach((function (e)
            {
                s.on(e, s.params.on[e])
            })), s.params && s.params.onAny && s.onAny(s.params.onAny), s.$ = sg, dg(s, {
                el: t,
                classNames: [],
                slides: sg(),
                slidesGrid: [],
                snapGrid: [],
                slidesSizesGrid: [],
                isHorizontal: function ()
                {
                    return "horizontal" === s.params.direction
                },
                isVertical: function ()
                {
                    return "vertical" === s.params.direction
                },
                activeIndex: 0,
                realIndex: 0,
                isBeginning: !0,
                isEnd: !1,
                translate: 0,
                previousTranslate: 0,
                progress: 0,
                velocity: 0,
                animating: !1,
                allowSlideNext: s.params.allowSlideNext,
                allowSlidePrev: s.params.allowSlidePrev,
                touchEvents: (l = ["touchstart", "touchmove", "touchend", "touchcancel"], c = ["mousedown", "mousemove", "mouseup"], s.support.pointerEvents && (c = ["pointerdown", "pointermove", "pointerup"]), s.touchEventsTouch = {
                    start: l[0],
                    move: l[1],
                    end: l[2],
                    cancel: l[3]
                }, s.touchEventsDesktop = {
                    start: c[0],
                    move: c[1],
                    end: c[2]
                }, s.support.touch || !s.params.simulateTouch ? s.touchEventsTouch : s.touchEventsDesktop),
                touchEventsData: {
                    isTouched: void 0,
                    isMoved: void 0,
                    allowTouchCallbacks: void 0,
                    touchStartTime: void 0,
                    isScrolling: void 0,
                    currentTranslate: void 0,
                    startTranslate: void 0,
                    allowThresholdMove: void 0,
                    formElements: "input, select, option, textarea, button, video, label",
                    lastClickTime: cg(),
                    clickTimeout: void 0,
                    velocities: [],
                    allowMomentumBounce: void 0,
                    isTouchEvent: void 0,
                    startMoving: void 0
                },
                allowClick: !0,
                allowTouchMove: s.params.allowTouchMove,
                touches: {startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0},
                imagesToLoad: [],
                imagesLoaded: 0
            }), s.useModules(), s.emit("_swiper"), s.params.init && s.init(), s
        }

        var t, n, r, i = e.prototype;
        return i.emitContainerClasses = function ()
        {
            var e = this;
            if (e.params._emitClasses && e.el)
            {
                var t = e.el.className.split(" ").filter((function (t)
                {
                    return 0 === t.indexOf("pwzrswiper-container") || 0 === t.indexOf(e.params.containerModifierClass)
                }));
                e.emit("_containerClasses", t.join(" "))
            }
        }, i.getSlideClasses = function (e)
        {
            var t = this;
            return e.className.split(" ").filter((function (e)
            {
                return 0 === e.indexOf("pwzrswiper-slide") || 0 === e.indexOf(t.params.slideClass)
            })).join(" ")
        }, i.emitSlidesClasses = function ()
        {
            var e = this;
            if (e.params._emitClasses && e.el)
            {
                var t = [];
                e.slides.each((function (n)
                {
                    var r = e.getSlideClasses(n);
                    t.push({slideEl: n, classNames: r}), e.emit("_slideClass", n, r)
                })), e.emit("_slideClasses", t)
            }
        }, i.slidesPerViewDynamic = function ()
        {
            var e = this, t = e.params, n = e.slides, r = e.slidesGrid, i = e.size, o = e.activeIndex, a = 1;
            if (t.centeredSlides)
            {
                for (var s, l = n[o].swiperSlideSize, c = o + 1; c < n.length; c += 1) n[c] && !s && (a += 1, (l += n[c].swiperSlideSize) > i && (s = !0));
                for (var u = o - 1; u >= 0; u -= 1) n[u] && !s && (a += 1, (l += n[u].swiperSlideSize) > i && (s = !0))
            } else for (var d = o + 1; d < n.length; d += 1) r[d] - r[o] < i && (a += 1);
            return a
        }, i.update = function ()
        {
            var e = this;
            if (e && !e.destroyed)
            {
                var t = e.snapGrid, n = e.params;
                n.breakpoints && e.setBreakpoint(), e.updateSize(), e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), e.params.freeMode ? (r(), e.params.autoHeight && e.updateAutoHeight()) : (("auto" === e.params.slidesPerView || e.params.slidesPerView > 1) && e.isEnd && !e.params.centeredSlides ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0)) || r(), n.watchOverflow && t !== e.snapGrid && e.checkOverflow(), e.emit("update")
            }

            function r()
            {
                var t = e.rtlTranslate ? -1 * e.translate : e.translate,
                    n = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
                e.setTranslate(n), e.updateActiveIndex(), e.updateSlidesClasses()
            }
        }, i.changeDirection = function (e, t)
        {
            void 0 === t && (t = !0);
            var n = this, r = n.params.direction;
            return e || (e = "horizontal" === r ? "vertical" : "horizontal"), e === r || "horizontal" !== e && "vertical" !== e || (n.$el.removeClass("" + n.params.containerModifierClass + r).addClass("" + n.params.containerModifierClass + e), n.emitContainerClasses(), n.params.direction = e, n.slides.each((function (t)
            {
                "vertical" === e ? t.style.width = "" : t.style.height = ""
            })), n.emit("changeDirection"), t && n.update()), n
        }, i.mount = function (e)
        {
            var t = this;
            if (t.mounted) return !0;
            var n, r = sg(e || t.params.el);
            return !!(e = r[0]) && (e.swiper = t, e && e.shadowRoot && e.shadowRoot.querySelector ? (n = sg(e.shadowRoot.querySelector("." + t.params.wrapperClass))).children = function (e)
            {
                return r.children(e)
            } : n = r.children("." + t.params.wrapperClass), dg(t, {
                $el: r,
                el: e,
                $wrapperEl: n,
                wrapperEl: n[0],
                mounted: !0,
                rtl: "rtl" === e.dir.toLowerCase() || "rtl" === r.css("direction"),
                rtlTranslate: "horizontal" === t.params.direction && ("rtl" === e.dir.toLowerCase() || "rtl" === r.css("direction")),
                wrongRTL: "-webkit-box" === n.css("display")
            }), !0)
        }, i.init = function (e)
        {
            var t = this;
            return t.initialized || !1 === t.mount(e) || (t.emit("beforeInit"), t.params.breakpoints && t.setBreakpoint(), t.addClasses(), t.params.loop && t.loopCreate(), t.updateSize(), t.updateSlides(), t.params.watchOverflow && t.checkOverflow(), t.params.grabCursor && t.setGrabCursor(), t.params.preloadImages && t.preloadImages(), t.params.loop ? t.slideTo(t.params.initialSlide + t.loopedSlides, 0, t.params.runCallbacksOnInit) : t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit), t.attachEvents(), t.initialized = !0, t.emit("init"), t.emit("afterInit")), t
        }, i.destroy = function (e, t)
        {
            void 0 === e && (e = !0), void 0 === t && (t = !0);
            var n, r = this, i = r.params, o = r.$el, a = r.$wrapperEl, s = r.slides;
            return void 0 === r.params || r.destroyed || (r.emit("beforeDestroy"), r.initialized = !1, r.detachEvents(), i.loop && r.loopDestroy(), t && (r.removeClasses(), o.removeAttr("style"), a.removeAttr("style"), s && s.length && s.removeClass([i.slideVisibleClass, i.slideActiveClass, i.slideNextClass, i.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-pwzrswiper-slide-index")), r.emit("destroy"), Object.keys(r.eventsListeners).forEach((function (e)
            {
                r.off(e)
            })), !1 !== e && (r.$el[0].swiper = null, n = r, Object.keys(n).forEach((function (e)
            {
                try
                {
                    n[e] = null
                } catch (e)
                {
                }
                try
                {
                    delete n[e]
                } catch (e)
                {
                }
            }))), r.destroyed = !0), null
        }, e.extendDefaults = function (e)
        {
            dg(Pg, e)
        }, e.installModule = function (t)
        {
            e.prototype.modules || (e.prototype.modules = {});
            var n = t.name || Object.keys(e.prototype.modules).length + "_" + cg();
            e.prototype.modules[n] = t
        }, e.use = function (t)
        {
            return Array.isArray(t) ? (t.forEach((function (t)
            {
                return e.installModule(t)
            })), e) : (e.installModule(t), e)
        }, t = e, r = [{
            key: "extendedDefaults", get: function ()
            {
                return Pg
            }
        }, {
            key: "defaults", get: function ()
            {
                return Og
            }
        }], (n = null) && Mg(t.prototype, n), r && Mg(t, r), e
    }();

    function Ig()
    {
        return (Ig = Object.assign || function (e)
        {
            for (var t = 1; t < arguments.length; t++)
            {
                var n = arguments[t];
                for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r])
            }
            return e
        }).apply(this, arguments)
    }

    Object.keys(Rg).forEach((function (e)
    {
        Object.keys(Rg[e]).forEach((function (t)
        {
            zg.prototype[t] = Rg[e][t]
        }))
    })), zg.use([vg, bg]);
    var Ag = {
        update: function ()
        {
            var e = this, t = e.params.navigation;
            if (!e.params.loop)
            {
                var n = e.navigation, r = n.$nextEl, i = n.$prevEl;
                i && i.length > 0 && (e.isBeginning ? i.addClass(t.disabledClass) : i.removeClass(t.disabledClass), i[e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"](t.lockClass)), r && r.length > 0 && (e.isEnd ? r.addClass(t.disabledClass) : r.removeClass(t.disabledClass), r[e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"](t.lockClass))
            }
        }, onPrevClick: function (e)
        {
            var t = this;
            e.preventDefault(), t.isBeginning && !t.params.loop || t.slidePrev()
        }, onNextClick: function (e)
        {
            var t = this;
            e.preventDefault(), t.isEnd && !t.params.loop || t.slideNext()
        }, init: function ()
        {
            var e, t, n = this, r = n.params.navigation;
            (r.nextEl || r.prevEl) && (r.nextEl && (e = sg(r.nextEl), n.params.uniqueNavElements && "string" == typeof r.nextEl && e.length > 1 && 1 === n.$el.find(r.nextEl).length && (e = n.$el.find(r.nextEl))), r.prevEl && (t = sg(r.prevEl), n.params.uniqueNavElements && "string" == typeof r.prevEl && t.length > 1 && 1 === n.$el.find(r.prevEl).length && (t = n.$el.find(r.prevEl))), e && e.length > 0 && e.on("click", n.navigation.onNextClick), t && t.length > 0 && t.on("click", n.navigation.onPrevClick), dg(n.navigation, {
                $nextEl: e,
                nextEl: e && e[0],
                $prevEl: t,
                prevEl: t && t[0]
            }))
        }, destroy: function ()
        {
            var e = this, t = e.navigation, n = t.$nextEl, r = t.$prevEl;
            n && n.length && (n.off("click", e.navigation.onNextClick), n.removeClass(e.params.navigation.disabledClass)), r && r.length && (r.off("click", e.navigation.onPrevClick), r.removeClass(e.params.navigation.disabledClass))
        }
    }, Lg = {
        name: "navigation",
        params: {
            navigation: {
                nextEl: null,
                prevEl: null,
                hideOnClick: !1,
                disabledClass: "pwzrswiper-button-disabled",
                hiddenClass: "pwzrswiper-button-hidden",
                lockClass: "pwzrswiper-button-lock"
            }
        },
        create: function ()
        {
            pg(this, {navigation: Ig({}, Ag)})
        },
        on: {
            init: function (e)
            {
                e.navigation.init(), e.navigation.update()
            }, toEdge: function (e)
            {
                e.navigation.update()
            }, fromEdge: function (e)
            {
                e.navigation.update()
            }, destroy: function (e)
            {
                e.navigation.destroy()
            }, click: function (e, t)
            {
                var n = e.navigation, r = n.$nextEl, i = n.$prevEl, o = t.target;
                if (e.params.navigation.hideOnClick && !sg(o).is(i) && !sg(o).is(r))
                {
                    if (e.pagination && e.params.pagination && e.params.pagination.clickable && (e.pagination.el === o || e.pagination.el.contains(o))) return;
                    var a;
                    r ? a = r.hasClass(e.params.navigation.hiddenClass) : i && (a = i.hasClass(e.params.navigation.hiddenClass)), !0 === a ? e.emit("navigationShow") : e.emit("navigationHide"), r && r.toggleClass(e.params.navigation.hiddenClass), i && i.toggleClass(e.params.navigation.hiddenClass)
                }
            }
        }
    };

    function Dg()
    {
        return (Dg = Object.assign || function (e)
        {
            for (var t = 1; t < arguments.length; t++)
            {
                var n = arguments[t];
                for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r])
            }
            return e
        }).apply(this, arguments)
    }

    var Ng = {
        update: function ()
        {
            var e = this, t = e.rtl, n = e.params.pagination;
            if (n.el && e.pagination.el && e.pagination.$el && 0 !== e.pagination.$el.length)
            {
                var r, i = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length,
                    o = e.pagination.$el,
                    a = e.params.loop ? Math.ceil((i - 2 * e.loopedSlides) / e.params.slidesPerGroup) : e.snapGrid.length;
                if (e.params.loop ? ((r = Math.ceil((e.activeIndex - e.loopedSlides) / e.params.slidesPerGroup)) > i - 1 - 2 * e.loopedSlides && (r -= i - 2 * e.loopedSlides), r > a - 1 && (r -= a), r < 0 && "bullets" !== e.params.paginationType && (r = a + r)) : r = void 0 !== e.snapIndex ? e.snapIndex : e.activeIndex || 0, "bullets" === n.type && e.pagination.bullets && e.pagination.bullets.length > 0)
                {
                    var s, l, c, u = e.pagination.bullets;
                    if (n.dynamicBullets && (e.pagination.bulletSize = u.eq(0)[e.isHorizontal() ? "outerWidth" : "outerHeight"](!0), o.css(e.isHorizontal() ? "width" : "height", e.pagination.bulletSize * (n.dynamicMainBullets + 4) + "px"), n.dynamicMainBullets > 1 && void 0 !== e.previousIndex && (e.pagination.dynamicBulletIndex += r - e.previousIndex, e.pagination.dynamicBulletIndex > n.dynamicMainBullets - 1 ? e.pagination.dynamicBulletIndex = n.dynamicMainBullets - 1 : e.pagination.dynamicBulletIndex < 0 && (e.pagination.dynamicBulletIndex = 0)), s = r - e.pagination.dynamicBulletIndex, c = ((l = s + (Math.min(u.length, n.dynamicMainBullets) - 1)) + s) / 2), u.removeClass(n.bulletActiveClass + " " + n.bulletActiveClass + "-next " + n.bulletActiveClass + "-next-next " + n.bulletActiveClass + "-prev " + n.bulletActiveClass + "-prev-prev " + n.bulletActiveClass + "-main"), o.length > 1) u.each((function (e)
                    {
                        var t = sg(e), i = t.index();
                        i === r && t.addClass(n.bulletActiveClass), n.dynamicBullets && (i >= s && i <= l && t.addClass(n.bulletActiveClass + "-main"), i === s && t.prev().addClass(n.bulletActiveClass + "-prev").prev().addClass(n.bulletActiveClass + "-prev-prev"), i === l && t.next().addClass(n.bulletActiveClass + "-next").next().addClass(n.bulletActiveClass + "-next-next"))
                    })); else
                    {
                        var d = u.eq(r), p = d.index();
                        if (d.addClass(n.bulletActiveClass), n.dynamicBullets)
                        {
                            for (var f = u.eq(s), h = u.eq(l), m = s; m <= l; m += 1) u.eq(m).addClass(n.bulletActiveClass + "-main");
                            if (e.params.loop) if (p >= u.length - n.dynamicMainBullets)
                            {
                                for (var v = n.dynamicMainBullets; v >= 0; v -= 1) u.eq(u.length - v).addClass(n.bulletActiveClass + "-main");
                                u.eq(u.length - n.dynamicMainBullets - 1).addClass(n.bulletActiveClass + "-prev")
                            } else f.prev().addClass(n.bulletActiveClass + "-prev").prev().addClass(n.bulletActiveClass + "-prev-prev"), h.next().addClass(n.bulletActiveClass + "-next").next().addClass(n.bulletActiveClass + "-next-next"); else f.prev().addClass(n.bulletActiveClass + "-prev").prev().addClass(n.bulletActiveClass + "-prev-prev"), h.next().addClass(n.bulletActiveClass + "-next").next().addClass(n.bulletActiveClass + "-next-next")
                        }
                    }
                    if (n.dynamicBullets)
                    {
                        var g = Math.min(u.length, n.dynamicMainBullets + 4),
                            y = (e.pagination.bulletSize * g - e.pagination.bulletSize) / 2 - c * e.pagination.bulletSize,
                            b = t ? "right" : "left";
                        u.css(e.isHorizontal() ? b : "top", y + "px")
                    }
                }
                if ("fraction" === n.type && (o.find("." + n.currentClass).text(n.formatFractionCurrent(r + 1)), o.find("." + n.totalClass).text(n.formatFractionTotal(a))), "progressbar" === n.type)
                {
                    var w;
                    w = n.progressbarOpposite ? e.isHorizontal() ? "vertical" : "horizontal" : e.isHorizontal() ? "horizontal" : "vertical";
                    var x = (r + 1) / a, _ = 1, C = 1;
                    "horizontal" === w ? _ = x : C = x, o.find("." + n.progressbarFillClass).transform("translate3d(0,0,0) scaleX(" + _ + ") scaleY(" + C + ")").transition(e.params.speed)
                }
                "custom" === n.type && n.renderCustom ? (o.html(n.renderCustom(e, r + 1, a)), e.emit("paginationRender", o[0])) : e.emit("paginationUpdate", o[0]), o[e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"](n.lockClass)
            }
        }, render: function ()
        {
            var e = this, t = e.params.pagination;
            if (t.el && e.pagination.el && e.pagination.$el && 0 !== e.pagination.$el.length)
            {
                var n = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length,
                    r = e.pagination.$el, i = "";
                if ("bullets" === t.type)
                {
                    var o = e.params.loop ? Math.ceil((n - 2 * e.loopedSlides) / e.params.slidesPerGroup) : e.snapGrid.length;
                    e.params.freeMode && !e.params.loop && o > n && (o = n);
                    for (var a = 0; a < o; a += 1) t.renderBullet ? i += t.renderBullet.call(e, a, t.bulletClass) : i += "<" + t.bulletElement + ' class="' + t.bulletClass + '"></' + t.bulletElement + ">";
                    r.html(i), e.pagination.bullets = r.find("." + t.bulletClass.replace(/ /g, "."))
                }
                "fraction" === t.type && (i = t.renderFraction ? t.renderFraction.call(e, t.currentClass, t.totalClass) : '<span class="' + t.currentClass + '"></span> / <span class="' + t.totalClass + '"></span>', r.html(i)), "progressbar" === t.type && (i = t.renderProgressbar ? t.renderProgressbar.call(e, t.progressbarFillClass) : '<span class="' + t.progressbarFillClass + '"></span>', r.html(i)), "custom" !== t.type && e.emit("paginationRender", e.pagination.$el[0])
            }
        }, init: function ()
        {
            var e = this, t = e.params.pagination;
            if (t.el)
            {
                var n = sg(t.el);
                0 !== n.length && (e.params.uniqueNavElements && "string" == typeof t.el && n.length > 1 && (n = e.$el.find(t.el)), "bullets" === t.type && t.clickable && n.addClass(t.clickableClass), n.addClass(t.modifierClass + t.type), "bullets" === t.type && t.dynamicBullets && (n.addClass("" + t.modifierClass + t.type + "-dynamic"), e.pagination.dynamicBulletIndex = 0, t.dynamicMainBullets < 1 && (t.dynamicMainBullets = 1)), "progressbar" === t.type && t.progressbarOpposite && n.addClass(t.progressbarOppositeClass), t.clickable && n.on("click", "." + t.bulletClass.replace(/ /g, "."), (function (t)
                {
                    t.preventDefault();
                    var n = sg(this).index() * e.params.slidesPerGroup;
                    e.params.loop && (n += e.loopedSlides), e.slideTo(n)
                })), dg(e.pagination, {$el: n, el: n[0]}))
            }
        }, destroy: function ()
        {
            var e = this, t = e.params.pagination;
            if (t.el && e.pagination.el && e.pagination.$el && 0 !== e.pagination.$el.length)
            {
                var n = e.pagination.$el;
                n.removeClass(t.hiddenClass), n.removeClass(t.modifierClass + t.type), e.pagination.bullets && e.pagination.bullets.removeClass(t.bulletActiveClass), t.clickable && n.off("click", "." + t.bulletClass.replace(/ /g, "."))
            }
        }
    }, Fg = {
        name: "pagination",
        params: {
            pagination: {
                el: null,
                bulletElement: "span",
                clickable: !1,
                hideOnClick: !1,
                renderBullet: null,
                renderProgressbar: null,
                renderFraction: null,
                renderCustom: null,
                progressbarOpposite: !1,
                type: "bullets",
                dynamicBullets: !1,
                dynamicMainBullets: 1,
                formatFractionCurrent: function (e)
                {
                    return e
                },
                formatFractionTotal: function (e)
                {
                    return e
                },
                bulletClass: "pwzrswiper-pagination-bullet",
                bulletActiveClass: "pwzrswiper-pagination-bullet-active",
                modifierClass: "pwzrswiper-pagination-",
                currentClass: "pwzrswiper-pagination-current",
                totalClass: "pwzrswiper-pagination-total",
                hiddenClass: "pwzrswiper-pagination-hidden",
                progressbarFillClass: "pwzrswiper-pagination-progressbar-fill",
                progressbarOppositeClass: "pwzrswiper-pagination-progressbar-opposite",
                clickableClass: "pwzrswiper-pagination-clickable",
                lockClass: "pwzrswiper-pagination-lock"
            }
        },
        create: function ()
        {
            pg(this, {pagination: Dg({dynamicBulletIndex: 0}, Ng)})
        },
        on: {
            init: function (e)
            {
                e.pagination.init(), e.pagination.render(), e.pagination.update()
            }, activeIndexChange: function (e)
            {
                (e.params.loop || void 0 === e.snapIndex) && e.pagination.update()
            }, snapIndexChange: function (e)
            {
                e.params.loop || e.pagination.update()
            }, slidesLengthChange: function (e)
            {
                e.params.loop && (e.pagination.render(), e.pagination.update())
            }, snapGridLengthChange: function (e)
            {
                e.params.loop || (e.pagination.render(), e.pagination.update())
            }, destroy: function (e)
            {
                e.pagination.destroy()
            }, click: function (e, t)
            {
                var n = t.target;
                if (e.params.pagination.el && e.params.pagination.hideOnClick && e.pagination.$el.length > 0 && !sg(n).hasClass(e.params.pagination.bulletClass))
                {
                    if (e.navigation && (e.navigation.nextEl && n === e.navigation.nextEl || e.navigation.prevEl && n === e.navigation.prevEl)) return;
                    !0 === e.pagination.$el.hasClass(e.params.pagination.hiddenClass) ? e.emit("paginationShow") : e.emit("paginationHide"), e.pagination.$el.toggleClass(e.params.pagination.hiddenClass)
                }
            }
        }
    };

    function Bg()
    {
        return (Bg = Object.assign || function (e)
        {
            for (var t = 1; t < arguments.length; t++)
            {
                var n = arguments[t];
                for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r])
            }
            return e
        }).apply(this, arguments)
    }

    var Wg = {
        loadInSlide: function (e, t)
        {
            void 0 === t && (t = !0);
            var n = this, r = n.params.lazy;
            if (void 0 !== e && 0 !== n.slides.length)
            {
                var i = n.virtual && n.params.virtual.enabled ? n.$wrapperEl.children("." + n.params.slideClass + '[data-pwzrswiper-slide-index="' + e + '"]') : n.slides.eq(e),
                    o = i.find("." + r.elementClass + ":not(." + r.loadedClass + "):not(." + r.loadingClass + ")");
                !i.hasClass(r.elementClass) || i.hasClass(r.loadedClass) || i.hasClass(r.loadingClass) || o.push(i[0]), 0 !== o.length && o.each((function (e)
                {
                    var o = sg(e);
                    o.addClass(r.loadingClass);
                    var a = o.attr("data-background"), s = o.attr("data-src"), l = o.attr("data-srcset"),
                        c = o.attr("data-sizes"), u = o.parent("picture");
                    n.loadImage(o[0], s || a, l, c, !1, (function ()
                    {
                        if (null != n && n && (!n || n.params) && !n.destroyed)
                        {
                            if (a ? (o.css("background-image", 'url("' + a + '")'), o.removeAttr("data-background")) : (l && (o.attr("srcset", l), o.removeAttr("data-srcset")), c && (o.attr("sizes", c), o.removeAttr("data-sizes")), u.length && u.children("source").each((function (e)
                            {
                                var t = sg(e);
                                t.attr("data-srcset") && (t.attr("srcset", t.attr("data-srcset")), t.removeAttr("data-srcset"))
                            })), s && (o.attr("src", s), o.removeAttr("data-src"))), o.addClass(r.loadedClass).removeClass(r.loadingClass), i.find("." + r.preloaderClass).remove(), n.params.loop && t)
                            {
                                var e = i.attr("data-pwzrswiper-slide-index");
                                if (i.hasClass(n.params.slideDuplicateClass))
                                {
                                    var d = n.$wrapperEl.children('[data-pwzrswiper-slide-index="' + e + '"]:not(.' + n.params.slideDuplicateClass + ")");
                                    n.lazy.loadInSlide(d.index(), !1)
                                } else
                                {
                                    var p = n.$wrapperEl.children("." + n.params.slideDuplicateClass + '[data-pwzrswiper-slide-index="' + e + '"]');
                                    n.lazy.loadInSlide(p.index(), !1)
                                }
                            }
                            n.emit("lazyImageReady", i[0], o[0]), n.params.autoHeight && n.updateAutoHeight()
                        }
                    })), n.emit("lazyImageLoad", i[0], o[0])
                }))
            }
        }, load: function ()
        {
            var e = this, t = e.$wrapperEl, n = e.params, r = e.slides, i = e.activeIndex,
                o = e.virtual && n.virtual.enabled, a = n.lazy, s = n.slidesPerView;

            function l(e)
            {
                if (o)
                {
                    if (t.children("." + n.slideClass + '[data-pwzrswiper-slide-index="' + e + '"]').length) return !0
                } else if (r[e]) return !0;
                return !1
            }

            function c(e)
            {
                return o ? sg(e).attr("data-pwzrswiper-slide-index") : sg(e).index()
            }

            if ("auto" === s && (s = 0), e.lazy.initialImageLoaded || (e.lazy.initialImageLoaded = !0), e.params.watchSlidesVisibility) t.children("." + n.slideVisibleClass).each((function (t)
            {
                var n = o ? sg(t).attr("data-pwzrswiper-slide-index") : sg(t).index();
                e.lazy.loadInSlide(n)
            })); else if (s > 1) for (var u = i; u < i + s; u += 1) l(u) && e.lazy.loadInSlide(u); else e.lazy.loadInSlide(i);
            if (a.loadPrevNext) if (s > 1 || a.loadPrevNextAmount && a.loadPrevNextAmount > 1)
            {
                for (var d = a.loadPrevNextAmount, p = s, f = Math.min(i + p + Math.max(d, p), r.length), h = Math.max(i - Math.max(p, d), 0), m = i + s; m < f; m += 1) l(m) && e.lazy.loadInSlide(m);
                for (var v = h; v < i; v += 1) l(v) && e.lazy.loadInSlide(v)
            } else
            {
                var g = t.children("." + n.slideNextClass);
                g.length > 0 && e.lazy.loadInSlide(c(g));
                var y = t.children("." + n.slidePrevClass);
                y.length > 0 && e.lazy.loadInSlide(c(y))
            }
        }, checkInViewOnLoad: function ()
        {
            var e = qv(), t = this;
            if (t && !t.destroyed)
            {
                var n = t.params.lazy.scrollingElement ? sg(t.params.lazy.scrollingElement) : sg(e), r = n[0] === e,
                    i = r ? e.innerWidth : n[0].offsetWidth, o = r ? e.innerHeight : n[0].offsetHeight,
                    a = t.$el.offset(), s = !1;
                t.rtlTranslate && (a.left -= t.$el[0].scrollLeft);
                for (var l = [[a.left, a.top], [a.left + t.width, a.top], [a.left, a.top + t.height], [a.left + t.width, a.top + t.height]], c = 0; c < l.length; c += 1)
                {
                    var u = l[c];
                    if (u[0] >= 0 && u[0] <= i && u[1] >= 0 && u[1] <= o)
                    {
                        if (0 === u[0] && 0 === u[1]) continue;
                        s = !0
                    }
                }
                s ? (t.lazy.load(), n.off("scroll", t.lazy.checkInViewOnLoad)) : t.lazy.scrollHandlerAttached || (t.lazy.scrollHandlerAttached = !0, n.on("scroll", t.lazy.checkInViewOnLoad))
            }
        }
    }, $g = {
        name: "lazy",
        params: {
            lazy: {
                checkInView: !1,
                enabled: !1,
                loadPrevNext: !1,
                loadPrevNextAmount: 1,
                loadOnTransitionStart: !1,
                scrollingElement: "",
                elementClass: "pwzrswiper-lazy",
                loadingClass: "pwzrswiper-lazy-loading",
                loadedClass: "pwzrswiper-lazy-loaded",
                preloaderClass: "pwzrswiper-lazy-preloader"
            }
        },
        create: function ()
        {
            pg(this, {lazy: Bg({initialImageLoaded: !1}, Wg)})
        },
        on: {
            beforeInit: function (e)
            {
                e.params.lazy.enabled && e.params.preloadImages && (e.params.preloadImages = !1)
            }, init: function (e)
            {
                e.params.lazy.enabled && !e.params.loop && 0 === e.params.initialSlide && (e.params.lazy.checkInView ? e.lazy.checkInViewOnLoad() : e.lazy.load())
            }, scroll: function (e)
            {
                e.params.freeMode && !e.params.freeModeSticky && e.lazy.load()
            }, "scrollbarDragMove resize _freeModeNoMomentumRelease": function (e)
            {
                e.params.lazy.enabled && e.lazy.load()
            }, transitionStart: function (e)
            {
                e.params.lazy.enabled && (e.params.lazy.loadOnTransitionStart || !e.params.lazy.loadOnTransitionStart && !e.lazy.initialImageLoaded) && e.lazy.load()
            }, transitionEnd: function (e)
            {
                e.params.lazy.enabled && !e.params.lazy.loadOnTransitionStart && e.lazy.load()
            }, slideChange: function (e)
            {
                e.params.lazy.enabled && e.params.cssMode && e.lazy.load()
            }
        }
    };

    function Hg()
    {
        return (Hg = Object.assign || function (e)
        {
            for (var t = 1; t < arguments.length; t++)
            {
                var n = arguments[t];
                for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r])
            }
            return e
        }).apply(this, arguments)
    }

    var jg = {
        setTranslate: function ()
        {
            for (var e = this, t = e.slides, n = 0; n < t.length; n += 1)
            {
                var r = e.slides.eq(n), i = -r[0].swiperSlideOffset;
                e.params.virtualTranslate || (i -= e.translate);
                var o = 0;
                e.isHorizontal() || (o = i, i = 0);
                var a = e.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(r[0].progress), 0) : 1 + Math.min(Math.max(r[0].progress, -1), 0);
                r.css({opacity: a}).transform("translate3d(" + i + "px, " + o + "px, 0px)")
            }
        }, setTransition: function (e)
        {
            var t = this, n = t.slides, r = t.$wrapperEl;
            if (n.transition(e), t.params.virtualTranslate && 0 !== e)
            {
                var i = !1;
                n.transitionEnd((function ()
                {
                    if (!i && t && !t.destroyed)
                    {
                        i = !0, t.animating = !1;
                        for (var e = ["webkitTransitionEnd", "transitionend"], n = 0; n < e.length; n += 1) r.trigger(e[n])
                    }
                }))
            }
        }
    }, Vg = {
        name: "effect-fade", params: {fadeEffect: {crossFade: !1}}, create: function ()
        {
            pg(this, {fadeEffect: Hg({}, jg)})
        }, on: {
            beforeInit: function (e)
            {
                if ("fade" === e.params.effect)
                {
                    e.classNames.push(e.params.containerModifierClass + "fade");
                    var t = {
                        slidesPerView: 1,
                        slidesPerColumn: 1,
                        slidesPerGroup: 1,
                        watchSlidesProgress: !0,
                        spaceBetween: 0,
                        virtualTranslate: !0
                    };
                    dg(e.params, t), dg(e.originalParams, t)
                }
            }, setTranslate: function (e)
            {
                "fade" === e.params.effect && e.fadeEffect.setTranslate()
            }, setTransition: function (e, t)
            {
                "fade" === e.params.effect && e.fadeEffect.setTransition(t)
            }
        }
    }, qg = function (e, t)
    {
        var n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
        return n ? Zn.indexOf(e) <= Zn.indexOf(t) : Zn.indexOf(e) < Zn.indexOf(t)
    }, Ug = "undefined" == typeof window ? lt.useEffect : lt.useLayoutEffect, Gg = "complete", Zg = "canceled";

    function Kg(e, t, n, r, i)
    {
        e.self === e ? e.scrollTo(t, n) : (r || (e.scrollLeft = t), i || (e.scrollTop = n))
    }

    function Yg(e)
    {
        var t = e._scrollSettings;
        if (t)
        {
            var n = t.maxSynchronousAlignments, r = function (e, t)
            {
                var n, r, i, o, a, s, l, c = e.align, u = e.target.getBoundingClientRect(),
                    d = c && null != c.left ? c.left : .5, p = c && null != c.top ? c.top : .5,
                    f = c && null != c.leftOffset ? c.leftOffset : 0, h = c && null != c.topOffset ? c.topOffset : 0,
                    m = d, v = p;
                if (e.isWindow(t)) s = Math.min(u.width, t.innerWidth), l = Math.min(u.height, t.innerHeight), r = u.left + t.pageXOffset - t.innerWidth * m + s * m, i = u.top + t.pageYOffset - t.innerHeight * v + l * v, i -= h, o = (r -= f) - t.pageXOffset, a = i - t.pageYOffset; else
                {
                    s = u.width, l = u.height, n = t.getBoundingClientRect();
                    var g = u.left - (n.left - t.scrollLeft), y = u.top - (n.top - t.scrollTop);
                    r = g + s * m - t.clientWidth * m, i = y + l * v - t.clientHeight * v, r -= f, i -= h, r = Math.max(Math.min(r, t.scrollWidth - t.clientWidth), 0), i = Math.max(Math.min(i, t.scrollHeight - t.clientHeight), 0), o = r - t.scrollLeft, a = i - t.scrollTop
                }
                return {x: r, y: i, differenceX: o, differenceY: a}
            }(t, e), i = Date.now() - t.startTime, o = Math.min(1 / t.time * i, 1);
            if (t.endIterations >= n) return Kg(e, r.x, r.y, t.lockX, t.lockY), e._scrollSettings = null, t.end(Gg);
            var a = 1 - t.ease(o);
            if (Kg(e, r.x - r.differenceX * a, r.y - r.differenceY * a, t.lockX, t.lockY), i >= t.time) return t.endIterations++, Yg(e);
            !function (e)
            {
                if ("requestAnimationFrame" in window) return window.requestAnimationFrame(e);
                setTimeout(e, 16)
            }(Yg.bind(null, e))
        }
    }

    function Xg(e)
    {
        return e.self === e
    }

    function Jg(e, t, n, r)
    {
        var i, o = !t._scrollSettings, a = t._scrollSettings, s = Date.now(), l = {passive: !0};

        function c(e)
        {
            t._scrollSettings = null, t.parentElement && t.parentElement._scrollSettings && t.parentElement._scrollSettings.end(e), n.debug && console.log("Scrolling ended with type", e, "for", t), r(e), i && (t.removeEventListener("touchstart", i, l), t.removeEventListener("wheel", i, l))
        }

        a && a.end(Zg);
        var u = n.maxSynchronousAlignments;
        null == u && (u = 3), t._scrollSettings = {
            startTime: a ? a.startTime : Date.now(),
            endIterations: 0,
            target: e,
            time: n.time + (a ? s - a.startTime : 0),
            ease: n.ease,
            align: n.align,
            isWindow: n.isWindow || Xg,
            maxSynchronousAlignments: u,
            end: c,
            lockX: n.lockX,
            lockY: n.lockY
        }, "cancellable" in n && !n.cancellable || (i = c.bind(null, Zg), t.addEventListener("touchstart", i, l), t.addEventListener("wheel", i, l)), o && Yg(t)
    }

    function Qg(e)
    {
        return "pageXOffset" in e || (e.scrollHeight !== e.clientHeight || e.scrollWidth !== e.clientWidth) && "hidden" !== getComputedStyle(e).overflow
    }

    function ey()
    {
        return !0
    }

    function ty(e)
    {
        if (e.assignedSlot) return ty(e.assignedSlot);
        if (e.parentElement) return "BODY" === e.parentElement.tagName ? e.parentElement.ownerDocument.defaultView || e.parentElement.ownerDocument.ownerWindow : e.parentElement;
        if (e.getRootNode)
        {
            var t = e.getRootNode();
            if (11 === t.nodeType) return t.host
        }
    }

    var ny = t((function (e, t, n)
    {
        if (e)
        {
            "function" == typeof t && (n = t, t = null), t || (t = {}), t.time = isNaN(t.time) ? 1e3 : t.time, t.ease = t.ease || function (e)
            {
                return 1 - Math.pow(1 - e, e / 2)
            }, t.lockX = t.lockX || !1, t.lockY = t.lockY || !1, t.scrollAllParents = "boolean" != typeof t.scrollAllParents || t.scrollAllParents;
            var r = ty(e), i = 1, o = t.validTarget || ey, a = t.isScrollable;
            for (t.debug && (console.log("About to scroll to", e), r || console.error("Target did not have a parent, is it mounted in the DOM?")); r;) if (t.debug && console.log("Scrolling parent node", r), o(r, i) && (a ? a(r, Qg) : Qg(r)) && (i++, Jg(e, r, t, s)), r = ty(r), !t.scrollAllParents || !r)
            {
                s(Gg);
                break
            }
        }

        function s(e)
        {
            --i || n && n(e)
        }
    }));
    var ry;
    ry = function (e, t)
    {
        if (t = t.split(":")[0], !(e = +e)) return !1;
        switch (t)
        {
            case"http":
            case"ws":
                return 80 !== e;
            case"https":
            case"wss":
                return 443 !== e;
            case"ftp":
                return 21 !== e;
            case"gopher":
                return 70 !== e;
            case"file":
                return !1
        }
        return 0 !== e
    };
    var iy = {}, oy = Object.prototype.hasOwnProperty;

    function ay(e)
    {
        try
        {
            return decodeURIComponent(e.replace(/\+/g, " "))
        } catch (e)
        {
            return null
        }
    }

    var sy = function (e, t)
    {
        t = t || "";
        var n, r, i = [];
        for (r in "string" != typeof t && (t = "?"), e) if (oy.call(e, r))
        {
            if ((n = e[r]) || null != n && !isNaN(n) || (n = ""), r = encodeURIComponent(r), n = encodeURIComponent(n), null === r || null === n) continue;
            i.push(r + "=" + n)
        }
        return i.length ? t + i.join("&") : ""
    };
    iy.stringify = sy;
    var ly = function (e)
    {
        for (var t, n = /([^=?&]+)=?([^&]*)/g, r = {}; t = n.exec(e);)
        {
            var i = ay(t[1]), o = ay(t[2]);
            null === i || null === o || i in r || (r[i] = o)
        }
        return r
    };
    iy.parse = ly;
    var cy = ry, uy = iy, dy = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, py = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\S\s]*)/i,
        fy = new RegExp("^[\\x09\\x0A\\x0B\\x0C\\x0D\\x20\\xA0\\u1680\\u180E\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200A\\u202F\\u205F\\u3000\\u2028\\u2029\\uFEFF]+");

    function hy(e)
    {
        return (e || "").toString().replace(fy, "")
    }

    var my = [["#", "hash"], ["?", "query"], function (e)
        {
            return e.replace("\\", "/")
        }, ["/", "pathname"], ["@", "auth", 1], [NaN, "host", void 0, 1, 1], [/:(\d+)$/, "port", void 0, 1], [NaN, "hostname", void 0, 1, 1]],
        vy = {hash: 1, query: 1};

    function gy(t)
    {
        var n,
            r = ("undefined" != typeof window ? window : void 0 !== e ? e : "undefined" != typeof self ? self : {}).location || {},
            i = {}, o = typeof (t = t || r);
        if ("blob:" === t.protocol) i = new by(unescape(t.pathname), {}); else if ("string" === o) for (n in i = new by(t, {}), vy) delete i[n]; else if ("object" === o)
        {
            for (n in t) n in vy || (i[n] = t[n]);
            void 0 === i.slashes && (i.slashes = dy.test(t.href))
        }
        return i
    }

    function yy(e)
    {
        e = hy(e);
        var t = py.exec(e);
        return {protocol: t[1] ? t[1].toLowerCase() : "", slashes: !!t[2], rest: t[3]}
    }

    function by(e, t, n)
    {
        if (e = hy(e), !(this instanceof by)) return new by(e, t, n);
        var r, i, o, a, s, l, c = my.slice(), u = typeof t, d = this, p = 0;
        for ("object" !== u && "string" !== u && (n = t, t = null), n && "function" != typeof n && (n = uy.parse), t = gy(t), r = !(i = yy(e || "")).protocol && !i.slashes, d.slashes = i.slashes || r && t.slashes, d.protocol = i.protocol || t.protocol || "", e = i.rest, i.slashes || (c[3] = [/(.*)/, "pathname"]); p < c.length; p++) "function" != typeof (a = c[p]) ? (o = a[0], l = a[1], o != o ? d[l] = e : "string" == typeof o ? ~(s = e.indexOf(o)) && ("number" == typeof a[2] ? (d[l] = e.slice(0, s), e = e.slice(s + a[2])) : (d[l] = e.slice(s), e = e.slice(0, s))) : (s = o.exec(e)) && (d[l] = s[1], e = e.slice(0, s.index)), d[l] = d[l] || r && a[3] && t[l] || "", a[4] && (d[l] = d[l].toLowerCase())) : e = a(e);
        n && (d.query = n(d.query)), r && t.slashes && "/" !== d.pathname.charAt(0) && ("" !== d.pathname || "" !== t.pathname) && (d.pathname = function (e, t)
        {
            if ("" === e) return t;
            for (var n = (t || "/").split("/").slice(0, -1).concat(e.split("/")), r = n.length, i = n[r - 1], o = !1, a = 0; r--;) "." === n[r] ? n.splice(r, 1) : ".." === n[r] ? (n.splice(r, 1), a++) : a && (0 === r && (o = !0), n.splice(r, 1), a--);
            return o && n.unshift(""), "." !== i && ".." !== i || n.push(""), n.join("/")
        }(d.pathname, t.pathname)), cy(d.port, d.protocol) || (d.host = d.hostname, d.port = ""), d.username = d.password = "", d.auth && (a = d.auth.split(":"), d.username = a[0] || "", d.password = a[1] || ""), d.origin = d.protocol && d.host && "file:" !== d.protocol ? d.protocol + "//" + d.host : "null", d.href = d.toString()
    }

    by.prototype = {
        set: function (e, t, n)
        {
            var r = this;
            switch (e)
            {
                case"query":
                    "string" == typeof t && t.length && (t = (n || uy.parse)(t)), r[e] = t;
                    break;
                case"port":
                    r[e] = t, cy(t, r.protocol) ? t && (r.host = r.hostname + ":" + t) : (r.host = r.hostname, r[e] = "");
                    break;
                case"hostname":
                    r[e] = t, r.port && (t += ":" + r.port), r.host = t;
                    break;
                case"host":
                    r[e] = t, /:\d+$/.test(t) ? (t = t.split(":"), r.port = t.pop(), r.hostname = t.join(":")) : (r.hostname = t, r.port = "");
                    break;
                case"protocol":
                    r.protocol = t.toLowerCase(), r.slashes = !n;
                    break;
                case"pathname":
                case"hash":
                    if (t)
                    {
                        var i = "pathname" === e ? "/" : "#";
                        r[e] = t.charAt(0) !== i ? i + t : t
                    } else r[e] = t;
                    break;
                default:
                    r[e] = t
            }
            for (var o = 0; o < my.length; o++)
            {
                var a = my[o];
                a[4] && (r[a[1]] = r[a[1]].toLowerCase())
            }
            return r.origin = r.protocol && r.host && "file:" !== r.protocol ? r.protocol + "//" + r.host : "null", r.href = r.toString(), r
        }, toString: function (e)
        {
            e && "function" == typeof e || (e = uy.stringify);
            var t, n = this, r = n.protocol;
            r && ":" !== r.charAt(r.length - 1) && (r += ":");
            var i = r + (n.slashes ? "//" : "");
            return n.username && (i += n.username, n.password && (i += ":" + n.password), i += "@"), i += n.host + n.pathname, (t = "object" == typeof n.query ? e(n.query) : n.query) && (i += "?" !== t.charAt(0) ? "?" + t : t), n.hash && (i += n.hash), i
        }
    }, by.extractProtocol = yy, by.location = gy, by.trimLeft = hy, by.qs = uy;
    var wy = t(by), xy = {};
    Object.defineProperty(xy, "__esModule", {value: !0});
    var _y = function (e, t)
    {
        "string" == typeof e && (e = [e]);
        for (var n = 0; n < e.length; n++)
        {
            Ty(Oy(e[n], t))
        }
    };
    xy.preload = _y;
    var Cy = Ty;
    xy.loadImage = Cy;
    var Ey = function (e)
    {
        var t = e.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
        return t ? t[1] : null
    };
    xy.imageSize = Ey;
    var Sy = Oy;
    xy.getSizedImageUrl = Sy;
    var ky = My;

    function Ty(e)
    {
        (new Image).src = e
    }

    function Oy(e, t)
    {
        if (null === t) return e;
        if ("master" === t) return My(e);
        var n = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp|heic|psd)(\?.*)/i);
        if (n)
        {
            var r = e.split(n[0]), i = n[0];
            return My(r[0] + "_" + t + i)
        }
        return null
    }

    function My(e)
    {
        return e.replace(/http(s)?:/, "")
    }

    xy.removeProtocol = ky;
    var Ry = new Error("Element already at target scroll position"), Py = new Error("Scroll cancelled"), zy = Math.min,
        Iy = Date.now;

    function Ay(e)
    {
        return function (t, n, r, i)
        {
            "function" == typeof (r = r || {}) && (i = r, r = {}), "function" != typeof i && (i = Dy);
            var o = Iy(), a = t[e], s = r.ease || Ly, l = isNaN(r.duration) ? 350 : +r.duration, c = !1;
            return a === n ? i(Ry, t[e]) : requestAnimationFrame((function r(u)
            {
                if (c) return i(Py, t[e]);
                var d = Iy(), p = zy(1, (d - o) / l), f = s(p);
                t[e] = f * (n - a) + a, p < 1 ? requestAnimationFrame(r) : requestAnimationFrame((function ()
                {
                    i(null, t[e])
                }))
            })), function ()
            {
                c = !0
            }
        }
    }

    function Ly(e)
    {
        return .5 * (1 - Math.cos(Math.PI * e))
    }

    function Dy()
    {
    }

    var Ny = t({left: Ay("scrollLeft"), top: Ay("scrollTop")});
    const Fy = ["//pwzimg.b-cdn.net", "//pwzimg.com", "//b.pwzimg.com"], By = e => (t = null, n = null, r = !1) =>
    {
        if (null === t && null === n) return e;
        if ("string" == typeof e && Fy.find((t => e.indexOf(t) > -1)))
        {
            return ((e, t = null, n = null) =>
            {
                try
                {
                    const r = new URL(e), i = 5760, o = new URLSearchParams(r.search);
                    if (null !== t)
                    {
                        const e = Math.min(Math.ceil(t), i);
                        o.append("width", `${e}`)
                    }
                    if (null !== n)
                    {
                        const e = Math.min(Math.ceil(n), i);
                        o.append("height", `${e}`)
                    }
                    return `${r.origin}${r.pathname}?${o}`
                } catch (e)
                {
                }
                return e
            })(e, t, n)
        }
        const i = ((e, t = !1) => t ? `${e}_crop_center` : e)(((e = null, t = null) =>
        {
            const n = 5760;
            if (null === e) return `x${Math.min(Math.ceil(t), n)}`;
            if (null === t) return `${Math.min(Math.ceil(e), n)}x`;
            return `${Math.min(Math.ceil(e), n)}x${Math.min(Math.ceil(t), n)}`
        })(t, n), r);
        return xy.getSizedImageUrl(e, i)
    };

    function Wy()
    {
        return Math.max(window.devicePixelRatio, 2);
    }

    //Ab undo to reduce pixel ratio
 /*   function Wy()
    {
        return window.devicePixelRatio || 1
    }*/

    const $y = e => (t, n) => t[e] > n[e] ? -1 : n[e] > t[e] ? 1 : 0;

    function Hy(e, t)
    {
        const n = Math.ceil(e.scrollLeft), r = Math.ceil(e.scrollTop), i = Math.floor(e.scrollLeft),
            o = Math.floor(e.scrollTop);
        return {
            start: t ? 0 === o : 0 === i,
            end: t ? e.offsetHeight + r >= e.scrollHeight : e.offsetWidth + n >= e.scrollWidth
        }
    }

    function jy(e, t, n)
    {
        return new Promise((r =>
        {
            t ? Ny.top(e, e.scrollTop + n * e.clientHeight, (() =>
            {
                r(Hy(e, t))
            })) : Ny.left(e, e.scrollLeft + n * e.clientWidth, (() =>
            {
                r(Hy(e, t))
            }))
        }))
    }

    const Vy = JSON.stringify({muted: !1, autoPlay: !0, controls: !0, loop: !1, autoRotate: !0});

    function qy(e, t, n, r = "media")
    {
        const i = {muted: !1, autoPlay: !0, controls: !0, loop: !1, autoRotate: !0};
        if (Array.isArray(n))
        {
            const o = n.find((t => t.id === e));
            if (o && Array.isArray(o[r]))
            {
                const e = o[r].find((e => e.id === t));
                if (e)
                {
                    const {id: t, ...n} = e;
                    return {...i, ...n}
                }
            }
        }
        return i
    }

    const Uy = (e, t, n, r = !1) =>
    {
        const i = e.find((e => e.id === n));
        if (i) return i;
        const o = (Array.isArray(t) ? t : []).find((e => e.id === n));
        if (o)
        {
            const t = o.value;
            if ("string" == typeof t)
            {
                const i = e.find((e => (e =>
                {
                    try
                    {
                        const {pathname: t} = new URL(e), n = t.lastIndexOf("/");
                        return -1 !== n ? t.substring(n + 1) : t
                    } catch (e)
                    {
                    }
                    return null
                })(e.originalSrc) === t));
                if (i) return console.log(`Fixed invalid image reference of ${n} ${t} to`), console.log(i), r ? {
                    ...i,
                    rescued: !0
                } : i
            }
        }
        return console.log(`Could not find a match for media ${n}`), null
    };

    function Gy(e)
    {
        return "left" === e || "right" === e
    }

    function Zy(e)
    {
        return Math.min(180 * Math.ceil(e / 180), 5760)
    }

    function Ky(e)
    {
        return "number" == typeof e && Number.isFinite(e) ? `${(1 / e * 100).toFixed(3)}%` : "100%"
    }

    function Yy(e)
    {
        const t = e.media.concat().sort((n = "position", (e, t) => e[n] > t[n] ? 1 : t[n] > e[n] ? -1 : 0)).map((e =>
        {
            return (t = function (e)
            {
                const {
                    media_type: t,
                    aspect_ratio: n,
                    preview_image: r,
                    external_id: i,
                    src: o,
                    host: a,
                    sources: s,
                    id: l,
                    alt: c,
                    width: u
                } = e, d = {id: `${l}`, type: t, alt: c}, p = s || [];
                if ("image" === t) return {...d, transformedSrc: By(o), originalSrc: o, scale: Ky(n), width: u};
                if ("video" === t)
                {
                    const e = p.filter((e => "video/mp4" === e.mime_type)).sort(((e, t) => t.height - e.height)).map((e => ({
                        mimeType: e.mime_type,
                        url: e.url
                    })));
                    if (e.length > 0)
                    {
                        const t = [], i = p.find((e => "application/x-mpegURL" === e.mime_type));
                        return i && t.push({mimeType: i.mime_type, url: i.url}), t.push(e[0]), {
                            ...d,
                            transformedSrc: By(r.src),
                            scale: Ky(r.aspect_ratio),
                            sources: t,
                            scaleSources: Ky(n)
                        }
                    }
                }
                if ("external_video" === t && "youtube" === a && "string" == typeof i) return {
                    ...d,
                    transformedSrc: By(r.src),
                    scale: Ky(r.aspect_ratio),
                    sources: [i],
                    scaleSources: Ky(n)
                };
                if ("model" === t)
                {
                    const e = p.find((e => "glb" === e.format));
                    if (e && "string" == typeof e.url) return {
                        ...d,
                        transformedSrc: By(r.src),
                        scale: Ky(r.aspect_ratio),
                        sources: [e.url],
                        scaleSources: Ky(r.aspect_ratio)
                    }
                }
                return null
            }(e)) ? {...t, rioSettings: {muted: !1, autoPlay: !0, controls: !0, loop: !1, autoRotate: !0}} : null;
            var t
        })).filter((e => null !== e));
        var n;
        const r = e.variants.map((e => ({
            id: `${e.id}`,
            featuredMediaIndex: e.featured_media ? t.findIndex((t => `${e.featured_media.id}` === t.id)) : -1,
            available: e.available
        })));
        return {media: t, variants: r}
    }

    function Xy(e)
    {
        return "numericSelectedBackground" === e ? "rgba(0, 0, 0, 0.75)" : "numericUnselectedBackground" === e ? "rgba(0, 0, 0, 0.2)" : "numericSelectedFill" === e ? "rgba(255, 255, 255, 1)" : "numericUnselectedFill" === e ? "rgba(0, 0, 0, 1)" : "standardSelectedBackground" === e ? "rgba(0, 0, 0, 0.75)" : "standardUnselectedBackground" === e ? "rgba(0, 0, 0, 0.2)" : null
    }

    const Jy = () =>
        {
            const {html5Player: e, loop: t, ...n} = {html5Player: !1, autoPlay: !0, muted: !1, controls: !0, loop: !0};
            return n
        }, Qy = (e = "rgb(0, 0, 0)") => ({style: "solid", color: e, thickness: 1, radius: 0}), eb = Zt.shape({
            autoPlay: Zt.bool.isRequired,
            autoRotate: Zt.bool.isRequired,
            controls: Zt.bool.isRequired,
            loop: Zt.bool.isRequired,
            muted: Zt.bool.isRequired
        }), tb = Zt.exact({
            id: Zt.string.isRequired,
            gqlId: Zt.string.isRequired,
            type: Zt.string.isRequired,
            alt: Zt.string.isRequired,
            originalSrc: Zt.string.isRequired,
            transformedSrc: Zt.func.isRequired,
            source: Zt.string,
            filename: Zt.string,
            scale: Zt.number,
            rioSettings: eb.isRequired
        }), nb = (Zt.shape({
            id: Zt.string.isRequired,
            title: Zt.string.isRequired,
            sku: Zt.string.isRequired,
            media: Zt.arrayOf(tb).isRequired,
            variantMediaId: Zt.string,
            fullTitle: Zt.string,
            options: Zt.arrayOf(Zt.exact({name: Zt.string.isRequired, value: Zt.string.isRequired})).isRequired
        }), (e, t, n) => "number" != typeof e.thumbnailWidth && "number" != typeof e.thumbnailsPerRow ? new Error(`One of 'thumbnails.thumbnailWidth' or 'thumbnails.thumbnailsPerRow' required by '${n}' component are not numbers`) : e.thumbnailWidth || e.thumbnailsPerRow ? Gy(e.orientation) && e.thumbnailsPerRow && !e.thumbnailWidth && !e.container ? new Error(`Both 'thumbnails.thumbnailWidth' and 'thumbnails.thumbnailsPerRow' is required by '${n}' component.`) : void 0 : new Error(`One of 'thumbnails.thumbnailWidth' or 'thumbnails.thumbnailsPerRow' is required by '${n}' component.`)),
        rb = Zt.shape({
            navigation: Zt.bool.isRequired,
            pagination: Zt.bool.isRequired,
            clickablePagination: Zt.bool,
            swipe: Zt.bool.isRequired,
            keyboard: Zt.bool,
            vertical: (e, t, n) =>
            {
                if (e.vertical)
                {
                    if (e.magnify) return new Error(`'magnify' cannot be true when 'vertical' is true in '${n}' component.`);
                    if (e.thumbnails) return new Error(`'thumbnails' cannot be true when 'vertical' is true in '${n}' component.`)
                }
            },
            verticalSpacing: Zt.string,
            verticalHoistVariantImage: Zt.bool,
            maxHeight: Zt.string,
            magnify: Zt.oneOfType([Zt.oneOf([!1]), Zt.exact({width: Zt.string, height: Zt.string, zoom: Zt.number})]),
            thumbnails: Zt.oneOfType([Zt.oneOf([!1]), Zt.exact({
                orientation: Zt.oneOf(["bottom", "top", "right", "left"]).isRequired,
                multiRow: (e, t, n) => "boolean" != typeof e.multiRow ? new Error(`'thumbnails.multiRow' is required to be a boolean by '${n}' component.`) : !e.multiRow && Gy(e.orientation) ? new Error(`'thumbnails.muliRow' cannot be false with left or right 'thumbnails.orientation' in '${n}' component.`) : void 0,
                thumbnailWidth: nb,
                thumbnailsPerRow: nb,
                container: (e, t, n) =>
                {
                    if (e.container) return "number" != typeof e.container ? new Error(`'thumbnails.container' needs to be a number in '${n}' component.`) : e.container < 0 || e.container > 1 ? new Error(`'thumbnails.container' needs to be between 0.0 and 1.0 (inclusive) in '${n}' component.`) : "number" != typeof e.thumbnailsPerRow ? new Error(`'thumbnails.thumbnailsPerRow' needs to also be set in conjuction with 'thumbnails.container' in '${n}' component.`) : "number" == typeof e.thumbnailWidth ? new Error(`'thumbnails.thumbnailWidth' cannot also be set with 'thumbnails.container' and 'thumbnails.thumbnailsPerRow' in '${n}' component.`) : void 0
                },
                navigation: Zt.bool.isRequired,
                verticalOverflow: (e, t, n) =>
                {
                    if ("boolean" == typeof e.verticalOverflow) return e.verticalOverflow && !Gy(e.orientation) ? new Error(`'thumbnails.verticalOverflow' cannot be true with top or bottom 'thumbnails.orientation' in '${n}' component.`) : !e.verticalOverflow && e.navigation ? new Error(`'thumbnails.verticalOverflow' cannot be false with 'thumbnails.navigation' also being true in '${n}' component.`) : void 0
                }
            })]),
            lightBox: Zt.bool.isRequired,
            lightBoxZoom: (e, t, n) =>
            {
                if (e.lightBox && !Number.isFinite(e.lightBoxZoom)) return new Error(`'lightBoxZoom' is required when 'lightBox' is true in '${n}' component.`)
            }
        }), ib = Zt.exact({
            id: Zt.string.isRequired,
            type: Zt.string.isRequired,
            alt: Zt.string,
            width: Zt.number,
            rioSettings: eb.isRequired,
            transformedSrc: Zt.func.isRequired,
            originalSrc: Zt.string,
            scale: Zt.string,
            sources: Zt.oneOfType([Zt.arrayOf(Zt.string), Zt.arrayOf(Zt.shape({
                url: Zt.string.isRequired,
                mimeType: Zt.string.isRequired
            }))]),
            scaleSources: Zt.string
        });
    var ob, ab, sb = {};
    /*! PhotoSwipe - v4.1.3 - 2019-01-08
      * http://photoswipe.com
      * Copyright (c) 2019 Dmitry Semenov;*/
    ob = sb, ab = function ()
    {
        return function (e, t, n, r)
        {
            var i = {
                features: null, bind: function (e, t, n, r)
                {
                    var i = (r ? "remove" : "add") + "EventListener";
                    t = t.split(" ");
                    for (var o = 0; o < t.length; o++) t[o] && e[i](t[o], n, !1)
                }, isArray: function (e)
                {
                    return e instanceof Array
                }, createEl: function (e, t)
                {
                    var n = document.createElement(t || "div");
                    return e && (n.className = e), n
                }, getScrollY: function ()
                {
                    var e = window.pageYOffset;
                    return void 0 !== e ? e : document.documentElement.scrollTop
                }, unbind: function (e, t, n)
                {
                    i.bind(e, t, n, !0)
                }, removeClass: function (e, t)
                {
                    var n = new RegExp("(\\s|^)" + t + "(\\s|$)");
                    e.className = e.className.replace(n, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "")
                }, addClass: function (e, t)
                {
                    i.hasClass(e, t) || (e.className += (e.className ? " " : "") + t)
                }, hasClass: function (e, t)
                {
                    return e.className && new RegExp("(^|\\s)" + t + "(\\s|$)").test(e.className)
                }, getChildByClass: function (e, t)
                {
                    for (var n = e.firstChild; n;)
                    {
                        if (i.hasClass(n, t)) return n;
                        n = n.nextSibling
                    }
                }, arraySearch: function (e, t, n)
                {
                    for (var r = e.length; r--;) if (e[r][n] === t) return r;
                    return -1
                }, extend: function (e, t, n)
                {
                    for (var r in t) if (t.hasOwnProperty(r))
                    {
                        if (n && e.hasOwnProperty(r)) continue;
                        e[r] = t[r]
                    }
                }, easing: {
                    sine: {
                        out: function (e)
                        {
                            return Math.sin(e * (Math.PI / 2))
                        }, inOut: function (e)
                        {
                            return -(Math.cos(Math.PI * e) - 1) / 2
                        }
                    }, cubic: {
                        out: function (e)
                        {
                            return --e * e * e + 1
                        }
                    }
                }, detectFeatures: function ()
                {
                    if (i.features) return i.features;
                    var e = i.createEl().style, t = "", n = {};
                    if (n.oldIE = document.all && !document.addEventListener, n.touch = "ontouchstart" in window, window.requestAnimationFrame && (n.raf = window.requestAnimationFrame, n.caf = window.cancelAnimationFrame), n.pointerEvent = !!window.PointerEvent || navigator.msPointerEnabled, !n.pointerEvent)
                    {
                        var r = navigator.userAgent;
                        if (/iP(hone|od)/.test(navigator.platform))
                        {
                            var o = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
                            o && o.length > 0 && (o = parseInt(o[1], 10)) >= 1 && o < 8 && (n.isOldIOSPhone = !0)
                        }
                        var a = r.match(/Android\s([0-9\.]*)/), s = a ? a[1] : 0;
                        (s = parseFloat(s)) >= 1 && (s < 4.4 && (n.isOldAndroid = !0), n.androidVersion = s), n.isMobileOpera = /opera mini|opera mobi/i.test(r)
                    }
                    for (var l, c, u = ["transform", "perspective", "animationName"], d = ["", "webkit", "Moz", "ms", "O"], p = 0; p < 4; p++)
                    {
                        t = d[p];
                        for (var f = 0; f < 3; f++) l = u[f], c = t + (t ? l.charAt(0).toUpperCase() + l.slice(1) : l), !n[l] && c in e && (n[l] = c);
                        t && !n.raf && (t = t.toLowerCase(), n.raf = window[t + "RequestAnimationFrame"], n.raf && (n.caf = window[t + "CancelAnimationFrame"] || window[t + "CancelRequestAnimationFrame"]))
                    }
                    if (!n.raf)
                    {
                        var h = 0;
                        n.raf = function (e)
                        {
                            var t = (new Date).getTime(), n = Math.max(0, 16 - (t - h)),
                                r = window.setTimeout((function ()
                                {
                                    e(t + n)
                                }), n);
                            return h = t + n, r
                        }, n.caf = function (e)
                        {
                            clearTimeout(e)
                        }
                    }
                    return n.svg = !!document.createElementNS && !!document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect, i.features = n, n
                }
            };
            i.detectFeatures(), i.features.oldIE && (i.bind = function (e, t, n, r)
            {
                t = t.split(" ");
                for (var i, o = (r ? "detach" : "attach") + "Event", a = function ()
                {
                    n.handleEvent.call(n)
                }, s = 0; s < t.length; s++) if (i = t[s]) if ("object" == typeof n && n.handleEvent)
                {
                    if (r)
                    {
                        if (!n["oldIE" + i]) return !1
                    } else n["oldIE" + i] = a;
                    e[o]("on" + i, n["oldIE" + i])
                } else e[o]("on" + i, n)
            });
            var o = this, a = {
                allowPanToNext: !0,
                spacing: .12,
                bgOpacity: 1,
                mouseUsed: !1,
                loop: !0,
                pinchToClose: !0,
                closeOnScroll: !0,
                closeOnVerticalDrag: !0,
                verticalDragRange: .75,
                hideAnimationDuration: 333,
                showAnimationDuration: 333,
                showHideOpacity: !1,
                focus: !0,
                escKey: !0,
                arrowKeys: !0,
                mainScrollEndFriction: .35,
                panEndFriction: .35,
                isClickableElement: function (e)
                {
                    return "A" === e.tagName
                },
                getDoubleTapZoom: function (e, t)
                {
                    return e || t.initialZoomLevel < .7 ? 1 : 1.33
                },
                maxSpreadZoom: 1.33,
                modal: !0,
                scaleMode: "fit"
            };
            i.extend(a, r);
            var s, l, c, u, d, p, f, h, m, v, g, y, b, w, x, _, C, E, S, k, T, O, M, R, P, z, I, A, L, D, N, F, B, W, $,
                H, j, V, q, U, G, Z, K, Y, X, J, Q, ee, te, ne, re, ie, oe, ae, se, le, ce = {x: 0, y: 0},
                ue = {x: 0, y: 0}, de = {x: 0, y: 0}, pe = {}, fe = 0, he = {}, me = {x: 0, y: 0}, ve = 0, ge = !0,
                ye = [], be = {}, we = !1, xe = function (e, t)
                {
                    i.extend(o, t.publicMethods), ye.push(e)
                }, _e = function (e)
                {
                    var t = $t();
                    return e > t - 1 ? e - t : e < 0 ? t + e : e
                }, Ce = {}, Ee = function (e, t)
                {
                    return Ce[e] || (Ce[e] = []), Ce[e].push(t)
                }, Se = function (e)
                {
                    var t = Ce[e];
                    if (t)
                    {
                        var n = Array.prototype.slice.call(arguments);
                        n.shift();
                        for (var r = 0; r < t.length; r++) t[r].apply(o, n)
                    }
                }, ke = function ()
                {
                    return (new Date).getTime()
                }, Te = function (e)
                {
                    ae = e, o.bg.style.opacity = e * a.bgOpacity
                }, Oe = function (e, t, n, r, i)
                {
                    (!we || i && i !== o.currItem) && (r /= i ? i.fitRatio : o.currItem.fitRatio), e[O] = y + t + "px, " + n + "px" + b + " scale(" + r + ")"
                }, Me = function (e)
                {
                    te && (e && (v > o.currItem.fitRatio ? we || (Yt(o.currItem, !1, !0), we = !0) : we && (Yt(o.currItem), we = !1)), Oe(te, de.x, de.y, v))
                }, Re = function (e)
                {
                    e.container && Oe(e.container.style, e.initialPosition.x, e.initialPosition.y, e.initialZoomLevel, e)
                }, Pe = function (e, t)
                {
                    t[O] = y + e + "px, 0px" + b
                }, ze = function (e, t)
                {
                    if (!a.loop && t)
                    {
                        var n = u + (me.x * fe - e) / me.x, r = Math.round(e - ut.x);
                        (n < 0 && r > 0 || n >= $t() - 1 && r < 0) && (e = ut.x + r * a.mainScrollEndFriction)
                    }
                    ut.x = e, Pe(e, d)
                }, Ie = function (e, t)
                {
                    var n = dt[e] - he[e];
                    return ue[e] + ce[e] + n - n * (t / g)
                }, Ae = function (e, t)
                {
                    e.x = t.x, e.y = t.y, t.id && (e.id = t.id)
                }, Le = function (e)
                {
                    e.x = Math.round(e.x), e.y = Math.round(e.y)
                }, De = null, Ne = function ()
                {
                    De && (i.unbind(document, "mousemove", Ne), i.addClass(e, "pwwp--has_mouse"), a.mouseUsed = !0, Se("mouseUsed")), De = setTimeout((function ()
                    {
                        De = null
                    }), 100)
                }, Fe = function (e, t)
                {
                    var n = Ut(o.currItem, pe, e);
                    return t && (ee = n), n
                }, Be = function (e)
                {
                    return e || (e = o.currItem), e.initialZoomLevel
                }, We = function (e)
                {
                    return e || (e = o.currItem), e.w > 0 ? a.maxSpreadZoom : 1
                }, $e = function (e, t, n, r)
                {
                    return r === o.currItem.initialZoomLevel ? (n[e] = o.currItem.initialPosition[e], !0) : (n[e] = Ie(e, r), n[e] > t.min[e] ? (n[e] = t.min[e], !0) : n[e] < t.max[e] && (n[e] = t.max[e], !0))
                }, He = function (e)
                {
                    var t = "";
                    a.escKey && 27 === e.keyCode ? t = "close" : a.arrowKeys && (37 === e.keyCode ? t = "prev" : 39 === e.keyCode && (t = "next")), t && (e.ctrlKey || e.altKey || e.shiftKey || e.metaKey || (e.preventDefault ? e.preventDefault() : e.returnValue = !1, o[t]()))
                }, je = function (e)
                {
                    e && (Z || G || ne || j) && (e.preventDefault(), e.stopPropagation())
                }, Ve = function ()
                {
                    o.setScrollOffset(0, i.getScrollY())
                }, qe = {}, Ue = 0, Ge = function (e)
                {
                    qe[e] && (qe[e].raf && z(qe[e].raf), Ue--, delete qe[e])
                }, Ze = function (e)
                {
                    qe[e] && Ge(e), qe[e] || (Ue++, qe[e] = {})
                }, Ke = function ()
                {
                    for (var e in qe) qe.hasOwnProperty(e) && Ge(e)
                }, Ye = function (e, t, n, r, i, o, a)
                {
                    var s, l = ke();
                    Ze(e);
                    var c = function ()
                    {
                        if (qe[e])
                        {
                            if ((s = ke() - l) >= r) return Ge(e), o(n), void (a && a());
                            o((n - t) * i(s / r) + t), qe[e].raf = P(c)
                        }
                    };
                    c()
                }, Xe = {
                    shout: Se, listen: Ee, viewportSize: pe, options: a, isMainScrollAnimating: function ()
                    {
                        return ne
                    }, getZoomLevel: function ()
                    {
                        return v
                    }, getCurrentIndex: function ()
                    {
                        return u
                    }, isDragging: function ()
                    {
                        return q
                    }, isZooming: function ()
                    {
                        return J
                    }, setScrollOffset: function (e, t)
                    {
                        he.x = e, D = he.y = t, Se("updateScrollOffset", he)
                    }, applyZoomPan: function (e, t, n, r)
                    {
                        de.x = t, de.y = n, v = e, Me(r)
                    }, init: function ()
                    {
                        if (!s && !l)
                        {
                            var n;
                            o.framework = i, o.template = e, o.bg = i.getChildByClass(e, "pwwp__bg"), I = e.className, s = !0, N = i.detectFeatures(), P = N.raf, z = N.caf, O = N.transform, L = N.oldIE, o.scrollWrap = i.getChildByClass(e, "pwwp__scroll-wrap"), o.container = i.getChildByClass(o.scrollWrap, "pwwp__container"), d = o.container.style, o.itemHolders = _ = [{
                                el: o.container.children[0],
                                wrap: 0,
                                index: -1
                            }, {el: o.container.children[1], wrap: 0, index: -1}, {
                                el: o.container.children[2],
                                wrap: 0,
                                index: -1
                            }], _[0].el.style.display = _[2].el.style.display = "none", function ()
                            {
                                if (O)
                                {
                                    var t = N.perspective && !R;
                                    return y = "translate" + (t ? "3d(" : "("), void (b = N.perspective ? ", 0px)" : ")")
                                }
                                O = "left", i.addClass(e, "pwwp--ie"), Pe = function (e, t)
                                {
                                    t.left = e + "px"
                                }, Re = function (e)
                                {
                                    var t = e.fitRatio > 1 ? 1 : e.fitRatio, n = e.container.style, r = t * e.w,
                                        i = t * e.h;
                                    n.width = r + "px", n.height = i + "px", n.left = e.initialPosition.x + "px", n.top = e.initialPosition.y + "px"
                                }, Me = function ()
                                {
                                    if (te)
                                    {
                                        var e = te, t = o.currItem, n = t.fitRatio > 1 ? 1 : t.fitRatio, r = n * t.w,
                                            i = n * t.h;
                                        e.width = r + "px", e.height = i + "px", e.left = de.x + "px", e.top = de.y + "px"
                                    }
                                }
                            }(), m = {
                                resize: o.updateSize, orientationchange: function ()
                                {
                                    clearTimeout(F), F = setTimeout((function ()
                                    {
                                        pe.x !== o.scrollWrap.clientWidth && o.updateSize()
                                    }), 500)
                                }, scroll: Ve, keydown: He, click: je
                            };
                            var r = N.isOldIOSPhone || N.isOldAndroid || N.isMobileOpera;
                            for (N.animationName && N.transform && !r || (a.showAnimationDuration = a.hideAnimationDuration = 0), n = 0; n < ye.length; n++) o["init" + ye[n]]();
                            t && (o.ui = new t(o, i)).init(), Se("firstUpdate"), u = u || a.index || 0, (isNaN(u) || u < 0 || u >= $t()) && (u = 0), o.currItem = Wt(u), (N.isOldIOSPhone || N.isOldAndroid) && (ge = !1), e.setAttribute("aria-hidden", "false"), a.modal && (ge ? e.style.position = "fixed" : (e.style.position = "absolute", e.style.top = i.getScrollY() + "px")), void 0 === D && (Se("initialLayout"), D = A = i.getScrollY());
                            var c = "pwwp--open ";
                            for (a.mainClass && (c += a.mainClass + " "), a.showHideOpacity && (c += "pwwp--animate_opacity "), c += R ? "pwwp--touch" : "pwwp--notouch", c += N.animationName ? " pwwp--css_animation" : "", c += N.svg ? " pwwp--svg" : "", i.addClass(e, c), o.updateSize(), p = -1, ve = null, n = 0; n < 3; n++) Pe((n + p) * me.x, _[n].el.style);
                            L || i.bind(o.scrollWrap, h, o), Ee("initialZoomInEnd", (function ()
                            {
                                o.setContent(_[0], u - 1), o.setContent(_[2], u + 1), _[0].el.style.display = _[2].el.style.display = "block", a.focus && e.focus(), i.bind(document, "keydown", o), N.transform && i.bind(o.scrollWrap, "click", o), a.mouseUsed || i.bind(document, "mousemove", Ne), i.bind(window, "resize scroll orientationchange", o), Se("bindEvents")
                            })), o.setContent(_[1], u), o.updateCurrItem(), Se("afterInit"), ge || (w = setInterval((function ()
                            {
                                Ue || q || J || v !== o.currItem.initialZoomLevel || o.updateSize()
                            }), 1e3)), i.addClass(e, "pwwp--visible")
                        }
                    }, close: function ()
                    {
                        s && (s = !1, l = !0, Se("close"), i.unbind(window, "resize scroll orientationchange", o), i.unbind(window, "scroll", m.scroll), i.unbind(document, "keydown", o), i.unbind(document, "mousemove", Ne), N.transform && i.unbind(o.scrollWrap, "click", o), q && i.unbind(window, f, o), clearTimeout(F), Se("unbindEvents"), Ht(o.currItem, null, !0, o.destroy))
                    }, destroy: function ()
                    {
                        Se("destroy"), Dt && clearTimeout(Dt), e.setAttribute("aria-hidden", "true"), e.className = I, w && clearInterval(w), i.unbind(o.scrollWrap, h, o), i.unbind(window, "scroll", o), ht(), Ke(), Ce = null
                    }, panTo: function (e, t, n)
                    {
                        n || (e > ee.min.x ? e = ee.min.x : e < ee.max.x && (e = ee.max.x), t > ee.min.y ? t = ee.min.y : t < ee.max.y && (t = ee.max.y)), de.x = e, de.y = t, Me()
                    }, handleEvent: function (e)
                    {
                        e = e || window.event, m[e.type] && m[e.type](e)
                    }, goTo: function (e)
                    {
                        var t = (e = _e(e)) - u;
                        ve = t, u = e, o.currItem = Wt(u), fe -= t, ze(me.x * fe), Ke(), ne = !1, o.updateCurrItem()
                    }, next: function ()
                    {
                        o.goTo(u + 1)
                    }, prev: function ()
                    {
                        o.goTo(u - 1)
                    }, updateCurrZoomItem: function (e)
                    {
                        if (e && Se("beforeChange", 0), _[1].el.children.length)
                        {
                            var t = _[1].el.children[0];
                            te = i.hasClass(t, "pwwp__zoom-wrap") ? t.style : null
                        } else te = null;
                        ee = o.currItem.bounds, g = v = o.currItem.initialZoomLevel, de.x = ee.center.x, de.y = ee.center.y, e && Se("afterChange")
                    }, invalidateCurrItems: function ()
                    {
                        x = !0;
                        for (var e = 0; e < 3; e++) _[e].item && (_[e].item.needsUpdate = !0)
                    }, updateCurrItem: function (e)
                    {
                        if (0 !== ve)
                        {
                            var t, n = Math.abs(ve);
                            if (!(e && n < 2))
                            {
                                o.currItem = Wt(u), we = !1, Se("beforeChange", ve), n >= 3 && (p += ve + (ve > 0 ? -3 : 3), n = 3);
                                for (var r = 0; r < n; r++) ve > 0 ? (t = _.shift(), _[2] = t, p++, Pe((p + 2) * me.x, t.el.style), o.setContent(t, u - n + r + 1 + 1)) : (t = _.pop(), _.unshift(t), p--, Pe(p * me.x, t.el.style), o.setContent(t, u + n - r - 1 - 1));
                                if (te && 1 === Math.abs(ve))
                                {
                                    var i = Wt(C);
                                    i.initialZoomLevel !== v && (Ut(i, pe), Yt(i), Re(i))
                                }
                                ve = 0, o.updateCurrZoomItem(), C = u, Se("afterChange")
                            }
                        }
                    }, updateSize: function (t)
                    {
                        if (!ge && a.modal)
                        {
                            var n = i.getScrollY();
                            if (D !== n && (e.style.top = n + "px", D = n), !t && be.x === window.innerWidth && be.y === window.innerHeight) return;
                            be.x = window.innerWidth, be.y = window.innerHeight, e.style.height = be.y + "px"
                        }
                        if (pe.x = o.scrollWrap.clientWidth, pe.y = o.scrollWrap.clientHeight, Ve(), me.x = pe.x + Math.round(pe.x * a.spacing), me.y = pe.y, ze(me.x * fe), Se("beforeResize"), void 0 !== p)
                        {
                            for (var r, s, l, c = 0; c < 3; c++) r = _[c], Pe((c + p) * me.x, r.el.style), l = u + c - 1, a.loop && $t() > 2 && (l = _e(l)), (s = Wt(l)) && (x || s.needsUpdate || !s.bounds) ? (o.cleanSlide(s), o.setContent(r, l), 1 === c && (o.currItem = s, o.updateCurrZoomItem(!0)), s.needsUpdate = !1) : -1 === r.index && l >= 0 && o.setContent(r, l), s && s.container && (Ut(s, pe), Yt(s), Re(s));
                            x = !1
                        }
                        g = v = o.currItem.initialZoomLevel, (ee = o.currItem.bounds) && (de.x = ee.center.x, de.y = ee.center.y, Me(!0)), Se("resize")
                    }, zoomTo: function (e, t, n, r, o)
                    {
                        t && (g = v, dt.x = Math.abs(t.x) - de.x, dt.y = Math.abs(t.y) - de.y, Ae(ue, de));
                        var a = Fe(e, !1), s = {};
                        $e("x", a, s, e), $e("y", a, s, e);
                        var l = v, c = de.x, u = de.y;
                        Le(s);
                        var d = function (t)
                        {
                            1 === t ? (v = e, de.x = s.x, de.y = s.y) : (v = (e - l) * t + l, de.x = (s.x - c) * t + c, de.y = (s.y - u) * t + u), o && o(t), Me(1 === t)
                        };
                        n ? Ye("customZoomTo", 0, 1, n, r || i.easing.sine.inOut, d) : d(1)
                    }
                }, Je = {}, Qe = {}, et = {}, tt = {}, nt = {}, rt = [], it = {}, ot = [], at = {}, st = 0,
                lt = {x: 0, y: 0}, ct = 0, ut = {x: 0, y: 0}, dt = {x: 0, y: 0}, pt = {x: 0, y: 0}, ft = function (e, t)
                {
                    return at.x = Math.abs(e.x - t.x), at.y = Math.abs(e.y - t.y), Math.sqrt(at.x * at.x + at.y * at.y)
                }, ht = function ()
                {
                    K && (z(K), K = null)
                }, mt = function ()
                {
                    q && (K = P(mt), Mt())
                }, vt = function (e, t)
                {
                    return !(!e || e === document) && !(e.getAttribute("class") && e.getAttribute("class").indexOf("pwwp__scroll-wrap") > -1) && (t(e) ? e : vt(e.parentNode, t))
                }, gt = {}, yt = function (e, t)
                {
                    return gt.prevent = !vt(e.target, a.isClickableElement), Se("preventDragEvent", e, t, gt), gt.prevent
                }, bt = function (e, t)
                {
                    return t.x = e.pageX, t.y = e.pageY, t.id = e.identifier, t
                }, wt = function (e, t, n)
                {
                    n.x = .5 * (e.x + t.x), n.y = .5 * (e.y + t.y)
                }, xt = function ()
                {
                    var e = de.y - o.currItem.initialPosition.y;
                    return 1 - Math.abs(e / (pe.y / 2))
                }, _t = {}, Ct = {}, Et = [], St = function (e)
                {
                    for (; Et.length > 0;) Et.pop();
                    return M ? (le = 0, rt.forEach((function (e)
                    {
                        0 === le ? Et[0] = e : 1 === le && (Et[1] = e), le++
                    }))) : e.type.indexOf("touch") > -1 ? e.touches && e.touches.length > 0 && (Et[0] = bt(e.touches[0], _t), e.touches.length > 1 && (Et[1] = bt(e.touches[1], Ct))) : (_t.x = e.pageX, _t.y = e.pageY, _t.id = "", Et[0] = _t), Et
                }, kt = function (e, t)
                {
                    var n, r, i, s, l = de[e] + t[e], c = t[e] > 0, u = ut.x + t.x, d = ut.x - it.x;
                    if (n = l > ee.min[e] || l < ee.max[e] ? a.panEndFriction : 1, l = de[e] + t[e] * n, (a.allowPanToNext || v === o.currItem.initialZoomLevel) && (te ? "h" !== re || "x" !== e || G || (c ? (l > ee.min[e] && (n = a.panEndFriction, ee.min[e], r = ee.min[e] - ue[e]), (r <= 0 || d < 0) && $t() > 1 ? (s = u, d < 0 && u > it.x && (s = it.x)) : ee.min.x !== ee.max.x && (i = l)) : (l < ee.max[e] && (n = a.panEndFriction, ee.max[e], r = ue[e] - ee.max[e]), (r <= 0 || d > 0) && $t() > 1 ? (s = u, d > 0 && u < it.x && (s = it.x)) : ee.min.x !== ee.max.x && (i = l))) : s = u, "x" === e)) return void 0 !== s && (ze(s, !0), Y = s !== it.x), ee.min.x !== ee.max.x && (void 0 !== i ? de.x = i : Y || (de.x += t.x * n)), void 0 !== s;
                    ne || Y || v > o.currItem.fitRatio && (de[e] += t[e] * n)
                }, Tt = function (e)
                {
                    if (!("mousedown" === e.type && e.button > 0)) if (Bt) e.preventDefault(); else if (!V || "mousedown" !== e.type)
                    {
                        if (yt(e, !0) && e.preventDefault(), Se("pointerDown"), M)
                        {
                            var t = i.arraySearch(rt, e.pointerId, "id");
                            t < 0 && (t = rt.length), rt[t] = {x: e.pageX, y: e.pageY, id: e.pointerId}
                        }
                        var n = St(e), r = n.length;
                        X = null, Ke(), q && 1 !== r || (q = ie = !0, i.bind(window, f, o), H = se = oe = j = Y = Z = U = G = !1, re = null, Se("firstTouchStart", n), Ae(ue, de), ce.x = ce.y = 0, Ae(tt, n[0]), Ae(nt, tt), it.x = me.x * fe, ot = [{
                            x: tt.x,
                            y: tt.y
                        }], W = B = ke(), Fe(v, !0), ht(), mt()), !J && r > 1 && !ne && !Y && (g = v, G = !1, J = U = !0, ce.y = ce.x = 0, Ae(ue, de), Ae(Je, n[0]), Ae(Qe, n[1]), wt(Je, Qe, pt), dt.x = Math.abs(pt.x) - de.x, dt.y = Math.abs(pt.y) - de.y, Q = ft(Je, Qe))
                    }
                }, Ot = function (e)
                {
                    if (e.preventDefault(), M)
                    {
                        var t = i.arraySearch(rt, e.pointerId, "id");
                        if (t > -1)
                        {
                            var n = rt[t];
                            n.x = e.pageX, n.y = e.pageY
                        }
                    }
                    if (q)
                    {
                        var r = St(e);
                        if (re || Z || J) X = r; else if (ut.x !== me.x * fe) re = "h"; else
                        {
                            var o = Math.abs(r[0].x - tt.x) - Math.abs(r[0].y - tt.y);
                            Math.abs(o) >= 10 && (re = o > 0 ? "h" : "v", X = r)
                        }
                    }
                }, Mt = function ()
                {
                    if (X)
                    {
                        var e = X.length;
                        if (0 !== e) if (Ae(Je, X[0]), et.x = Je.x - tt.x, et.y = Je.y - tt.y, J && e > 1)
                        {
                            if (tt.x = Je.x, tt.y = Je.y, !et.x && !et.y && function (e, t)
                            {
                                return e.x === t.x && e.y === t.y
                            }(X[1], Qe)) return;
                            Ae(Qe, X[1]), G || (G = !0, Se("zoomGestureStarted"));
                            var t = ft(Je, Qe), n = At(t);
                            n > o.currItem.initialZoomLevel + o.currItem.initialZoomLevel / 15 && (se = !0);
                            var r = 1, i = Be(), s = We();
                            if (n < i) if (a.pinchToClose && !se && g <= o.currItem.initialZoomLevel)
                            {
                                var l = 1 - (i - n) / (i / 1.2);
                                Te(l), Se("onPinchClose", l), oe = !0
                            } else (r = (i - n) / i) > 1 && (r = 1), n = i - r * (i / 3); else n > s && ((r = (n - s) / (6 * i)) > 1 && (r = 1), n = s + r * i);
                            r < 0 && (r = 0), wt(Je, Qe, lt), ce.x += lt.x - pt.x, ce.y += lt.y - pt.y, Ae(pt, lt), de.x = Ie("x", n), de.y = Ie("y", n), H = n > v, v = n, Me()
                        } else
                        {
                            if (!re) return;
                            if (ie && (ie = !1, Math.abs(et.x) >= 10 && (et.x -= X[0].x - nt.x), Math.abs(et.y) >= 10 && (et.y -= X[0].y - nt.y)), tt.x = Je.x, tt.y = Je.y, 0 === et.x && 0 === et.y) return;
                            if ("v" === re && a.closeOnVerticalDrag && "fit" === a.scaleMode && v === o.currItem.initialZoomLevel)
                            {
                                ce.y += et.y, de.y += et.y;
                                var c = xt();
                                return j = !0, Se("onVerticalDrag", c), Te(c), void Me()
                            }
                            !function (e, t, n)
                            {
                                if (e - W > 50)
                                {
                                    var r = ot.length > 2 ? ot.shift() : {};
                                    r.x = t, r.y = n, ot.push(r), W = e
                                }
                            }(ke(), Je.x, Je.y), Z = !0, ee = o.currItem.bounds, kt("x", et) || (kt("y", et), Le(de), Me())
                        }
                    }
                }, Rt = function (e)
                {
                    if (N.isOldAndroid)
                    {
                        if (V && "mouseup" === e.type) return;
                        e.type.indexOf("touch") > -1 && (clearTimeout(V), V = setTimeout((function ()
                        {
                            V = 0
                        }), 600))
                    }
                    var t;
                    if (Se("pointerUp"), yt(e, !1) && e.preventDefault(), M)
                    {
                        var n = i.arraySearch(rt, e.pointerId, "id");
                        n > -1 && (t = rt.splice(n, 1)[0], navigator.msPointerEnabled ? (t.type = {
                            4: "mouse",
                            2: "touch",
                            3: "pen"
                        }[e.pointerType], t.type || (t.type = e.pointerType || "mouse")) : t.type = e.pointerType || "mouse")
                    }
                    var r, s = St(e), l = s.length;
                    if ("mouseup" === e.type && (l = 0), 2 === l) return X = null, !0;
                    1 === l && Ae(nt, s[0]), 0 !== l || re || ne || (t || ("mouseup" === e.type ? t = {
                        x: e.pageX,
                        y: e.pageY,
                        type: "mouse"
                    } : e.changedTouches && e.changedTouches[0] && (t = {
                        x: e.changedTouches[0].pageX,
                        y: e.changedTouches[0].pageY,
                        type: "touch"
                    })), Se("touchRelease", e, t));
                    var c = -1;
                    if (0 === l && (q = !1, i.unbind(window, f, o), ht(), J ? c = 0 : -1 !== ct && (c = ke() - ct)), ct = 1 === l ? ke() : -1, r = -1 !== c && c < 150 ? "zoom" : "swipe", J && l < 2 && (J = !1, 1 === l && (r = "zoomPointerUp"), Se("zoomGestureEnded")), X = null, Z || G || ne || j) if (Ke(), $ || ($ = Pt()), $.calculateSwipeSpeed("x"), j) if (xt() < a.verticalDragRange) o.close(); else
                    {
                        var u = de.y, d = ae;
                        Ye("verticalDrag", 0, 1, 300, i.easing.cubic.out, (function (e)
                        {
                            de.y = (o.currItem.initialPosition.y - u) * e + u, Te((1 - d) * e + d), Me()
                        })), Se("onVerticalDrag", 1)
                    } else
                    {
                        if ((Y || ne) && 0 === l)
                        {
                            if (It(r, $)) return;
                            r = "zoomPointerUp"
                        }
                        ne || ("swipe" === r ? !Y && v > o.currItem.fitRatio && zt($) : Lt())
                    }
                }, Pt = function ()
                {
                    var e, t, n = {
                        lastFlickOffset: {},
                        lastFlickDist: {},
                        lastFlickSpeed: {},
                        slowDownRatio: {},
                        slowDownRatioReverse: {},
                        speedDecelerationRatio: {},
                        speedDecelerationRatioAbs: {},
                        distanceOffset: {},
                        backAnimDestination: {},
                        backAnimStarted: {},
                        calculateSwipeSpeed: function (r)
                        {
                            ot.length > 1 ? (e = ke() - W + 50, t = ot[ot.length - 2][r]) : (e = ke() - B, t = nt[r]), n.lastFlickOffset[r] = tt[r] - t, n.lastFlickDist[r] = Math.abs(n.lastFlickOffset[r]), n.lastFlickDist[r] > 20 ? n.lastFlickSpeed[r] = n.lastFlickOffset[r] / e : n.lastFlickSpeed[r] = 0, Math.abs(n.lastFlickSpeed[r]) < .1 && (n.lastFlickSpeed[r] = 0), n.slowDownRatio[r] = .95, n.slowDownRatioReverse[r] = 1 - n.slowDownRatio[r], n.speedDecelerationRatio[r] = 1
                        },
                        calculateOverBoundsAnimOffset: function (e, t)
                        {
                            n.backAnimStarted[e] || (de[e] > ee.min[e] ? n.backAnimDestination[e] = ee.min[e] : de[e] < ee.max[e] && (n.backAnimDestination[e] = ee.max[e]), void 0 !== n.backAnimDestination[e] && (n.slowDownRatio[e] = .7, n.slowDownRatioReverse[e] = 1 - n.slowDownRatio[e], n.speedDecelerationRatioAbs[e] < .05 && (n.lastFlickSpeed[e] = 0, n.backAnimStarted[e] = !0, Ye("bounceZoomPan" + e, de[e], n.backAnimDestination[e], t || 300, i.easing.sine.out, (function (t)
                            {
                                de[e] = t, Me()
                            })))))
                        },
                        calculateAnimOffset: function (e)
                        {
                            n.backAnimStarted[e] || (n.speedDecelerationRatio[e] = n.speedDecelerationRatio[e] * (n.slowDownRatio[e] + n.slowDownRatioReverse[e] - n.slowDownRatioReverse[e] * n.timeDiff / 10), n.speedDecelerationRatioAbs[e] = Math.abs(n.lastFlickSpeed[e] * n.speedDecelerationRatio[e]), n.distanceOffset[e] = n.lastFlickSpeed[e] * n.speedDecelerationRatio[e] * n.timeDiff, de[e] += n.distanceOffset[e])
                        },
                        panAnimLoop: function ()
                        {
                            if (qe.zoomPan && (qe.zoomPan.raf = P(n.panAnimLoop), n.now = ke(), n.timeDiff = n.now - n.lastNow, n.lastNow = n.now, n.calculateAnimOffset("x"), n.calculateAnimOffset("y"), Me(), n.calculateOverBoundsAnimOffset("x"), n.calculateOverBoundsAnimOffset("y"), n.speedDecelerationRatioAbs.x < .05 && n.speedDecelerationRatioAbs.y < .05)) return de.x = Math.round(de.x), de.y = Math.round(de.y), Me(), void Ge("zoomPan")
                        }
                    };
                    return n
                }, zt = function (e)
                {
                    if (e.calculateSwipeSpeed("y"), ee = o.currItem.bounds, e.backAnimDestination = {}, e.backAnimStarted = {}, Math.abs(e.lastFlickSpeed.x) <= .05 && Math.abs(e.lastFlickSpeed.y) <= .05) return e.speedDecelerationRatioAbs.x = e.speedDecelerationRatioAbs.y = 0, e.calculateOverBoundsAnimOffset("x"), e.calculateOverBoundsAnimOffset("y"), !0;
                    Ze("zoomPan"), e.lastNow = ke(), e.panAnimLoop()
                }, It = function (e, t)
                {
                    var n, r, s;
                    if (ne || (st = u), "swipe" === e)
                    {
                        var l = tt.x - nt.x, c = t.lastFlickDist.x < 10;
                        l > 30 && (c || t.lastFlickOffset.x > 20) ? r = -1 : l < -30 && (c || t.lastFlickOffset.x < -20) && (r = 1)
                    }
                    r && ((u += r) < 0 ? (u = a.loop ? $t() - 1 : 0, s = !0) : u >= $t() && (u = a.loop ? 0 : $t() - 1, s = !0), s && !a.loop || (ve += r, fe -= r, n = !0));
                    var d, p = me.x * fe, f = Math.abs(p - ut.x);
                    return n || p > ut.x == t.lastFlickSpeed.x > 0 ? (d = Math.abs(t.lastFlickSpeed.x) > 0 ? f / Math.abs(t.lastFlickSpeed.x) : 333, d = Math.min(d, 400), d = Math.max(d, 250)) : d = 333, st === u && (n = !1), ne = !0, Se("mainScrollAnimStart"), Ye("mainScroll", ut.x, p, d, i.easing.cubic.out, ze, (function ()
                    {
                        Ke(), ne = !1, st = -1, (n || st !== u) && o.updateCurrItem(), Se("mainScrollAnimComplete")
                    })), n && o.updateCurrItem(!0), n
                }, At = function (e)
                {
                    return 1 / Q * e * g
                }, Lt = function ()
                {
                    var e = v, t = Be(), n = We();
                    v < t ? e = t : v > n && (e = n);
                    var r, a = ae;
                    return oe && !H && !se && v < t ? (o.close(), !0) : (oe && (r = function (e)
                    {
                        Te((1 - a) * e + a)
                    }), o.zoomTo(e, 0, 200, i.easing.cubic.out, r), !0)
                };
            xe("Gestures", {
                publicMethods: {
                    initGestures: function ()
                    {
                        var e = function (e, t, n, r, i)
                        {
                            E = e + t, S = e + n, k = e + r, T = i ? e + i : ""
                        };
                        (M = N.pointerEvent) && N.touch && (N.touch = !1), M ? navigator.msPointerEnabled ? e("MSPointer", "Down", "Move", "Up", "Cancel") : e("pointer", "down", "move", "up", "cancel") : N.touch ? (e("touch", "start", "move", "end", "cancel"), R = !0) : e("mouse", "down", "move", "up"), f = S + " " + k + " " + T, h = E, M && !R && (R = navigator.maxTouchPoints > 1 || navigator.msMaxTouchPoints > 1), o.likelyTouchDevice = R, m[E] = Tt, m[S] = Ot, m[k] = Rt, T && (m[T] = m[k]), N.touch && (h += " mousedown", f += " mousemove mouseup", m.mousedown = m[E], m.mousemove = m[S], m.mouseup = m[k]), R || (a.allowPanToNext = !1)
                    }
                }
            });
            var Dt, Nt, Ft, Bt, Wt, $t, Ht = function (t, n, r, s)
            {
                var l;
                Dt && clearTimeout(Dt), Bt = !0, Ft = !0, t.initialLayout ? (l = t.initialLayout, t.initialLayout = null) : l = a.getThumbBoundsFn && a.getThumbBoundsFn(u);
                var d, p, f = r ? a.hideAnimationDuration : a.showAnimationDuration, h = function ()
                {
                    Ge("initialZoom"), r ? (o.template.removeAttribute("style"), o.bg.removeAttribute("style")) : (Te(1), n && (n.style.display = "block"), i.addClass(e, "pwwp--animated-in"), Se("initialZoom" + (r ? "OutEnd" : "InEnd"))), s && s(), Bt = !1
                };
                if (!f || !l || void 0 === l.x) return Se("initialZoom" + (r ? "Out" : "In")), v = t.initialZoomLevel, Ae(de, t.initialPosition), Me(), e.style.opacity = r ? 0 : 1, Te(1), void (f ? setTimeout((function ()
                {
                    h()
                }), f) : h());
                d = c, p = !o.currItem.src || o.currItem.loadError || a.showHideOpacity, t.miniImg && (t.miniImg.style.webkitBackfaceVisibility = "hidden"), r || (v = l.w / t.w, de.x = l.x, de.y = l.y - A, o[p ? "template" : "bg"].style.opacity = .001, Me()), Ze("initialZoom"), r && !d && i.removeClass(e, "pwwp--animated-in"), p && (r ? i[(d ? "remove" : "add") + "Class"](e, "pwwp--animate_opacity") : setTimeout((function ()
                {
                    i.addClass(e, "pwwp--animate_opacity")
                }), 30)), Dt = setTimeout((function ()
                {
                    if (Se("initialZoom" + (r ? "Out" : "In")), r)
                    {
                        var n = l.w / t.w, o = {x: de.x, y: de.y}, a = v, s = ae, c = function (t)
                        {
                            1 === t ? (v = n, de.x = l.x, de.y = l.y - D) : (v = (n - a) * t + a, de.x = (l.x - o.x) * t + o.x, de.y = (l.y - D - o.y) * t + o.y), Me(), p ? e.style.opacity = 1 - t : Te(s - t * s)
                        };
                        d ? Ye("initialZoom", 0, 1, f, i.easing.cubic.out, c, h) : (c(1), Dt = setTimeout(h, f + 20))
                    } else v = t.initialZoomLevel, Ae(de, t.initialPosition), Me(), Te(1), p ? e.style.opacity = 1 : Te(1), Dt = setTimeout(h, f + 20)
                }), r ? 25 : 90)
            }, jt = {}, Vt = [], qt = {
                index: 0,
                errorMsg: '<div class="pwwp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
                forceProgressiveLoading: !1,
                preload: [1, 1],
                getNumItemsFn: function ()
                {
                    return Nt.length
                }
            }, Ut = function (e, t, n)
            {
                if (e.src && !e.loadError)
                {
                    var r = !n;
                    if (r && (e.vGap || (e.vGap = {
                        top: 0,
                        bottom: 0
                    }), Se("parseVerticalMargin", e)), jt.x = t.x, jt.y = t.y - e.vGap.top - e.vGap.bottom, r)
                    {
                        var i = jt.x / e.w, o = jt.y / e.h;
                        e.fitRatio = i < o ? i : o;
                        var s = a.scaleMode;
                        "orig" === s ? n = 1 : "fit" === s && (n = e.fitRatio), n > 1 && (n = 1), e.initialZoomLevel = n, e.bounds || (e.bounds = {
                            center: {
                                x: 0,
                                y: 0
                            }, max: {x: 0, y: 0}, min: {x: 0, y: 0}
                        })
                    }
                    if (!n) return;
                    return function (e, t, n)
                    {
                        var r = e.bounds;
                        r.center.x = Math.round((jt.x - t) / 2), r.center.y = Math.round((jt.y - n) / 2) + e.vGap.top, r.max.x = t > jt.x ? Math.round(jt.x - t) : r.center.x, r.max.y = n > jt.y ? Math.round(jt.y - n) + e.vGap.top : r.center.y, r.min.x = t > jt.x ? 0 : r.center.x, r.min.y = n > jt.y ? e.vGap.top : r.center.y
                    }(e, e.w * n, e.h * n), r && n === e.initialZoomLevel && (e.initialPosition = e.bounds.center), e.bounds
                }
                return e.w = e.h = 0, e.initialZoomLevel = e.fitRatio = 1, e.bounds = {
                    center: {x: 0, y: 0},
                    max: {x: 0, y: 0},
                    min: {x: 0, y: 0}
                }, e.initialPosition = e.bounds.center, e.bounds
            }, Gt = function (e, t, n, r, i, a)
            {
                t.loadError || r && (t.imageAppended = !0, Yt(t, r, t === o.currItem && we), n.appendChild(r), a && setTimeout((function ()
                {
                    t && t.loaded && t.placeholder && (t.placeholder.style.display = "none", t.placeholder = null)
                }), 500))
            }, Zt = function (e)
            {
                e.loading = !0, e.loaded = !1;
                var t = e.img = i.createEl("pwwp__img", "img"), n = function ()
                {
                    e.loading = !1, e.loaded = !0, e.loadComplete ? e.loadComplete(e) : e.img = null, t.onload = t.onerror = null, t = null
                };
                return t.onload = n, t.onerror = function ()
                {
                    e.loadError = !0, n()
                }, t.src = e.src, t
            }, Kt = function (e, t)
            {
                if (e.src && e.loadError && e.container) return t && (e.container.innerHTML = ""), e.container.innerHTML = a.errorMsg.replace("%url%", e.src), !0
            }, Yt = function (e, t, n)
            {
                if (e.src)
                {
                    t || (t = e.container.lastChild);
                    var r = n ? e.w : Math.round(e.w * e.fitRatio), i = n ? e.h : Math.round(e.h * e.fitRatio);
                    e.placeholder && !e.loaded && (e.placeholder.style.width = r + "px", e.placeholder.style.height = i + "px"), t.style.width = r + "px", t.style.height = i + "px"
                }
            }, Xt = function ()
            {
                if (Vt.length)
                {
                    for (var e, t = 0; t < Vt.length; t++) (e = Vt[t]).holder.index === e.index && Gt(e.index, e.item, e.baseDiv, e.img, 0, e.clearPlaceholder);
                    Vt = []
                }
            };
            xe("Controller", {
                publicMethods: {
                    lazyLoadItem: function (e)
                    {
                        e = _e(e);
                        var t = Wt(e);
                        t && (!t.loaded && !t.loading || x) && (Se("gettingData", e, t), t.src && Zt(t))
                    }, initController: function ()
                    {
                        i.extend(a, qt, !0), o.items = Nt = n, Wt = o.getItemAt, $t = a.getNumItemsFn, a.loop, $t() < 3 && (a.loop = !1), Ee("beforeChange", (function (e)
                        {
                            var t, n = a.preload, r = null === e || e >= 0, i = Math.min(n[0], $t()),
                                s = Math.min(n[1], $t());
                            for (t = 1; t <= (r ? s : i); t++) o.lazyLoadItem(u + t);
                            for (t = 1; t <= (r ? i : s); t++) o.lazyLoadItem(u - t)
                        })), Ee("initialLayout", (function ()
                        {
                            o.currItem.initialLayout = a.getThumbBoundsFn && a.getThumbBoundsFn(u)
                        })), Ee("mainScrollAnimComplete", Xt), Ee("initialZoomInEnd", Xt), Ee("destroy", (function ()
                        {
                            for (var e, t = 0; t < Nt.length; t++) (e = Nt[t]).container && (e.container = null), e.placeholder && (e.placeholder = null), e.img && (e.img = null), e.preloader && (e.preloader = null), e.loadError && (e.loaded = e.loadError = !1);
                            Vt = null
                        }))
                    }, getItemAt: function (e)
                    {
                        return e >= 0 && void 0 !== Nt[e] && Nt[e]
                    }, allowProgressiveImg: function ()
                    {
                        return a.forceProgressiveLoading || !R || a.mouseUsed || screen.width > 1200
                    }, setContent: function (e, t)
                    {
                        a.loop && (t = _e(t));
                        var n = o.getItemAt(e.index);
                        n && (n.container = null);
                        var r, l = o.getItemAt(t);
                        if (l)
                        {
                            Se("gettingData", t, l), e.index = t, e.item = l;
                            var c = l.container = i.createEl("pwwp__zoom-wrap");
                            if (!l.src && l.html && (l.html.tagName ? c.appendChild(l.html) : c.innerHTML = l.html), Kt(l), Ut(l, pe), !l.src || l.loadError || l.loaded) l.src && !l.loadError && ((r = i.createEl("pwwp__img", "img")).style.opacity = 1, r.src = l.src, Yt(l, r), Gt(0, l, c, r)); else
                            {
                                if (l.loadComplete = function (n)
                                {
                                    if (s)
                                    {
                                        if (e && e.index === t)
                                        {
                                            if (Kt(n, !0)) return n.loadComplete = n.img = null, Ut(n, pe), Re(n), void (e.index === u && o.updateCurrZoomItem());
                                            n.imageAppended ? !Bt && n.placeholder && (n.placeholder.style.display = "none", n.placeholder = null) : N.transform && (ne || Bt) ? Vt.push({
                                                item: n,
                                                baseDiv: c,
                                                img: n.img,
                                                index: t,
                                                holder: e,
                                                clearPlaceholder: !0
                                            }) : Gt(0, n, c, n.img, 0, !0)
                                        }
                                        n.loadComplete = null, n.img = null, Se("imageLoadComplete", t, n)
                                    }
                                }, i.features.transform)
                                {
                                    var d = "pwwp__img pwwp__img--placeholder";
                                    d += l.msrc ? "" : " pwwp__img--placeholder--blank";
                                    var p = i.createEl(d, l.msrc ? "img" : "");
                                    l.msrc && (p.src = l.msrc), Yt(l, p), c.appendChild(p), l.placeholder = p
                                }
                                l.loading || Zt(l), o.allowProgressiveImg() && (!Ft && N.transform ? Vt.push({
                                    item: l,
                                    baseDiv: c,
                                    img: l.img,
                                    index: t,
                                    holder: e
                                }) : Gt(0, l, c, l.img, 0, !0))
                            }
                            Ft || t !== u ? Re(l) : (te = c.style, Ht(l, r || l.img)), e.el.innerHTML = "", e.el.appendChild(c)
                        } else e.el.innerHTML = ""
                    }, cleanSlide: function (e)
                    {
                        e.img && (e.img.onload = e.img.onerror = null), e.loaded = e.loading = e.img = e.imageAppended = !1
                    }
                }
            });
            var Jt, Qt, en = {}, tn = function (e, t, n)
            {
                var r = document.createEvent("CustomEvent"),
                    i = {origEvent: e, target: e.target, releasePoint: t, pointerType: n || "touch"};
                r.initCustomEvent("pwwpTap", !0, !0, i), e.target.dispatchEvent(r)
            };
            xe("Tap", {
                publicMethods: {
                    initTap: function ()
                    {
                        Ee("firstTouchStart", o.onTapStart), Ee("touchRelease", o.onTapRelease), Ee("destroy", (function ()
                        {
                            en = {}, Jt = null
                        }))
                    }, onTapStart: function (e)
                    {
                        e.length > 1 && (clearTimeout(Jt), Jt = null)
                    }, onTapRelease: function (e, t)
                    {
                        var n, r;
                        if (t && !Z && !U && !Ue)
                        {
                            var o = t;
                            if (Jt && (clearTimeout(Jt), Jt = null, n = o, r = en, Math.abs(n.x - r.x) < 25 && Math.abs(n.y - r.y) < 25)) return void Se("doubleTap", o);
                            if ("mouse" === t.type) return void tn(e, t, "mouse");
                            if ("BUTTON" === e.target.tagName.toUpperCase() || i.hasClass(e.target, "pwwp__single-tap")) return void tn(e, t);
                            Ae(en, o), Jt = setTimeout((function ()
                            {
                                tn(e, t), Jt = null
                            }), 300)
                        }
                    }
                }
            }), xe("DesktopZoom", {
                publicMethods: {
                    initDesktopZoom: function ()
                    {
                        L || (R ? Ee("mouseUsed", (function ()
                        {
                            o.setupDesktopZoom()
                        })) : o.setupDesktopZoom(!0))
                    }, setupDesktopZoom: function (t)
                    {
                        Qt = {};
                        var n = "wheel mousewheel DOMMouseScroll";
                        Ee("bindEvents", (function ()
                        {
                            i.bind(e, n, o.handleMouseWheel)
                        })), Ee("unbindEvents", (function ()
                        {
                            Qt && i.unbind(e, n, o.handleMouseWheel)
                        })), o.mouseZoomedIn = !1;
                        var r, a = function ()
                        {
                            o.mouseZoomedIn && (i.removeClass(e, "pwwp--zoomed-in"), o.mouseZoomedIn = !1), v < 1 ? i.addClass(e, "pwwp--zoom-allowed") : i.removeClass(e, "pwwp--zoom-allowed"), s()
                        }, s = function ()
                        {
                            r && (i.removeClass(e, "pwwp--dragging"), r = !1)
                        };
                        Ee("resize", a), Ee("afterChange", a), Ee("pointerDown", (function ()
                        {
                            o.mouseZoomedIn && (r = !0, i.addClass(e, "pwwp--dragging"))
                        })), Ee("pointerUp", s), t || a()
                    }, handleMouseWheel: function (e)
                    {
                        if (v <= o.currItem.fitRatio) return a.modal && (!a.closeOnScroll || Ue || q ? e.preventDefault() : O && Math.abs(e.deltaY) > 2 && (c = !0, o.close())), !0;
                        if (e.stopPropagation(), Qt.x = 0, "deltaX" in e) 1 === e.deltaMode ? (Qt.x = 18 * e.deltaX, Qt.y = 18 * e.deltaY) : (Qt.x = e.deltaX, Qt.y = e.deltaY); else if ("wheelDelta" in e) e.wheelDeltaX && (Qt.x = -.16 * e.wheelDeltaX), e.wheelDeltaY ? Qt.y = -.16 * e.wheelDeltaY : Qt.y = -.16 * e.wheelDelta; else
                        {
                            if (!("detail" in e)) return;
                            Qt.y = e.detail
                        }
                        Fe(v, !0);
                        var t = de.x - Qt.x, n = de.y - Qt.y;
                        (a.modal || t <= ee.min.x && t >= ee.max.x && n <= ee.min.y && n >= ee.max.y) && e.preventDefault(), o.panTo(t, n)
                    }, toggleDesktopZoom: function (t)
                    {
                        t = t || {x: pe.x / 2 + he.x, y: pe.y / 2 + he.y};
                        var n = a.getDoubleTapZoom(!0, o.currItem), r = v === n;
                        o.mouseZoomedIn = !r, o.zoomTo(r ? o.currItem.initialZoomLevel : n, t, 333), i[(r ? "remove" : "add") + "Class"](e, "pwwp--zoomed-in")
                    }
                }
            });
            var nn, rn, on, an, sn, ln, cn, un, dn, pn, fn, hn, mn = {history: !0, galleryUID: 1}, vn = function ()
            {
                return fn.hash.substring(1)
            }, gn = function ()
            {
                nn && clearTimeout(nn), on && clearTimeout(on)
            }, yn = function ()
            {
                var e = vn(), t = {};
                if (e.length < 5) return t;
                var n, r = e.split("&");
                for (n = 0; n < r.length; n++) if (r[n])
                {
                    var i = r[n].split("=");
                    i.length < 2 || (t[i[0]] = i[1])
                }
                if (a.galleryPIDs)
                {
                    var o = t.pid;
                    for (t.pid = 0, n = 0; n < Nt.length; n++) if (Nt[n].pid === o)
                    {
                        t.pid = n;
                        break
                    }
                } else t.pid = parseInt(t.pid, 10) - 1;
                return t.pid < 0 && (t.pid = 0), t
            }, bn = function ()
            {
                if (on && clearTimeout(on), Ue || q) on = setTimeout(bn, 500); else
                {
                    an ? clearTimeout(rn) : an = !0;
                    var e = u + 1, t = Wt(u);
                    t.hasOwnProperty("pid") && (e = t.pid);
                    var n = cn + "&gid=" + a.galleryUID + "&pid=" + e;
                    un || -1 === fn.hash.indexOf(n) && (pn = !0);
                    var r = fn.href.split("#")[0] + "#" + n;
                    hn ? "#" + n !== window.location.hash && history[un ? "replaceState" : "pushState"]("", document.title, r) : un ? fn.replace(r) : fn.hash = n, un = !0, rn = setTimeout((function ()
                    {
                        an = !1
                    }), 60)
                }
            };
            xe("History", {
                publicMethods: {
                    initHistory: function ()
                    {
                        if (i.extend(a, mn, !0), a.history)
                        {
                            fn = window.location, pn = !1, dn = !1, un = !1, cn = vn(), hn = "pushState" in history, cn.indexOf("gid=") > -1 && (cn = (cn = cn.split("&gid=")[0]).split("?gid=")[0]), Ee("afterChange", o.updateURL), Ee("unbindEvents", (function ()
                            {
                                i.unbind(window, "hashchange", o.onHashChange)
                            }));
                            var e = function ()
                            {
                                ln = !0, dn || (pn ? history.back() : cn ? fn.hash = cn : hn ? history.pushState("", document.title, fn.pathname + fn.search) : fn.hash = ""), gn()
                            };
                            Ee("unbindEvents", (function ()
                            {
                                c && e()
                            })), Ee("destroy", (function ()
                            {
                                ln || e()
                            })), Ee("firstUpdate", (function ()
                            {
                                u = yn().pid
                            }));
                            var t = cn.indexOf("pid=");
                            t > -1 && "&" === (cn = cn.substring(0, t)).slice(-1) && (cn = cn.slice(0, -1)), setTimeout((function ()
                            {
                                s && i.bind(window, "hashchange", o.onHashChange)
                            }), 40)
                        }
                    }, onHashChange: function ()
                    {
                        if (vn() === cn) return dn = !0, void o.close();
                        an || (sn = !0, o.goTo(yn().pid), sn = !1)
                    }, updateURL: function ()
                    {
                        gn(), sn || (un ? nn = setTimeout(bn, 800) : bn())
                    }
                }
            }), i.extend(o, Xe)
        }
    }, "object" == typeof sb ? sb = ab() : ob.PhotoSwipe = ab();
    var lb = t(sb), cb = {};
    /*! PhotoSwipe Default UI - 4.1.3 - 2019-01-08
      * http://photoswipe.com
      * Copyright (c) 2019 Dmitry Semenov;*/
    !function (e, t)
    {
        "object" == typeof cb ? cb = t() : e.PhotoSwipeUI_Default = t()
    }(cb, (function ()
    {
        return function (e, t)
        {
            var n, r, i, o, a, s, l, c, u, d, p, f, h, m, v, g, y, b, w = this, x = !1, _ = !0, C = !0, E = {
                barsSize: {top: 44, bottom: "auto"},
                closeElClasses: ["item", "caption", "zoom-wrap", "ui", "top-bar"],
                timeToIdle: 4e3,
                timeToIdleOutside: 1e3,
                loadingIndicatorDelay: 1e3,
                addCaptionHTMLFn: function (e, t)
                {
                    return e.title ? (t.children[0].innerHTML = e.title, !0) : (t.children[0].innerHTML = "", !1)
                },
                closeEl: !0,
                captionEl: !0,
                fullscreenEl: !0,
                zoomEl: !0,
                shareEl: !0,
                counterEl: !0,
                arrowEl: !0,
                preloaderEl: !0,
                tapToClose: !1,
                tapToToggleControls: !0,
                clickToCloseNonZoomable: !0,
                shareButtons: [{
                    id: "facebook",
                    label: "Share on Facebook",
                    url: "https://www.facebook.com/sharer/sharer.php?u={{url}}"
                }, {
                    id: "twitter",
                    label: "Tweet",
                    url: "https://twitter.com/intent/tweet?text={{text}}&url={{url}}"
                }, {
                    id: "pinterest",
                    label: "Pin it",
                    url: "http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}"
                }, {id: "download", label: "Download image", url: "{{raw_image_url}}", download: !0}],
                getImageURLForShare: function ()
                {
                    return e.currItem.src || ""
                },
                getPageURLForShare: function ()
                {
                    return window.location.href
                },
                getTextForShare: function ()
                {
                    return e.currItem.title || ""
                },
                indexIndicatorSep: " / ",
                fitControlsWidth: 1200
            }, S = function (e)
            {
                if (g) return !0;
                e = e || window.event, v.timeToIdle && v.mouseUsed && !u && A();
                for (var n, r, i = (e.target || e.srcElement).getAttribute("class") || "", o = 0; o < F.length; o++) (n = F[o]).onTap && i.indexOf("pwwp__" + n.name) > -1 && (n.onTap(), r = !0);
                if (r)
                {
                    e.stopPropagation && e.stopPropagation(), g = !0;
                    var a = t.features.isOldAndroid ? 600 : 30;
                    setTimeout((function ()
                    {
                        g = !1
                    }), a)
                }
            }, k = function (e, n, r)
            {
                t[(r ? "add" : "remove") + "Class"](e, "pwwp__" + n)
            }, T = function ()
            {
                var e = 1 === v.getNumItemsFn();
                e !== m && (k(r, "ui--one-slide", e), m = e)
            }, O = function ()
            {
                k(l, "share-modal--hidden", C)
            }, M = function ()
            {
                return (C = !C) ? (t.removeClass(l, "pwwp__share-modal--fade-in"), setTimeout((function ()
                {
                    C && O()
                }), 300)) : (O(), setTimeout((function ()
                {
                    C || t.addClass(l, "pwwp__share-modal--fade-in")
                }), 30)), C || P(), !1
            }, R = function (t)
            {
                var n = (t = t || window.event).target || t.srcElement;
                return e.shout("shareLinkClick", t, n), !!n.href && (!!n.hasAttribute("download") || (window.open(n.href, "pwwp_share", "scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420,top=100,left=" + (window.screen ? Math.round(screen.width / 2 - 275) : 100)), C || M(), !1))
            }, P = function ()
            {
                for (var e, t, n, r, i = "", o = 0; o < v.shareButtons.length; o++) e = v.shareButtons[o], t = v.getImageURLForShare(e), n = v.getPageURLForShare(e), r = v.getTextForShare(e), i += '<a href="' + e.url.replace("{{url}}", encodeURIComponent(n)).replace("{{image_url}}", encodeURIComponent(t)).replace("{{raw_image_url}}", t).replace("{{text}}", encodeURIComponent(r)) + '" target="_blank" class="pwwp__share--' + e.id + '"' + (e.download ? "download" : "") + ">" + e.label + "</a>", v.parseShareButtonOut && (i = v.parseShareButtonOut(e, i));
                l.children[0].innerHTML = i, l.children[0].onclick = R
            }, z = function (e)
            {
                for (var n = 0; n < v.closeElClasses.length; n++) if (t.hasClass(e, "pwwp__" + v.closeElClasses[n])) return !0
            }, I = 0, A = function ()
            {
                clearTimeout(b), I = 0, u && w.setIdle(!1)
            }, L = function (e)
            {
                var t = (e = e || window.event).relatedTarget || e.toElement;
                t && "HTML" !== t.nodeName || (clearTimeout(b), b = setTimeout((function ()
                {
                    w.setIdle(!0)
                }), v.timeToIdleOutside))
            }, D = function (e)
            {
                f !== e && (k(p, "preloader--active", !e), f = e)
            }, N = function (n)
            {
                var a = n.vGap;
                if (!e.likelyTouchDevice || v.mouseUsed || screen.width > v.fitControlsWidth)
                {
                    var s = v.barsSize;
                    if (v.captionEl && "auto" === s.bottom) if (o || ((o = t.createEl("pwwp__caption pwwp__caption--fake")).appendChild(t.createEl("pwwp__caption__center")), r.insertBefore(o, i), t.addClass(r, "pwwp__ui--fit")), v.addCaptionHTMLFn(n, o, !0))
                    {
                        var l = o.clientHeight;
                        a.bottom = parseInt(l, 10) || 44
                    } else a.bottom = s.top; else a.bottom = "auto" === s.bottom ? 0 : s.bottom;
                    a.top = s.top
                } else a.top = a.bottom = 0
            }, F = [{
                name: "caption", option: "captionEl", onInit: function (e)
                {
                    i = e
                }
            }, {
                name: "share-modal", option: "shareEl", onInit: function (e)
                {
                    l = e
                }, onTap: function ()
                {
                    M()
                }
            }, {
                name: "button--share", option: "shareEl", onInit: function (e)
                {
                    s = e
                }, onTap: function ()
                {
                    M()
                }
            }, {name: "button--zoom", option: "zoomEl", onTap: e.toggleDesktopZoom}, {
                name: "counter",
                option: "counterEl",
                onInit: function (e)
                {
                    a = e
                }
            }, {name: "button--close", option: "closeEl", onTap: e.close}, {
                name: "button--arrow--left",
                option: "arrowEl",
                onTap: e.prev
            }, {name: "button--arrow--right", option: "arrowEl", onTap: e.next}, {
                name: "button--fs",
                option: "fullscreenEl",
                onTap: function ()
                {
                    n.isFullscreen() ? n.exit() : n.enter()
                }
            }, {
                name: "preloader", option: "preloaderEl", onInit: function (e)
                {
                    p = e
                }
            }];
            w.init = function ()
            {
                var a;
                t.extend(e.options, E, !0), v = e.options, r = t.getChildByClass(e.scrollWrap, "pwwp__ui"), (d = e.listen)("onVerticalDrag", (function (e)
                {
                    _ && e < .95 ? w.hideControls() : !_ && e >= .95 && w.showControls()
                })), d("onPinchClose", (function (e)
                {
                    _ && e < .9 ? (w.hideControls(), a = !0) : a && !_ && e > .9 && w.showControls()
                })), d("zoomGestureEnded", (function ()
                {
                    (a = !1) && !_ && w.showControls()
                })), d("beforeChange", w.update), d("doubleTap", (function (t)
                {
                    var n = e.currItem.initialZoomLevel;
                    e.getZoomLevel() !== n ? e.zoomTo(n, t, 333) : e.zoomTo(v.getDoubleTapZoom(!1, e.currItem), t, 333)
                })), d("preventDragEvent", (function (e, t, n)
                {
                    var r = e.target || e.srcElement;
                    r && r.getAttribute("class") && e.type.indexOf("mouse") > -1 && (r.getAttribute("class").indexOf("__caption") > 0 || /(SMALL|STRONG|EM)/i.test(r.tagName)) && (n.prevent = !1)
                })), d("bindEvents", (function ()
                {
                    t.bind(r, "pwwpTap click", S), t.bind(e.scrollWrap, "pwwpTap", w.onGlobalTap), e.likelyTouchDevice || t.bind(e.scrollWrap, "mouseover", w.onMouseOver)
                })), d("unbindEvents", (function ()
                {
                    C || M(), y && clearInterval(y), t.unbind(document, "mouseout", L), t.unbind(document, "mousemove", A), t.unbind(r, "pwwpTap click", S), t.unbind(e.scrollWrap, "pwwpTap", w.onGlobalTap), t.unbind(e.scrollWrap, "mouseover", w.onMouseOver), n && (t.unbind(document, n.eventK, w.updateFullscreen), n.isFullscreen() && (v.hideAnimationDuration = 0, n.exit()), n = null)
                })), d("destroy", (function ()
                {
                    v.captionEl && (o && r.removeChild(o), t.removeClass(i, "pwwp__caption--empty")), l && (l.children[0].onclick = null), t.removeClass(r, "pwwp__ui--over-close"), t.addClass(r, "pwwp__ui--hidden"), w.setIdle(!1)
                })), v.showAnimationDuration || t.removeClass(r, "pwwp__ui--hidden"), d("initialZoomIn", (function ()
                {
                    v.showAnimationDuration && t.removeClass(r, "pwwp__ui--hidden")
                })), d("initialZoomOut", (function ()
                {
                    t.addClass(r, "pwwp__ui--hidden")
                })), d("parseVerticalMargin", N), function ()
                {
                    var e, n, i, o = function (r)
                    {
                        if (r) for (var o = r.length, a = 0; a < o; a++)
                        {
                            e = r[a], n = e.className;
                            for (var s = 0; s < F.length; s++) i = F[s], n.indexOf("pwwp__" + i.name) > -1 && (v[i.option] ? (t.removeClass(e, "pwwp__element--disabled"), i.onInit && i.onInit(e)) : t.addClass(e, "pwwp__element--disabled"))
                        }
                    };
                    o(r.children);
                    var a = t.getChildByClass(r, "pwwp__top-bar");
                    a && o(a.children)
                }(), v.shareEl && s && l && (C = !0), T(), v.timeToIdle && d("mouseUsed", (function ()
                {
                    t.bind(document, "mousemove", A), t.bind(document, "mouseout", L), y = setInterval((function ()
                    {
                        2 == ++I && w.setIdle(!0)
                    }), v.timeToIdle / 2)
                })), v.fullscreenEl && !t.features.isOldAndroid && (n || (n = w.getFullscreenAPI()), n ? (t.bind(document, n.eventK, w.updateFullscreen), w.updateFullscreen(), t.addClass(e.template, "pwwp--supports-fs")) : t.removeClass(e.template, "pwwp--supports-fs")), v.preloaderEl && (D(!0), d("beforeChange", (function ()
                {
                    clearTimeout(h), h = setTimeout((function ()
                    {
                        e.currItem && e.currItem.loading ? (!e.allowProgressiveImg() || e.currItem.img && !e.currItem.img.naturalWidth) && D(!1) : D(!0)
                    }), v.loadingIndicatorDelay)
                })), d("imageLoadComplete", (function (t, n)
                {
                    e.currItem === n && D(!0)
                })))
            }, w.setIdle = function (e)
            {
                u = e, k(r, "ui--idle", e)
            }, w.update = function ()
            {
                _ && e.currItem ? (w.updateIndexIndicator(), v.captionEl && (v.addCaptionHTMLFn(e.currItem, i), k(i, "caption--empty", !e.currItem.title)), x = !0) : x = !1, C || M(), T()
            }, w.updateFullscreen = function (r)
            {
                r && setTimeout((function ()
                {
                    e.setScrollOffset(0, t.getScrollY())
                }), 50), t[(n.isFullscreen() ? "add" : "remove") + "Class"](e.template, "pwwp--fs")
            }, w.updateIndexIndicator = function ()
            {
                v.counterEl && (a.innerHTML = e.getCurrentIndex() + 1 + v.indexIndicatorSep + v.getNumItemsFn())
            }, w.onGlobalTap = function (n)
            {
                var r = (n = n || window.event).target || n.srcElement;
                if (!g) if (n.detail && "mouse" === n.detail.pointerType)
                {
                    if (z(r)) return void e.close();
                    t.hasClass(r, "pwwp__img") && (1 === e.getZoomLevel() && e.getZoomLevel() <= e.currItem.fitRatio ? v.clickToCloseNonZoomable && e.close() : e.toggleDesktopZoom(n.detail.releasePoint))
                } else if (v.tapToToggleControls && (_ ? w.hideControls() : w.showControls()), v.tapToClose && (t.hasClass(r, "pwwp__img") || z(r))) return void e.close()
            }, w.onMouseOver = function (e)
            {
                var t = (e = e || window.event).target || e.srcElement;
                k(r, "ui--over-close", z(t))
            }, w.hideControls = function ()
            {
                t.addClass(r, "pwwp__ui--hidden"), _ = !1
            }, w.showControls = function ()
            {
                _ = !0, x || w.update(), t.removeClass(r, "pwwp__ui--hidden")
            }, w.supportsFullscreen = function ()
            {
                var e = document;
                return !!(e.exitFullscreen || e.mozCancelFullScreen || e.webkitExitFullscreen || e.msExitFullscreen)
            }, w.getFullscreenAPI = function ()
            {
                var t, n = document.documentElement, r = "fullscreenchange";
                return n.requestFullscreen ? t = {
                    enterK: "requestFullscreen",
                    exitK: "exitFullscreen",
                    elementK: "fullscreenElement",
                    eventK: r
                } : n.mozRequestFullScreen ? t = {
                    enterK: "mozRequestFullScreen",
                    exitK: "mozCancelFullScreen",
                    elementK: "mozFullScreenElement",
                    eventK: "moz" + r
                } : n.webkitRequestFullscreen ? t = {
                    enterK: "webkitRequestFullscreen",
                    exitK: "webkitExitFullscreen",
                    elementK: "webkitFullscreenElement",
                    eventK: "webkit" + r
                } : n.msRequestFullscreen && (t = {
                    enterK: "msRequestFullscreen",
                    exitK: "msExitFullscreen",
                    elementK: "msFullscreenElement",
                    eventK: "MSFullscreenChange"
                }), t && (t.enter = function ()
                {
                    if (c = v.closeOnScroll, v.closeOnScroll = !1, "webkitRequestFullscreen" !== this.enterK) return e.template[this.enterK]();
                    e.template[this.enterK](Element.ALLOW_KEYBOARD_INPUT)
                }, t.exit = function ()
                {
                    return v.closeOnScroll = c, document[this.exitK]()
                }, t.isFullscreen = function ()
                {
                    return document[this.elementK]
                }), t
            }
        }
    }));
    var ub, db, pb, fb, hb, mb, vb, gb, yb, bb, wb, xb = t(cb), _b = !1;

    function Cb(e)
    {
        "string" != typeof e && (e = String(e));
        for (var t = "", n = 0; n < e.length; n++)
        {
            var r = e[n];
            switch (r)
            {
                case"<":
                    t += "&lt;";
                    break;
                case">":
                    t += "&gt;";
                    break;
                case'"':
                    t += "&quot;";
                    break;
                case"&":
                    t += "&amp;";
                    break;
                default:
                    t += r
            }
        }
        return t
    }

    function Eb(e)
    {
        var t = "";
        for (var n in e)
        {
            var r = e[n];
            null != r && (t && (t += " "), t += "-" == n[0] ? n : hb[n] || (hb[n] = n.replace(/([A-Z])/g, "-$1").toLowerCase()), t += ": ", t += r, "number" == typeof r && !1 === db.test(n) && (t += "px"), t += ";")
        }
        return t || void 0
    }

    function Sb(e, t)
    {
        for (var n in t) e[n] = t[n];
        return e
    }

    function kb(e, t)
    {
        return Array.isArray(t) ? t.reduce(kb, e) : null != t && !1 !== t && e.push(t), e
    }

    function Tb(e, t, n)
    {
        var r = function e(t, n, r, i, o, a)
        {
            if (null == t || "boolean" == typeof t) return "";
            Array.isArray(t) && (t = V().createElement(V().Fragment, null, t));
            var s = t.type, l = t.props, c = !1;
            n = n || {};
            var u, d = (r = r || {}).pretty, p = d && "string" == typeof d ? d : "\t";
            if ("object" != typeof t && !s) return Cb(t);
            if ("function" == typeof s)
            {
                if (c = !0, !r.shallow || !i && !1 !== r.renderRootComponent)
                {
                    if (s === V().Fragment)
                    {
                        var f = "", h = [];
                        kb(h, t.props.children);
                        for (var m = 0; m < h.length; m++) f += (m > 0 && d ? "\n" : "") + e(h[m], n, r, !1 !== r.shallowHighOrder, o, a);
                        return f
                    }
                    var v, g = t.__c = {__v: t, context: n, props: t.props, setState: yb, forceUpdate: yb, __h: []};
                    if (V().options.__b && V().options.__b(t), V().options.__r && V().options.__r(t), s.prototype && "function" == typeof s.prototype.render)
                    {
                        var y = s.contextType, b = y && n[y.__c], w = null != y ? b ? b.props.value : y.__ : n;
                        (g = t.__c = new s(l, w)).__v = t, g._dirty = g.__d = !0, g.props = l, null == g.state && (g.state = {}), null == g._nextState && null == g.__s && (g._nextState = g.__s = g.state), g.context = w, s.getDerivedStateFromProps ? g.state = Sb(Sb({}, g.state), s.getDerivedStateFromProps(g.props, g.state)) : g.componentWillMount && (g.componentWillMount(), g.state = g._nextState !== g.state ? g._nextState : g.__s !== g.state ? g.__s : g.state), v = g.render(g.props, g.state, g.context)
                    } else
                    {
                        var x = s.contextType, _ = x && n[x.__c], C = null != x ? _ ? _.props.value : x.__ : n;
                        v = s.call(t.__c, l, C)
                    }
                    return g.getChildContext && (n = Sb(Sb({}, n), g.getChildContext())), V().options.diffed && V().options.diffed(t), e(v, n, r, !1 !== r.shallowHighOrder, o, a)
                }
                s = (u = s).displayName || u !== Function && u.name || function (e)
                {
                    var t = (Function.prototype.toString.call(e).match(/^\s*function\s+([^( ]+)/) || "")[1];
                    if (!t)
                    {
                        for (var n = -1, r = vb.length; r--;) if (vb[r] === e)
                        {
                            n = r;
                            break
                        }
                        n < 0 && (n = vb.push(e) - 1), t = "UnnamedComponent" + n
                    }
                    return t
                }(u)
            }
            var E, S, k = "";
            if (l)
            {
                var T = Object.keys(l);
                r && !0 === r.sortAttributes && T.sort();
                for (var O = 0; O < T.length; O++)
                {
                    var M = T[O], R = l[M];
                    if ("children" !== M)
                    {
                        if (!M.match(/[\s\n\\/='"\0<>]/) && (r && r.allAttributes || "key" !== M && "ref" !== M && "__self" !== M && "__source" !== M && "defaultValue" !== M))
                        {
                            if ("className" === M)
                            {
                                if (l.class) continue;
                                M = "class"
                            } else o && M.match(/^xlink:?./) && (M = M.toLowerCase().replace(/^xlink:?/, "xlink:"));
                            if ("htmlFor" === M)
                            {
                                if (l.for) continue;
                                M = "for"
                            }
                            "style" === M && R && "object" == typeof R && (R = Eb(R)), "a" === M[0] && "r" === M[1] && "boolean" == typeof R && (R = String(R));
                            var P = r.attributeHook && r.attributeHook(M, R, n, r, c);
                            if (P || "" === P) k += P; else if ("dangerouslySetInnerHTML" === M) S = R && R.__html; else if ("textarea" === s && "value" === M) E = R; else if ((R || 0 === R || "" === R) && "function" != typeof R)
                            {
                                if (!(!0 !== R && "" !== R || (R = M, r && r.xml)))
                                {
                                    k += " " + M;
                                    continue
                                }
                                if ("value" === M)
                                {
                                    if ("select" === s)
                                    {
                                        a = R;
                                        continue
                                    }
                                    "option" === s && a == R && (k += " selected")
                                }
                                k += " " + M + '="' + Cb(R) + '"'
                            }
                        }
                    } else E = R
                }
            }
            if (d)
            {
                var z = k.replace(/^\n\s*/, " ");
                z === k || ~z.indexOf("\n") ? d && ~k.indexOf("\n") && (k += "\n") : k = z
            }
            if (k = "<" + s + k + ">", String(s).match(/[\s\n\\/='"\0<>]/)) throw new Error(s + " is not a valid HTML tag name in " + k);
            var I, A = String(s).match(gb) || r.voidElements && String(s).match(r.voidElements), L = [];
            if (S) d && fb(S) && (S = "\n" + p + pb(S, p)), k += S; else if (null != E && kb(I = [], E).length)
            {
                for (var D = d && ~k.indexOf("\n"), N = !1, F = 0; F < I.length; F++)
                {
                    var B = I[F];
                    if (null != B && !1 !== B)
                    {
                        var W = e(B, n, r, !0, "svg" === s || "foreignObject" !== s && o, a);
                        if (d && !D && fb(W) && (D = !0), W) if (d)
                        {
                            var $ = W.length > 0 && "<" != W[0];
                            N && $ ? L[L.length - 1] += W : L.push(W), N = $
                        } else L.push(W)
                    }
                }
                if (d && D) for (var H = L.length; H--;) L[H] = "\n" + p + pb(L[H], p)
            }
            if (L.length || S) k += L.join(""); else if (r && r.xml) return k.substring(0, k.length - 1) + " />";
            return !A || I || S ? (d && ~k.indexOf("\n") && (k += "\n"), k += "</" + s + ">") : k = k.replace(/>$/, " />"), k
        }(e, t, n);
        return V().options.__c && V().options.__c(e, wb), r
    }

    var Ob, Mb, Rb = {};
    try
    {
        _b || (_b = !0, ub = {}, V(), db = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|^--/i, pb = function (e, t)
        {
            return String(e).replace(/(\n+)/g, "$1" + (t || "\t"))
        }, fb = function (e, t, n)
        {
            return String(e).length > (t || 40) || !n && -1 !== String(e).indexOf("\n") || -1 !== String(e).indexOf("<")
        }, hb = {}, mb = {shallow: !0}, vb = [], gb = /^(area|base|br|col|embed|hr|img|input|link|meta|param|source|track|wbr)$/, yb = function ()
        {
        }, Tb.render = Tb, bb = function (e, t)
        {
            return Tb(e, t, mb)
        }, wb = [], Tb.shallowRender = bb, r(ub, "default", (function ()
        {
            return Tb
        })), r(ub, "shallowRender", (function ()
        {
            return bb
        })), r(ub, "renderToString", (function ()
        {
            return Tb
        })), r(ub, "renderToStaticMarkup", (function ()
        {
            return Tb
        })), r(ub, "render", (function ()
        {
            return Tb
        })), n(ub)), Ob = (Mb = ub).default || Mb
    } catch (e)
    {
        throw Error('renderToString() error: missing "preact-render-to-string" dependency.')
    }
    Rb = {renderToString: Ob, renderToStaticMarkup: Ob};
    const Pb = ({scale: e, mediaScale: t}) =>
    {
        const n = (e =>
        {
            const t = window.innerHeight / window.innerWidth, n = window.innerWidth * e;
            return {width: n, height: n * t}
        })(e), r = Math.min(n.width, n.height / t);
        return {width: r, height: r * t}
    };

    function zb({maxWidthParam: e, zoom: t, scale: n})
    {
        const r = [5760];
        "number" == typeof e && r.push(e);
        const i = Math.min(...r);
        for (let e = 100; e > 0; e -= 1)
        {
            const {width: r, height: o} = Pb({scale: t * (e / 100), mediaScale: n});
            if (r <= i) return {width: r, height: o}
        }
        return {width: i, height: i * n}
    }

    function Ib(e, t, n, r)
    {
        const {
            type: i,
            sources: o,
            alt: a,
            scale: s,
            scaleSources: l,
            transformedSrc: c,
            rioSettings: u,
            ignoreScale: d = !1
        } = e, p = function ({scaleSources: e, scaleParam: t, ignoreScale: n})
        {
            if (n) return null;
            const r = e || t;
            return r ? parseFloat(r) / 100 : null
        }({scaleSources: l, scaleParam: s, ignoreScale: d});
        if ("image" === i && null !== p)
        {
            const r = zb({maxWidthParam: e.width, zoom: Math.max(n, Wy()), scale: p}),
                i = function ({imageSizeScaledWithDPP: e, imageSizeScaled: t})
                {
                    return e.width > 0 && e.width > t.width ? t.width / e.width : 1
                }({imageSizeScaled: zb({maxWidthParam: e.width, zoom: n, scale: p}), imageSizeScaledWithDPP: r});
            return {src: c(r.width), msrc: t, w: r.width, h: r.height, maxZoom: i}
        }
        const {width: f, height: h} = Pb({scale: .8, mediaScale: null === p ? 1 : p});
        if ("video" === i)
        {
            const e = `video-${Em.v4()}`;
            return {
                rioId: e,
                html: Rb.renderToString(lt.createElement(wl, {
                    container: !0,
                    alignItems: "center",
                    justify: "center",
                    style: {width: "100%", height: "100%"}
                }, lt.createElement(wl, {
                    item: !0,
                    style: {width: f, height: h}
                }, !r && lt.createElement("iframe", {
                    id: e,
                    frameBorder: "0",
                    style: {width: "100%", height: "100%"},
                    allow: "fullscreen; accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                    allowFullScreen: "allowfullscreen",
                    src: `https://pwzcdn.com/rio-store/prod/video-player/index.html?payload=${encodeURIComponent(JSON.stringify({
                        ...u,
                        sources: o,
                        autoPlay: !1,
                        poster: t
                    }))}`,
                    title: a
                }), r && lt.createElement("video", {
                    id: e,
                    controls: u.controls,
                    poster: t,
                    loop: u.loop,
                    autoPlay: !1,
                    muted: u.muted,
                    title: a,
                    playsInline: !0,
                    style: {width: "100%", height: "100%"}
                }, o.map((e => lt.createElement("source", {key: e.url, src: e.url, type: e.mimeType})))))))
            }
        }
        if ("external_video" === i)
        {
            const e = `external-video-${Em.v4()}`;
            return {
                rioId: e,
                html: Rb.renderToString(lt.createElement(wl, {
                    container: !0,
                    alignItems: "center",
                    justify: "center",
                    style: {width: "100%", height: "100%"}
                }, lt.createElement(wl, {item: !0, style: {width: f, height: h}}, lt.createElement("iframe", {
                    id: e,
                    frameBorder: "0",
                    style: {width: "100%", height: "100%"},
                    allow: "fullscreen; accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                    allowFullScreen: "allowfullscreen",
                    src: `https://pwzcdn.com/rio-store/prod/yt-player/index.html?payload=${encodeURIComponent(JSON.stringify({
                        source: o[0],
                        muted: u.muted,
                        controls: u.controls,
                        autoPlay: !1,
                        title: a || void 0
                    }))}`,
                    title: a
                }))))
            }
        }
        if ("model" === i)
        {
            const e = t;
            return {
                html: Rb.renderToString(lt.createElement(wl, {
                    container: !0,
                    alignItems: "center",
                    justify: "center",
                    style: {width: "100%", height: "100%"}
                }, lt.createElement(wl, {
                    item: !0,
                    style: {width: f, height: h}
                }, lt.createElement("iframe", {
                    style: {width: "100%", height: "100%"},
                    frameBorder: "0",
                    allow: "fullscreen; accelerometer; gyroscope",
                    allowFullScreen: "allowfullscreen",
                    src: `https://pwzcdn.com/rio-store/prod/model-viewer/index.html?src=${encodeURIComponent(o[0])}${a ? `&alt=${encodeURIComponent(a)}` : ""}${e ? `&poster=${encodeURIComponent(e)}` : ""}${u.autoRotate ? "&autorotate=true" : ""}`,
                    title: a
                }))))
            }
        }
        return {}
    }

    var Ab = (e, t, n, r, i, o) =>
    {
        const a = (t, a) =>
        {
            const s = (e =>
            {
                const t = e.childNodes, n = [];
                for (let e = 0; e < t.length; e += 1)
                {
                    const r = t[e];
                    if (1 !== r.nodeType)
                    {
                        n.push(null);
                        continue
                    }
                    const i = r.children[0];
                    "IMG" === i.tagName ? n.push(i.getAttribute("src")) : "DIV" === i.tagName && "VIDEO" === i.getAttribute("data-tagname") || "DIV" === i.tagName && "MODEL" === i.getAttribute("data-tagname") ? n.push(i.getAttribute("data-poster")) : n.push(null)
                }
                return n
            })(a), l = r.map(((e, t) => Ib(e, s[t], i, o))), c = function ({media: e, items: t})
            {
                const n = [], r = e =>
                {
                    try
                    {
                        e.destroy()
                    } catch
                    {
                    }
                }, i = new MutationObserver((() =>
                {
                    for (let e = 0; e < t.length; e += 1) if (n[e])
                    {
                        const [t, i] = n[e];
                        document.body.contains(i) || (r(t), delete n[e])
                    }
                }));
                return i.observe(document.body, {childList: !0, subtree: !0}), {
                    initVideo: (r, i) =>
                    {
                        if (!n[r])
                        {
                            const o = e[r], {rioId: a} = t[r];
                            if ("external_video" === o.type && "string" == typeof a)
                            {
                                const e = document.querySelector(`#${a}`), t = (() =>
                                {
                                    const t = e.contentWindow;
                                    return {
                                        play: () =>
                                        {
                                            t.postMessage({rioOrigin: "video-player", play: !0}, "*")
                                        }, pause: () =>
                                        {
                                            t.postMessage({rioOrigin: "video-player", pause: !0}, "*")
                                        }, destroy: () =>
                                        {
                                            t.postMessage({rioOrigin: "video-player", destroy: !0}, "*")
                                        }
                                    }
                                })();
                                n[r] = [t, e]
                            }
                            if ("video" === o.type && "string" == typeof a)
                            {
                                const e = document.querySelector(`#${a}`);
                                if (i) return void (n[r] = [e, e]);
                                const t = (() =>
                                {
                                    const t = e.contentWindow;
                                    return {
                                        play: () =>
                                        {
                                            t.postMessage({play: !0}, "*")
                                        }, pause: () =>
                                        {
                                            t.postMessage({pause: !0}, "*")
                                        }, destroy: () =>
                                        {
                                            t.postMessage({destroy: !0}, "*")
                                        }
                                    }
                                })();
                                n[r] = [t, e]
                            }
                        }
                    }, playVideo: r =>
                    {
                        for (let e = 0; e < t.length; e += 1) if (e !== r && n[e])
                        {
                            const [t] = n[e];
                            try
                            {
                                t.pause()
                            } catch
                            {
                            }
                        }
                        if (n[r] && e[r].rioSettings.autoPlay)
                        {
                            const [e] = n[r];
                            try
                            {
                                e.play()
                            } catch
                            {
                            }
                        }
                    }, destroyVideos: () =>
                    {
                        i.disconnect();
                        for (let e = 0; e < t.length; e += 1) if (n[e])
                        {
                            const [t] = n[e];
                            r(t), delete n[e]
                        }
                    }
                }
            }({media: r, items: l}), u = {
                closeEl: !0,
                captionEl: !1,
                fullscreenEl: !0,
                zoomEl: !0,
                shareEl: !1,
                counterEl: !1,
                arrowEl: !0,
                preloaderEl: !0,
                history: !1,
                galleryUID: a.getAttribute("data-pwwp-uid"),
                index: t,
                getDoubleTapZoom: (e, t) =>
                {
                    const n = "number" == typeof t.maxZoom ? t.maxZoom : 1;
                    return e || t.initialZoomLevel < .7 ? n : 1.5 * n
                }
            }, d = new lb(e.current, xb, l, u);
            d.init(), window.productWizRioLightboxOpen = !0, d.listen("unbindEvents", (() =>
            {
                const e = d.getCurrentIndex(), t = n();
                t && t.slideTo(e, 0), c.destroyVideos(), window.productWizRioLightboxOpen = !1
            })), d.listen("afterChange", (() =>
            {
                const e = d.getCurrentIndex();
                c.initVideo(e, o), c.playVideo(e)
            }))
        };
        t.setAttribute("data-pwwp-uid", 1), t.onclick = e =>
        {
            const t = (e, n) => e && (n(e) ? e : t(e.parentNode, n)), n = e || window.event;
            n.preventDefault ? n.preventDefault() : n.returnValue = !1;
            const i = n.target || n.srcElement, o = t(i, (e => e.tagName && "div" === e.tagName.toLowerCase()));
            if (!o) return;
            if (!o.id.startsWith("pwzrswiper-slide")) return;
            const s = o.parentNode, {childNodes: l} = o.parentNode;
            let c, u = 0;
            for (let e = 0; e < l.length; e += 1) if (1 === l[e].nodeType)
            {
                if (l[e] === o)
                {
                    c = u;
                    break
                }
                u += 1
            }
            return c >= 0 && "image" === r[c].type && a(c, s), !1
        }
    };

    function Lb({swiperWrapperElement: e, getSwiper: t, media: n, lightBoxZoom: r, html5Player: i})
    {
        const o = ae(null);
        return ie((() =>
        {
            Ab(o, e, t, n, r, i)
        }), [t, i, r, n, e]), lt.createElement("div", {
            style: {
                position: "absolute",
                zIndex: 2147483647
            }
        }, lt.createElement("div", {
            ref: o,
            className: "pwwp",
            tabIndex: "-1",
            role: "dialog",
            "aria-hidden": "true"
        }, lt.createElement("div", {
            id: "pwwp__bg-id",
            className: "pwwp__bg"
        }), lt.createElement("div", {className: "pwwp__scroll-wrap"}, lt.createElement("div", {className: "pwwp__container"}, lt.createElement("div", {className: "pwwp__item"}), lt.createElement("div", {className: "pwwp__item"}), lt.createElement("div", {className: "pwwp__item"})), lt.createElement("div", {className: "pwwp__ui pwwp__ui--hidden"}, lt.createElement("div", {className: "pwwp__top-bar"}, lt.createElement("div", {className: "pwwp__counter"}), lt.createElement("div", {
            className: "pwwp__button pwwp__button--close",
            title: "Close (Esc)"
        }), lt.createElement("div", {
            className: "pwwp__button pwwp__button--share",
            title: "Share"
        }), lt.createElement("div", {
            className: "pwwp__button pwwp__button--fs",
            title: "Toggle fullscreen"
        }), lt.createElement("div", {
            className: "pwwp__button pwwp__button--zoom",
            title: "Zoom in/out"
        }), lt.createElement("div", {className: "pwwp__preloader"}, lt.createElement("div", {className: "pwwp__preloader__icn"}, lt.createElement("div", {className: "pwwp__preloader__cut"}, lt.createElement("div", {className: "pwwp__preloader__donut"}))))), lt.createElement("div", {className: "pwwp__share-modal pwwp__share-modal--hidden pwwp__single-tap"}, lt.createElement("div", {className: "pwwp__share-tooltip"})), lt.createElement("div", {
            className: "pwwp__button pwwp__button--arrow--left",
            title: "Previous (arrow left)"
        }), lt.createElement("div", {
            className: "pwwp__button pwwp__button--arrow--right",
            title: "Next (arrow right)"
        }), lt.createElement("div", {className: "pwwp__caption"}, lt.createElement("div", {className: "pwwp__caption__center"}))))))
    }

    Lb.propTypes = {
        swiperWrapperElement: Zt.object.isRequired,
        getSwiper: Zt.func.isRequired,
        media: Zt.arrayOf(ib).isRequired,
        lightBoxZoom: Zt.number.isRequired
    };
    let Db = null;

    function Nb({paginationSettings: e})
    {
        const t = Fi(), n = ae(null), {
            type: r,
            size: i,
            spacing: o,
            standardColors: {selected: a, unselected: s},
            numericColors: {selectedBackground: l, unselectedBackground: c, selectedFill: u, unselectedFill: d},
            spacingFromImage: p
        } = e, f = "numeric" === r, h = f ? 8 * i : 3 * i, m = t.spacing(p), v = (({
                                                                                       width: e,
                                                                                       height: t,
                                                                                       spacing: n,
                                                                                       selectedBackground: r,
                                                                                       unselectedBackground: i,
                                                                                       selectedFill: o,
                                                                                       unselectedFill: a
                                                                                   }) => ({
            standard: `\n      .pwzrswiper-pagination-bullet {\n        margin: ${n}px;\n        width: ${e}px;\n        height: ${t}px;\n        background: ${i};\n        opacity: 1;\n      }\n      .pwzrswiper-pagination-bullet-active {\n        background: ${r};\n      }\n    `,
            numeric: `\n      .pwzrswiper-pagination-bullet {\n        outline: none;\n        width: ${e}px;\n        height: ${t}px;\n        text-align: center;\n        line-height: ${e}px;\n        font-size: ${Math.floor(.6 * e)}px;\n        color: ${a};\n        opacity: 1;\n        background: ${i};\n        margin: ${n}px;\n        user-select: none;\n      }\n      .pwzrswiper-pagination-bullet-active {\n        color: ${o};\n        background: ${r};\n      }\n    `
        }))({
            width: h,
            height: h,
            spacing: o,
            selectedBackground: f ? l : a,
            unselectedBackground: f ? c : s,
            selectedFill: u,
            unselectedFill: d
        });
        return lt.createElement(lt.Fragment, null, lt.createElement("style", null, `\n          .pwzrswiper-pagination {\n            z-index: unset !important;\n          }\n          ${v[f ? "numeric" : "standard"]}\n        `), lt.createElement("div", {
            ref: n,
            style: {display: "flex", justifyContent: "center", minHeight: Db || "initial", marginTop: m}
        }, lt.createElement(Xh, {
            handleHeight: !0, onResize: (e, t) =>
            {
                Db = t;
                const r = n.current;
                r && (r.style.minHeight = "initial")
            }
        }), lt.createElement("div", {
            style: {position: "static", marginTop: f ? 10 : 5, marginBottom: f ? 5 : 2},
            className: ka("pwzrswiper-pagination")
        })))
    }

    function Fb({rootClassName: e, border: t, slideCircular: n})
    {
        return ie((() =>
        {
            if (!t) return null;
            const {style: r, color: i, thickness: o, radius: a} = t, s = document.createElement("style");
            return s.innerHTML = `\n      .pwzrswiper-slide[data-root="${e}"]:before {\n        content: "";\n        border: ${o}px ${r} ${i};\n        border-radius: ${n ? "50%" : `${a}px`};\n        display: block;\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        box-sizing: border-box;\n        z-index: 1;\n        pointer-events: none;\n      }\n      `, document.head.appendChild(s), () =>
            {
                document.head.removeChild(s)
            }
        }), []), null
    }

    zg.use([Lg, Fg, $g, Vg]);

    class Bb extends lt.Component
    {
        constructor(e)
        {
            super(e), Wd(this, "querySelector", (e =>
            {
                var t;
                return null === (t = this.rootRef.current) || void 0 === t ? void 0 : t.querySelector(e)
            })), Wd(this, "scrollToSwiperSlide", (() =>
            {
                const e = this.querySelector(`#pwzrswiper-slide-${this.selected}`);
                e && ny(e, {time: 300})
            })), Wd(this, "mountPhotoSwipe", (() =>
            {
                const {media: e, config: {lightBox: t, lightBoxZoom: n}} = this.props;
                if (t)
                {
                    this.photoSwipeId = `photo-swipe-${Em.v4()}`;
                    const t = document.createElement("div");
                    t.id = this.photoSwipeId, document.body.appendChild(t), He(lt.createElement(Lb, {
                        swiperWrapperElement: this.querySelector("#pwzrswiper-wrapper"),
                        getSwiper: () => this.swiper,
                        media: e,
                        lightBoxZoom: n,
                        html5Player: this.html5Player
                    }), t)
                }
            })), Wd(this, "destroyPhotoSwipe", (() =>
            {
                if (this.photoSwipeId)
                {
                    const e = document.querySelector(`#${this.photoSwipeId}`);
                    e.parentNode.removeChild(e)
                }
            })), Wd(this, "initVideoPlayers", (() =>
            {
                const {media: e} = this.props;
                for (let t = 0; t < e.length; t += 1)
                {
                    const n = e[t];
                    if ("external_video" === n.type && (this.videoPlayers[t] = (() =>
                    {
                        const e = this.querySelector(`#pwzrswiper-img-frame-${t}`).contentWindow;
                        return {
                            play: () =>
                            {
                                e.postMessage({rioOrigin: "video-player", play: !0}, "*")
                            }, pause: () =>
                            {
                                e.postMessage({rioOrigin: "video-player", pause: !0}, "*")
                            }, destroy: () =>
                            {
                                e.postMessage({rioOrigin: "video-player", destroy: !0}, "*")
                            }
                        }
                    })()), "video" === n.type) if (this.html5Player)
                    {
                        const e = this.querySelector(`#pwzrswiper-img-${t}`);
                        this.videoPlayers[t] = e
                    } else this.videoPlayers[t] = (() =>
                        {
                            const e = this.querySelector(`#pwzrswiper-img-frame-${t}`).contentWindow;
                            return {
                                play: () =>
                                {
                                    e.postMessage({play: !0}, "*")
                                }, pause: () =>
                                {
                                    e.postMessage({pause: !0}, "*")
                                }, destroy: () =>
                                {
                                    e.postMessage({destroy: !0}, "*")
                                }
                            }
                        })()
                }
            })), Wd(this, "destroyVideoPlayers", (() =>
            {
                const {media: e} = this.props;
                for (let t = 0; t < e.length; t += 1) this.videoPlayers[t] && (this.html5Player ? "function" == typeof this.videoPlayers[t].destroy && this.videoPlayers[t].destroy() : this.videoPlayers[t].destroy())
            })), Wd(this, "mountVideos", (() =>
            {
                this.videoPlayers = [], this.initVideoPlayers()
            })), Wd(this, "destroyVideos", (() =>
            {
                this.destroyVideoPlayers(), delete this.videoPlayers
            })), Wd(this, "getRioMediaSettings", ((e, t) => function (e)
            {
                return Vy === JSON.stringify(e)
            }(t) ? this.calculateRioMediaSettings(e) : t)), Wd(this, "playVideo", (() =>
            {
                if (window.productWizRioLightboxOpen) return;
                const {media: e} = this.props;
                for (let t = 0; t < e.length; t += 1) t !== this.selected && this.videoPlayers[t] && this.videoPlayers[t].pause();
                if (this.videoPlayers[this.selected])
                {
                    const {rioSettings: t, type: n} = e[this.selected];
                    this.getRioMediaSettings(n, t).autoPlay && this.videoPlayers[this.selected].play()
                }
            })), Wd(this, "mountSwiper", (() =>
            {
                const {
                    onSlideChange: e,
                    config: {
                        pagination: t,
                        navigation: n,
                        keyboard: r,
                        maxHeight: i,
                        preloadNextImage: o,
                        slideTransition: a
                    },
                    config: s
                } = this.props, l = (e, t) => s[e] ? {[t]: s[e]} : {}, {paginationSettings: c} = this;
                this.swiper = new zg(this.querySelector(".pwzrswiper-container"), {
                    init: !1,
                    initialSlide: this.selected,
                    resizeObserver: !0,
                    autoHeight: !0,
                    allowTouchMove: !0,
                    preloadImages: !1,
                    simulateTouch: !1,
                    lazy: !0,
                    keyboard: {enabled: "boolean" != typeof r || r, onlyInViewport: !1},
                    pagination: !!t && {
                        el: this.querySelector(".pwzrswiper-pagination"),
                        clickable: c.clickable,
                        renderBullet: function (e, t)
                        {
                            return "numeric" === c.type ? `<span tabindex="-1" class="${t}">${e + 1}</span>` : `<span tabindex="-1" class="${t}"></span>`
                        }
                    },
                    navigation: !!n && {
                        nextEl: this.querySelector(".pwzrswiper-btn-next"),
                        prevEl: this.querySelector(".pwzrswiper-btn-prev")
                    }, ...l("slideTransition", "effect"), ...l("simulateTouch", "simulateTouch"), ...o ? {lazy: {loadPrevNext: !0}} : {}, ..."fade" === a ? {fadeEffect: {crossFade: !0}} : {}
                }), this.swiper.on("slideChange", (() =>
                {
                    this.selected = this.swiper.realIndex, this.updateSwiperContainerWidth(), e(this.selected), this.initOrReinitDriftIfNeeded(), this.playVideo()
                })), this.swiper.on("slideChangeTransitionStart", (() =>
                {
                    "string" == typeof i && this.swiper.update()
                }))
            })), Wd(this, "getSwiperContainerWrapperWidth", (() =>
            {
                const e = this.querySelector("#pwzrswiper-container-wrapper");
                return e && "number" == typeof e.clientWidth && e.clientWidth > 0 ? e.clientWidth : null
            })), Wd(this, "getMaxHeightRatio", (e => "width" === e || "square" === e ? 1 : "short" === e ? 3 / 4 : "tall" === e ? 7 / 6 : null)), Wd(this, "getSwiperContainerMaxWidth", (() =>
            {
                const {media: e, config: {maxHeight: t}} = this.props;
                if ("string" == typeof t)
                {
                    const n = parseFloat(this.getScale(e[this.selected]));
                    if (Number.isFinite(n))
                    {
                        const e = this.getMaxHeightRatio(t);
                        if ("number" == typeof e)
                        {
                            const t = 1e4 * e / n;
                            if (Number.isFinite(t))
                            {
                                const e = t.toFixed(3);
                                if (e < 100)
                                {
                                    const t = this.getSwiperContainerWrapperWidth();
                                    return "number" == typeof t ? `${Math.floor(t * (e / 100))}px` : `${e}%`
                                }
                            }
                        }
                        if (t.endsWith("px"))
                        {
                            const e = parseFloat(t);
                            if (Number.isFinite(e)) return `${Math.floor(100 * e / Math.ceil(n))}px`
                        }
                    }
                }
                return "100%"
            })), Wd(this, "updateSwiperContainerWidth", (() =>
            {
                if (this.swiper)
                {
                    const e = this.querySelector(".pwzrswiper-container");
                    if (e)
                    {
                        const t = this.getSwiperContainerWidth();
                        t !== this.swiperContainerWidth && (e.style.width = t, this.swiperContainerWidth = t)
                    }
                }
            })), Wd(this, "getSwiperContainerWidth", (() => `min(100%, ${this.getSwiperContainerMaxWidth()})`)), Wd(this, "getInitialSwiperContainerWidth", (() =>
            {
                const e = this.getSwiperContainerWidth();
                return this.swiperContainerWidth = e, e
            })), Wd(this, "destroySwiper", (() =>
            {
                if (this.swiper) try
                {
                    this.swiper.destroy()
                } catch
                {
                }
                delete this.swiper
            })), Wd(this, "initOrReinitDriftIfNeeded", (() =>
            {
                const {config: {magnify: e}, media: t} = this.props;
                if (!e) return;
                this.destroyDrift();
                const n = (Rv || (Rv = !0, Iv()), Ov).default;
                for (let e = 0; e < t.length; e += 1)
                {
                    if ("image" !== t[e].type) continue;
                    const r = this.querySelector(`#pwzrswiper-img-${e}`),
                        i = this.querySelector(`#pwzrswiper-slide-${e}`);
                    this[`drift${e}`] = new n(r, {
                        inlineContainer: i,
                        inlinePane: !0,
                        containInline: !0,
                        injectBaseStyles: !1,
                        handleTouch: !0,
                        zoomFactor: this.getMagnifyZoom()
                    })
                }
            })), Wd(this, "destroyDrift", (() =>
            {
                const {media: e} = this.props;
                for (let t = 0; t < e.length; t += 1)
                {
                    const e = this[`drift${t}`];
                    e && (e.destroy(), delete this[`drift${t}`])
                }
            })), Wd(this, "updateResponsiveImages", (() =>
            {
                const {media: e} = this.props;
                for (let t = 0; t < e.length; t += 1)
                {
                    const n = e[t], r = this.querySelector(`#pwzrswiper-img-${t}`),
                        i = Bb.generateResponsiveImage(n, this.responsiveImageWidth),
                        o = Bb.generateResponsiveImage(n, Zy(this.containerWidth * Math.max(Wy(), this.getMagnifyZoom())));
                    "video" === n.type ? r.setAttribute("poster", i) : "image" === n.type && ("string" == typeof r.className && (r.className = r.className.replace("pwzrswiper-lazy-loaded", "")), r.setAttribute(this.swiper ? "data-src" : "src", i), r.setAttribute("data-zoom", o))
                }
            })), Wd(this, "getMagnifyZoom", (() =>
            {
                const {config: {magnify: e}} = this.props;
                return e && e.zoom || 3
            })), Wd(this, "getScale", (e => e.scaleSources || e.scale)), Wd(this, "updateScaling", (e =>
            {
                for (let t = 0; t < e.length; t += 1)
                {
                    const n = e[t], r = this.querySelector(`#pwzrswiper-slide-${t}`), i = this.getScale(n);
                    r.style.paddingBottom = i
                }
            }));
            const {selected: t, config: {paginationSettings: n}, mediaDefaults: r} = e, {
                video: i,
                externalVideo: o,
                model: a
            } = r || {};
            this.selected = t, this.rootRef = lt.createRef(), this.rootClassName = `rio-${Em.v4()}`, this.paginationSettings = {
                type: "standard",
                clickable: !1,
                size: 3,
                spacing: 3,
                spacingFromImage: 0,
                standardColors: {
                    selected: Xy("standardSelectedBackground"),
                    unselected: Xy("standardUnselectedBackground")
                },
                numericColors: {
                    selectedBackground: Xy("numericSelectedBackground"),
                    unselectedBackground: Xy("numericUnselectedBackground"),
                    selectedFill: Xy("numericSelectedFill"),
                    unselectedFill: Xy("numericUnselectedFill")
                }, ...n || {}
            };
            const s = {
                video: {
                    muted: !1, autoPlay: !0, controls: !0, loop: !1, autoRotate: !0, ...{
                        html5Player: !1,
                        autoPlay: !0,
                        muted: !1,
                        controls: !0,
                        loop: !0, ...i || {}
                    }
                },
                externalVideo: {
                    muted: !1,
                    autoPlay: !0,
                    controls: !0,
                    loop: !1,
                    autoRotate: !0, ...{...Jy(), ...o || {}}
                },
                model: {
                    muted: !1,
                    autoPlay: !0,
                    controls: !0,
                    loop: !1,
                    autoRotate: !0, ...{autoRotate: !0, ...a || {}}
                }
            };
            this.html5Player = s.video.html5Player, this.calculateRioMediaSettings = e => "external_video" === e ? s.externalVideo : "model" === e ? s.model : s.video
        }

        static getPlaceholderImageWidth(e)
        {
            return qg("xl", e) ? 900 : qg("lg", e) ? 720 : qg("md", e) ? 540 : 360
        }

        static generatePlaceholderImage(e, t)
        {
            const n = Bb.getPlaceholderImageWidth(t);
            return e.transformedSrc(n)
        }

        static generateResponsiveImage(e, t)
        {
            return e.transformedSrc(t)
        }

        componentDidMount()
        {
            const {scrollIntoViewOnMount: e, config: {vertical: t}} = this.props;
            t || this.mountSwiper(), this.mountPhotoSwipe(), this.initOrReinitDriftIfNeeded(), this.mountVideos(), e && this.scrollToSwiperSlide()
        }

        shouldComponentUpdate(e)
        {
            const {selected: t} = e;
            return this.selected !== t && (this.swiper ? this.swiper.slideToLoop(t) : (this.selected = t, this.scrollToSwiperSlide())), !1
        }

        componentWillUnmount()
        {
            this.destroyVideos(), this.destroyDrift(), this.destroySwiper(), this.destroyPhotoSwipe()
        }

        render()
        {
            const {
                media: e,
                classes: t,
                width: n,
                config: {
                    pagination: r,
                    navigation: i,
                    navigationSettings: o,
                    magnify: a,
                    lightBox: s,
                    vertical: l,
                    verticalSpacing: c,
                    verticalType: u,
                    border: d,
                    slideCircular: p
                }
            } = this.props, f = l ? {display: "flex", flexDirection: "row", flexWrap: "wrap"} : {}, h = l ? {} : {
                width: this.getInitialSwiperContainerWidth(), ...a ? {
                    [a.width && "full" !== a.width && "--magnify-width"]: a.width,
                    [a.height && "full" !== a.height && "--magnify-height"]: a.height
                } : {}
            }, m = 1 === e.length, v = () =>
            {
                if (d)
                {
                    const {radius: e} = d;
                    return {borderRadius: p ? "50%" : `${e}px`, overflow: "hidden"}
                }
                return {}
            }, g = (() =>
            {
                const e = {
                    type: "oval",
                    size: 5,
                    fill: "rgba(255, 255, 255, 1)",
                    background: "rgba(0, 0, 0, 0.4)", ...o || {}
                }, {widthPx: t, heightPx: n, borderRadius: r, svgSize: i} = (() =>
                {
                    const t = 8 * e.size, n = () => t - (4 / 3 * e.size + 8 / 3),
                        r = () => t - (8 / 3 * e.size + 16 / 3), i = `${t}px`, {type: o} = e;
                    return "circle" === o ? {
                        widthPx: i,
                        heightPx: i,
                        borderRadius: "50%",
                        svgSize: r()
                    } : "square" === o ? {
                        widthPx: i,
                        heightPx: i,
                        borderRadius: "3px",
                        svgSize: r()
                    } : "rectangle" === o ? {
                        widthPx: t / 1.6 + "px",
                        heightPx: i,
                        borderRadius: "3px",
                        svgSize: n()
                    } : {widthPx: i, heightPx: 1.4 * t + "px", borderRadius: "50%", svgSize: n()}
                })();
                return {
                    position: "absolute",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: t,
                    height: n,
                    zIndex: 1,
                    borderRadius: r,
                    fill: e.fill,
                    backgroundColor: e.background,
                    svgSize: i
                }
            })();
            return lt.createElement("div", {
                ref: this.rootRef,
                id: "pwzrswiper-container-wrapper"
            }, lt.createElement(Fb, {
                slideCircular: p,
                border: d,
                rootClassName: this.rootClassName
            }), !l && lt.createElement(Xh, {
                handleWidth: !0, skipOnMount: !0, onResize: () =>
                {
                    this.updateSwiperContainerWidth()
                }
            }), lt.createElement("div", {style: {position: "relative"}}, lt.createElement("div", {
                className: ka("pwzrswiper-container", l ? null : t.containerHidden),
                style: h
            }, lt.createElement(Xh, {
                handleWidth: !0, handleHeight: !0, onResize: (r, i) =>
                {
                    const o = () =>
                    {
                        this.containerWidth = r;
                        const e = Zy(r * Wy());
                        this.responsiveImageWidth !== e && (this.responsiveImageWidth = Math.max(e, Bb.getPlaceholderImageWidth(n)), this.updateResponsiveImages())
                    };
                    if (!l && (this.swiper || this.mountSwiper(), !this.swiper.initialized))
                    {
                        const n = this.querySelector(".pwzrswiper-container");
                        n.className = n.className.replace(t.containerHidden, t.containerVisible), o(), this.swiper.init(), this.updateScaling(e), this.updateSwiperContainerWidth()
                    }
                    o(), this.swiper && this.swiper.update()
                }
            }), lt.createElement("div", {
                id: "pwzrswiper-wrapper",
                className: "pwzrswiper-wrapper",
                style: f
            }, e.map(((e, r) =>
            {
                const i = Bb.generatePlaceholderImage(e, n), {id: o, alt: d, type: p, sources: f, rioSettings: h} = e,
                    g = this.getRioMediaSettings(p, h), y = (l || r === this.selected) && g.muted && g.autoPlay,
                    b = Number.parseInt(c, 10) || 0;
                return lt.createElement("div", {
                    id: `pwzrswiper-slide-${r}`,
                    className: "pwzrswiper-slide",
                    "data-root": this.rootClassName,
                    style: {
                        cursor: s && "image" === p ? "pointer" : "default", paddingBottom: (() =>
                        {
                            if (!l) return r === this.selected ? this.getScale(e) : void 0;
                            if (!m)
                            {
                                const t = () =>
                                {
                                    const t = Number.parseFloat(this.getScale(e)) / 100 * (b / 2);
                                    return `calc((${this.getScale(e)} / 2) - ${t}px)`
                                };
                                if ("two-columns" === u) return t();
                                if ("two-columns-main" === u && r > 0) return t()
                            }
                            return this.getScale(e)
                        })(), marginBottom: (() =>
                        {
                            if (l) return `${b}px`
                        })(), width: (() =>
                        {
                            if (l)
                            {
                                if (!m)
                                {
                                    const e = () => `calc(50% - ${b / 2}px)`;
                                    if ("two-columns" === u) return e();
                                    if ("two-columns-main" === u && r > 0) return e()
                                }
                                return "100%"
                            }
                        })(), marginRight: (() =>
                        {
                            if (l && !m)
                            {
                                if ("two-columns" === u && r % 2 == 0) return `${b}px`;
                                if ("two-columns-main" === u && r % 2 != 0) return `${b}px`
                            }
                        })(), ...v()
                    },
                    key: o
                }, "video" === p && !this.html5Player && lt.createElement("div", {
                    id: `pwzrswiper-img-${r}`,
                    className: ka("pwzrswiper-lazy", t.slideExternalVideo),
                    "data-tagname": "VIDEO",
                    "data-poster": i
                }, lt.createElement("iframe", {
                    id: `pwzrswiper-img-frame-${r}`,
                    className: t.slideExternalVideoIframe,
                    frameBorder: "0",
                    allow: "fullscreen; accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                    allowFullScreen: "allowfullscreen",
                    src: `https://pwzcdn.com/rio-store/prod/video-player/index.html?payload=${encodeURIComponent(JSON.stringify({
                        ...g,
                        autoPlay: y,
                        sources: f,
                        poster: i
                    }))}`,
                    title: d
                })), "video" === p && this.html5Player && lt.createElement("video", {
                    id: `pwzrswiper-img-${r}`,
                    className: ka("pwzrswiper-lazy", t.slideVideo),
                    controls: g.controls,
                    poster: i,
                    loop: g.loop,
                    autoPlay: y,
                    muted: g.muted,
                    title: d,
                    playsInline: !0
                }, f.map((e => lt.createElement("source", {
                    key: e.url,
                    src: e.url,
                    type: e.mimeType
                })))), "model" === p && lt.createElement("div", {
                    id: `pwzrswiper-img-${r}`,
                    className: ka("pwzrswiper-lazy", t.slideModel),
                    "data-tagname": "MODEL",
                    "data-poster": i
                }, lt.createElement("iframe", {
                    className: t.slideModelIframe,
                    frameBorder: "0",
                    allow: "fullscreen; accelerometer; gyroscope",
                    allowFullScreen: "allowfullscreen",
                    src: `https://pwzcdn.com/rio-store/prod/model-viewer/index.html?src=${encodeURIComponent(f[0])}${d ? `&alt=${encodeURIComponent(d)}` : ""}&poster=${encodeURIComponent(i)}${g.autoRotate ? "&autorotate=true" : ""}`,
                    title: d
                })), "external_video" === p && lt.createElement("div", {
                    id: `pwzrswiper-img-${r}`,
                    className: ka("pwzrswiper-lazy", t.slideExternalVideo)
                }, lt.createElement("iframe", {
                    id: `pwzrswiper-img-frame-${r}`,
                    className: t.slideExternalVideoIframe,
                    frameBorder: "0",
                    allow: "fullscreen; accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                    allowFullScreen: "allowfullscreen",
                    src: `https://pwzcdn.com/rio-store/prod/yt-player/index.html?payload=${encodeURIComponent(JSON.stringify({
                        source: f[0],
                        muted: g.muted,
                        controls: g.controls,
                        autoPlay: y,
                        title: d || void 0
                    }))}`,
                    title: d
                })), "image" === p && lt.createElement("img", {
                    id: `pwzrswiper-img-${r}`,
                    className: ka("pwzrswiper-lazy", t.slideImg),
                    src: i,
                    alt: d
                }), a && "image" === p && lt.createElement(Xh, {
                    handleWidth: !0, handleHeight: !0, onResize: () =>
                    {
                        const {
                            style: e,
                            clientHeight: t,
                            clientWidth: n
                        } = this.querySelector(`#pwzrswiper-slide-${r}`);
                        "full" === a.width && (e.setProperty("--magnify-width", `${n}px`), e.setProperty("--magnify-width-full", "yes")), "full" === a.height && (e.setProperty("--magnify-height", `${t}px`), e.setProperty("--magnify-height-full", "yes"))
                    }
                }))
            })))), !l && i && e.length > 1 && lt.createElement(lt.Fragment, null, lt.createElement("style", null, "\n                  .pwzrswiper-button-disabled {\n                    opacity: 0.35;\n                    cursor: auto;\n                    pointer-events: none;\n                  }\n                "), lt.createElement("div", {
                style: g,
                className: ka("pwzrswiper-btn-next", t.arrowRight)
            }, lt.createElement("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: g.svgSize,
                height: g.svgSize,
                viewBox: "0 0 20 20"
            }, lt.createElement("path", {d: "M5.377 19.523a.675.675 0 010-.955L13.945 10 5.377 1.432a.675.675 0 11.955-.955l8.815 8.816a1 1 0 010 1.414l-8.815 8.816a.675.675 0 01-.955 0z"}))), lt.createElement("div", {
                style: g,
                className: ka("pwzrswiper-btn-prev", t.arrowLeft)
            }, lt.createElement("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: g.svgSize,
                height: g.svgSize,
                viewBox: "0 0 20 20"
            }, lt.createElement("path", {d: "M14.477.477a.675.675 0 010 .955L5.91 10l8.568 8.568a.675.675 0 11-.954.955l-8.816-8.816a1 1 0 010-1.414L13.523.477a.675.675 0 01.954 0z"}))))), !l && r && e.length > 1 && lt.createElement(Nb, {paginationSettings: this.paginationSettings}))
        }
    }

    Bb.propTypes = {
        config: rb.isRequired,
        onSlideChange: Zt.func.isRequired,
        selected: Zt.number.isRequired,
        width: Zt.string.isRequired,
        media: Zt.arrayOf(ib).isRequired,
        scrollIntoViewOnMount: Zt.bool.isRequired,
        classes: Zt.exact({
            slideImg: Zt.string.isRequired,
            slideModel: Zt.string.isRequired,
            slideModelIframe: Zt.string.isRequired,
            slideExternalVideo: Zt.string.isRequired,
            slideExternalVideoIframe: Zt.string.isRequired,
            slideVideo: Zt.string.isRequired,
            arrow: Zt.string.isRequired,
            arrowRight: Zt.string.isRequired,
            arrowLeft: Zt.string.isRequired,
            containerVisible: Zt.string.isRequired,
            containerHidden: Zt.string.isRequired
        }).isRequired
    };
    var Wb = function ()
    {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
        return function (e)
        {
            var n = t.reduceRight((function (e, t)
            {
                return t(e)
            }), e);
            return Fa(n, e)
        }
    }(Bv({
        containerVisible: {opacity: 1, transition: "opacity 0.2s ease-in-out"},
        containerHidden: {opacity: 0},
        slideImg: {position: "absolute", width: "100%", height: "auto", maxWidth: "none"},
        slideModel: {position: "absolute", width: "100%", height: "100%", maxWidth: "none"},
        slideModelIframe: {width: "100%", height: "100%"},
        slideExternalVideo: {position: "absolute", width: "100%", height: "100%", maxWidth: "none"},
        slideExternalVideoIframe: {width: "100%", height: "100%"},
        arrowRight: {right: "5px"},
        arrowLeft: {left: "5px"},
        slideVideo: {position: "absolute", width: "100%", height: "auto", maxWidth: "none"}
    }), function ()
    {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        return function (t)
        {
            var n = e.withTheme, r = void 0 !== n && n, i = e.noSSR, o = void 0 !== i && i, a = e.initialWidth;

            function s(e)
            {
                var n = Va(), i = e.theme || n, s = xr({theme: i, name: "PwzrWithWidth", props: At({}, e)}),
                    l = s.initialWidth, c = s.width, u = zt(s, ["initialWidth", "width"]), d = lt.useState(!1),
                    p = d[0], f = d[1];
                Ug((function ()
                {
                    f(!0)
                }), []);
                var h = mo(i.breakpoints.keys).reverse().reduce((function (e, t)
                {
                    var n = wd(i.breakpoints.up(t));
                    return !e && n ? t : e
                }), null), m = At({width: c || (p || o ? h : void 0) || l || a}, r ? {theme: i} : {}, {}, u);
                return void 0 === m.width ? null : lt.createElement(t, m)
            }

            return Fa(s, t), s
        }
    }())(Bb);

    function $b()
    {
        return lt.createElement("svg", {
            riocandrag: "true",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 20 20"
        }, lt.createElement("path", {
            fill: "#212b36",
            d: "M3.2 0h13.6A3.2 3.2 0 0120 3.2v13.6a3.2 3.2 0 01-3.2 3.2H3.2A3.2 3.2 0 010 16.8V3.2A3.2 3.2 0 013.2 0z",
            opacity: ".9"
        }), lt.createElement("path", {
            fill: "#c4cdd5",
            d: "M8.277 12.927V7.07l4.649 2.927-4.649 2.93zm-.134-7.235a.595.595 0 00-.32-.092c-.344 0-.623.292-.623.653v7.492c0 .119.03.235.089.337.177.309.56.41.855.224l5.954-3.747a.638.638 0 00.214-.224.673.673 0 00-.214-.897L8.144 5.691z"
        }))
    }

    function Hb()
    {
        return lt.createElement("svg", {
            riocandrag: "true",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 20 20"
        }, lt.createElement("path", {
            fill: "#212b36",
            d: "M3.2 0h13.6A3.2 3.2 0 0120 3.2v13.6a3.2 3.2 0 01-3.2 3.2H3.2A3.2 3.2 0 010 16.8V3.2A3.2 3.2 0 013.2 0z",
            opacity: ".9"
        }), lt.createElement("path", {
            fill: "#c4cdd5",
            d: "M14.139 7.816l-3.877-2.149a.54.54 0 00-.523 0L5.862 7.816a.496.496 0 00-.261.435v4.298c0 .179.1.345.261.435l3.877 2.149a.54.54 0 00.523 0l3.877-2.149a.496.496 0 00.261-.435V8.251c0-.179-.1-.345-.261-.435zM10 6.682l2.831 1.569L10 9.82 7.169 8.251 10 6.682zM6.646 9.12l2.831 1.569v3.139l-2.831-1.57V9.119zm3.877 4.709V10.69l2.831-1.569v3.138l-2.831 1.57z"
        }))
    }

    const jb = Ff((() => ({
        thumbnailImage: {width: "100%", height: "100%"},
        thumbnailPlay: {position: "absolute", top: "4px", right: "2px", width: "26px", height: "26px"},
        thumbnailButton: {position: "relative", boxSizing: "border-box"}
    })));
    const Vb = lt.forwardRef((({
                                   config: {
                                       thumbnails: {
                                           thumbnailWidth: e,
                                           thumbnailsPerRow: t,
                                           orientation: n,
                                           multiRow: r,
                                           spacing: i,
                                           fit: o,
                                           borderSelected: a,
                                           borderUnselected: s
                                       }, pagination: l
                                   },
                                   media: c,
                                   onThumbnailSelected: u,
                                   selected: d,
                                   swiperKey: p,
                                   onThumbnailsScrolled: f,
                                   onThumbnailsResized: h,
                                   isDefaultMedia: m
                               }, v) =>
    {
        const g = jb(), y = Boolean(e), b = Gy(n), [w, x] = ne(y ? e : 0), _ = ae(p), C = ae(!m), E = ce((e =>
            {
                if (e)
                {
                    if (_.current !== p && (C.current = !0, _.current = p), C.current) return void (C.current = !1);
                    ny(e, {time: 100, lockX: b, lockY: !b, scrollAllParents: !1}, (() =>
                    {
                        f()
                    }))
                }
            }), [b, f, p]), S = Va().spacing("number" == typeof i ? i : 1), k = "contain" === o || "cover" === o,
            T = le((() =>
            {
                const e = {...Qy(null), ...a || {}};
                return {
                    border: `${e.thickness}px ${e.style} ${e.color || "var(--rio-thumbnail-selection-color, rgb(0, 0, 0))"}`,
                    borderRadius: `${e.radius}px`
                }
            }), [a]), O = le((() =>
            {
                const e = {style: "solid", color: null, thickness: 1, radius: 0, ...s || {}};
                return {border: `${e.thickness}px ${e.style} ${e.color || "transparent"}`, borderRadius: `${e.radius}px`}
            }), [s]);
        return lt.createElement(wl, {
            onScroll: () =>
            {
                f()
            },
            ref: v,
            container: !0,
            direction: "row",
            justify: r ? "center" : void 0,
            alignItems: "center",
            wrap: r ? "wrap" : "nowrap",
            style: {overflow: "auto"},
            className: "rio-hide-scrollbar"
        }, lt.createElement(Xh, {
            key: p,
            handleWidth: !b,
            handleHeight: b,
            refreshMode: "debounce",
            refreshRate: 250,
            onResize: () =>
            {
                h()
            }
        }), !y && lt.createElement(Xh, {
            handleWidth: !0, onResize: e =>
            {
                const n = e / t;
                x(Math.floor(n))
            }
        }), w > 0 && c.map((({transformedSrc: e, id: t, alt: n, scale: i, type: a}, s) =>
        {
            const {width: p, height: f, widthInner: h, heightInner: m} = function ({
                                                                                       thumbnailWidth: e,
                                                                                       scale: t,
                                                                                       square: n,
                                                                                       spacing: r
                                                                                   })
                {
                    const i = e, o = e * (parseFloat(t) / 100), a = e - r, s = a * (parseFloat(t) / 100);
                    return {width: i, height: n ? i : o, widthInner: a, heightInner: n ? a : s}
                }({thumbnailWidth: w, scale: i, spacing: S, square: k}), v = Zy(w * Wy()), y = !r && !b, x = 0 === s,
                _ = s === c.length - 1, C = x || _, M = !b && C && !r, R = b && C, P = M ? p - (p - h) / 2 : p,
                z = R ? f - (f - m) / 2 : f, I = _ ? "flex-end" : "flex-start";
            return lt.createElement(wl, {
                item: !0,
                container: !0,
                ref: s === d ? E : void 0,
                key: t,
                style: {
                    minWidth: P,
                    minHeight: z,
                    width: P,
                    height: z, ...y && x ? {marginLeft: "auto"} : {}, ...y && _ ? {marginRight: "auto"} : {}
                },
                alignItems: R ? I : "center",
                justify: M ? I : "center"
            }, lt.createElement("div", {
                role: "none",
                onClick: () =>
                {
                    u(s)
                },
                onKeyPress: e =>
                {
                    "Enter" === e.key && u(s)
                },
                tabIndex: l ? -1 : s + 1,
                className: g.thumbnailButton,
                style: {width: h, height: m, ...s === d ? T : O}
            }, lt.createElement("img", {
                src: e(v),
                alt: n,
                className: g.thumbnailImage,
                style: {
                    ..."contain" === o || "cover" === o ? {objectFit: o} : {},
                    borderRadius: (s === d ? T : O).borderRadius
                }
            }), ("video" === a || "external_video" === a) && lt.createElement("div", {className: g.thumbnailPlay}, lt.createElement($b, null)), "model" === a && lt.createElement("div", {className: g.thumbnailPlay}, lt.createElement(Hb, null))))
        })))
    }));
    Vb.propTypes = {
        config: rb.isRequired,
        media: Zt.arrayOf(ib).isRequired,
        selected: Zt.number.isRequired,
        swiperKey: Zt.string.isRequired,
        onThumbnailSelected: Zt.func.isRequired,
        onThumbnailsScrolled: Zt.func.isRequired,
        onThumbnailsResized: Zt.func.isRequired,
        isDefaultMedia: Zt.bool.isRequired
    };
    const qb = Ff((() => ({root: {display: "flex"}, thumbnailsContainer: {display: "flex"}})));

    function Ub(e)
    {
        if ("bottom" === e) return "column-reverse";
        if ("top" === e) return "column";
        if ("right" === e) return "row-reverse";
        if ("left" === e) return "row";
        throw Error(`Unknown thumbnail orientation '${e}'`)
    }

    function Gb({isLrOrien: e, thumbnails: t})
    {
        return e && t.verticalOverflow ? 0 : "auto"
    }

    function Zb({isLrOrien: e, thumbnails: t})
    {
        return e ? t.container ? 100 * t.container + "%" : t.thumbnailWidth * t.thumbnailsPerRow + "px" : null
    }

    function Kb({
                    media: e,
                    config: t,
                    selected: n,
                    onSelectedChanged: r,
                    swiperKey: i,
                    isDefaultMedia: o,
                    scrollIntoViewOnMount: a,
                    mediaDefaults: s
                })
    {
        const l = jf(), c = qb(), {thumbnails: u} = t, d = !!u && Gy(u.orientation), p = e.length > 1 && u,
            f = !!p && Gy(p.orientation), h = null == p ? void 0 : p.spacingFromImage,
            m = l.spacing("number" == typeof h ? h : 1), [v, g] = ne(Gb({
                isLrOrien: d,
                thumbnails: u
            })), [y, b] = ne(Zb({isLrOrien: d, thumbnails: u})), [w, x] = ne(!1), [_, C] = ne(!1), [E, S] = ne(Em.v4());
        ie((() =>
        {
            g(Gb({isLrOrien: d, thumbnails: u})), b(Zb({isLrOrien: d, thumbnails: u})), S(Em.v4())
        }), [f, p]);
        const [k, T] = ne("100%"), O = ae(null), M = ce((() =>
        {
            if (!p.navigation) return;
            const e = O.current;
            if (e)
            {
                const t = Hy(e, f);
                C(!t.start), x(!t.end)
            }
        }), [f, p]), R = p ? {flexDirection: Ub(p.orientation)} : {flexDirection: "column"}, P = le((() =>
        {
            const e = {
                fill: "rgba(255, 255, 255, 1)",
                background: "rgba(0, 0, 0, 0.5)",
                size: 5, ...(null == p ? void 0 : p.navigationSettings) || {}
            }, t = `${l.spacing(e.size)}px`;
            return {color: e.fill, backgroundColor: e.background, width: t, height: t}
        }), [l, p]);
        return lt.createElement("div", {className: c.root, style: R}, lt.createElement(Xh, {
            handleWidth: !0,
            key: E,
            onResize: e =>
            {
                let t = y;
                f && p.container && (t = `${Math.floor(e * p.container)}px`, b(t));
                const n = `${Math.floor(e)}px`;
                T("string" == typeof t ? `calc(${n} - ${p ? `${t} - ${m}px` : "0px"})` : n)
            }
        }), p && lt.createElement("div", {
            style: f ? {
                overflowY: "auto",
                overflowX: "hidden",
                flexDirection: "column",
                alignItems: "center",
                width: y,
                height: v,
                ["margin" + ("left" === p.orientation ? "Right" : "Left")]: m,
                position: "relative",
                boxSizing: "border-box"
            } : {flexDirection: "row", marginTop: m, position: "relative", alignItems: "center"},
            className: ka("rio-hide-scrollbar", c.thumbnailsContainer)
        }, 0 !== v && p.navigation && _ && lt.createElement(_l, {
            component: "div",
            role: "none",
            size: "small",
            onClick: async () =>
            {
                const e = await jy(O.current, f, -1);
                C(!e.start), x(!e.end)
            },
            style: {...P, position: "absolute", zIndex: 1, [!f && "left"]: 0, [f && "top"]: 0}
        }, f && lt.createElement(Cm, {style: {fontSize: P.width}}), !f && lt.createElement(lm, {style: {fontSize: P.width}})), lt.createElement(Vb, {
            ref: O,
            swiperKey: i,
            config: t,
            media: e,
            selected: n,
            onThumbnailSelected: e =>
            {
                r(e)
            },
            onThumbnailsScrolled: M,
            onThumbnailsResized: () =>
            {
                M()
            },
            isDefaultMedia: o
        }), 0 !== v && p.navigation && w && lt.createElement(_l, {
            component: "div",
            role: "none",
            size: "small",
            onClick: async () =>
            {
                const e = await jy(O.current, f, 1);
                C(!e.start), x(!e.end)
            },
            style: {...P, position: "absolute", zIndex: 1, [!f && "right"]: 0, [f && "bottom"]: 0}
        }, f && lt.createElement(ym, {style: {fontSize: P.width}}), !f && lt.createElement(fm, {style: {fontSize: P.width}}))), lt.createElement("div", {
            style: f ? {
                flex: 1,
                overflow: "hidden"
            } : void 0
        }, lt.createElement("div", {style: {maxWidth: k}}, lt.createElement(Wb, {
            key: i,
            config: t,
            media: e,
            selected: n,
            onSlideChange: e =>
            {
                r(e)
            },
            scrollIntoViewOnMount: a,
            mediaDefaults: s
        }), f && p.verticalOverflow && lt.createElement(Xh, {
            handleHeight: !0, key: E, onResize: (e, t) =>
            {
                g(t)
            }
        }))))
    }

    function Yb(e, t, n)
    {
        const r = n || function ()
        {
            const {href: e} = window.location, t = wy(e, !0), {variant: n} = t.query;
            return n || null
        }();
        if (r) if (e)
        {
            const e = t.variants.find((e => e.id === r));
            if (e && e.featuredMediaIndex > -1) return e.featuredMediaIndex
        } else
        {
            const e = t.findIndex((e => e.variant === r));
            if (e > -1) return e
        }
        if (e)
        {
            const e = t.variants.find((e => !0 === e.available));
            if (e && e.featuredMediaIndex > -1) return e.featuredMediaIndex
        } else
        {
            const e = t.findIndex((e => !0 === e.available));
            if (e > -1) return e
        }
        return 0
    }

    Kb.propTypes = {
        config: rb.isRequired,
        media: Zt.arrayOf(ib).isRequired,
        selected: Zt.number.isRequired,
        onSelectedChanged: Zt.func.isRequired,
        swiperKey: Zt.string.isRequired,
        isDefaultMedia: Zt.bool.isRequired,
        scrollIntoViewOnMount: Zt.bool.isRequired
    }, (_d || (_d = !0, Cd()), xd)();
    var Xb, Jb, Qb = !1;

    function ew(e, t, n)
    {
        e.addEventListener(t, n)
    }

    function tw(e, t, n)
    {
        e.removeEventListener(t, n)
    }

    function nw(e)
    {
        let t = null;
        for (let n = 0; n < document.forms.length; n++)
        {
            const r = document.forms[n].getAttribute("action");
            r && r.indexOf("/cart/add") >= 0 && (t || (t = Jb(e)), ew(document.forms[n], "change", t))
        }
        return t
    }

    function rw(e)
    {
        for (let t = 0; t < document.forms.length; t++)
        {
            const n = document.forms[t].getAttribute("action");
            n && n.indexOf("/cart/add") >= 0 && tw(document.forms[t], "change", e)
        }
    }

    function iw()
    {
        Jb = e => t =>
        {
            !function (e, t)
            {
                try
                {
                    let n;
                    if (!(n = e.id.options && e.id.options[e.id.selectedIndex] ? e.id.options[e.id.selectedIndex] : e.id)) return;
                    t(n.value)
                } catch (e)
                {
                    console.warn(`[productwiz-rio] Error in trackViewedProductVariant: ${e.message}`)
                }
            }((t = t || window.event).currentTarget, e)
        }, r(Xb = {}, "addListeners", (function ()
        {
            return nw
        })), r(Xb, "removeListeners", (function ()
        {
            return rw
        }))
    }

    function ow()
    {
        return Qb || (Qb = !0, iw()), Xb
    }

    var aw, sw = !1;

    function lw(e)
    {
        const t = document.querySelector(".rio-current-variant");
        if (t)
        {
            console.log("rio: rio-current-variant-found");
            const n = t =>
            {
                console.log(`rio: change to variant ${t.target.value}`), e(`${t.target.value}`)
            };
            return t.addEventListener("change", n), n
        }
        return console.log("rio: rio-current-variant not found"), null
    }

    function cw(e)
    {
        const t = document.querySelector(".rio-current-variant");
        t && t.removeEventListener("change", e)
    }

    function uw()
    {
        return sw || (sw = !0, r(aw = {}, "addListeners", (function ()
        {
            return lw
        })), r(aw, "removeListeners", (function ()
        {
            return cw
        }))), aw
    }

    function dw({
                    isDefaultMedia: e,
                    mediaParam: t,
                    useFormListener: n,
                    useManualListener: r,
                    setSelectedVariant: i,
                    setSelectedMedia: o,
                    selectedVariant: a,
                    setMediaKey: s
                })
    {
        const l = ae(null), c = ce((n =>
        {
            const r = Yb(e, t, n);
            if (i(r), !e)
            {
                if (!function (e, t, n)
                {
                    const {media: r} = e[t], {media: i} = e[n];
                    if (Array.isArray(r) && Array.isArray(i))
                    {
                        const e = r.map((e => e.id)), t = i.map((e => e.id));
                        if (e.length !== t.length) return !1;
                        for (let n = 0; n < e.length; n += 1) if (e[n] !== t[n]) return !1;
                        return !0
                    }
                    return !1
                }(t, a, r))
                {
                    o(0);
                    const {variant: e} = t[r];
                    s(e)
                }
            }
        }), [e, t, a, s, o, i]);
        ie((() =>
        {
            l.current = c
        }), [c]), ie((() =>
        {
            const e = (({useFormListener: e, useManualListener: t, handleLocationChangeRef: n}) =>
            {
                if (e || t)
                {
                    const {addListeners: t} = e ? ow() : uw();
                    return t((e =>
                    {
                        n.current && n.current(e)
                    }))
                }
                const r = () =>
                {
                    n.current && n.current()
                };
                return window.addEventListener("locationchange", r), r
            })({useFormListener: n, useManualListener: r, handleLocationChangeRef: l});
            return () =>
            {
                e && (({useFormListener: e, useManualListener: t, event: n}) =>
                {
                    if (e || t)
                    {
                        const {removeListeners: t} = e ? ow() : uw();
                        t(n)
                    } else window.removeEventListener("locationchange", n)
                })({useFormListener: n, useManualListener: r, event: e})
            }
        }), [n, r])
    }

    function pw({
                    media: e,
                    mobileConfig: t,
                    desktopConfig: n,
                    breakpoint: r,
                    useFormListener: i,
                    useManualListener: o,
                    mediaDefaults: a,
                    disableNavigationWithMedia: s,
                    onSelection: l,
                    initialSelection: c
                })
    {
        const u = "object" == typeof e.media && "object" == typeof e.variants,
            d = wd(`(min-width:${"none" === r ? "0px" : r})`, {noSsr: !0}),
            p = le((() => Yb(u, e)), [c, u, e]), [f, h] = ne(p), [m, v] = ne(0), [g, y] = ne(u ? null : e[f].variant),
            b = function ({isDefaultMedia: e, mediaParam: t, config: n, disableNavigationWithMedia: r})
            {
                if (r) return n;
                if (!1 !== n.thumbnails) return n;
                const i = e => "video" === e.type || "external_video" === e.type || "model" === e.type;
                if (e)
                {
                    for (const e of t.media) if (i(e)) return {...n, navigation: !0}
                } else for (const e of t) for (const t of e.media) if (i(t)) return {...n, navigation: !0};
                return n
            }({isDefaultMedia: u, mediaParam: e, config: d ? n : t, disableNavigationWithMedia: s}),
            w = !!b.vertical && !!b.verticalHoistVariantImages;
        let x, _, C, E;
        const S = d ? "desktop" : "mobile";
        if (u) x = S, w ? (_ = `${S}-${f}`, C = [e.media[f], ...e.media.filter(((e, t) => t !== f))], E = 0) : (_ = S, C = e.media, E = f); else
        {
            x = S, _ = `${g}-${S}`, C = e[f].media, E = m
        }
        const k = function ({verticalHoistVariantImages: e, selectedVariant: t, isDefaultMedia: n})
        {
            const r = ae(null);
            return ie((() =>
            {
                r.current = t
            }), [t]), !!n && !!e && "number" == typeof r.current && r.current !== t
        }({verticalHoistVariantImages: w, selectedVariant: f, isDefaultMedia: u});
        return dw({
            isDefaultMedia: u,
            mediaParam: e,
            useFormListener: i,
            useManualListener: o,
            setSelectedVariant: h,
            setSelectedMedia: v,
            selectedVariant: f,
            setMediaKey: y
        }), lt.createElement(Kb, {
            key: x, swiperKey: _, media: C, config: b, selected: E, onSelectedChanged: e =>
            {
                u ? h(e) : v(e)
            }, scrollIntoViewOnMount: k, isDefaultMedia: u, mediaDefaults: a
        })
    }

    function fw({
                    media: e,
                    mobileConfig: t,
                    desktopConfig: n,
                    mobileDesktopConfig: r,
                    breakpoint: i,
                    useFormListener: o,
                    useManualListener: a,
                    mediaDefaults: s,
                    disableNavigationWithMedia: l,
                    onSelection: c,
                    initialSelection: u
                })
    {
        const d = !!r, p = d ? "none" : i, f = d ? r : t, h = d ? r : n;
        return lt.createElement(pw, {
            media: e,
            mobileConfig: f,
            desktopConfig: h,
            breakpoint: p,
            useFormListener: o,
            useManualListener: a,
            mediaDefaults: s,
            disableNavigationWithMedia: l,
            onSelection: c,
            initialSelection: u
        })
    }

    function hw({product: e, productRio: t, mediaSettings: n, imageFilenames: r})
    {
        return e && !t ? Yy(e) : function (e, t, n, r)
        {
            const i = Yy(e), o = i.variants.map((e =>
            {
                const o = [], a = t.find((t => t.id === e.id));
                return a && a.media.forEach((e =>
                {
                    const t = Uy(i.media, r, e);
                    t && o.push({...t, rioSettings: qy(a.id, e, n)})
                })), o.length < 1 && o.push(...i.media), {variant: e.id, available: e.available, media: o}
            }));
            return o.length < 1 ? i : o
        }(e, t, n, r)
    }

    function mw({children: e})
    {
        {
            const t = wr({overrides: {PwzrSvgIcon: {root: {width: "35px", height: "35px"}}}});
            return lt.createElement(Wa, {theme: t}, e)
        }
    }

    function vw({rio: e, onSelection: t, initialSelection: n})
    {
        const {
            product: r,
            productRio: i,
            mediaSettings: o,
            imageFilenames: a,
            useFormListener: s,
            useManualListener: l,
            config: {
                mobile: c,
                desktop: u,
                mobileDesktop: d,
                breakpoint: p,
                lightBoxBackgroundColor: f,
                thumbnailSelectionColor: h,
                video: m,
                externalVideo: v,
                model: g,
                disableNavigationWithMedia: y
            }
        } = e, b = hw({product: r, productRio: i, mediaSettings: o, imageFilenames: a});
        return lt.createElement("div", {
            style: {
                width: "100%",
                height: "auto",
                textAlign: "left"
            }
        }, lt.createElement("style", null, `\n            :root {\n              --rio-lightbox-background-color: ${f || "rgb(0, 0, 0)"};\n              --rio-thumbnail-selection-color: ${h || "rgb(0, 0, 0)"};\n            }\n          `), lt.createElement(mw, null, lt.createElement(fw, {
            media: b,
            mobileConfig: c,
            desktopConfig: u,
            mobileDesktopConfig: d,
            breakpoint: p,
            useFormListener: "boolean" == typeof s && s,
            useManualListener: "boolean" == typeof l && l,
            mediaDefaults: {video: m, externalVideo: v, model: g},
            disableNavigationWithMedia: y,
            onSelection: t,
            initialSelection: n
        })))
    }

    fw.defaultProps = {useFormListener: !1, useManualListener: !1}, fw.propTypes = {
        breakpoint: Zt.string.isRequired,
        useFormListener: Zt.bool,
        useManualListener: Zt.bool,
        mobileConfig: rb.isRequired,
        desktopConfig: rb.isRequired,
        media: Zt.oneOfType([Zt.arrayOf(Zt.exact({
            variant: Zt.string.isRequired,
            available: Zt.bool.isRequired,
            media: Zt.arrayOf(ib).isRequired
        })), Zt.exact({
            media: Zt.arrayOf(ib).isRequired,
            variants: Zt.arrayOf(Zt.exact({
                id: Zt.string.isRequired,
                featuredMediaIndex: Zt.number.isRequired,
                available: Zt.bool.isRequired
            })).isRequired
        })]).isRequired
    };
    var gw = {}, yw = Ed;
    Object.defineProperty(gw, "__esModule", {value: !0});
    var bw = void 0;
    gw.default = bw;
    var ww = yw(f);
    bw = (0, yw(nm).default)(ww.default.createElement("path", {d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"}), "Edit"), gw.default = bw;
    var xw, _w = t(gw), Cw = !1;

    function Ew()
    {
        xw = function ()
        {
            var t = this, n = {exports: this}, r = "__lodash_hash_undefined__", i = 9007199254740991,
                o = "[object Arguments]", a = "[object Function]", s = "[object Object]",
                l = /^\[object .+?Constructor\]$/, c = /^(?:0|[1-9]\d*)$/, u = {};
            u["[object Float32Array]"] = u["[object Float64Array]"] = u["[object Int8Array]"] = u["[object Int16Array]"] = u["[object Int32Array]"] = u["[object Uint8Array]"] = u["[object Uint8ClampedArray]"] = u["[object Uint16Array]"] = u["[object Uint32Array]"] = !0, u[o] = u["[object Array]"] = u["[object ArrayBuffer]"] = u["[object Boolean]"] = u["[object DataView]"] = u["[object Date]"] = u["[object Error]"] = u[a] = u["[object Map]"] = u["[object Number]"] = u[s] = u["[object RegExp]"] = u["[object Set]"] = u["[object String]"] = u["[object WeakMap]"] = !1;
            var d = "object" == typeof e && e && e.Object === Object && e,
                p = "object" == typeof self && self && self.Object === Object && self,
                f = d || p || Function("return this")(), h = "object" == typeof t && t && !t.nodeType && t,
                m = h && "object" == typeof n && n && !n.nodeType && n, v = m && m.exports === h, g = v && d.process,
                y = function ()
                {
                    try
                    {
                        var e = m && m.require && m.require("util").types;
                        return e || g && g.binding && g.binding("util")
                    } catch (e)
                    {
                    }
                }(), b = y && y.isTypedArray;

            function w(e, t, n)
            {
                switch (n.length)
                {
                    case 0:
                        return e.call(t);
                    case 1:
                        return e.call(t, n[0]);
                    case 2:
                        return e.call(t, n[0], n[1]);
                    case 3:
                        return e.call(t, n[0], n[1], n[2])
                }
                return e.apply(t, n)
            }

            var x, _, C, E = Array.prototype, S = Function.prototype, k = Object.prototype, T = f["__core-js_shared__"],
                O = S.toString, M = k.hasOwnProperty,
                R = (x = /[^.]+$/.exec(T && T.keys && T.keys.IE_PROTO || "")) ? "Symbol(src)_1." + x : "",
                P = k.toString, z = O.call(Object),
                I = RegExp("^" + O.call(M).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
                A = v ? f.Buffer : void 0, L = f.Symbol, D = f.Uint8Array, N = A ? A.allocUnsafe : void 0,
                F = (_ = Object.getPrototypeOf, C = Object, function (e)
                {
                    return _(C(e))
                }), B = Object.create, W = k.propertyIsEnumerable, $ = E.splice, H = L ? L.toStringTag : void 0,
                j = function ()
                {
                    try
                    {
                        var e = he(Object, "defineProperty");
                        return e({}, "", {}), e
                    } catch (e)
                    {
                    }
                }(), V = A ? A.isBuffer : void 0, q = Math.max, U = Date.now, G = he(f, "Map"),
                Z = he(Object, "create"), K = function ()
                {
                    function e()
                    {
                    }

                    return function (t)
                    {
                        if (!ke(t)) return {};
                        if (B) return B(t);
                        e.prototype = t;
                        var n = new e;
                        return e.prototype = void 0, n
                    }
                }();

            function Y(e)
            {
                var t = -1, n = null == e ? 0 : e.length;
                for (this.clear(); ++t < n;)
                {
                    var r = e[t];
                    this.set(r[0], r[1])
                }
            }

            function X(e)
            {
                var t = -1, n = null == e ? 0 : e.length;
                for (this.clear(); ++t < n;)
                {
                    var r = e[t];
                    this.set(r[0], r[1])
                }
            }

            function J(e)
            {
                var t = -1, n = null == e ? 0 : e.length;
                for (this.clear(); ++t < n;)
                {
                    var r = e[t];
                    this.set(r[0], r[1])
                }
            }

            function Q(e)
            {
                var t = this.__data__ = new X(e);
                this.size = t.size
            }

            function ee(e, t)
            {
                var n = xe(e), r = !n && we(e), i = !n && !r && Ce(e), o = !n && !r && !i && Oe(e),
                    a = n || r || i || o, s = a ? function (e, t)
                    {
                        for (var n = -1, r = Array(e); ++n < e;) r[n] = t(n);
                        return r
                    }(e.length, String) : [], l = s.length;
                for (var c in e) !t && !M.call(e, c) || a && ("length" == c || i && ("offset" == c || "parent" == c) || o && ("buffer" == c || "byteLength" == c || "byteOffset" == c) || me(c, l)) || s.push(c);
                return s
            }

            function te(e, t, n)
            {
                (void 0 !== n && !be(e[t], n) || void 0 === n && !(t in e)) && ie(e, t, n)
            }

            function ne(e, t, n)
            {
                var r = e[t];
                M.call(e, t) && be(r, n) && (void 0 !== n || t in e) || ie(e, t, n)
            }

            function re(e, t)
            {
                for (var n = e.length; n--;) if (be(e[n][0], t)) return n;
                return -1
            }

            function ie(e, t, n)
            {
                "__proto__" == t && j ? j(e, t, {configurable: !0, enumerable: !0, value: n, writable: !0}) : e[t] = n
            }

            Y.prototype.clear = function ()
            {
                this.__data__ = Z ? Z(null) : {}, this.size = 0
            }, Y.prototype.delete = function (e)
            {
                var t = this.has(e) && delete this.__data__[e];
                return this.size -= t ? 1 : 0, t
            }, Y.prototype.get = function (e)
            {
                var t = this.__data__;
                if (Z)
                {
                    var n = t[e];
                    return n === r ? void 0 : n
                }
                return M.call(t, e) ? t[e] : void 0
            }, Y.prototype.has = function (e)
            {
                var t = this.__data__;
                return Z ? void 0 !== t[e] : M.call(t, e)
            }, Y.prototype.set = function (e, t)
            {
                var n = this.__data__;
                return this.size += this.has(e) ? 0 : 1, n[e] = Z && void 0 === t ? r : t, this
            }, X.prototype.clear = function ()
            {
                this.__data__ = [], this.size = 0
            }, X.prototype.delete = function (e)
            {
                var t = this.__data__, n = re(t, e);
                return !(n < 0) && (n == t.length - 1 ? t.pop() : $.call(t, n, 1), --this.size, !0)
            }, X.prototype.get = function (e)
            {
                var t = this.__data__, n = re(t, e);
                return n < 0 ? void 0 : t[n][1]
            }, X.prototype.has = function (e)
            {
                return re(this.__data__, e) > -1
            }, X.prototype.set = function (e, t)
            {
                var n = this.__data__, r = re(n, e);
                return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this
            }, J.prototype.clear = function ()
            {
                this.size = 0, this.__data__ = {hash: new Y, map: new (G || X), string: new Y}
            }, J.prototype.delete = function (e)
            {
                var t = fe(this, e).delete(e);
                return this.size -= t ? 1 : 0, t
            }, J.prototype.get = function (e)
            {
                return fe(this, e).get(e)
            }, J.prototype.has = function (e)
            {
                return fe(this, e).has(e)
            }, J.prototype.set = function (e, t)
            {
                var n = fe(this, e), r = n.size;
                return n.set(e, t), this.size += n.size == r ? 0 : 1, this
            }, Q.prototype.clear = function ()
            {
                this.__data__ = new X, this.size = 0
            }, Q.prototype.delete = function (e)
            {
                var t = this.__data__, n = t.delete(e);
                return this.size = t.size, n
            }, Q.prototype.get = function (e)
            {
                return this.__data__.get(e)
            }, Q.prototype.has = function (e)
            {
                return this.__data__.has(e)
            }, Q.prototype.set = function (e, t)
            {
                var n = this.__data__;
                if (n instanceof X)
                {
                    var r = n.__data__;
                    if (!G || r.length < 199) return r.push([e, t]), this.size = ++n.size, this;
                    n = this.__data__ = new J(r)
                }
                return n.set(e, t), this.size = n.size, this
            };
            var oe, ae = function (e, t, n)
            {
                for (var r = -1, i = Object(e), o = n(e), a = o.length; a--;)
                {
                    var s = o[oe ? a : ++r];
                    if (!1 === t(i[s], s, i)) break
                }
                return e
            };

            function se(e)
            {
                return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : H && H in Object(e) ? function (e)
                {
                    var t = M.call(e, H), n = e[H];
                    try
                    {
                        e[H] = void 0;
                        var r = !0
                    } catch (e)
                    {
                    }
                    var i = P.call(e);
                    r && (t ? e[H] = n : delete e[H]);
                    return i
                }(e) : function (e)
                {
                    return P.call(e)
                }(e)
            }

            function le(e)
            {
                return Te(e) && se(e) == o
            }

            function ce(e)
            {
                return !(!ke(e) || function (e)
                {
                    return !!R && R in e
                }(e)) && (Ee(e) ? I : l).test(function (e)
                {
                    if (null != e)
                    {
                        try
                        {
                            return O.call(e)
                        } catch (e)
                        {
                        }
                        try
                        {
                            return e + ""
                        } catch (e)
                        {
                        }
                    }
                    return ""
                }(e))
            }

            function ue(e)
            {
                if (!ke(e)) return function (e)
                {
                    var t = [];
                    if (null != e) for (var n in Object(e)) t.push(n);
                    return t
                }(e);
                var t = ve(e), n = [];
                for (var r in e) ("constructor" != r || !t && M.call(e, r)) && n.push(r);
                return n
            }

            function de(e, t, n, r, i)
            {
                e !== t && ae(t, (function (o, a)
                {
                    if (i || (i = new Q), ke(o)) !function (e, t, n, r, i, o, a)
                    {
                        var l = ge(e, n), c = ge(t, n), u = a.get(c);
                        if (u) return void te(e, n, u);
                        var d = o ? o(l, c, n + "", e, t, a) : void 0, p = void 0 === d;
                        if (p)
                        {
                            var f = xe(c), h = !f && Ce(c), m = !f && !h && Oe(c);
                            d = c, f || h || m ? xe(l) ? d = l : Te(w = l) && _e(w) ? d = function (e, t)
                            {
                                var n = -1, r = e.length;
                                t || (t = Array(r));
                                for (; ++n < r;) t[n] = e[n];
                                return t
                            }(l) : h ? (p = !1, d = function (e, t)
                            {
                                if (t) return e.slice();
                                var n = e.length, r = N ? N(n) : new e.constructor(n);
                                return e.copy(r), r
                            }(c, !0)) : m ? (p = !1, v = c, g = !0 ? (y = v.buffer, b = new y.constructor(y.byteLength), new D(b).set(new D(y)), b) : v.buffer, d = new v.constructor(g, v.byteOffset, v.length)) : d = [] : function (e)
                            {
                                if (!Te(e) || se(e) != s) return !1;
                                var t = F(e);
                                if (null === t) return !0;
                                var n = M.call(t, "constructor") && t.constructor;
                                return "function" == typeof n && n instanceof n && O.call(n) == z
                            }(c) || we(c) ? (d = l, we(l) ? d = function (e)
                            {
                                return function (e, t, n, r)
                                {
                                    var i = !n;
                                    n || (n = {});
                                    var o = -1, a = t.length;
                                    for (; ++o < a;)
                                    {
                                        var s = t[o], l = r ? r(n[s], e[s], s, n, e) : void 0;
                                        void 0 === l && (l = e[s]), i ? ie(n, s, l) : ne(n, s, l)
                                    }
                                    return n
                                }(e, Me(e))
                            }(l) : ke(l) && !Ee(l) || (d = function (e)
                            {
                                return "function" != typeof e.constructor || ve(e) ? {} : K(F(e))
                            }(c))) : p = !1
                        }
                        var v, g, y, b;
                        var w;
                        p && (a.set(c, d), i(d, c, r, o, a), a.delete(c));
                        te(e, n, d)
                    }(e, t, a, n, de, r, i); else
                    {
                        var l = r ? r(ge(e, a), o, a + "", e, t, i) : void 0;
                        void 0 === l && (l = o), te(e, a, l)
                    }
                }), Me)
            }

            function pe(e, t)
            {
                return ye(function (e, t, n)
                {
                    return t = q(void 0 === t ? e.length - 1 : t, 0), function ()
                    {
                        for (var r = arguments, i = -1, o = q(r.length - t, 0), a = Array(o); ++i < o;) a[i] = r[t + i];
                        i = -1;
                        for (var s = Array(t + 1); ++i < t;) s[i] = r[i];
                        return s[t] = n(a), w(e, this, s)
                    }
                }(e, t, ze), e + "")
            }

            function fe(e, t)
            {
                var n, r, i = e.__data__;
                return ("string" == (r = typeof (n = t)) || "number" == r || "symbol" == r || "boolean" == r ? "__proto__" !== n : null === n) ? i["string" == typeof t ? "string" : "hash"] : i.map
            }

            function he(e, t)
            {
                var n = function (e, t)
                {
                    return null == e ? void 0 : e[t]
                }(e, t);
                return ce(n) ? n : void 0
            }

            function me(e, t)
            {
                var n = typeof e;
                return !!(t = null == t ? i : t) && ("number" == n || "symbol" != n && c.test(e)) && e > -1 && e % 1 == 0 && e < t
            }

            function ve(e)
            {
                var t = e && e.constructor;
                return e === ("function" == typeof t && t.prototype || k)
            }

            function ge(e, t)
            {
                if (("constructor" !== t || "function" != typeof e[t]) && "__proto__" != t) return e[t]
            }

            var ye = function (e)
            {
                var t = 0, n = 0;
                return function ()
                {
                    var r = U(), i = 16 - (r - n);
                    if (n = r, i > 0)
                    {
                        if (++t >= 800) return arguments[0]
                    } else t = 0;
                    return e.apply(void 0, arguments)
                }
            }(j ? function (e, t)
            {
                return j(e, "toString", {
                    configurable: !0, enumerable: !1, value: (n = t, function ()
                    {
                        return n
                    }), writable: !0
                });
                var n
            } : ze);

            function be(e, t)
            {
                return e === t || e != e && t != t
            }

            var we = le(function ()
            {
                return arguments
            }()) ? le : function (e)
            {
                return Te(e) && M.call(e, "callee") && !W.call(e, "callee")
            }, xe = Array.isArray;

            function _e(e)
            {
                return null != e && Se(e.length) && !Ee(e)
            }

            var Ce = V || function ()
            {
                return !1
            };

            function Ee(e)
            {
                if (!ke(e)) return !1;
                var t = se(e);
                return t == a || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t
            }

            function Se(e)
            {
                return "number" == typeof e && e > -1 && e % 1 == 0 && e <= i
            }

            function ke(e)
            {
                var t = typeof e;
                return null != e && ("object" == t || "function" == t)
            }

            function Te(e)
            {
                return null != e && "object" == typeof e
            }

            var Oe = b ? function (e)
            {
                return function (t)
                {
                    return e(t)
                }
            }(b) : function (e)
            {
                return Te(e) && Se(e.length) && !!u[se(e)]
            };

            function Me(e)
            {
                return _e(e) ? ee(e, !0) : ue(e)
            }

            var Re, Pe = (Re = function (e, t, n)
            {
                de(e, t, n)
            }, pe((function (e, t)
            {
                var n = -1, r = t.length, i = r > 1 ? t[r - 1] : void 0, o = r > 2 ? t[2] : void 0;
                for (i = Re.length > 3 && "function" == typeof i ? (r--, i) : void 0, o && function (e, t, n)
                {
                    if (!ke(n)) return !1;
                    var r = typeof t;
                    return !!("number" == r ? _e(n) && me(t, n.length) : "string" == r && t in n) && be(n[t], e)
                }(t[0], t[1], o) && (i = r < 3 ? void 0 : i, r = 1), e = Object(e); ++n < r;)
                {
                    var a = t[n];
                    a && Re(e, a, n, i)
                }
                return e
            })));

            function ze(e)
            {
                return e
            }

            return n.exports = Pe, n.exports
        }.call({})
    }

    let Sw;

    function kw(e)
    {
        return "lightbox-background-color" === e || "thumbnail-selection-color" === e ? "rgb(0, 0, 0)" : "border-colors-double" === e ? "rgb(255, 255, 255)" : "border-colors-selected" === e ? "rgb(50, 50, 50)" : "border-colors-unselected" === e ? "rgb(220, 220, 220)" : "border-colors-hovering" === e ? "rgb(100, 100, 100)" : "border-colors-outOfStockCrossOut" === e ? "rgb(25, 25, 25)" : "tooltip-background-color" === e ? "rgba(97, 97, 97)" : "swatch-selected-background-color" === e ? null : "swatch-background-color" === e ? "rgb(255, 255, 255)" : "alert-background-color" === e ? "rgb(237, 247, 237)" : "tooltip-text-color" === e || "unselected-background-color" === e ? "rgb(255, 255, 255)" : "unselected-text-color" === e ? "rgb(0, 0, 0)" : "select-background-color" === e ? "rgb(255, 255, 255)" : "select-text-color" === e || "selected-background-color" === e ? "rgb(0, 0, 0)" : "selected-text-color" === e ? "rgb(255, 255, 255)" : e.endsWith("-background-color") || e.endsWith("-border-color") ? null : "rgb(0, 0, 0)"
    }

    function Tw(e)
    {
        return "swatch-text-size" === e || "swatch-title-text-size" === e ? 14 : "title-text-size" === e ? 18 : "subtitle-text-size" === e ? 16 : "alert-text-size" === e ? 18 : "tooltip-text-size" === e || "selected-text-size" === e ? 14 : "select-text-size" === e ? 16 : "unselected-text-size" === e ? 14 : 18
    }

    function Ow(e)
    {
        return "tooltip-text-padding" === e ? [8, 8, 4, 4] : "swatch-title-text-padding" === e ? [3, 3, 2, 2] : "swatch-text-padding" === e ? [0, 0, 0, 0] : [5, 5, 2, 5]
    }

    function Mw(e)
    {
        return "swatch-title-margin" === e ? [0, 0, 2, 2] : [0, 0, 5, 5]
    }

    function Rw(e)
    {
        return "border-thickness-double" === e ? 3 : 1
    }

    function Pw(e)
    {
        return "border-radius-px" === e ? 4 : 18
    }

    function zw()
    {
        return {
            title: {
                enabled: !0,
                text: null,
                textBold: !1,
                textUppercase: !1,
                textColor: kw("title-text-color"),
                textSize: Tw("title-text-size"),
                textPadding: Ow("title-text-padding"),
                backgroundColor: null,
                borderColor: kw("title-border-color"),
                borderStyle: "solid",
                borderThickness: Rw("title-border-thickness"),
                borderRadius: Pw("title-border-radius"),
                position: ["above", 1],
                margin: Mw("title-margin")
            },
            subtitle: {
                enabled: !0,
                text: null,
                textBold: !1,
                textUppercase: !1,
                textColor: kw("subtitle-text-color"),
                textSize: Tw("subtitle-text-size"),
                textPadding: Ow("subtitle-text-padding"),
                backgroundColor: null,
                borderColor: kw("subtitle-border-color"),
                borderStyle: "solid",
                borderThickness: Rw("subtitle-border-thickness"),
                borderRadius: Pw("subtitle-border-radius"),
                position: ["below", 1],
                margin: Mw("subtitle-margin")
            },
            alert: {
                enabled: !0,
                text: null,
                textBold: !1,
                textUppercase: !1,
                textColor: kw("alert-text-color"),
                textSize: Tw("alert-text-size"),
                textPadding: Ow("alert-text-padding"),
                backgroundColor: kw("alert-background-color"),
                borderColor: kw("alert-border-color"),
                borderStyle: "solid",
                borderThickness: Rw("alert-border-thickness"),
                borderRadius: Pw("alert-border-radius"),
                position: ["above", 1],
                margin: Mw("alert-margin")
            }
        }
    }

    function Iw(e, t)
    {
        const n = Array.isArray(t) ? t : [];
        return e.map((e =>
        {
            const t = n.findIndex((t => t.id === e)), r = t > -1 ? n[t] : void 0;
            return {
                id: e,
                name: e,
                config: Sw({
                    text: null,
                    textBold: !1,
                    textUppercase: !1,
                    textColor: kw("swatch-text-color"),
                    textSize: Tw("swatch-text-size"),
                    textPadding: Ow("swatch-text-padding"),
                    backgroundImage: null,
                    backgroundPosition: "left",
                    backgroundSize: 100,
                    backgroundSizePx: 24,
                    backgroundBorderRadius: 18,
                    backgroundType: "one-solid",
                    backgroundColor: kw("swatch-background-color"),
                    backgroundColor2: kw("swatch-background-color"),
                    backgroundColor3: kw("swatch-background-color"),
                    backgroundColor4: kw("swatch-background-color"),
                    selectedBackgroundColor: kw("swatch-selected-background-color"), ...zw(),
                    tooltip: {
                        enabled: !0,
                        text: null,
                        textBold: !1,
                        textUppercase: !1,
                        textColor: kw("tooltip-text-color"),
                        textSize: Tw("tooltip-text-size"),
                        textPadding: Ow("tooltip-text-padding"),
                        backgroundColor: kw("tooltip-background-color"),
                        position: ["below"]
                    }
                }, r ? r.config : {})
            }
        }))
    }

    function Aw(e, t)
    {
        return t.options.map(((t, n) => ({id: e.options[n].name, value: t})))
    }

    function Lw(e, t, n = null)
    {
        const r = t[e], i = !(!r.enabled || !r.text);
        if (!n) return [i];
        const [o, a] = r.position;
        return [i && o === n, a]
    }

    Cw || (Cw = !0, Ew()), Sw = xw;
    const Dw = ["title", "subtitle", "alert"];
    const Nw = lt.createContext("product-options");
    const Fw = {
        "one-solid": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR1%" d="M0 0.176H120V120.176H0z"></path></svg>',
        "two-columns": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR1%" d="M0 0H120V120H0z"></path><path fill="%COLOR2%" d="M60 0H120V120H60z"></path></svg>',
        "two-rows": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR1%" d="M120 0H240V120H120z" transform="rotate(90 120 0)"></path><path fill="%COLOR2%" d="M120 60H180V180H120z" transform="rotate(90 120 60)"></path></svg>',
        "two-diagonal-downside": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR2%" d="M0 0H120V120H0z"></path><path fill="%COLOR1%" d="M0 0l120 120V0H0z"></path></svg>',
        "two-diagonal-upside": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR2%" d="M0 120H120V240H0z" transform="rotate(-90 0 120)"></path><path fill="%COLOR1%" d="M0 120L120 0H0v120z"></path></svg>',
        "three-column": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR1%" d="M0 0H120V120H0z"></path><path fill="%COLOR2%" d="M40 0H120V120H40z"></path><path fill="%COLOR3%" d="M80 0H120V120H80z"></path></svg>',
        "three-rows": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR1%" d="M120 0H240V120H120z" transform="rotate(90 120 0)"></path><path fill="%COLOR2%" d="M120 40H200V160H120z" transform="rotate(90 120 40)"></path><path fill="%COLOR3%" d="M120 80H160V200H120z" transform="rotate(90 120 80)"></path></svg>',
        "three-triangles": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR1%" d="M0 0H120V120H0z"></path><path fill="%COLOR2%" d="M60 0H120V120H60z"></path><path fill="%COLOR3%" d="M60 60l60 60H0l60-60z"></path></svg>',
        "three-triangles-circle": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR1%" d="M120 0H240V120H120z" transform="rotate(90 120 0)"></path><path fill="%COLOR2%" d="M120 0H240V60H120z" transform="rotate(90 120 0)"></path><path fill="%COLOR3%" d="M120 120H0V93.846L60 60l60 34.872V120z"></path></svg>',
        "three-diagonal-downside": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR2%" d="M0 0H120V120H0z"></path><path fill="%COLOR1%" d="M40 0l80 80V0H40z"></path><path fill="%COLOR3%" d="M80 120L0 40v80h80z"></path></svg>',
        "three-diagonal-upside": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR2%" d="M120 0H240V120H120z" transform="rotate(90 120 0)"></path><path fill="%COLOR3%" d="M120 40l-80 80h80V40z"></path><path fill="%COLOR1%" d="M0 80L80 0H0v80z"></path></svg>',
        "four-triangles": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR1%" d="M0 0H120V120H0z"></path><path fill="%COLOR2%" d="M0 0l120 120V0H0z"></path><path fill="%COLOR3%" d="M120 0L0 120h120V0z"></path><path fill="%COLOR4%" d="M60 60l60 60H0l60-60z"></path></svg>',
        "four-squares": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR1%" d="M0 0H120V119.008H0z"></path><path fill="%COLOR2%" d="M60 0H120V119.008H60z"></path><path fill="%COLOR3%" d="M120 60.496H179.504V180.496H120z" transform="rotate(90 120 60.496)"></path><path fill="%COLOR4%" d="M0 60.496H60V119.999H0z"></path></svg>',
        "four-columns": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR1%" d="M0 0H120V120H0z"></path><path fill="%COLOR2%" d="M30 0H120V120H30z"></path><path fill="%COLOR3%" d="M60 0H120V120H60z"></path><path fill="%COLOR4%" d="M90 0H120V120H90z"></path></svg>',
        "four-rows": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR1%" d="M120 0H240V120H120z" transform="rotate(90 120 0)"></path><path fill="%COLOR2%" d="M120 30H210V150H120z" transform="rotate(90 120 30)"></path><path fill="%COLOR3%" d="M120 60H180V180H120z" transform="rotate(90 120 60)"></path><path fill="%COLOR4%" d="M120 90H150V210H120z" transform="rotate(90 120 90)"></path></svg>',
        "four-diagonal-downside": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR1%" d="M120 0H240V120H120z" transform="rotate(90 120 0)"></path><path fill="%COLOR2%" fill-rule="evenodd" d="M120 120V60L60 0H0v120h120z" clip-rule="evenodd"></path><path fill="%COLOR3%" d="M120 120L0 0v120h120z"></path><path fill="%COLOR4%" d="M60 120L0 60v60h60z"></path></svg>',
        "four-diagonal-upside": '<svg xmlns="http://www.w3.org/2000/svg" width="%SIZE%" height="%SIZE%" fill="none" viewBox="0 0 120 120" data-reactroot=""><path fill="%COLOR1%" d="M0 0H120V120H0z"></path><path fill="%COLOR2%" fill-rule="evenodd" d="M0 0v120h120V0H60L0 60V0z" clip-rule="evenodd"></path><path fill="%COLOR3%" d="M120 0L0 120h120V0z"></path><path fill="%COLOR4%" d="M120 60l-60 60h60V60z"></path></svg>'
    };
    ja((e => ({
        button: {width: 50, height: 50, filter: "brightness(1.1)", cursor: "pointer"},
        buttonSelected: {outline: "solid 2px"},
        buttonHovering: {filter: "brightness(1.3)"}
    })));
    const Bw = lt.createContext("assets");

    function Ww(e)
    {
        const t = function ()
        {
            if (window.__productWizRio && window.__productWizRioProductOptionsSettings && window.__productWizRioProductOptionsSettings.productOptionsCenteredOnMobile)
            {
                const {config: {breakpoint: e}} = window.__productWizRio;
                return e
            }
            return "none"
        }(), n = wd(`(min-width:${"none" === t ? "0px" : t})`, {noSsr: !0});
        return "none" === t ? e.centered : !n || e.centered
    }

    function $w(e, t, n)
    {
        if ("string" != typeof e) return null;
        let r = e;
        return null !== t && (r = r.replace(/%P%/g, function (e, t)
        {
            "string" == typeof e && (e = e.replace(".", ""));
            var n = "", r = /\{\{\s*(\w+)\s*\}\}/, i = t || "${{amount}}";

            function o(e, t, n, r)
            {
                if (n = n || ",", r = r || ".", isNaN(e) || null === e) return 0;
                var i = (e = (e / 100).toFixed(t)).split(".");
                return i[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + n) + (i[1] ? r + i[1] : "")
            }

            switch (i.match(r)[1])
            {
                case"amount":
                    n = o(e, 2);
                    break;
                case"amount_no_decimals":
                    n = o(e, 0);
                    break;
                case"amount_with_comma_separator":
                    n = o(e, 2, ".", ",");
                    break;
                case"amount_no_decimals_with_comma_separator":
                    n = o(e, 0, ".", ",");
                    break;
                case"amount_no_decimals_with_space_separator":
                    n = o(e, 0, " ");
                    break;
                case"amount_with_apostrophe_separator":
                    n = o(e, 2, "'")
            }
            return i.replace(r, n)
        }(t, function ()
        {
            var e;
            const t = null === (e = window.__productWizRio) || void 0 === e ? void 0 : e.moneyFormat;
            return "string" == typeof t ? t : null
        }()))), "string" == typeof n && (r = r.replace(/%N%/g, n)), r
    }

    function Hw({selected: e, hovering: t, borderSelectedColor: n, borderUnselectedColor: r, borderHoverColor: i})
    {
        const o = e ? n : t ? i : r;
        return o || "transparent"
    }

    const jw = ja((() => ({
        tooltip: {
            backgroundColor: "var(--rio-tooltip-background-color)",
            color: "var(--rio-tooltip-text-color)",
            boxShadow: "none",
            fontSize: "var(--rio-tooltip-text-size)",
            padding: "var(--rio-tooltip-padding)"
        }, arrow: {color: "var(--rio-tooltip-background-color)"}
    })));

    function Vw({outOfStockTooltip: e, value: t, children: n, available: r, name: i, price: o})
    {
        jw();
        const a = le((() => `rio-tooltip-${Em.v4()}`), []), {
            config: {
                tooltip: {
                    enabled: s,
                    text: l,
                    textSize: c,
                    textBold: u,
                    textUppercase: d,
                    textColor: p,
                    textPadding: f,
                    backgroundColor: h,
                    position: [m]
                }
            }
        } = t, v = e && !r, g = !(!l || !s), y = g || v, b = le((() => function ()
        {
            const e = window.__productWizRioProductOptionsSettings;
            return "object" == typeof e && null !== e && "string" == typeof e.outOfStockI18n ? e.outOfStockI18n : "Out of stock"
        }()), []), w = g && v ? `${l} - ${b}` : v ? b : g ? l : null;
        return ie((() =>
        {
            const e = `\n        .${a}-tooltip {\n          background-color: ${h};\n          color: ${p};\n          box-shadow: none;\n          font-size: ${c}px;\n          font-weight: ${u ? "bold" : "normal"};\n          text-transform: ${d ? "uppercase" : "none"};\n          padding: ${f[2]}px ${f[1]}px ${f[3]}px ${f[0]}px;\n        }\n        .${a}-arrow {\n          color: ${h};\n        }\n      `,
                t = document.createElement("style");
            return t.textContent = e, document.head.appendChild(t), () =>
            {
                document.head.removeChild(t)
            }
        }), [h, u, d, p, f, c, a]), y ? lt.createElement(bd, {
            classes: {tooltip: `${a}-tooltip`, arrow: `${a}-arrow`},
            title: $w(w, o, i),
            arrow: !0,
            placement: "above" === m ? "top" : "bottom"
        }, n) : n
    }

    function qw({text: e, config: t})
    {
        const {
            textBold: n,
            textUppercase: r,
            textSize: i,
            textColor: o,
            backgroundColor: a,
            textPadding: [s, l, c, u],
            borderStyle: d,
            borderColor: p,
            borderRadius: f,
            borderThickness: h,
            margin: [, , m, v],
            position: [g],
            useThemeSettings: y
        } = t;
        return lt.createElement(wl, {
            item: !0,
            container: !0,
            direction: "column"
        }, "below" === g && lt.createElement(Ms, {height: m}), lt.createElement(wl, {item: !0}, lt.createElement("div", {
            className: y ? "rio-product-option-title" : void 0,
            style: y ? {} : {
                lineHeight: 1,
                fontSize: i,
                fontWeight: n ? "bold" : void 0,
                textTransform: r ? "uppercase" : "none",
                color: o,
                background: a,
                paddingLeft: s,
                paddingRight: l,
                paddingTop: c,
                paddingBottom: u, ...p || a ? {
                    ...p ? {borderColor: p, borderStyle: `${d}`, borderWidth: `${h}px`} : {},
                    borderRadius: `${f}%`
                } : {}
            }
        }, e)), "above" === g && lt.createElement(Ms, {height: v}))
    }

    const Uw = lt.createContext("spacing");

    function Gw({placeholderKey: e, placeholderCellKey: t})
    {
        const [n, r] = ue(Uw);
        return lt.createElement(Xh, {
            handleHeight: !0, onResize: (i, o) =>
            {
                const a = [...(n[e] || []).filter((e => e.id !== t)), {id: t, height: o}];
                r({...n, [e]: a})
            }
        })
    }

    function Zw({placeholderKey: e, placeholderCellKey: t, outerTextId: n, config: r, price: i, name: o})
    {
        const a = function (e)
        {
            const [t] = ue(Uw), n = t[e];
            if (Array.isArray(n)) return Math.max(...n.map((e => e.height)))
        }(e);
        if ("placeholder" === n) return lt.createElement("div", {style: {height: a}});
        const s = r[n], {text: l} = s;
        return lt.createElement("div", {style: {height: a}}, lt.createElement(wl, {
            container: !0,
            style: {height: "100%"},
            alignItems: "center"
        }, lt.createElement(wl, {item: !0}, lt.createElement(Gw, {
            placeholderKey: e,
            placeholderCellKey: t
        }), lt.createElement(qw, {text: $w(l, i, o), config: s}))))
    }

    function Kw({hide: e, title: t, selectedOptionName: n, config: r})
    {
        const {textAlign: i, displaySelectedOptionValue: o, enabled: a, text: s} = r, l = Ww(r),
            c = le((() => l || "center" === i ? {justify: "center"} : "right" === i ? {direction: "row-reverse"} : {direction: "row"}), [l, i]),
            u = le((() =>
            {
                let e;
                return e = s ? $w(s, null, t) : t, lt.createElement(lt.Fragment, null, lt.createElement("span", {dangerouslySetInnerHTML: {__html: e}}), o && lt.createElement(lt.Fragment, null, ": ", lt.createElement("span", {className: "rio-product-option-title-option-value"}, n)))
            }), [o, n, s, t]);
        return !a || e ? null : lt.createElement(wl, Rd({container: !0}, c), lt.createElement(wl, {item: !0}, lt.createElement(qw, {
            text: u,
            config: r
        })))
    }

    function Yw({
                    type: e,
                    buttonType: t,
                    buttonWidth: n,
                    backgroundType: r,
                    backgroundImage: i,
                    size: o,
                    color1: a,
                    color2: s,
                    color3: l,
                    color4: c
                })
    {
        return le((() =>
        {
            if ("button" === e) return;
            const u = "fit-text" === t ? n : o;
            if (0 === u) return;
            if (!i && "swatch" === e && "one-solid" !== r)
            {
                return `url('data:image/svg+xml;utf8,${encodeURIComponent(function ({
                                                                                        id: e,
                                                                                        size: t,
                                                                                        color1: n,
                                                                                        color2: r,
                                                                                        color3: i,
                                                                                        color4: o
                                                                                    })
                {
                    const a = Fw[e];
                    return ("string" == typeof a ? a : Fw["one-solid"]).replace(/%SIZE%/g, `${t}px`).replace(/%COLOR1%/g, n).replace(/%COLOR2%/g, r).replace(/%COLOR3%/g, i).replace(/%COLOR4%/g, o)
                }({id: r, size: u, color1: a, color2: s, color3: l, color4: c}))}')`
            }
            const d = Wy() * u;
            return i ? `url(${By(i.url)(d, d)})` : void 0
        }), [e, t, n, o, i, r, a, s, l, c])
    }

    function Xw({
                    backgroundImage: e,
                    size: t,
                    borderRadius: n,
                    borderDouble: r,
                    borderDoubleThickness: i,
                    borderDoubleColor: o
                })
    {
        const a = le((() => `rio-button-icon-border-double-${Em.v4()}`), []), s = Math.ceil(Wy() * t),
            l = By(e.url)(s, s);
        return lt.createElement("div", {
            className: r ? a : void 0,
            style: {
                width: t,
                height: t,
                backgroundImage: `url(${l})`,
                backgroundSize: "cover",
                borderRadius: `${n}%`,
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                position: "relative"
            }
        }, r && lt.createElement("style", null, `\n            .${a}:before {\n              content: "";\n              border: ${i}px solid ${o};\n              border-radius: ${n}%;\n              display: block;\n              position: absolute;\n              top: -1px;\n              left: -1px;\n              width: ${t + 2}px;\n              height: ${t + 2}px;\n            }\n          `))
    }

    function Jw({id: e, outOfStockStyle: t, available: n, selected: r, onChange: i, values: o})
    {
        ie((() =>
        {
            if ("hide" !== t) return;
            if (n[r]) return;
            let a = r, s = r, l = !1;
            for (; l ? a += 1 : s -= 1, !(s < 0 && a > o.length - 1);)
            {
                const e = l ? a : s;
                if (e >= 0 && e <= o.length - 1 && n[e])
                {
                    l = e;
                    break
                }
                l = !l
            }
            "number" == typeof l && i(e, o[l].id)
        }), [n, e, i, t, r, o])
    }

    function Qw({index: e, position: t, outerTextIndex: n, outerTextId: r, config: i, price: o, name: a})
    {
        if (!r) return null;
        const s = `${t}-${n}`, l = `${e}-${n}`;
        return lt.createElement(Zw, {
            placeholderKey: s,
            placeholderCellKey: l,
            outerTextId: r,
            config: i,
            price: o,
            name: a
        })
    }

    function ex({
                    value: e,
                    index: t,
                    size: n,
                    type: r,
                    buttonType: i,
                    border: o,
                    borderThickness: a,
                    borderRadius: s,
                    borderRadiusPx: l,
                    borderSelectedColor: c,
                    borderUnselectedColor: u,
                    borderHoverColor: d,
                    borderOutOfStockCrossOutColor: p,
                    borderDouble: f,
                    borderDoubleColor: h,
                    borderDoubleThickness: m,
                    outOfStock: v,
                    selected: g,
                    available: y,
                    setSelected: b,
                    hovering: w,
                    setHovering: x,
                    price: _,
                    outerTextMatrices: C,
                    selectedConfig: E,
                    unselectedConfig: S,
                    horizontalCarousel: k,
                    onNavigationScrolled: T,
                    initialScroll: O
                })
    {
        const {
                id: M,
                name: R,
                config: P,
                config: {
                    backgroundImage: z,
                    backgroundColor: I,
                    backgroundColor2: A,
                    backgroundColor3: L,
                    backgroundColor4: D,
                    selectedBackgroundColor: N,
                    backgroundType: F,
                    backgroundPosition: B,
                    backgroundSize: W,
                    backgroundSizePx: $,
                    backgroundBorderRadius: H,
                    text: j,
                    textPadding: V
                }
            } = e, [q, U] = ne({width: 0, height: 0}), {width: G, height: Z} = q, K = Yw({
                type: r,
                buttonType: i,
                buttonWidth: G,
                backgroundType: F,
                backgroundImage: z,
                size: n,
                color1: I,
                color2: A,
                color3: L,
                color4: D
            }), Y = le((() => "swatch" === r && "one-solid" === F && null !== N ? N : null), [F, N, r]),
            X = le((() => t === g), [t, g]), J = ce((e => "button" === r ? (X ? E : S)[e] : P[e]), [r, P, X, E, S]),
            Q = le((() => "button" === r ? "fit-text" : i), [i, r]), ee = le((() => J("backgroundColor")), [J]),
            te = le((() => J("textColor")), [J]), re = le((() => J("textSize")), [J]),
            oe = le((() => J("textBold")), [J]), ae = le((() => J("textUppercase")), [J]),
            se = le((() => "button" === r ? e.name : j), [j, r, e.name]), ue = le((() =>
            {
                if ("swatch" === r && "fit-text" === Q || "button" === r)
                {
                    const [e, t, n, r] = V;
                    return {paddingLeft: e, paddingRight: t, paddingTop: n, paddingBottom: r}
                }
                return {}
            }), [Q, V, r]), de = le((() => `rio-swatch-unavailable-${Em.v4()}`), []),
            pe = le((() => `rio-swatch-border-double-${Em.v4()}`), []), [fe, he] = ne({length: 0, radians: 0}),
            me = function ({size: e, fitText: t})
            {
                return t ? 62 === e ? "medium" : 102 === e ? "large" : "small" : e
            }({size: n, fitText: "button" === r || "fit-text" === Q}), [ve, ge] = C,
            ye = "button" === r && z ? lt.createElement(Xw, {
                backgroundImage: z,
                borderRadius: H,
                size: $,
                borderDouble: f,
                borderDoubleThickness: m,
                borderDoubleColor: h
            }) : null, be = le((() => wr({overrides: {MuiButton: {label: ue}}})), [ue]), we = function (e, t, n, r, i)
            {
                if ("swatch" === e)
                {
                    if ("circular" === t) return "50%";
                    if ("round" === n) return `${r}%`
                }
                if ("button" === e) return `${i}px`
            }(r, Q, o, s, l);
        ie((() =>
        {
            const e = G, t = Z, n = Math.sqrt(e ** 2 + t ** 2), r = Math.PI / 2 - Math.atan(e / t);
            he({length: n, radians: r})
        }), [a, Z, G]);
        const xe = "button" === r || "swatch" === r && "fit-text" === Q ? "1.0" : "0.9", _e = ce((e =>
        {
            const t = O.current ? 0 : 100;
            O.current = !1, e && window.requestAnimationFrame((() =>
            {
                ny(e, {
                    time: t,
                    lockX: !1,
                    lockY: !0,
                    validTarget: e => !(!e || "function" != typeof e.matches || !e.matches(".rio-hide-scrollbar"))
                }, (() =>
                {
                    T()
                }))
            }))
        }), [T]), Ce = lt.createElement(wl, {
            container: !0,
            direction: "column",
            alignItems: "center"
        }, ve[t].map(((e, n) => lt.createElement(Qw, {
            index: t,
            position: "above",
            key: n,
            outerTextIndex: n,
            outerTextId: e,
            config: P,
            price: _,
            name: R
        }))), lt.createElement("div", null, "cross-out" === v.style && lt.createElement(lt.Fragment, null, lt.createElement("style", null, `\n                .${de} {\n                  opacity: 0.6;\n                }\n                .${de}::after {\n                  content: "";\n                  position: absolute;\n                  transform-origin: 0 0;\n                  top: 50%;\n                  left: 50%;\n                  width: ${fe.length}px;\n                  transform: rotate(${fe.radians}rad) scale(${xe}) translate(-50%, -50%);\n                  border-top: ${a + .5}px solid ${p};\n                }\n            `)), "fade-out" === v.style && lt.createElement("style", null, `\n              .${de} {\n                opacity: 0.6;\n              }     \n            `), "swatch" === r && f && lt.createElement("style", null, `\n            .${pe}:before {\n              content: "";\n              border: ${m}px solid ${h};\n              ${we ? `border-radius: ${we};` : ""}\n              display: block;\n              position: absolute;\n              top: -1;\n              width: -1;\n              width: calc(100% + 2px);\n              height: calc(100% + 2px);\n            }\n          `), lt.createElement(Xh, {
            handleWidth: !0,
            handleHeight: !0,
            onResize: (e, t) =>
            {
                U({width: e, height: t})
            }
        }), lt.createElement(Wa, {theme: be}, lt.createElement(ml, {
            component: "div",
            role: "none",
            ref: k && t === g ? _e : void 0,
            onClick: () =>
            {
                b(M)
            },
            onMouseOver: () =>
            {
                x(t)
            },
            onMouseOut: () =>
            {
                x(-1)
            },
            className: ka(y ? void 0 : de, pe),
            "data-option-value": M,
            size: "string" == typeof me ? me : void 0,
            startIcon: "left" === B ? ye : void 0,
            endIcon: "right" === B ? ye : void 0,
            style: {
                position: "relative",
                backgroundColor: Y && t === g ? Y : ee,
                backgroundImage: K,
                backgroundSize: z ? 100 === W ? "cover" : `${W}% auto` : void 0,
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat", ..."number" == typeof me ? {minWidth: me, width: me, height: me} : {},
                outline: "none",
                boxSizing: "border-box",
                border: "solid",
                borderWidth: `${a}px`,
                borderRadius: we,
                borderColor: Hw({
                    selected: t === g,
                    hovering: t === w,
                    borderSelectedColor: c,
                    borderUnselectedColor: u,
                    borderHoverColor: d
                })
            }
        }, lt.createElement("span", {
            style: {
                fontSize: re,
                color: te,
                fontWeight: oe ? "bold" : "normal",
                textTransform: ae ? "uppercase" : "none"
            }
        }, !!se && $w(se, _, R), !se && " ")))), ge[t].map(((e, n) => lt.createElement(Qw, {
            index: t,
            position: "below",
            key: n,
            outerTextIndex: n,
            outerTextId: e,
            config: P,
            price: _,
            name: R
        }))));
        return lt.createElement(wl, {key: M, item: !0}, lt.createElement(Vw, {
            outOfStockTooltip: v.tooltip,
            available: y,
            value: e,
            name: R,
            price: _
        }, Ce))
    }

    const tx = ja((e => ({
        inputLabel: {marginBottom: e.spacing(.5)},
        helperText: {marginTop: e.spacing(.5)},
        items: {padding: e.spacing(.5)},
        navigationRoot: {
            color: "white",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            width: "41px",
            height: "41px",
            margin: "auto",
            bottom: 0,
            top: 0,
            zIndex: 1,
            position: "absolute",
            "&:hover": {
                color: "white",
                backgroundColor: "rgba(0, 0, 0, 0.4)",
                "@media (hover: none)": {backgroundColor: "rgba(0, 0, 0, 0.5)"}
            }
        }
    })));

    function nx({children: e, option: t, selected: n})
    {
        const {
                name: r,
                config: {type: i, horizontalCarousel: o, centered: a, title: s, select: {fullWidth: l}},
                values: c
            } = t, u = le((() => "select" !== i ? a && !o ? "center" : void 0 : a ? "center" : void 0), [a, o, i]),
            d = le((() => "select" !== i ? o ? void 0 : "fit-content" : l ? void 0 : "fit-content"), [o, l, i]),
            p = le((() => ({title: r, config: s, selectedOptionName: c[n].name})), [r, n, s, c]), f = ne({});
        return lt.createElement(Uw.Provider, {value: f}, lt.createElement(wl, {
            item: !0,
            container: !0,
            justify: u
        }, lt.createElement(wl, {
            container: !0,
            wrap: "nowrap",
            direction: "column",
            style: {position: "relative"},
            className: "fit-content" === d ? "rio-width-fit-content" : void 0
        }, lt.createElement(Kw, Rd({hide: "above" !== s.position[0]}, p)), e, lt.createElement(Kw, Rd({hide: "below" !== s.position[0]}, p)))))
    }

    function rx({option: e, onChange: t, selected: n, available: r, prices: i})
    {
        const {
            id: o,
            values: a,
            config: {
                size: s,
                spacing: l,
                centered: c,
                horizontalCarousel: u,
                type: d,
                buttonType: p,
                border: f,
                borderThickness: h,
                borderRadius: m,
                borderRadiusPx: v,
                borderSelectedColor: g,
                borderUnselectedColor: y,
                borderHoverColor: b,
                borderOutOfStockCrossOutColor: w,
                borderDouble: x,
                borderDoubleColor: _,
                borderDoubleThickness: C,
                outOfStock: E,
                selected: S,
                unselected: k
            }
        } = e, T = tx(), [O, M] = ne(-1), R = ce((e =>
        {
            t(o, e)
        }), [o, t]);
        Jw({id: o, outOfStockStyle: E.style, available: r, selected: n, onChange: t, values: a});
        const P = le((() => ["above", "below"].map((e => function ({position: e, optionValues: t})
            {
                const n = t.map((t => Dw.map((n =>
                {
                    const [r, i] = Lw(n, t.config, e);
                    return {enabled: r, id: n, priority: i}
                })).sort($y("priority")).map((({enabled: e, id: t}) => e ? t : null))));
                if (n.length > 0) for (let e = 0; e < n[0].length; e += 1)
                {
                    let t = !0;
                    for (let r = 0; r < n.length; r += 1) n[r][e] && (t = !1);
                    if (!t) for (let t = 0; t < n.length; t += 1) n[t][e] || (n[t][e] = "placeholder")
                }
                return n
            }({position: e, optionValues: a})))), [a]), z = ae(null), [I, A] = ne(!1), [L, D] = ne(!1), N = ae(!0),
            F = ce((() =>
            {
                if (!u) return;
                const e = z.current;
                if (e)
                {
                    const t = Hy(e, !1);
                    D(!t.start), A(!t.end)
                }
            }), [u]), B = a.map(((e, t) =>
            {
                const {id: o} = e;
                return ["hide" === E.style && !r[t], o, lt.createElement(ex, {
                    value: e,
                    values: a,
                    type: d,
                    buttonType: p,
                    size: s,
                    index: t,
                    available: r[t],
                    price: i[t],
                    border: f,
                    borderThickness: h,
                    borderRadius: m,
                    borderRadiusPx: v,
                    borderSelectedColor: g,
                    borderUnselectedColor: y,
                    borderHoverColor: b,
                    borderOutOfStockCrossOutColor: w,
                    borderDouble: x,
                    borderDoubleColor: _,
                    borderDoubleThickness: C,
                    outOfStock: E,
                    selected: n,
                    setSelected: R,
                    hovering: O,
                    setHovering: M,
                    outerTextMatrices: P,
                    selectedConfig: S,
                    unselectedConfig: k,
                    horizontalCarousel: u,
                    onNavigationScrolled: F,
                    initialScroll: N
                })]
            })), W = !B.find((([e]) => !e)), $ = Va(), H = $.spacing(1), j = $.spacing(l);
        return lt.createElement(nx, {
            option: e,
            selected: n
        }, !W && lt.createElement(lt.Fragment, null, u && lt.createElement(Xh, {
            handleWidth: !0,
            refreshMode: "debounce",
            refreshRate: 250,
            onResize: () =>
            {
                F()
            }
        }), u && L && lt.createElement(_l, {
            component: "div",
            role: "none",
            size: "small",
            classes: {root: T.navigationRoot},
            onClick: async () =>
            {
                const e = await jy(z.current, !1, -1);
                D(!e.start), A(!e.end)
            },
            style: {left: 0}
        }, lt.createElement(lm, {fontSize: "large"})), lt.createElement(wl, {
            ref: z,
            item: !0,
            container: !0,
            direction: "row",
            "data-option": o,
            "data-option-type": d,
            wrap: u ? "nowrap" : void 0,
            justify: !u && c ? "center" : void 0,
            style: {overflowX: "auto", alignItems: "center"},
            spacing: u ? void 0 : l,
            className: ka("rio-hide-scrollbar", T.items, !u && "rio-width-fit-content")
        }, B.map((([e, t, n], r, i) => e ? lt.createElement(lt.Fragment, {key: t}) : lt.createElement(wl, {
            item: !0,
            key: t,
            style: {paddingRight: u ? r !== i.length - 1 ? j : H : void 0}
        }, n))), u && I && lt.createElement(_l, {
            component: "div",
            role: "none",
            size: "small",
            classes: {root: T.navigationRoot},
            onClick: async () =>
            {
                const e = await jy(z.current, !1, 1);
                D(!e.start), A(!e.end)
            },
            style: {right: 0}
        }, lt.createElement(fm, {fontSize: "large"})))), W && lt.createElement(wl, {
            item: !0,
            container: !0,
            justify: "center"
        }, lt.createElement(Sl, null, "None available")))
    }

    function ix({option: e, selected: t, setSelected: n, available: r})
    {
        const {
                id: i,
                values: o,
                config: {
                    type: a,
                    select: {
                        backgroundColor: s,
                        textColor: l,
                        textSize: c,
                        textBold: u,
                        textUppercase: d,
                        fullWidth: p,
                        darkMenu: f,
                        variant: h,
                        outerText: m,
                        minWidth: v
                    },
                    outOfStock: {style: g},
                    borderUnselectedColor: y,
                    borderSelectedColor: b,
                    borderHoverColor: w,
                    borderThickness: x,
                    borderRadiusPx: _,
                    borderDouble: C,
                    borderDoubleThickness: E,
                    borderDoubleColor: S
                }
            } = e, k = y || "transparent", T = b || "transparent", O = w || "transparent", M = ce((e => Dw.map((t =>
            {
                const [n, r] = Lw(t, m, e);
                return {id: t, priority: r, enabled: n}
            })).sort($y("priority")).filter((e => e.enabled)).map((e => e.id))), [m]), R = le((() => M("above")), [M]),
            P = le((() => M("below")), [M]), z = ce((e =>
            {
                if (!r[e] && "none" !== g)
                {
                    if ("cross-out" === g) return {textDecoration: "line-through"};
                    if ("fade-out" === g) return {opacity: .5}
                }
                return {}
            }), [r, g]), I = le((() =>
            {
                const e = {
                    root: {
                        "& $notchedOutline": {borderColor: k, borderWidth: x},
                        "&:hover $notchedOutline": {borderColor: O, borderWidth: x},
                        "&$focused $notchedOutline": {borderColor: T, borderWidth: x}
                    }
                }, t = {
                    underline: {
                        "&::before": {borderBottom: `${x}px solid ${k}`},
                        "&::after": {borderBottom: `${x}px solid ${T}`},
                        "&:hover:not($disabled):not($error):not($focused):before": {borderBottom: `${x}px solid ${O}`}
                    }
                }, n = {
                    root: {"&:focus": {backgroundColor: "transparent !important"}},
                    icon: {color: l, width: "24px", height: "24px"}
                }, r = {root: {fontSize: "16px"}};
                return wr({
                    palette: {type: f ? "dark" : "light"},
                    overrides: {
                        MuiOutlinedInput: e,
                        MuiInput: t,
                        MuiSelect: n,
                        MuiMenuItem: r,
                        PwzrOutlinedInput: e,
                        PwzrInput: t,
                        PwzrSelect: n,
                        PwzrMenuItem: r
                    }
                })
            }), [O, T, x, k, f, l]), A = o.map(((e, t) =>
            {
                if (!r[t] && "hide" === g) return [!0, lt.createElement(lt.Fragment, {key: e.id})];
                const {
                    config: {
                        backgroundImage: n,
                        backgroundSizePx: i,
                        backgroundBorderRadius: o,
                        backgroundPosition: a
                    }
                } = e, s = n ? lt.createElement(Xw, {
                    backgroundImage: n,
                    borderRadius: o,
                    size: i,
                    borderDouble: C,
                    borderDoubleThickness: E,
                    borderDoubleColor: S
                }) : null;
                return [!1, lt.createElement(Al, {
                    key: e.id,
                    value: t,
                    style: z(t),
                    "data-option-value": e.id
                }, lt.createElement(wl, {
                    container: !0,
                    direction: "row",
                    wrap: "nowrap",
                    alignItems: "center"
                }, s && "left" === a && lt.createElement(lt.Fragment, null, s, lt.createElement(Ms, {mr: 1})), lt.createElement("span", null, e.name), s && "right" === a && lt.createElement(lt.Fragment, null, lt.createElement(Ms, {ml: 1}), s))), r[t]]
            }));
        return !A.find((([e]) => !e)) ? lt.createElement(wl, {
            item: !0,
            container: !0,
            justify: "center"
        }, lt.createElement(Sl, null, "None available")) : lt.createElement(wl, {
            item: !0,
            container: !0,
            direction: "column",
            alignItems: "center"
        }, R.map(((e, t) => lt.createElement(Qw, {
            index: 0,
            position: "above",
            key: t,
            outerTextIndex: t,
            outerTextId: e,
            config: m
        }))), lt.createElement(Wa, {theme: I}, lt.createElement(iu, {
            variant: h,
            value: t,
            fullWidth: p,
            onChange: e =>
            {
                const t = o[e.target.value];
                n(t.id)
            },
            MenuProps: {disableScrollLock: !0, autoFocus: !1},
            style: {
                backgroundColor: s,
                fontWeight: u ? "bold" : "normal",
                textTransform: d ? "uppercase" : "none",
                textDecoration: A[t][2] ? void 0 : "line-through",
                color: l,
                fontSize: `${c}px`,
                marginTop: 5,
                marginLeft: 5,
                marginBottom: 5,
                minWidth: p ? void 0 : v,
                borderRadius: _
            },
            "data-option": i,
            "data-option-type": a
        }, A.map((([, e]) => e)))), P.map(((e, t) => lt.createElement(Qw, {
            index: 0,
            position: "below",
            key: t,
            outerTextIndex: t,
            outerTextId: e,
            config: m
        }))))
    }

    function ox({option: e, selected: t, onChange: n, available: r})
    {
        const {id: i, values: o, config: {outOfStock: {style: a}}} = e, s = ce((e =>
        {
            n(i, e)
        }), [i, n]);
        return Jw({
            id: i,
            outOfStockStyle: a,
            available: r,
            selected: t,
            onChange: n,
            values: o
        }), lt.createElement(nx, {option: e, selected: t}, lt.createElement(ix, {
            option: e,
            selected: t,
            setSelected: s,
            available: r
        }))
    }

    function ax({option: e, variant: t, onChange: n, selected: r, available: i, prices: o})
    {
        return "select" !== e.config.type ? lt.createElement(rx, {
            option: e,
            variant: t,
            onChange: n,
            selected: r,
            available: i,
            prices: o
        }) : lt.createElement(ox, {option: e, variant: t, onChange: n, selected: r, available: i, prices: o})
    }

    function sx({option: e})
    {
        const {assets: t} = ue(Bw), n = ce((e => ((e, t) =>
        {
            if (!Array.isArray(e) || "string" != typeof t) return null;
            return e.find((e => e.id === t)) || null
        })(t, e)), [t]), r = Ww(e.config);
        return le((() => ({
            ...e, config: {...e.config, centered: r}, values: e.values.map((e =>
            {
                const {config: {backgroundImage: t}} = e;
                if ("object" == typeof t && null !== t)
                {
                    const r = n(t.id);
                    return r && "string" == typeof r.url ? {
                        ...e,
                        config: {...e.config, backgroundImage: {...e.config.backgroundImage, url: r.url}}
                    } : {...e, config: {...e.config, backgroundImage: null}}
                }
                return e
            }))
        })), [r, n, e])
    }

    function lx({option: e, index: t})
    {
        const {selections: n, onChange: r} = ue(Nw), i = sx({option: e});
        return lt.createElement(lt.Fragment, {key: i.id}, lt.createElement(ax, {
            option: i,
            selected: n[t].index,
            available: n[t].available,
            prices: n[t].prices,
            onChange: r
        }))
    }

    const cx = ja((() => ({
        editContainer: {width: "80px", marginTop: "24px"},
        optionContainer: {width: "calc(100% - 80px)"},
        edit: {
            backgroundColor: "rgba(94, 109, 191)",
            color: "white",
            "&:hover": {backgroundColor: "rgba(94, 109, 191, 0.9)", boxShadow: "unset"}
        }
    })));

    function ux({editable: e, options: t, optionsToHide: n, spacing: r = 1, setEditOption: i})
    {
        const o = cx();
        return e ? lt.createElement(wl, {
            container: !0,
            direction: "column"
        }, t.map(((e, n) => lt.createElement(lt.Fragment, {key: e.id}, lt.createElement(wl, {
            item: !0,
            container: !0,
            direction: "row"
        }, lt.createElement(wl, {
            item: !0,
            container: !0,
            className: o.editContainer,
            alignItems: "center"
        }, lt.createElement(wl, {item: !0}, lt.createElement(wl, {
            container: !0,
            direction: "column",
            alignItems: "center"
        }, lt.createElement(wl, {item: !0}, lt.createElement(_l, {
            onClick: () =>
            {
                i(e)
            }, className: o.edit
        }, lt.createElement(_w, {color: "inherit"}))), lt.createElement(wl, {item: !0}, lt.createElement(Tl, {
            component: "button",
            variant: "body1",
            onClick: () =>
            {
                i(e)
            }
        }, "Edit"))))), lt.createElement(wl, {item: !0, className: o.optionContainer}, lt.createElement(lx, {
            option: e,
            index: n
        }))), n !== t.length - 1 && lt.createElement(Ms, {mb: r}))))) : lt.createElement(wl, {
            container: !0,
            direction: "column"
        }, t.map(((e, t) => !!n.find((t => t === e.id)) ? lt.createElement(lt.Fragment, {key: e.id}) : lt.createElement(lt.Fragment, {key: e.id}, lt.createElement(wl, {
            item: !0,
            container: !0
        }, lt.createElement(lx, {option: e, index: t})), lt.createElement(Ms, {mb: r})))))
    }

    function dx(e, t)
    {
        return e.find((e =>
        {
            if (e.options.length !== t.length) return !1;
            for (const n of e.options) if (!t.find((e => e.id === n.id && e.value === n.value))) return !1;
            return !0
        }))
    }

    function px(e, t)
    {
        const n = t.find((t => t.id === e.id));
        if (n)
        {
            const t = e.values.findIndex((e => e.id === n.value));
            if (t > -1) return t
        }
        return 0
    }

    function fx({
                    variants: e,
                    options: t,
                    settings: n,
                    initialSelectedVariantId: r,
                    editable: i = !1,
                    optionsToHide: o = [],
                    onChange: a = (() =>
                    {
                    }),
                    selectionType: s = "default",
                    setEditOption: l
                })
    {
        const [c, u] = ne(function (e, t)
        {
            if ("string" == typeof t)
            {
                const n = e.find((e => `${e.id}` === t));
                if (n) return n.options
            }
            return (e.find((e => e.available)) || e[0]).options
        }(e, r)), d = le((() => function (e, t, n, r)
        {
            return t.map((t =>
            {
                const i = n.filter((e => e.id !== t.id)),
                    o = t.values.map((e => [{id: t.id, value: e.id}, ...i])).map((t =>
                    {
                        const n = dx(e, t);
                        return "default" === r ? n || {available: !1, price: 0} : {
                            price: 0, ...n || {},
                            available: "always-available" === r
                        }
                    }));
                return {id: t.id, index: px(t, n), available: o.map((e => e.available)), prices: o.map((e => e.price))}
            }))
        }(e, t, c, s)), [s, c, t, e]), p = ce(((t, n) =>
        {
            const r = [...c], i = r.findIndex((e => e.id === t));
            i > -1 && (r[i] = {id: t, value: n}), u(r), a(r, dx(e, r))
        }), [c, a, e]), f = le((() => ({onChange: p, selections: d, editable: i})), [i, p, d]);
        return lt.createElement(Nw.Provider, {value: f}, lt.createElement(ux, {
            options: t,
            editable: i,
            optionsToHide: o,
            spacing: n.spacing,
            setEditOption: l
        }))
    }

    var hx = {};
    const mx = () =>
        {
            throw new Error("Must be server!")
        }, vx = [{id: "none", name: "None", static: !0}, {id: "partner", name: "Partner", static: !0}, {
            id: "free",
            name: "Free",
            static: !1
        }, {id: "starter", name: "Starter", price: 4.99, static: !1}, {
            id: "starter",
            name: "Starter",
            price: 3.99,
            static: !1
        }, {id: "pro", name: "Pro", price: 7.99, static: !1}, {id: "pro", name: "Pro", price: 6.99, static: !1}],
        gx = (e, t = !0) =>
        {
            const n = vx.find((n => !(!t && n.static) && n.id === e));
            if (!n) throw Error(`unknown plan id ${e}`);
            return n
        },
        yx = e => "none-stacked" === e || ("none-stacked-two-columns" === e || "none-stacked-two-columns-main" === e);

    function bx()
    {
        const e = ({config: e}) =>
        {
            const {
                product: t,
                options: n,
                onChange: r,
                initialSelectedVariantId: i,
                settings: o
            } = e, [a, s] = ne(Em.v4());
            console.log(`Rio-options render key: ${a}`), e.forceUpdate = ce((() =>
            {
                s(Em.v4())
            }), []);
            const l = le((() => function (e, t)
            {
                const n = Array.isArray(t) ? t : [];
                return {
                    options: e.options.map((e =>
                    {
                        const {name: t, name: r, values: i} = e, o = n.findIndex((e => e.id === r)),
                            a = o > -1 ? n[o] : void 0;
                        return {
                            id: r, name: t, values: Iw(i, a ? a.values : null), config: Sw({
                                type: "button",
                                buttonType: "square",
                                size: 48,
                                spacing: 1,
                                horizontalCarousel: !1,
                                centered: !1,
                                title: {
                                    enabled: !0,
                                    useThemeSettings: !0,
                                    displaySelectedOptionValue: !1,
                                    text: null,
                                    textBold: !1,
                                    textUppercase: !1,
                                    textColor: kw("swatch-title-text-color"),
                                    textSize: Tw("swatch-title-text-size"),
                                    textPadding: Ow("swatch-title-text-padding"),
                                    textAlign: "left",
                                    backgroundColor: null,
                                    borderColor: kw("swatch-title-border-color"),
                                    borderStyle: "solid",
                                    borderThickness: Rw("swatch-title-border-thickness"),
                                    borderRadius: Pw("swatch-title-border-radius"),
                                    position: ["above"],
                                    margin: Mw("swatch-title-margin")
                                },
                                border: "round",
                                borderStyle: "solid",
                                borderThickness: Rw("border-thickness"),
                                borderRadius: Pw("border-radius"),
                                borderRadiusPx: Pw("border-radius-px"),
                                borderSelectedColor: kw("border-colors-selected"),
                                borderUnselectedColor: kw("border-colors-unselected"),
                                borderHoverColor: kw("border-colors-hovering"),
                                borderOutOfStockCrossOutColor: kw("border-colors-outOfStockCrossOut"),
                                borderDouble: !1,
                                borderDoubleColor: kw("border-colors-double"),
                                borderDoubleThickness: Rw("border-thickness-double"),
                                outOfStock: {style: "cross-out", tooltip: !1},
                                unselected: {
                                    backgroundColor: kw("unselected-background-color"),
                                    textBold: !1,
                                    textUppercase: !1,
                                    textColor: kw("unselected-text-color"),
                                    textSize: Tw("unselected-text-size")
                                },
                                selected: {
                                    backgroundColor: kw("selected-background-color"),
                                    textBold: !1,
                                    textUppercase: !1,
                                    textColor: kw("selected-text-color"),
                                    textSize: Tw("selected-text-size")
                                },
                                select: {
                                    variant: "outlined",
                                    minWidth: 120,
                                    fullWidth: !1,
                                    darkMenu: !1,
                                    textSize: Tw("select-text-size"),
                                    textBold: !1,
                                    textUppercase: !1,
                                    textColor: kw("select-text-color"),
                                    backgroundColor: kw("select-background-color"),
                                    outerText: zw()
                                }
                            }, a ? a.config : {})
                        }
                    })),
                    variants: Array.isArray(e.variants) ? e.variants.map((t => ({
                        id: t.id,
                        title: t.title,
                        price: t.price,
                        available: t.available,
                        options: Aw(e, t)
                    }))) : []
                }
            }(t, n)), []), c = wr({overrides: {PwzrSvgIcon: {root: {width: "35px", height: "35px"}}}}), u = le((() =>
            {
                if ("undefined" != typeof __productWizRioAssets && Array.isArray(__productWizRioAssets)) try
                {
                    return {assets: hx.decompressAssets(__productWizRioAssets)}
                } catch (e)
                {
                    console.log("Failed to decompress assets:"), console.log(e)
                }
                return {assets: null}
            }), []);
            return lt.createElement(Bw.Provider, {value: u}, lt.createElement(Wa, {theme: c}, lt.createElement(fx, {
                key: a,
                variants: l.variants,
                options: l.options,
                settings: o,
                initialSelectedVariantId: i,
                onChange: r
            })))
        };
        "undefined" != typeof __productWizRioOptions && (__productWizRioOptions.processRenderQueue = () =>
        {
            const t = [...__productWizRioOptions.renderQueue];
            for (const n of t)
            {
                const [t, r, i] = n;
                He(lt.createElement(e, {config: r}), t, i)
            }
            __productWizRioOptions.renderQueue = __productWizRioOptions.renderQueue.filter((e => !t.includes(e)))
        }, __productWizRioOptions.processRenderQueue())
    }

    hx = {
        getServerPort: mx,
        getServerEndpoint: () => `http://localhost:${mx()}`,
        getSubscriptionPlanByPrice: e =>
        {
            const t = vx.find((t => `${t.price}` === e));
            if (!t) throw Error(`unknown plan price ${e}`);
            return t
        },
        getSubscriptionPlanById: gx,
        delay: e => new Promise((t => setTimeout(t, e))),
        getSubscriptionPlansById: e => vx.filter((t => t.id === e)),
        getSubscriptionPaidPlans: () => [gx("starter"), gx("pro")],
        buildVariantImagesConfig: ({
                                       templateConfig: e,
                                       customTheme: t,
                                       themeSettings: n,
                                       settings: {general: r, desktop: i, mobile: o},
                                       logError: a
                                   }) =>
        {
            const s = JSON.stringify(e);
            let l = JSON.parse(s);
            const c = (e, t) =>
            {
                const r = l[t], {
                    thumbnails: {
                        desktop: {horizontal: i, vertical: o},
                        mobile: {horizontal: a, vertical: s}
                    }
                } = n, c = () => "bottom" === e.thumbnails ? "carousel" === e.thumbnailsNavigation ? {
                    multiRow: !1,
                    navigation: !0
                } : {multiRow: !0, navigation: !1} : "carousel" === e.thumbnailsNavigation ? {
                    verticalOverflow: !0,
                    navigation: !0
                } : {verticalOverflow: !1, navigation: !1}, u = "desktop" === t ? i : a, d = "desktop" === t ? o : s;
                if (r.swipe = !0, delete r.vertical, delete r.verticalSpacing, delete r.verticalType, delete r.verticalHoistVariantImages, "none" === e.thumbnails) r.thumbnails = !1, r.pagination = !0, r.navigation = !1; else if ("none-with-navigation" === e.thumbnails) r.thumbnails = !1, r.pagination = !0, r.navigation = !0; else if ("bottom" === e.thumbnails)
                {
                    const e = {...u, orientation: "bottom", ...c()};
                    r.thumbnails = e, r.pagination = !1, r.navigation = !1
                } else if ("left" === e.thumbnails)
                {
                    const e = {...d, orientation: "left", ...c()};
                    r.thumbnails = e, r.pagination = !1, r.navigation = !1
                } else if ("right" === e.thumbnails)
                {
                    const e = {...d, orientation: "right", ...c()};
                    r.thumbnails = e, r.pagination = !1, r.navigation = !1
                } else yx(e.thumbnails) && (r.thumbnails = !1, r.pagination = !1, r.navigation = !1, r.vertical = !0, r.verticalSpacing = "15px", "none-stacked-two-columns" === e.thumbnails ? r.verticalType = "two-columns" : "none-stacked-two-columns-main" === e.thumbnails ? (r.verticalHoistVariantImages = !0, r.verticalType = "two-columns-main") : r.verticalType = void 0)
            };
            if (!t) try
            {
                c(i, "desktop"), c(o, "mobile")
            } catch (e)
            {
                l = JSON.parse(s), a(e)
            }
            return l.desktop.lightBox = !!i.lightBox, l.desktop.lightBox && (l.desktop.lightBoxZoom = (null == i ? void 0 : i.zoomAmount) || 2), l.desktop.magnify = !!i.magnify && {
                width: "full",
                height: "full",
                zoom: (null == i ? void 0 : i.zoomAmount) || 2
            }, yx(i.thumbnails) && (l.desktop.magnify = !1), l.mobile.lightBox = !!o.lightBox, l.mobile.lightBox && (l.mobile.lightBoxZoom = (null == o ? void 0 : o.zoomAmount) || 2), l.mobile.magnify = !!o.magnify && {
                width: "full",
                height: "full",
                zoom: (null == o ? void 0 : o.zoomAmount) || 2
            }, yx(o.thumbnails) && (l.mobile.magnify = !1), r && (l.lightBoxBackgroundColor = r.lightBoxBackgroundColor, l.thumbnailSelectionColor = r.thumbnailSelectionColor), l
        },
        isStackedProductGallery: yx,
        decompressAssets: function (e)
        {
            const t = e.filter((e => !!e.urlBase)), n = e.filter((e => !!e.themeIdBase));
            if (t.length < 1 && n.length < 1) return e;
            const r = t.map(((e, t) => [`{${t}}`, e.url])), i = n.map(((e, t) => [`{${t}}`, e.id])),
                o = e.filter((e => !e.urlBase && !e.themeIdBase)), a = [];
            for (const e of o)
            {
                let t = e.url;
                if ("string" == typeof t)
                {
                    for (const [e, n] of r) t = t.replace(e, n);
                    t = t.replace("{i}", e.id)
                }
                let n = e.themeId;
                if ("string" == typeof n) for (const [e, t] of i) n = n.replace(e, t);
                a.push({...e, ...void 0 !== t ? {url: t} : {}, ...void 0 !== n ? {themeId: n} : {}})
            }
            return a
        }
    };
    (function ()
    {
        var e = {exports: this};
        return this.__esModule = !0, window.__productWizRioJsInit ? (console.log("Rio JS has already been init!"), e.exports) : (window.__productWizRioJsInit = !0, function ()
        {
            if ("undefined" != typeof __productWizRio)
            {
                const {enabled: e} = __productWizRio;
                if (e) if ("undefined" != typeof __productWizRioViV2 && __productWizRioViV2) console.log("Variant images in V2 mode"), __productWizRio.processRenderQueue = () =>
                {
                    const e = [...__productWizRio.renderQueue];
                    for (const t of e)
                    {
                        const [e, n] = t;
                        He(lt.createElement(vw, {rio: __productWizRio}), e, n)
                    }
                    __productWizRio.renderQueue = __productWizRio.renderQueue.filter((t => !e.includes(t)))
                }, __productWizRio.processRenderQueue(); else
                {
                    const e = async () =>
                    {
                        const e = document.querySelector(".rio-media-gallery");
                        e && He(lt.createElement(vw, {rio: __productWizRio}), e)
                    }, {hijackInit: t} = __productWizRio;
                    t ? (console.log("Variant images in V1 override init mode"), __productWizRio.init = e) : (console.log("Variant images in V1 mode"), "loading" === document.readyState ? document.addEventListener("DOMContentLoaded", e) : e())
                }
            }
        }(), bx(), e.exports)
    }).call({})
}();
//# sourceMappingURL=index.js.map
